import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_expression_proto from './dcei_engine_expression_proto';
class EffectTarget_Type {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "TARGET_UNIT": return 1;
        case "TARGET_LOCATION": return 2;
        case "TARGET_UNIT_OR_LOCATION": return 3;
        case "SOURCE_UNIT": return 4;
        case "SOURCE_LOCATION": return 5;
        case "SOURCE_UNIT_OR_LOCATION": return 6;
        case "CASTER_UNIT": return 7;
        case "CASTER_LOCATION": return 8;
        case "CASTER_UNIT_OR_LOCATION": return 9;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectTarget_Type.fromJson(value);
  }
  static fromReact(e) {
    return EffectTarget_Type.fromJson(e);
  }
}
EffectTarget_Type.NONE = 0;
EffectTarget_Type.TARGET_UNIT = 1;
EffectTarget_Type.TARGET_LOCATION = 2;
EffectTarget_Type.TARGET_UNIT_OR_LOCATION = 3;
EffectTarget_Type.SOURCE_UNIT = 4;
EffectTarget_Type.SOURCE_LOCATION = 5;
EffectTarget_Type.SOURCE_UNIT_OR_LOCATION = 6;
EffectTarget_Type.CASTER_UNIT = 7;
EffectTarget_Type.CASTER_LOCATION = 8;
EffectTarget_Type.CASTER_UNIT_OR_LOCATION = 9;
EffectTarget_Type.default = 0;
EffectTarget_Type.values = {
  NONE: 0,
  TARGET_UNIT: 1,
  TARGET_LOCATION: 2,
  TARGET_UNIT_OR_LOCATION: 3,
  SOURCE_UNIT: 4,
  SOURCE_LOCATION: 5,
  SOURCE_UNIT_OR_LOCATION: 6,
  CASTER_UNIT: 7,
  CASTER_LOCATION: 8,
  CASTER_UNIT_OR_LOCATION: 9,
};
EffectTarget_Type.names = {
  0: "NONE",
  1: "TARGET_UNIT",
  2: "TARGET_LOCATION",
  3: "TARGET_UNIT_OR_LOCATION",
  4: "SOURCE_UNIT",
  5: "SOURCE_LOCATION",
  6: "SOURCE_UNIT_OR_LOCATION",
  7: "CASTER_UNIT",
  8: "CASTER_LOCATION",
  9: "CASTER_UNIT_OR_LOCATION",
};
export class EffectTarget {
  get descriptor() {
    return EffectTarget.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectTarget) {
      return value;
    }
    return EffectTarget.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectTarget();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {EffectTarget} other
   * @returns {EffectTarget}
   */
  merge(other) {
    const copy = new EffectTarget(this);
    return copy;
  }
}
EffectTarget.default = new EffectTarget();
EffectTarget.Type = EffectTarget_Type;
class EffectTarget_Builder {
  constructor(value) {
    this._value = new EffectTarget(value);
  }
  build() {
    return new EffectTarget(this._value);
  }
}
EffectTarget.Builder = EffectTarget_Builder;
class EffectTarget_WithParent {
  /**
   * @param {EffectTarget} value
   * @param {EffectTarget_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectTarget.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new EffectTarget_WithParent(current, parent);
    return result;
  }
}
EffectTarget_WithParent.default = new EffectTarget_WithParent(EffectTarget.default, null);
EffectTarget.WithParent = EffectTarget_WithParent;
class EffectTarget_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectTarget.descriptor = new EffectTarget_Descriptor();
class EffectUnitTarget_Type {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "TARGET_UNIT": return 1;
        case "SOURCE_UNIT": return 2;
        case "CASTER_UNIT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectUnitTarget_Type.fromJson(value);
  }
  static fromReact(e) {
    return EffectUnitTarget_Type.fromJson(e);
  }
}
EffectUnitTarget_Type.NONE = 0;
EffectUnitTarget_Type.TARGET_UNIT = 1;
EffectUnitTarget_Type.SOURCE_UNIT = 2;
EffectUnitTarget_Type.CASTER_UNIT = 3;
EffectUnitTarget_Type.default = 0;
EffectUnitTarget_Type.values = {
  NONE: 0,
  TARGET_UNIT: 1,
  SOURCE_UNIT: 2,
  CASTER_UNIT: 3,
};
EffectUnitTarget_Type.names = {
  0: "NONE",
  1: "TARGET_UNIT",
  2: "SOURCE_UNIT",
  3: "CASTER_UNIT",
};
export class EffectUnitTarget {
  get descriptor() {
    return EffectUnitTarget.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectUnitTarget) {
      return value;
    }
    return EffectUnitTarget.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectUnitTarget();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {EffectUnitTarget} other
   * @returns {EffectUnitTarget}
   */
  merge(other) {
    const copy = new EffectUnitTarget(this);
    return copy;
  }
}
EffectUnitTarget.default = new EffectUnitTarget();
EffectUnitTarget.Type = EffectUnitTarget_Type;
class EffectUnitTarget_Builder {
  constructor(value) {
    this._value = new EffectUnitTarget(value);
  }
  build() {
    return new EffectUnitTarget(this._value);
  }
}
EffectUnitTarget.Builder = EffectUnitTarget_Builder;
class EffectUnitTarget_WithParent {
  /**
   * @param {EffectUnitTarget} value
   * @param {EffectUnitTarget_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectUnitTarget.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new EffectUnitTarget_WithParent(current, parent);
    return result;
  }
}
EffectUnitTarget_WithParent.default = new EffectUnitTarget_WithParent(EffectUnitTarget.default, null);
EffectUnitTarget.WithParent = EffectUnitTarget_WithParent;
class EffectUnitTarget_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectUnitTarget.descriptor = new EffectUnitTarget_Descriptor();
class EffectTargetType_Type {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "UNIT": return 1;
        case "LOCATION": return 2;
        case "UNIT_OR_LOCATION": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectTargetType_Type.fromJson(value);
  }
  static fromReact(e) {
    return EffectTargetType_Type.fromJson(e);
  }
}
EffectTargetType_Type.NONE = 0;
EffectTargetType_Type.UNIT = 1;
EffectTargetType_Type.LOCATION = 2;
EffectTargetType_Type.UNIT_OR_LOCATION = 3;
EffectTargetType_Type.default = 0;
EffectTargetType_Type.values = {
  NONE: 0,
  UNIT: 1,
  LOCATION: 2,
  UNIT_OR_LOCATION: 3,
};
EffectTargetType_Type.names = {
  0: "NONE",
  1: "UNIT",
  2: "LOCATION",
  3: "UNIT_OR_LOCATION",
};
export class EffectTargetType {
  get descriptor() {
    return EffectTargetType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectTargetType) {
      return value;
    }
    return EffectTargetType.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectTargetType();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {EffectTargetType} other
   * @returns {EffectTargetType}
   */
  merge(other) {
    const copy = new EffectTargetType(this);
    return copy;
  }
}
EffectTargetType.default = new EffectTargetType();
EffectTargetType.Type = EffectTargetType_Type;
class EffectTargetType_Builder {
  constructor(value) {
    this._value = new EffectTargetType(value);
  }
  build() {
    return new EffectTargetType(this._value);
  }
}
EffectTargetType.Builder = EffectTargetType_Builder;
class EffectTargetType_WithParent {
  /**
   * @param {EffectTargetType} value
   * @param {EffectTargetType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectTargetType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new EffectTargetType_WithParent(current, parent);
    return result;
  }
}
EffectTargetType_WithParent.default = new EffectTargetType_WithParent(EffectTargetType.default, null);
EffectTargetType.WithParent = EffectTargetType_WithParent;
class EffectTargetType_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectTargetType.descriptor = new EffectTargetType_Descriptor();
export class Effect {
  get descriptor() {
    return Effect.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._parent = null;
    this._oneofEffectTypeCase = 0;
    this._oneofEffectTypeValue = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._oneofEffectTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Effect) {
      return value;
    }
    return Effect.fromJson(value);
  }
  static fromJson(json) {
    const result = new Effect();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.parent != null) {
      result._hasParent = true;
      result._parent = JsonToString.fromJson(json.parent);
    }
    if (json.launchMissile != null) {
      result._oneofEffectTypeCase = 2;
      result._oneofEffectTypeValue = EffectLaunchMissile.fromJson(json.launchMissile);
    }
    if (json.damage != null) {
      result._oneofEffectTypeCase = 3;
      result._oneofEffectTypeValue = EffectDamage.fromJson(json.damage);
    }
    if (json.areaSearch != null) {
      result._oneofEffectTypeCase = 4;
      result._oneofEffectTypeValue = EffectAreaSearch.fromJson(json.areaSearch);
    }
    if (json.persistent != null) {
      result._oneofEffectTypeCase = 5;
      result._oneofEffectTypeValue = EffectPersistent.fromJson(json.persistent);
    }
    if (json.kill != null) {
      result._oneofEffectTypeCase = 7;
      result._oneofEffectTypeValue = EffectKill.fromJson(json.kill);
    }
    if (json.spawn != null) {
      result._oneofEffectTypeCase = 8;
      result._oneofEffectTypeValue = EffectSpawn.fromJson(json.spawn);
    }
    if (json.spawnTroop != null) {
      result._oneofEffectTypeCase = 9;
      result._oneofEffectTypeValue = EffectSpawnTroop.fromJson(json.spawnTroop);
    }
    if (json.morph != null) {
      result._oneofEffectTypeCase = 10;
      result._oneofEffectTypeValue = EffectMorph.fromJson(json.morph);
    }
    if (json.morphTroop != null) {
      result._oneofEffectTypeCase = 11;
      result._oneofEffectTypeValue = EffectMorphTroop.fromJson(json.morphTroop);
    }
    if (json.applyBehavior != null) {
      result._oneofEffectTypeCase = 12;
      result._oneofEffectTypeValue = EffectApplyBehavior.fromJson(json.applyBehavior);
    }
    if (json.removeBehavior != null) {
      result._oneofEffectTypeCase = 13;
      result._oneofEffectTypeValue = EffectRemoveBehavior.fromJson(json.removeBehavior);
    }
    if (json.applyTag != null) {
      result._oneofEffectTypeCase = 14;
      result._oneofEffectTypeValue = EffectApplyTag.fromJson(json.applyTag);
    }
    if (json.removeTag != null) {
      result._oneofEffectTypeCase = 15;
      result._oneofEffectTypeValue = EffectRemoveTag.fromJson(json.removeTag);
    }
    if (json.switchEffect != null) {
      result._oneofEffectTypeCase = 16;
      result._oneofEffectTypeValue = EffectSwitch.fromJson(json.switchEffect);
    }
    if (json.setWaypoints != null) {
      result._oneofEffectTypeCase = 17;
      result._oneofEffectTypeValue = EffectSetWaypoints.fromJson(json.setWaypoints);
    }
    if (json.disengage != null) {
      result._oneofEffectTypeCase = 18;
      result._oneofEffectTypeValue = EffectDisengage.fromJson(json.disengage);
    }
    if (json.sell != null) {
      result._oneofEffectTypeCase = 19;
      result._oneofEffectTypeValue = EffectSell.fromJson(json.sell);
    }
    if (json.heal != null) {
      result._oneofEffectTypeCase = 20;
      result._oneofEffectTypeValue = EffectHeal.fromJson(json.heal);
    }
    if (json.addGold != null) {
      result._oneofEffectTypeCase = 21;
      result._oneofEffectTypeValue = EffectAddGold.fromJson(json.addGold);
    }
    if (json.teleport != null) {
      result._oneofEffectTypeCase = 22;
      result._oneofEffectTypeValue = EffectTeleport.fromJson(json.teleport);
    }
    if (json.teleportAlongWaypoint != null) {
      result._oneofEffectTypeCase = 23;
      result._oneofEffectTypeValue = EffectTeleportAlongWaypoint.fromJson(json.teleportAlongWaypoint);
    }
    if (json.setRallyPoint != null) {
      result._oneofEffectTypeCase = 24;
      result._oneofEffectTypeValue = EffectSetRallyPoint.fromJson(json.setRallyPoint);
    }
    if (json.set != null) {
      result._oneofEffectTypeCase = 25;
      result._oneofEffectTypeValue = EffectSet.fromJson(json.set);
    }
    if (json.enumerateUnitList != null) {
      result._oneofEffectTypeCase = 26;
      result._oneofEffectTypeValue = EffectEnumerateUnitList.fromJson(json.enumerateUnitList);
    }
    if (json.setBounty != null) {
      result._oneofEffectTypeCase = 27;
      result._oneofEffectTypeValue = EffectSetBounty.fromJson(json.setBounty);
    }
    if (json.remove != null) {
      result._oneofEffectTypeCase = 29;
      result._oneofEffectTypeValue = EffectRemove.fromJson(json.remove);
    }
    if (json.stop != null) {
      result._oneofEffectTypeCase = 30;
      result._oneofEffectTypeValue = EffectStop.fromJson(json.stop);
    }
    if (json.modifyUnit != null) {
      result._oneofEffectTypeCase = 31;
      result._oneofEffectTypeValue = EffectModifyUnit.fromJson(json.modifyUnit);
    }
    if (json.issueAbility != null) {
      result._oneofEffectTypeCase = 32;
      result._oneofEffectTypeValue = EffectIssueAbility.fromJson(json.issueAbility);
    }
    if (json.consumeMana != null) {
      result._oneofEffectTypeCase = 33;
      result._oneofEffectTypeValue = EffectConsumeMana.fromJson(json.consumeMana);
    }
    if (json.issueCommand != null) {
      result._oneofEffectTypeCase = 34;
      result._oneofEffectTypeValue = EffectIssueCommand.fromJson(json.issueCommand);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.parent = JsonToString.toJson(this._parent);
    }
    switch (this._oneofEffectTypeCase) {
      case 2:
        result.launchMissile = EffectLaunchMissile.toJson(this._oneofEffectTypeValue);
        break;
      case 3:
        result.damage = EffectDamage.toJson(this._oneofEffectTypeValue);
        break;
      case 4:
        result.areaSearch = EffectAreaSearch.toJson(this._oneofEffectTypeValue);
        break;
      case 5:
        result.persistent = EffectPersistent.toJson(this._oneofEffectTypeValue);
        break;
      case 7:
        result.kill = EffectKill.toJson(this._oneofEffectTypeValue);
        break;
      case 8:
        result.spawn = EffectSpawn.toJson(this._oneofEffectTypeValue);
        break;
      case 9:
        result.spawnTroop = EffectSpawnTroop.toJson(this._oneofEffectTypeValue);
        break;
      case 10:
        result.morph = EffectMorph.toJson(this._oneofEffectTypeValue);
        break;
      case 11:
        result.morphTroop = EffectMorphTroop.toJson(this._oneofEffectTypeValue);
        break;
      case 12:
        result.applyBehavior = EffectApplyBehavior.toJson(this._oneofEffectTypeValue);
        break;
      case 13:
        result.removeBehavior = EffectRemoveBehavior.toJson(this._oneofEffectTypeValue);
        break;
      case 14:
        result.applyTag = EffectApplyTag.toJson(this._oneofEffectTypeValue);
        break;
      case 15:
        result.removeTag = EffectRemoveTag.toJson(this._oneofEffectTypeValue);
        break;
      case 16:
        result.switchEffect = EffectSwitch.toJson(this._oneofEffectTypeValue);
        break;
      case 17:
        result.setWaypoints = EffectSetWaypoints.toJson(this._oneofEffectTypeValue);
        break;
      case 18:
        result.disengage = EffectDisengage.toJson(this._oneofEffectTypeValue);
        break;
      case 19:
        result.sell = EffectSell.toJson(this._oneofEffectTypeValue);
        break;
      case 20:
        result.heal = EffectHeal.toJson(this._oneofEffectTypeValue);
        break;
      case 21:
        result.addGold = EffectAddGold.toJson(this._oneofEffectTypeValue);
        break;
      case 22:
        result.teleport = EffectTeleport.toJson(this._oneofEffectTypeValue);
        break;
      case 23:
        result.teleportAlongWaypoint = EffectTeleportAlongWaypoint.toJson(this._oneofEffectTypeValue);
        break;
      case 24:
        result.setRallyPoint = EffectSetRallyPoint.toJson(this._oneofEffectTypeValue);
        break;
      case 25:
        result.set = EffectSet.toJson(this._oneofEffectTypeValue);
        break;
      case 26:
        result.enumerateUnitList = EffectEnumerateUnitList.toJson(this._oneofEffectTypeValue);
        break;
      case 27:
        result.setBounty = EffectSetBounty.toJson(this._oneofEffectTypeValue);
        break;
      case 29:
        result.remove = EffectRemove.toJson(this._oneofEffectTypeValue);
        break;
      case 30:
        result.stop = EffectStop.toJson(this._oneofEffectTypeValue);
        break;
      case 31:
        result.modifyUnit = EffectModifyUnit.toJson(this._oneofEffectTypeValue);
        break;
      case 32:
        result.issueAbility = EffectIssueAbility.toJson(this._oneofEffectTypeValue);
        break;
      case 33:
        result.consumeMana = EffectConsumeMana.toJson(this._oneofEffectTypeValue);
        break;
      case 34:
        result.issueCommand = EffectIssueCommand.toJson(this._oneofEffectTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get parent() {
    return this._hasParent ? this._parent : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['parent']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['parent'])};
  }
  get oneofEffectTypeCase() {
    return this._oneofEffectTypeCase;
  }
  deleteOneofEffectType(path) {
    switch (this._oneofEffectTypeCase) {
      default:
      case 2: {
        return {type: 'DELETE', path: path.concat(['launchMissile'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['damage'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['areaSearch'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['persistent'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['kill'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['spawn'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['spawnTroop'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['morph'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['morphTroop'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['applyBehavior'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['removeBehavior'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['applyTag'])};
      }
      case 15: {
        return {type: 'DELETE', path: path.concat(['removeTag'])};
      }
      case 16: {
        return {type: 'DELETE', path: path.concat(['switchEffect'])};
      }
      case 17: {
        return {type: 'DELETE', path: path.concat(['setWaypoints'])};
      }
      case 18: {
        return {type: 'DELETE', path: path.concat(['disengage'])};
      }
      case 19: {
        return {type: 'DELETE', path: path.concat(['sell'])};
      }
      case 20: {
        return {type: 'DELETE', path: path.concat(['heal'])};
      }
      case 21: {
        return {type: 'DELETE', path: path.concat(['addGold'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['teleport'])};
      }
      case 23: {
        return {type: 'DELETE', path: path.concat(['teleportAlongWaypoint'])};
      }
      case 24: {
        return {type: 'DELETE', path: path.concat(['setRallyPoint'])};
      }
      case 25: {
        return {type: 'DELETE', path: path.concat(['set'])};
      }
      case 26: {
        return {type: 'DELETE', path: path.concat(['enumerateUnitList'])};
      }
      case 27: {
        return {type: 'DELETE', path: path.concat(['setBounty'])};
      }
      case 29: {
        return {type: 'DELETE', path: path.concat(['remove'])};
      }
      case 30: {
        return {type: 'DELETE', path: path.concat(['stop'])};
      }
      case 31: {
        return {type: 'DELETE', path: path.concat(['modifyUnit'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['issueAbility'])};
      }
      case 33: {
        return {type: 'DELETE', path: path.concat(['consumeMana'])};
      }
      case 34: {
        return {type: 'DELETE', path: path.concat(['issueCommand'])};
      }
    }
  }
  /**
   * @returns {EffectLaunchMissile}
   */
  get launchMissile() {
    return this._oneofEffectTypeCase === 2 ? this._oneofEffectTypeValue : EffectLaunchMissile.default;
  }
  setLaunchMissile(path, value) {
    return {type: 'SET', path: path.concat(['launchMissile']), value: value.toJson()};
  }
  deleteLaunchMissile(path) {
    return {type: 'DELETE', path: path.concat(['launchMissile'])};
  }
  /**
   * @returns {EffectDamage}
   */
  get damage() {
    return this._oneofEffectTypeCase === 3 ? this._oneofEffectTypeValue : EffectDamage.default;
  }
  setDamage(path, value) {
    return {type: 'SET', path: path.concat(['damage']), value: value.toJson()};
  }
  deleteDamage(path) {
    return {type: 'DELETE', path: path.concat(['damage'])};
  }
  /**
   * @returns {EffectAreaSearch}
   */
  get areaSearch() {
    return this._oneofEffectTypeCase === 4 ? this._oneofEffectTypeValue : EffectAreaSearch.default;
  }
  setAreaSearch(path, value) {
    return {type: 'SET', path: path.concat(['areaSearch']), value: value.toJson()};
  }
  deleteAreaSearch(path) {
    return {type: 'DELETE', path: path.concat(['areaSearch'])};
  }
  /**
   * @returns {EffectPersistent}
   */
  get persistent() {
    return this._oneofEffectTypeCase === 5 ? this._oneofEffectTypeValue : EffectPersistent.default;
  }
  setPersistent(path, value) {
    return {type: 'SET', path: path.concat(['persistent']), value: value.toJson()};
  }
  deletePersistent(path) {
    return {type: 'DELETE', path: path.concat(['persistent'])};
  }
  /**
   * @returns {EffectKill}
   */
  get kill() {
    return this._oneofEffectTypeCase === 7 ? this._oneofEffectTypeValue : EffectKill.default;
  }
  setKill(path, value) {
    return {type: 'SET', path: path.concat(['kill']), value: value.toJson()};
  }
  deleteKill(path) {
    return {type: 'DELETE', path: path.concat(['kill'])};
  }
  /**
   * @returns {EffectSpawn}
   */
  get spawn() {
    return this._oneofEffectTypeCase === 8 ? this._oneofEffectTypeValue : EffectSpawn.default;
  }
  setSpawn(path, value) {
    return {type: 'SET', path: path.concat(['spawn']), value: value.toJson()};
  }
  deleteSpawn(path) {
    return {type: 'DELETE', path: path.concat(['spawn'])};
  }
  /**
   * @returns {EffectSpawnTroop}
   */
  get spawnTroop() {
    return this._oneofEffectTypeCase === 9 ? this._oneofEffectTypeValue : EffectSpawnTroop.default;
  }
  setSpawnTroop(path, value) {
    return {type: 'SET', path: path.concat(['spawnTroop']), value: value.toJson()};
  }
  deleteSpawnTroop(path) {
    return {type: 'DELETE', path: path.concat(['spawnTroop'])};
  }
  /**
   * @returns {EffectMorph}
   */
  get morph() {
    return this._oneofEffectTypeCase === 10 ? this._oneofEffectTypeValue : EffectMorph.default;
  }
  setMorph(path, value) {
    return {type: 'SET', path: path.concat(['morph']), value: value.toJson()};
  }
  deleteMorph(path) {
    return {type: 'DELETE', path: path.concat(['morph'])};
  }
  /**
   * @returns {EffectMorphTroop}
   */
  get morphTroop() {
    return this._oneofEffectTypeCase === 11 ? this._oneofEffectTypeValue : EffectMorphTroop.default;
  }
  setMorphTroop(path, value) {
    return {type: 'SET', path: path.concat(['morphTroop']), value: value.toJson()};
  }
  deleteMorphTroop(path) {
    return {type: 'DELETE', path: path.concat(['morphTroop'])};
  }
  /**
   * @returns {EffectApplyBehavior}
   */
  get applyBehavior() {
    return this._oneofEffectTypeCase === 12 ? this._oneofEffectTypeValue : EffectApplyBehavior.default;
  }
  setApplyBehavior(path, value) {
    return {type: 'SET', path: path.concat(['applyBehavior']), value: value.toJson()};
  }
  deleteApplyBehavior(path) {
    return {type: 'DELETE', path: path.concat(['applyBehavior'])};
  }
  /**
   * @returns {EffectRemoveBehavior}
   */
  get removeBehavior() {
    return this._oneofEffectTypeCase === 13 ? this._oneofEffectTypeValue : EffectRemoveBehavior.default;
  }
  setRemoveBehavior(path, value) {
    return {type: 'SET', path: path.concat(['removeBehavior']), value: value.toJson()};
  }
  deleteRemoveBehavior(path) {
    return {type: 'DELETE', path: path.concat(['removeBehavior'])};
  }
  /**
   * @returns {EffectApplyTag}
   */
  get applyTag() {
    return this._oneofEffectTypeCase === 14 ? this._oneofEffectTypeValue : EffectApplyTag.default;
  }
  setApplyTag(path, value) {
    return {type: 'SET', path: path.concat(['applyTag']), value: value.toJson()};
  }
  deleteApplyTag(path) {
    return {type: 'DELETE', path: path.concat(['applyTag'])};
  }
  /**
   * @returns {EffectRemoveTag}
   */
  get removeTag() {
    return this._oneofEffectTypeCase === 15 ? this._oneofEffectTypeValue : EffectRemoveTag.default;
  }
  setRemoveTag(path, value) {
    return {type: 'SET', path: path.concat(['removeTag']), value: value.toJson()};
  }
  deleteRemoveTag(path) {
    return {type: 'DELETE', path: path.concat(['removeTag'])};
  }
  /**
   * @returns {EffectSwitch}
   */
  get switchEffect() {
    return this._oneofEffectTypeCase === 16 ? this._oneofEffectTypeValue : EffectSwitch.default;
  }
  setSwitchEffect(path, value) {
    return {type: 'SET', path: path.concat(['switchEffect']), value: value.toJson()};
  }
  deleteSwitchEffect(path) {
    return {type: 'DELETE', path: path.concat(['switchEffect'])};
  }
  /**
   * @returns {EffectSetWaypoints}
   */
  get setWaypoints() {
    return this._oneofEffectTypeCase === 17 ? this._oneofEffectTypeValue : EffectSetWaypoints.default;
  }
  setSetWaypoints(path, value) {
    return {type: 'SET', path: path.concat(['setWaypoints']), value: value.toJson()};
  }
  deleteSetWaypoints(path) {
    return {type: 'DELETE', path: path.concat(['setWaypoints'])};
  }
  /**
   * @returns {EffectDisengage}
   */
  get disengage() {
    return this._oneofEffectTypeCase === 18 ? this._oneofEffectTypeValue : EffectDisengage.default;
  }
  setDisengage(path, value) {
    return {type: 'SET', path: path.concat(['disengage']), value: value.toJson()};
  }
  deleteDisengage(path) {
    return {type: 'DELETE', path: path.concat(['disengage'])};
  }
  /**
   * @returns {EffectSell}
   */
  get sell() {
    return this._oneofEffectTypeCase === 19 ? this._oneofEffectTypeValue : EffectSell.default;
  }
  setSell(path, value) {
    return {type: 'SET', path: path.concat(['sell']), value: value.toJson()};
  }
  deleteSell(path) {
    return {type: 'DELETE', path: path.concat(['sell'])};
  }
  /**
   * @returns {EffectHeal}
   */
  get heal() {
    return this._oneofEffectTypeCase === 20 ? this._oneofEffectTypeValue : EffectHeal.default;
  }
  setHeal(path, value) {
    return {type: 'SET', path: path.concat(['heal']), value: value.toJson()};
  }
  deleteHeal(path) {
    return {type: 'DELETE', path: path.concat(['heal'])};
  }
  /**
   * @returns {EffectAddGold}
   */
  get addGold() {
    return this._oneofEffectTypeCase === 21 ? this._oneofEffectTypeValue : EffectAddGold.default;
  }
  setAddGold(path, value) {
    return {type: 'SET', path: path.concat(['addGold']), value: value.toJson()};
  }
  deleteAddGold(path) {
    return {type: 'DELETE', path: path.concat(['addGold'])};
  }
  /**
   * @returns {EffectTeleport}
   */
  get teleport() {
    return this._oneofEffectTypeCase === 22 ? this._oneofEffectTypeValue : EffectTeleport.default;
  }
  setTeleport(path, value) {
    return {type: 'SET', path: path.concat(['teleport']), value: value.toJson()};
  }
  deleteTeleport(path) {
    return {type: 'DELETE', path: path.concat(['teleport'])};
  }
  /**
   * @returns {EffectTeleportAlongWaypoint}
   */
  get teleportAlongWaypoint() {
    return this._oneofEffectTypeCase === 23 ? this._oneofEffectTypeValue : EffectTeleportAlongWaypoint.default;
  }
  setTeleportAlongWaypoint(path, value) {
    return {type: 'SET', path: path.concat(['teleportAlongWaypoint']), value: value.toJson()};
  }
  deleteTeleportAlongWaypoint(path) {
    return {type: 'DELETE', path: path.concat(['teleportAlongWaypoint'])};
  }
  /**
   * @returns {EffectSetRallyPoint}
   */
  get setRallyPoint() {
    return this._oneofEffectTypeCase === 24 ? this._oneofEffectTypeValue : EffectSetRallyPoint.default;
  }
  setSetRallyPoint(path, value) {
    return {type: 'SET', path: path.concat(['setRallyPoint']), value: value.toJson()};
  }
  deleteSetRallyPoint(path) {
    return {type: 'DELETE', path: path.concat(['setRallyPoint'])};
  }
  /**
   * @returns {EffectSet}
   */
  get set() {
    return this._oneofEffectTypeCase === 25 ? this._oneofEffectTypeValue : EffectSet.default;
  }
  setSet(path, value) {
    return {type: 'SET', path: path.concat(['set']), value: value.toJson()};
  }
  deleteSet(path) {
    return {type: 'DELETE', path: path.concat(['set'])};
  }
  /**
   * @returns {EffectEnumerateUnitList}
   */
  get enumerateUnitList() {
    return this._oneofEffectTypeCase === 26 ? this._oneofEffectTypeValue : EffectEnumerateUnitList.default;
  }
  setEnumerateUnitList(path, value) {
    return {type: 'SET', path: path.concat(['enumerateUnitList']), value: value.toJson()};
  }
  deleteEnumerateUnitList(path) {
    return {type: 'DELETE', path: path.concat(['enumerateUnitList'])};
  }
  /**
   * @returns {EffectSetBounty}
   */
  get setBounty() {
    return this._oneofEffectTypeCase === 27 ? this._oneofEffectTypeValue : EffectSetBounty.default;
  }
  setSetBounty(path, value) {
    return {type: 'SET', path: path.concat(['setBounty']), value: value.toJson()};
  }
  deleteSetBounty(path) {
    return {type: 'DELETE', path: path.concat(['setBounty'])};
  }
  /**
   * @returns {EffectRemove}
   */
  get remove() {
    return this._oneofEffectTypeCase === 29 ? this._oneofEffectTypeValue : EffectRemove.default;
  }
  setRemove(path, value) {
    return {type: 'SET', path: path.concat(['remove']), value: value.toJson()};
  }
  deleteRemove(path) {
    return {type: 'DELETE', path: path.concat(['remove'])};
  }
  /**
   * @returns {EffectStop}
   */
  get stop() {
    return this._oneofEffectTypeCase === 30 ? this._oneofEffectTypeValue : EffectStop.default;
  }
  setStop(path, value) {
    return {type: 'SET', path: path.concat(['stop']), value: value.toJson()};
  }
  deleteStop(path) {
    return {type: 'DELETE', path: path.concat(['stop'])};
  }
  /**
   * @returns {EffectModifyUnit}
   */
  get modifyUnit() {
    return this._oneofEffectTypeCase === 31 ? this._oneofEffectTypeValue : EffectModifyUnit.default;
  }
  setModifyUnit(path, value) {
    return {type: 'SET', path: path.concat(['modifyUnit']), value: value.toJson()};
  }
  deleteModifyUnit(path) {
    return {type: 'DELETE', path: path.concat(['modifyUnit'])};
  }
  /**
   * @returns {EffectIssueAbility}
   */
  get issueAbility() {
    return this._oneofEffectTypeCase === 32 ? this._oneofEffectTypeValue : EffectIssueAbility.default;
  }
  setIssueAbility(path, value) {
    return {type: 'SET', path: path.concat(['issueAbility']), value: value.toJson()};
  }
  deleteIssueAbility(path) {
    return {type: 'DELETE', path: path.concat(['issueAbility'])};
  }
  /**
   * @returns {EffectConsumeMana}
   */
  get consumeMana() {
    return this._oneofEffectTypeCase === 33 ? this._oneofEffectTypeValue : EffectConsumeMana.default;
  }
  setConsumeMana(path, value) {
    return {type: 'SET', path: path.concat(['consumeMana']), value: value.toJson()};
  }
  deleteConsumeMana(path) {
    return {type: 'DELETE', path: path.concat(['consumeMana'])};
  }
  /**
   * @returns {EffectIssueCommand}
   */
  get issueCommand() {
    return this._oneofEffectTypeCase === 34 ? this._oneofEffectTypeValue : EffectIssueCommand.default;
  }
  setIssueCommand(path, value) {
    return {type: 'SET', path: path.concat(['issueCommand']), value: value.toJson()};
  }
  deleteIssueCommand(path) {
    return {type: 'DELETE', path: path.concat(['issueCommand'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Effect(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Effect(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Effect(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._hasParent = true;
              copy._parent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Effect(this);
              copy._hasParent = false;
              copy._parent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchMissile": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 2;
              copy._oneofEffectTypeValue = EffectLaunchMissile.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 2) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 2) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 2;
            copy._oneofEffectTypeValue = EffectLaunchMissile.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.launchMissile.apply(type, path.slice(1), value);
          if (newValue === this.launchMissile) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 2;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "damage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 3;
              copy._oneofEffectTypeValue = EffectDamage.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 3) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 3) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 3;
            copy._oneofEffectTypeValue = EffectDamage.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.damage.apply(type, path.slice(1), value);
          if (newValue === this.damage) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 3;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "areaSearch": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 4;
              copy._oneofEffectTypeValue = EffectAreaSearch.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 4) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 4) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 4;
            copy._oneofEffectTypeValue = EffectAreaSearch.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.areaSearch.apply(type, path.slice(1), value);
          if (newValue === this.areaSearch) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 4;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "persistent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 5;
              copy._oneofEffectTypeValue = EffectPersistent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 5) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 5) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 5;
            copy._oneofEffectTypeValue = EffectPersistent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.persistent.apply(type, path.slice(1), value);
          if (newValue === this.persistent) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 5;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "kill": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 7;
              copy._oneofEffectTypeValue = EffectKill.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 7) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 7) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 7;
            copy._oneofEffectTypeValue = EffectKill.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.kill.apply(type, path.slice(1), value);
          if (newValue === this.kill) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 7;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "spawn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 8;
              copy._oneofEffectTypeValue = EffectSpawn.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 8) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 8) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 8;
            copy._oneofEffectTypeValue = EffectSpawn.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.spawn.apply(type, path.slice(1), value);
          if (newValue === this.spawn) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 8;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "spawnTroop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 9;
              copy._oneofEffectTypeValue = EffectSpawnTroop.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 9) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 9) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 9;
            copy._oneofEffectTypeValue = EffectSpawnTroop.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.spawnTroop.apply(type, path.slice(1), value);
          if (newValue === this.spawnTroop) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 9;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "morph": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 10;
              copy._oneofEffectTypeValue = EffectMorph.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 10) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 10) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 10;
            copy._oneofEffectTypeValue = EffectMorph.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.morph.apply(type, path.slice(1), value);
          if (newValue === this.morph) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 10;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "morphTroop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 11;
              copy._oneofEffectTypeValue = EffectMorphTroop.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 11) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 11) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 11;
            copy._oneofEffectTypeValue = EffectMorphTroop.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.morphTroop.apply(type, path.slice(1), value);
          if (newValue === this.morphTroop) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 11;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "applyBehavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 12;
              copy._oneofEffectTypeValue = EffectApplyBehavior.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 12) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 12) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 12;
            copy._oneofEffectTypeValue = EffectApplyBehavior.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.applyBehavior.apply(type, path.slice(1), value);
          if (newValue === this.applyBehavior) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 12;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "removeBehavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 13;
              copy._oneofEffectTypeValue = EffectRemoveBehavior.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 13) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 13) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 13;
            copy._oneofEffectTypeValue = EffectRemoveBehavior.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.removeBehavior.apply(type, path.slice(1), value);
          if (newValue === this.removeBehavior) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 13;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "applyTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 14;
              copy._oneofEffectTypeValue = EffectApplyTag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 14) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 14) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 14;
            copy._oneofEffectTypeValue = EffectApplyTag.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.applyTag.apply(type, path.slice(1), value);
          if (newValue === this.applyTag) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 14;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "removeTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 15;
              copy._oneofEffectTypeValue = EffectRemoveTag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 15) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 15) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 15;
            copy._oneofEffectTypeValue = EffectRemoveTag.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.removeTag.apply(type, path.slice(1), value);
          if (newValue === this.removeTag) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 15;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "switchEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 16;
              copy._oneofEffectTypeValue = EffectSwitch.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 16) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 16) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 16;
            copy._oneofEffectTypeValue = EffectSwitch.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.switchEffect.apply(type, path.slice(1), value);
          if (newValue === this.switchEffect) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 16;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "setWaypoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 17;
              copy._oneofEffectTypeValue = EffectSetWaypoints.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 17) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 17) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 17;
            copy._oneofEffectTypeValue = EffectSetWaypoints.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setWaypoints.apply(type, path.slice(1), value);
          if (newValue === this.setWaypoints) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 17;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "disengage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 18;
              copy._oneofEffectTypeValue = EffectDisengage.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 18) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 18) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 18;
            copy._oneofEffectTypeValue = EffectDisengage.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.disengage.apply(type, path.slice(1), value);
          if (newValue === this.disengage) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 18;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "sell": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 19;
              copy._oneofEffectTypeValue = EffectSell.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 19) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 19) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 19;
            copy._oneofEffectTypeValue = EffectSell.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.sell.apply(type, path.slice(1), value);
          if (newValue === this.sell) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 19;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "heal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 20;
              copy._oneofEffectTypeValue = EffectHeal.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 20) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 20) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 20;
            copy._oneofEffectTypeValue = EffectHeal.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.heal.apply(type, path.slice(1), value);
          if (newValue === this.heal) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 20;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "addGold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 21;
              copy._oneofEffectTypeValue = EffectAddGold.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 21) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 21) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 21;
            copy._oneofEffectTypeValue = EffectAddGold.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.addGold.apply(type, path.slice(1), value);
          if (newValue === this.addGold) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 21;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "teleport": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 22;
              copy._oneofEffectTypeValue = EffectTeleport.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 22) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 22) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 22;
            copy._oneofEffectTypeValue = EffectTeleport.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.teleport.apply(type, path.slice(1), value);
          if (newValue === this.teleport) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 22;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "teleportAlongWaypoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 23;
              copy._oneofEffectTypeValue = EffectTeleportAlongWaypoint.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 23) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 23) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 23;
            copy._oneofEffectTypeValue = EffectTeleportAlongWaypoint.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.teleportAlongWaypoint.apply(type, path.slice(1), value);
          if (newValue === this.teleportAlongWaypoint) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 23;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "setRallyPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 24;
              copy._oneofEffectTypeValue = EffectSetRallyPoint.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 24) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 24) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 24;
            copy._oneofEffectTypeValue = EffectSetRallyPoint.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setRallyPoint.apply(type, path.slice(1), value);
          if (newValue === this.setRallyPoint) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 24;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "set": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 25;
              copy._oneofEffectTypeValue = EffectSet.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 25) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 25) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 25;
            copy._oneofEffectTypeValue = EffectSet.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.set.apply(type, path.slice(1), value);
          if (newValue === this.set) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 25;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "enumerateUnitList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 26;
              copy._oneofEffectTypeValue = EffectEnumerateUnitList.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 26) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 26) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 26;
            copy._oneofEffectTypeValue = EffectEnumerateUnitList.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.enumerateUnitList.apply(type, path.slice(1), value);
          if (newValue === this.enumerateUnitList) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 26;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "setBounty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 27;
              copy._oneofEffectTypeValue = EffectSetBounty.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 27) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 27) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 27;
            copy._oneofEffectTypeValue = EffectSetBounty.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setBounty.apply(type, path.slice(1), value);
          if (newValue === this.setBounty) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 27;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "remove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 29;
              copy._oneofEffectTypeValue = EffectRemove.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 29) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 29) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 29;
            copy._oneofEffectTypeValue = EffectRemove.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.remove.apply(type, path.slice(1), value);
          if (newValue === this.remove) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 29;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "stop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 30;
              copy._oneofEffectTypeValue = EffectStop.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 30) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 30) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 30;
            copy._oneofEffectTypeValue = EffectStop.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.stop.apply(type, path.slice(1), value);
          if (newValue === this.stop) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 30;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "modifyUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 31;
              copy._oneofEffectTypeValue = EffectModifyUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 31) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 31) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 31;
            copy._oneofEffectTypeValue = EffectModifyUnit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modifyUnit.apply(type, path.slice(1), value);
          if (newValue === this.modifyUnit) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 31;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "issueAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 32;
              copy._oneofEffectTypeValue = EffectIssueAbility.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 32) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 32) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 32;
            copy._oneofEffectTypeValue = EffectIssueAbility.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.issueAbility.apply(type, path.slice(1), value);
          if (newValue === this.issueAbility) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 32;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "consumeMana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 33;
              copy._oneofEffectTypeValue = EffectConsumeMana.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 33) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 33) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 33;
            copy._oneofEffectTypeValue = EffectConsumeMana.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.consumeMana.apply(type, path.slice(1), value);
          if (newValue === this.consumeMana) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 33;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      case "issueCommand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 34;
              copy._oneofEffectTypeValue = EffectIssueCommand.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofEffectTypeCase !== 34) {
                return this;
              }
              const copy = new Effect(this);
              copy._oneofEffectTypeCase = 0;
              copy._oneofEffectTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofEffectTypeCase !== 34) {
            const copy = new Effect(this);
            copy._oneofEffectTypeCase = 34;
            copy._oneofEffectTypeValue = EffectIssueCommand.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.issueCommand.apply(type, path.slice(1), value);
          if (newValue === this.issueCommand) {
            return this;
          }
          const copy = new Effect(this);
          copy._oneofEffectTypeCase = 34;
          copy._oneofEffectTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Effect} other
   * @returns {Effect}
   */
  merge(other) {
    const copy = new Effect(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._parent = other._parent;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    if (other._oneofEffectTypeCase === 2) {
      if (this._oneofEffectTypeCase === 2) {
        copy._oneofEffectTypeValue = copy._oneofEffectTypeValue.merge(other._oneofEffectTypeValue);
      } else {
        copy._oneofEffectTypeValue = other._oneofEffectTypeValue;
      }
      copy._oneofEffectTypeCase = 2;
    }
    return copy;
  }
}
Effect.default = new Effect();
class Effect_Builder {
  constructor(value) {
    this._value = new Effect(value);
  }
  build() {
    return new Effect(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._parent = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._parent = null;
    return this;
  }
  clearoneofEffectType() {
    this._value._oneofEffectTypeCase = 0;
    this._value._oneofEffectTypeValue = null;
    return this;
  }
  setLaunchMissile(value) {
    this._value._oneofEffectTypeCase = 2;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setDamage(value) {
    this._value._oneofEffectTypeCase = 3;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setAreaSearch(value) {
    this._value._oneofEffectTypeCase = 4;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setPersistent(value) {
    this._value._oneofEffectTypeCase = 5;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setKill(value) {
    this._value._oneofEffectTypeCase = 7;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSpawn(value) {
    this._value._oneofEffectTypeCase = 8;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSpawnTroop(value) {
    this._value._oneofEffectTypeCase = 9;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setMorph(value) {
    this._value._oneofEffectTypeCase = 10;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setMorphTroop(value) {
    this._value._oneofEffectTypeCase = 11;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setApplyBehavior(value) {
    this._value._oneofEffectTypeCase = 12;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setRemoveBehavior(value) {
    this._value._oneofEffectTypeCase = 13;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setApplyTag(value) {
    this._value._oneofEffectTypeCase = 14;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setRemoveTag(value) {
    this._value._oneofEffectTypeCase = 15;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSwitchEffect(value) {
    this._value._oneofEffectTypeCase = 16;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSetWaypoints(value) {
    this._value._oneofEffectTypeCase = 17;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setDisengage(value) {
    this._value._oneofEffectTypeCase = 18;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSell(value) {
    this._value._oneofEffectTypeCase = 19;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setHeal(value) {
    this._value._oneofEffectTypeCase = 20;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setAddGold(value) {
    this._value._oneofEffectTypeCase = 21;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setTeleport(value) {
    this._value._oneofEffectTypeCase = 22;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setTeleportAlongWaypoint(value) {
    this._value._oneofEffectTypeCase = 23;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSetRallyPoint(value) {
    this._value._oneofEffectTypeCase = 24;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSet(value) {
    this._value._oneofEffectTypeCase = 25;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setEnumerateUnitList(value) {
    this._value._oneofEffectTypeCase = 26;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setSetBounty(value) {
    this._value._oneofEffectTypeCase = 27;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setRemove(value) {
    this._value._oneofEffectTypeCase = 29;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setStop(value) {
    this._value._oneofEffectTypeCase = 30;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setModifyUnit(value) {
    this._value._oneofEffectTypeCase = 31;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setIssueAbility(value) {
    this._value._oneofEffectTypeCase = 32;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setConsumeMana(value) {
    this._value._oneofEffectTypeCase = 33;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
  setIssueCommand(value) {
    this._value._oneofEffectTypeCase = 34;
    this._value._oneofEffectTypeValue = value;
    return this;
  }
}
Effect.Builder = Effect_Builder;
class Effect_WithParent {
  /**
   * @param {Effect} value
   * @param {Effect_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Effect.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get parent() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.parent;
      } else {
        this._cachedParent = this._parent ? this._parent.parent : this._value.parent;
      }
    }
    return this._cachedParent;
  }
  get oneofEffectTypeCase() {
    if (this._cachedoneofEffectTypeCase === undefined) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedoneofEffectTypeCase = this._parent ? this._parent.oneofEffectTypeCase : 0;
      } else {
        this._cachedoneofEffectTypeCase = this._value._oneofEffectTypeCase;
      }
    }
    return this._cachedoneofEffectTypeCase;
  }
  get launchMissile() {
    if (!this._cachedLaunchMissile) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedLaunchMissile = this._parent ? new EffectLaunchMissile.WithParent(EffectLaunchMissile.default, this._parent.launchMissile) : this._value.launchMissile;
      } else if (this._value._oneofEffectTypeCase === 2) {
        this._cachedLaunchMissile = new EffectLaunchMissile.WithParent(this._value.launchMissile, this._parent && this._parent.oneofEffectTypeCase === 2 ? this._parent.launchMissile : null);
      } else {
        this._cachedLaunchMissile = EffectLaunchMissile.WithParent.default;
      }
    }
    return this._cachedLaunchMissile;
  }
  get damage() {
    if (!this._cachedDamage) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedDamage = this._parent ? new EffectDamage.WithParent(EffectDamage.default, this._parent.damage) : this._value.damage;
      } else if (this._value._oneofEffectTypeCase === 3) {
        this._cachedDamage = new EffectDamage.WithParent(this._value.damage, this._parent && this._parent.oneofEffectTypeCase === 3 ? this._parent.damage : null);
      } else {
        this._cachedDamage = EffectDamage.WithParent.default;
      }
    }
    return this._cachedDamage;
  }
  get areaSearch() {
    if (!this._cachedAreaSearch) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedAreaSearch = this._parent ? new EffectAreaSearch.WithParent(EffectAreaSearch.default, this._parent.areaSearch) : this._value.areaSearch;
      } else if (this._value._oneofEffectTypeCase === 4) {
        this._cachedAreaSearch = new EffectAreaSearch.WithParent(this._value.areaSearch, this._parent && this._parent.oneofEffectTypeCase === 4 ? this._parent.areaSearch : null);
      } else {
        this._cachedAreaSearch = EffectAreaSearch.WithParent.default;
      }
    }
    return this._cachedAreaSearch;
  }
  get persistent() {
    if (!this._cachedPersistent) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedPersistent = this._parent ? new EffectPersistent.WithParent(EffectPersistent.default, this._parent.persistent) : this._value.persistent;
      } else if (this._value._oneofEffectTypeCase === 5) {
        this._cachedPersistent = new EffectPersistent.WithParent(this._value.persistent, this._parent && this._parent.oneofEffectTypeCase === 5 ? this._parent.persistent : null);
      } else {
        this._cachedPersistent = EffectPersistent.WithParent.default;
      }
    }
    return this._cachedPersistent;
  }
  get kill() {
    if (!this._cachedKill) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedKill = this._parent ? new EffectKill.WithParent(EffectKill.default, this._parent.kill) : this._value.kill;
      } else if (this._value._oneofEffectTypeCase === 7) {
        this._cachedKill = new EffectKill.WithParent(this._value.kill, this._parent && this._parent.oneofEffectTypeCase === 7 ? this._parent.kill : null);
      } else {
        this._cachedKill = EffectKill.WithParent.default;
      }
    }
    return this._cachedKill;
  }
  get spawn() {
    if (!this._cachedSpawn) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSpawn = this._parent ? new EffectSpawn.WithParent(EffectSpawn.default, this._parent.spawn) : this._value.spawn;
      } else if (this._value._oneofEffectTypeCase === 8) {
        this._cachedSpawn = new EffectSpawn.WithParent(this._value.spawn, this._parent && this._parent.oneofEffectTypeCase === 8 ? this._parent.spawn : null);
      } else {
        this._cachedSpawn = EffectSpawn.WithParent.default;
      }
    }
    return this._cachedSpawn;
  }
  get spawnTroop() {
    if (!this._cachedSpawnTroop) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSpawnTroop = this._parent ? new EffectSpawnTroop.WithParent(EffectSpawnTroop.default, this._parent.spawnTroop) : this._value.spawnTroop;
      } else if (this._value._oneofEffectTypeCase === 9) {
        this._cachedSpawnTroop = new EffectSpawnTroop.WithParent(this._value.spawnTroop, this._parent && this._parent.oneofEffectTypeCase === 9 ? this._parent.spawnTroop : null);
      } else {
        this._cachedSpawnTroop = EffectSpawnTroop.WithParent.default;
      }
    }
    return this._cachedSpawnTroop;
  }
  get morph() {
    if (!this._cachedMorph) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedMorph = this._parent ? new EffectMorph.WithParent(EffectMorph.default, this._parent.morph) : this._value.morph;
      } else if (this._value._oneofEffectTypeCase === 10) {
        this._cachedMorph = new EffectMorph.WithParent(this._value.morph, this._parent && this._parent.oneofEffectTypeCase === 10 ? this._parent.morph : null);
      } else {
        this._cachedMorph = EffectMorph.WithParent.default;
      }
    }
    return this._cachedMorph;
  }
  get morphTroop() {
    if (!this._cachedMorphTroop) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedMorphTroop = this._parent ? new EffectMorphTroop.WithParent(EffectMorphTroop.default, this._parent.morphTroop) : this._value.morphTroop;
      } else if (this._value._oneofEffectTypeCase === 11) {
        this._cachedMorphTroop = new EffectMorphTroop.WithParent(this._value.morphTroop, this._parent && this._parent.oneofEffectTypeCase === 11 ? this._parent.morphTroop : null);
      } else {
        this._cachedMorphTroop = EffectMorphTroop.WithParent.default;
      }
    }
    return this._cachedMorphTroop;
  }
  get applyBehavior() {
    if (!this._cachedApplyBehavior) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedApplyBehavior = this._parent ? new EffectApplyBehavior.WithParent(EffectApplyBehavior.default, this._parent.applyBehavior) : this._value.applyBehavior;
      } else if (this._value._oneofEffectTypeCase === 12) {
        this._cachedApplyBehavior = new EffectApplyBehavior.WithParent(this._value.applyBehavior, this._parent && this._parent.oneofEffectTypeCase === 12 ? this._parent.applyBehavior : null);
      } else {
        this._cachedApplyBehavior = EffectApplyBehavior.WithParent.default;
      }
    }
    return this._cachedApplyBehavior;
  }
  get removeBehavior() {
    if (!this._cachedRemoveBehavior) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedRemoveBehavior = this._parent ? new EffectRemoveBehavior.WithParent(EffectRemoveBehavior.default, this._parent.removeBehavior) : this._value.removeBehavior;
      } else if (this._value._oneofEffectTypeCase === 13) {
        this._cachedRemoveBehavior = new EffectRemoveBehavior.WithParent(this._value.removeBehavior, this._parent && this._parent.oneofEffectTypeCase === 13 ? this._parent.removeBehavior : null);
      } else {
        this._cachedRemoveBehavior = EffectRemoveBehavior.WithParent.default;
      }
    }
    return this._cachedRemoveBehavior;
  }
  get applyTag() {
    if (!this._cachedApplyTag) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedApplyTag = this._parent ? new EffectApplyTag.WithParent(EffectApplyTag.default, this._parent.applyTag) : this._value.applyTag;
      } else if (this._value._oneofEffectTypeCase === 14) {
        this._cachedApplyTag = new EffectApplyTag.WithParent(this._value.applyTag, this._parent && this._parent.oneofEffectTypeCase === 14 ? this._parent.applyTag : null);
      } else {
        this._cachedApplyTag = EffectApplyTag.WithParent.default;
      }
    }
    return this._cachedApplyTag;
  }
  get removeTag() {
    if (!this._cachedRemoveTag) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedRemoveTag = this._parent ? new EffectRemoveTag.WithParent(EffectRemoveTag.default, this._parent.removeTag) : this._value.removeTag;
      } else if (this._value._oneofEffectTypeCase === 15) {
        this._cachedRemoveTag = new EffectRemoveTag.WithParent(this._value.removeTag, this._parent && this._parent.oneofEffectTypeCase === 15 ? this._parent.removeTag : null);
      } else {
        this._cachedRemoveTag = EffectRemoveTag.WithParent.default;
      }
    }
    return this._cachedRemoveTag;
  }
  get switchEffect() {
    if (!this._cachedSwitchEffect) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSwitchEffect = this._parent ? new EffectSwitch.WithParent(EffectSwitch.default, this._parent.switchEffect) : this._value.switchEffect;
      } else if (this._value._oneofEffectTypeCase === 16) {
        this._cachedSwitchEffect = new EffectSwitch.WithParent(this._value.switchEffect, this._parent && this._parent.oneofEffectTypeCase === 16 ? this._parent.switchEffect : null);
      } else {
        this._cachedSwitchEffect = EffectSwitch.WithParent.default;
      }
    }
    return this._cachedSwitchEffect;
  }
  get setWaypoints() {
    if (!this._cachedSetWaypoints) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSetWaypoints = this._parent ? new EffectSetWaypoints.WithParent(EffectSetWaypoints.default, this._parent.setWaypoints) : this._value.setWaypoints;
      } else if (this._value._oneofEffectTypeCase === 17) {
        this._cachedSetWaypoints = new EffectSetWaypoints.WithParent(this._value.setWaypoints, this._parent && this._parent.oneofEffectTypeCase === 17 ? this._parent.setWaypoints : null);
      } else {
        this._cachedSetWaypoints = EffectSetWaypoints.WithParent.default;
      }
    }
    return this._cachedSetWaypoints;
  }
  get disengage() {
    if (!this._cachedDisengage) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedDisengage = this._parent ? new EffectDisengage.WithParent(EffectDisengage.default, this._parent.disengage) : this._value.disengage;
      } else if (this._value._oneofEffectTypeCase === 18) {
        this._cachedDisengage = new EffectDisengage.WithParent(this._value.disengage, this._parent && this._parent.oneofEffectTypeCase === 18 ? this._parent.disengage : null);
      } else {
        this._cachedDisengage = EffectDisengage.WithParent.default;
      }
    }
    return this._cachedDisengage;
  }
  get sell() {
    if (!this._cachedSell) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSell = this._parent ? new EffectSell.WithParent(EffectSell.default, this._parent.sell) : this._value.sell;
      } else if (this._value._oneofEffectTypeCase === 19) {
        this._cachedSell = new EffectSell.WithParent(this._value.sell, this._parent && this._parent.oneofEffectTypeCase === 19 ? this._parent.sell : null);
      } else {
        this._cachedSell = EffectSell.WithParent.default;
      }
    }
    return this._cachedSell;
  }
  get heal() {
    if (!this._cachedHeal) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedHeal = this._parent ? new EffectHeal.WithParent(EffectHeal.default, this._parent.heal) : this._value.heal;
      } else if (this._value._oneofEffectTypeCase === 20) {
        this._cachedHeal = new EffectHeal.WithParent(this._value.heal, this._parent && this._parent.oneofEffectTypeCase === 20 ? this._parent.heal : null);
      } else {
        this._cachedHeal = EffectHeal.WithParent.default;
      }
    }
    return this._cachedHeal;
  }
  get addGold() {
    if (!this._cachedAddGold) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedAddGold = this._parent ? new EffectAddGold.WithParent(EffectAddGold.default, this._parent.addGold) : this._value.addGold;
      } else if (this._value._oneofEffectTypeCase === 21) {
        this._cachedAddGold = new EffectAddGold.WithParent(this._value.addGold, this._parent && this._parent.oneofEffectTypeCase === 21 ? this._parent.addGold : null);
      } else {
        this._cachedAddGold = EffectAddGold.WithParent.default;
      }
    }
    return this._cachedAddGold;
  }
  get teleport() {
    if (!this._cachedTeleport) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedTeleport = this._parent ? new EffectTeleport.WithParent(EffectTeleport.default, this._parent.teleport) : this._value.teleport;
      } else if (this._value._oneofEffectTypeCase === 22) {
        this._cachedTeleport = new EffectTeleport.WithParent(this._value.teleport, this._parent && this._parent.oneofEffectTypeCase === 22 ? this._parent.teleport : null);
      } else {
        this._cachedTeleport = EffectTeleport.WithParent.default;
      }
    }
    return this._cachedTeleport;
  }
  get teleportAlongWaypoint() {
    if (!this._cachedTeleportAlongWaypoint) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedTeleportAlongWaypoint = this._parent ? new EffectTeleportAlongWaypoint.WithParent(EffectTeleportAlongWaypoint.default, this._parent.teleportAlongWaypoint) : this._value.teleportAlongWaypoint;
      } else if (this._value._oneofEffectTypeCase === 23) {
        this._cachedTeleportAlongWaypoint = new EffectTeleportAlongWaypoint.WithParent(this._value.teleportAlongWaypoint, this._parent && this._parent.oneofEffectTypeCase === 23 ? this._parent.teleportAlongWaypoint : null);
      } else {
        this._cachedTeleportAlongWaypoint = EffectTeleportAlongWaypoint.WithParent.default;
      }
    }
    return this._cachedTeleportAlongWaypoint;
  }
  get setRallyPoint() {
    if (!this._cachedSetRallyPoint) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSetRallyPoint = this._parent ? new EffectSetRallyPoint.WithParent(EffectSetRallyPoint.default, this._parent.setRallyPoint) : this._value.setRallyPoint;
      } else if (this._value._oneofEffectTypeCase === 24) {
        this._cachedSetRallyPoint = new EffectSetRallyPoint.WithParent(this._value.setRallyPoint, this._parent && this._parent.oneofEffectTypeCase === 24 ? this._parent.setRallyPoint : null);
      } else {
        this._cachedSetRallyPoint = EffectSetRallyPoint.WithParent.default;
      }
    }
    return this._cachedSetRallyPoint;
  }
  get set() {
    if (!this._cachedSet) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSet = this._parent ? new EffectSet.WithParent(EffectSet.default, this._parent.set) : this._value.set;
      } else if (this._value._oneofEffectTypeCase === 25) {
        this._cachedSet = new EffectSet.WithParent(this._value.set, this._parent && this._parent.oneofEffectTypeCase === 25 ? this._parent.set : null);
      } else {
        this._cachedSet = EffectSet.WithParent.default;
      }
    }
    return this._cachedSet;
  }
  get enumerateUnitList() {
    if (!this._cachedEnumerateUnitList) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedEnumerateUnitList = this._parent ? new EffectEnumerateUnitList.WithParent(EffectEnumerateUnitList.default, this._parent.enumerateUnitList) : this._value.enumerateUnitList;
      } else if (this._value._oneofEffectTypeCase === 26) {
        this._cachedEnumerateUnitList = new EffectEnumerateUnitList.WithParent(this._value.enumerateUnitList, this._parent && this._parent.oneofEffectTypeCase === 26 ? this._parent.enumerateUnitList : null);
      } else {
        this._cachedEnumerateUnitList = EffectEnumerateUnitList.WithParent.default;
      }
    }
    return this._cachedEnumerateUnitList;
  }
  get setBounty() {
    if (!this._cachedSetBounty) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedSetBounty = this._parent ? new EffectSetBounty.WithParent(EffectSetBounty.default, this._parent.setBounty) : this._value.setBounty;
      } else if (this._value._oneofEffectTypeCase === 27) {
        this._cachedSetBounty = new EffectSetBounty.WithParent(this._value.setBounty, this._parent && this._parent.oneofEffectTypeCase === 27 ? this._parent.setBounty : null);
      } else {
        this._cachedSetBounty = EffectSetBounty.WithParent.default;
      }
    }
    return this._cachedSetBounty;
  }
  get remove() {
    if (!this._cachedRemove) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedRemove = this._parent ? new EffectRemove.WithParent(EffectRemove.default, this._parent.remove) : this._value.remove;
      } else if (this._value._oneofEffectTypeCase === 29) {
        this._cachedRemove = new EffectRemove.WithParent(this._value.remove, this._parent && this._parent.oneofEffectTypeCase === 29 ? this._parent.remove : null);
      } else {
        this._cachedRemove = EffectRemove.WithParent.default;
      }
    }
    return this._cachedRemove;
  }
  get stop() {
    if (!this._cachedStop) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedStop = this._parent ? new EffectStop.WithParent(EffectStop.default, this._parent.stop) : this._value.stop;
      } else if (this._value._oneofEffectTypeCase === 30) {
        this._cachedStop = new EffectStop.WithParent(this._value.stop, this._parent && this._parent.oneofEffectTypeCase === 30 ? this._parent.stop : null);
      } else {
        this._cachedStop = EffectStop.WithParent.default;
      }
    }
    return this._cachedStop;
  }
  get modifyUnit() {
    if (!this._cachedModifyUnit) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedModifyUnit = this._parent ? new EffectModifyUnit.WithParent(EffectModifyUnit.default, this._parent.modifyUnit) : this._value.modifyUnit;
      } else if (this._value._oneofEffectTypeCase === 31) {
        this._cachedModifyUnit = new EffectModifyUnit.WithParent(this._value.modifyUnit, this._parent && this._parent.oneofEffectTypeCase === 31 ? this._parent.modifyUnit : null);
      } else {
        this._cachedModifyUnit = EffectModifyUnit.WithParent.default;
      }
    }
    return this._cachedModifyUnit;
  }
  get issueAbility() {
    if (!this._cachedIssueAbility) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedIssueAbility = this._parent ? new EffectIssueAbility.WithParent(EffectIssueAbility.default, this._parent.issueAbility) : this._value.issueAbility;
      } else if (this._value._oneofEffectTypeCase === 32) {
        this._cachedIssueAbility = new EffectIssueAbility.WithParent(this._value.issueAbility, this._parent && this._parent.oneofEffectTypeCase === 32 ? this._parent.issueAbility : null);
      } else {
        this._cachedIssueAbility = EffectIssueAbility.WithParent.default;
      }
    }
    return this._cachedIssueAbility;
  }
  get consumeMana() {
    if (!this._cachedConsumeMana) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedConsumeMana = this._parent ? new EffectConsumeMana.WithParent(EffectConsumeMana.default, this._parent.consumeMana) : this._value.consumeMana;
      } else if (this._value._oneofEffectTypeCase === 33) {
        this._cachedConsumeMana = new EffectConsumeMana.WithParent(this._value.consumeMana, this._parent && this._parent.oneofEffectTypeCase === 33 ? this._parent.consumeMana : null);
      } else {
        this._cachedConsumeMana = EffectConsumeMana.WithParent.default;
      }
    }
    return this._cachedConsumeMana;
  }
  get issueCommand() {
    if (!this._cachedIssueCommand) {
      if (this._value._oneofEffectTypeCase === 0) {
        this._cachedIssueCommand = this._parent ? new EffectIssueCommand.WithParent(EffectIssueCommand.default, this._parent.issueCommand) : this._value.issueCommand;
      } else if (this._value._oneofEffectTypeCase === 34) {
        this._cachedIssueCommand = new EffectIssueCommand.WithParent(this._value.issueCommand, this._parent && this._parent.oneofEffectTypeCase === 34 ? this._parent.issueCommand : null);
      } else {
        this._cachedIssueCommand = EffectIssueCommand.WithParent.default;
      }
    }
    return this._cachedIssueCommand;
  }
  update(current, parent) {
    const result = new Effect_WithParent(current, parent);
    if (this._cachedLaunchMissile && this._value._oneofEffectTypeCase === 2 && current._oneofEffectTypeCase === 2) {
      if (this._value.launchMissile === current.launchMissile && this._parent === parent) {
        result._cachedLaunchMissile = this._cachedLaunchMissile;
      } else {
        result._cachedLaunchMissile = this._cachedLaunchMissile.update(current.launchMissile, parent && parent.oneofEffectTypeCase === 2 ? parent.launchMissile : null);
      }
    }
    if (this._cachedDamage && this._value._oneofEffectTypeCase === 3 && current._oneofEffectTypeCase === 3) {
      if (this._value.damage === current.damage && this._parent === parent) {
        result._cachedDamage = this._cachedDamage;
      } else {
        result._cachedDamage = this._cachedDamage.update(current.damage, parent && parent.oneofEffectTypeCase === 3 ? parent.damage : null);
      }
    }
    if (this._cachedAreaSearch && this._value._oneofEffectTypeCase === 4 && current._oneofEffectTypeCase === 4) {
      if (this._value.areaSearch === current.areaSearch && this._parent === parent) {
        result._cachedAreaSearch = this._cachedAreaSearch;
      } else {
        result._cachedAreaSearch = this._cachedAreaSearch.update(current.areaSearch, parent && parent.oneofEffectTypeCase === 4 ? parent.areaSearch : null);
      }
    }
    if (this._cachedPersistent && this._value._oneofEffectTypeCase === 5 && current._oneofEffectTypeCase === 5) {
      if (this._value.persistent === current.persistent && this._parent === parent) {
        result._cachedPersistent = this._cachedPersistent;
      } else {
        result._cachedPersistent = this._cachedPersistent.update(current.persistent, parent && parent.oneofEffectTypeCase === 5 ? parent.persistent : null);
      }
    }
    if (this._cachedKill && this._value._oneofEffectTypeCase === 7 && current._oneofEffectTypeCase === 7) {
      if (this._value.kill === current.kill && this._parent === parent) {
        result._cachedKill = this._cachedKill;
      } else {
        result._cachedKill = this._cachedKill.update(current.kill, parent && parent.oneofEffectTypeCase === 7 ? parent.kill : null);
      }
    }
    if (this._cachedSpawn && this._value._oneofEffectTypeCase === 8 && current._oneofEffectTypeCase === 8) {
      if (this._value.spawn === current.spawn && this._parent === parent) {
        result._cachedSpawn = this._cachedSpawn;
      } else {
        result._cachedSpawn = this._cachedSpawn.update(current.spawn, parent && parent.oneofEffectTypeCase === 8 ? parent.spawn : null);
      }
    }
    if (this._cachedSpawnTroop && this._value._oneofEffectTypeCase === 9 && current._oneofEffectTypeCase === 9) {
      if (this._value.spawnTroop === current.spawnTroop && this._parent === parent) {
        result._cachedSpawnTroop = this._cachedSpawnTroop;
      } else {
        result._cachedSpawnTroop = this._cachedSpawnTroop.update(current.spawnTroop, parent && parent.oneofEffectTypeCase === 9 ? parent.spawnTroop : null);
      }
    }
    if (this._cachedMorph && this._value._oneofEffectTypeCase === 10 && current._oneofEffectTypeCase === 10) {
      if (this._value.morph === current.morph && this._parent === parent) {
        result._cachedMorph = this._cachedMorph;
      } else {
        result._cachedMorph = this._cachedMorph.update(current.morph, parent && parent.oneofEffectTypeCase === 10 ? parent.morph : null);
      }
    }
    if (this._cachedMorphTroop && this._value._oneofEffectTypeCase === 11 && current._oneofEffectTypeCase === 11) {
      if (this._value.morphTroop === current.morphTroop && this._parent === parent) {
        result._cachedMorphTroop = this._cachedMorphTroop;
      } else {
        result._cachedMorphTroop = this._cachedMorphTroop.update(current.morphTroop, parent && parent.oneofEffectTypeCase === 11 ? parent.morphTroop : null);
      }
    }
    if (this._cachedApplyBehavior && this._value._oneofEffectTypeCase === 12 && current._oneofEffectTypeCase === 12) {
      if (this._value.applyBehavior === current.applyBehavior && this._parent === parent) {
        result._cachedApplyBehavior = this._cachedApplyBehavior;
      } else {
        result._cachedApplyBehavior = this._cachedApplyBehavior.update(current.applyBehavior, parent && parent.oneofEffectTypeCase === 12 ? parent.applyBehavior : null);
      }
    }
    if (this._cachedRemoveBehavior && this._value._oneofEffectTypeCase === 13 && current._oneofEffectTypeCase === 13) {
      if (this._value.removeBehavior === current.removeBehavior && this._parent === parent) {
        result._cachedRemoveBehavior = this._cachedRemoveBehavior;
      } else {
        result._cachedRemoveBehavior = this._cachedRemoveBehavior.update(current.removeBehavior, parent && parent.oneofEffectTypeCase === 13 ? parent.removeBehavior : null);
      }
    }
    if (this._cachedApplyTag && this._value._oneofEffectTypeCase === 14 && current._oneofEffectTypeCase === 14) {
      if (this._value.applyTag === current.applyTag && this._parent === parent) {
        result._cachedApplyTag = this._cachedApplyTag;
      } else {
        result._cachedApplyTag = this._cachedApplyTag.update(current.applyTag, parent && parent.oneofEffectTypeCase === 14 ? parent.applyTag : null);
      }
    }
    if (this._cachedRemoveTag && this._value._oneofEffectTypeCase === 15 && current._oneofEffectTypeCase === 15) {
      if (this._value.removeTag === current.removeTag && this._parent === parent) {
        result._cachedRemoveTag = this._cachedRemoveTag;
      } else {
        result._cachedRemoveTag = this._cachedRemoveTag.update(current.removeTag, parent && parent.oneofEffectTypeCase === 15 ? parent.removeTag : null);
      }
    }
    if (this._cachedSwitchEffect && this._value._oneofEffectTypeCase === 16 && current._oneofEffectTypeCase === 16) {
      if (this._value.switchEffect === current.switchEffect && this._parent === parent) {
        result._cachedSwitchEffect = this._cachedSwitchEffect;
      } else {
        result._cachedSwitchEffect = this._cachedSwitchEffect.update(current.switchEffect, parent && parent.oneofEffectTypeCase === 16 ? parent.switchEffect : null);
      }
    }
    if (this._cachedSetWaypoints && this._value._oneofEffectTypeCase === 17 && current._oneofEffectTypeCase === 17) {
      if (this._value.setWaypoints === current.setWaypoints && this._parent === parent) {
        result._cachedSetWaypoints = this._cachedSetWaypoints;
      } else {
        result._cachedSetWaypoints = this._cachedSetWaypoints.update(current.setWaypoints, parent && parent.oneofEffectTypeCase === 17 ? parent.setWaypoints : null);
      }
    }
    if (this._cachedDisengage && this._value._oneofEffectTypeCase === 18 && current._oneofEffectTypeCase === 18) {
      if (this._value.disengage === current.disengage && this._parent === parent) {
        result._cachedDisengage = this._cachedDisengage;
      } else {
        result._cachedDisengage = this._cachedDisengage.update(current.disengage, parent && parent.oneofEffectTypeCase === 18 ? parent.disengage : null);
      }
    }
    if (this._cachedSell && this._value._oneofEffectTypeCase === 19 && current._oneofEffectTypeCase === 19) {
      if (this._value.sell === current.sell && this._parent === parent) {
        result._cachedSell = this._cachedSell;
      } else {
        result._cachedSell = this._cachedSell.update(current.sell, parent && parent.oneofEffectTypeCase === 19 ? parent.sell : null);
      }
    }
    if (this._cachedHeal && this._value._oneofEffectTypeCase === 20 && current._oneofEffectTypeCase === 20) {
      if (this._value.heal === current.heal && this._parent === parent) {
        result._cachedHeal = this._cachedHeal;
      } else {
        result._cachedHeal = this._cachedHeal.update(current.heal, parent && parent.oneofEffectTypeCase === 20 ? parent.heal : null);
      }
    }
    if (this._cachedAddGold && this._value._oneofEffectTypeCase === 21 && current._oneofEffectTypeCase === 21) {
      if (this._value.addGold === current.addGold && this._parent === parent) {
        result._cachedAddGold = this._cachedAddGold;
      } else {
        result._cachedAddGold = this._cachedAddGold.update(current.addGold, parent && parent.oneofEffectTypeCase === 21 ? parent.addGold : null);
      }
    }
    if (this._cachedTeleport && this._value._oneofEffectTypeCase === 22 && current._oneofEffectTypeCase === 22) {
      if (this._value.teleport === current.teleport && this._parent === parent) {
        result._cachedTeleport = this._cachedTeleport;
      } else {
        result._cachedTeleport = this._cachedTeleport.update(current.teleport, parent && parent.oneofEffectTypeCase === 22 ? parent.teleport : null);
      }
    }
    if (this._cachedTeleportAlongWaypoint && this._value._oneofEffectTypeCase === 23 && current._oneofEffectTypeCase === 23) {
      if (this._value.teleportAlongWaypoint === current.teleportAlongWaypoint && this._parent === parent) {
        result._cachedTeleportAlongWaypoint = this._cachedTeleportAlongWaypoint;
      } else {
        result._cachedTeleportAlongWaypoint = this._cachedTeleportAlongWaypoint.update(current.teleportAlongWaypoint, parent && parent.oneofEffectTypeCase === 23 ? parent.teleportAlongWaypoint : null);
      }
    }
    if (this._cachedSetRallyPoint && this._value._oneofEffectTypeCase === 24 && current._oneofEffectTypeCase === 24) {
      if (this._value.setRallyPoint === current.setRallyPoint && this._parent === parent) {
        result._cachedSetRallyPoint = this._cachedSetRallyPoint;
      } else {
        result._cachedSetRallyPoint = this._cachedSetRallyPoint.update(current.setRallyPoint, parent && parent.oneofEffectTypeCase === 24 ? parent.setRallyPoint : null);
      }
    }
    if (this._cachedSet && this._value._oneofEffectTypeCase === 25 && current._oneofEffectTypeCase === 25) {
      if (this._value.set === current.set && this._parent === parent) {
        result._cachedSet = this._cachedSet;
      } else {
        result._cachedSet = this._cachedSet.update(current.set, parent && parent.oneofEffectTypeCase === 25 ? parent.set : null);
      }
    }
    if (this._cachedEnumerateUnitList && this._value._oneofEffectTypeCase === 26 && current._oneofEffectTypeCase === 26) {
      if (this._value.enumerateUnitList === current.enumerateUnitList && this._parent === parent) {
        result._cachedEnumerateUnitList = this._cachedEnumerateUnitList;
      } else {
        result._cachedEnumerateUnitList = this._cachedEnumerateUnitList.update(current.enumerateUnitList, parent && parent.oneofEffectTypeCase === 26 ? parent.enumerateUnitList : null);
      }
    }
    if (this._cachedSetBounty && this._value._oneofEffectTypeCase === 27 && current._oneofEffectTypeCase === 27) {
      if (this._value.setBounty === current.setBounty && this._parent === parent) {
        result._cachedSetBounty = this._cachedSetBounty;
      } else {
        result._cachedSetBounty = this._cachedSetBounty.update(current.setBounty, parent && parent.oneofEffectTypeCase === 27 ? parent.setBounty : null);
      }
    }
    if (this._cachedRemove && this._value._oneofEffectTypeCase === 29 && current._oneofEffectTypeCase === 29) {
      if (this._value.remove === current.remove && this._parent === parent) {
        result._cachedRemove = this._cachedRemove;
      } else {
        result._cachedRemove = this._cachedRemove.update(current.remove, parent && parent.oneofEffectTypeCase === 29 ? parent.remove : null);
      }
    }
    if (this._cachedStop && this._value._oneofEffectTypeCase === 30 && current._oneofEffectTypeCase === 30) {
      if (this._value.stop === current.stop && this._parent === parent) {
        result._cachedStop = this._cachedStop;
      } else {
        result._cachedStop = this._cachedStop.update(current.stop, parent && parent.oneofEffectTypeCase === 30 ? parent.stop : null);
      }
    }
    if (this._cachedModifyUnit && this._value._oneofEffectTypeCase === 31 && current._oneofEffectTypeCase === 31) {
      if (this._value.modifyUnit === current.modifyUnit && this._parent === parent) {
        result._cachedModifyUnit = this._cachedModifyUnit;
      } else {
        result._cachedModifyUnit = this._cachedModifyUnit.update(current.modifyUnit, parent && parent.oneofEffectTypeCase === 31 ? parent.modifyUnit : null);
      }
    }
    if (this._cachedIssueAbility && this._value._oneofEffectTypeCase === 32 && current._oneofEffectTypeCase === 32) {
      if (this._value.issueAbility === current.issueAbility && this._parent === parent) {
        result._cachedIssueAbility = this._cachedIssueAbility;
      } else {
        result._cachedIssueAbility = this._cachedIssueAbility.update(current.issueAbility, parent && parent.oneofEffectTypeCase === 32 ? parent.issueAbility : null);
      }
    }
    if (this._cachedConsumeMana && this._value._oneofEffectTypeCase === 33 && current._oneofEffectTypeCase === 33) {
      if (this._value.consumeMana === current.consumeMana && this._parent === parent) {
        result._cachedConsumeMana = this._cachedConsumeMana;
      } else {
        result._cachedConsumeMana = this._cachedConsumeMana.update(current.consumeMana, parent && parent.oneofEffectTypeCase === 33 ? parent.consumeMana : null);
      }
    }
    if (this._cachedIssueCommand && this._value._oneofEffectTypeCase === 34 && current._oneofEffectTypeCase === 34) {
      if (this._value.issueCommand === current.issueCommand && this._parent === parent) {
        result._cachedIssueCommand = this._cachedIssueCommand;
      } else {
        result._cachedIssueCommand = this._cachedIssueCommand.update(current.issueCommand, parent && parent.oneofEffectTypeCase === 34 ? parent.issueCommand : null);
      }
    }
    return result;
  }
}
Effect_WithParent.default = new Effect_WithParent(Effect.default, null);
Effect.WithParent = Effect_WithParent;
class Effect_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get parent() {
    if (!this._parent) {
      this._parent = {
        name: "parent",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedEffectNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parent;
  }
  get launchMissile() {
    if (!this._launchMissile) {
      this._launchMissile = {
        name: "launchMissile",
        Name: "LaunchMissile",
        number: 2,
        protoType: 11,
        protoName: "launch_missile",
        oneofIndex: 4,
        type: EffectLaunchMissile,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchMissile;
  }
  get damage() {
    if (!this._damage) {
      this._damage = {
        name: "damage",
        Name: "Damage",
        number: 3,
        protoType: 11,
        protoName: "damage",
        oneofIndex: 4,
        type: EffectDamage,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damage;
  }
  get areaSearch() {
    if (!this._areaSearch) {
      this._areaSearch = {
        name: "areaSearch",
        Name: "AreaSearch",
        number: 4,
        protoType: 11,
        protoName: "area_search",
        oneofIndex: 4,
        type: EffectAreaSearch,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._areaSearch;
  }
  get persistent() {
    if (!this._persistent) {
      this._persistent = {
        name: "persistent",
        Name: "Persistent",
        number: 5,
        protoType: 11,
        protoName: "persistent",
        oneofIndex: 4,
        type: EffectPersistent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistent;
  }
  get kill() {
    if (!this._kill) {
      this._kill = {
        name: "kill",
        Name: "Kill",
        number: 7,
        protoType: 11,
        protoName: "kill",
        oneofIndex: 4,
        type: EffectKill,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._kill;
  }
  get spawn() {
    if (!this._spawn) {
      this._spawn = {
        name: "spawn",
        Name: "Spawn",
        number: 8,
        protoType: 11,
        protoName: "spawn",
        oneofIndex: 4,
        type: EffectSpawn,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawn;
  }
  get spawnTroop() {
    if (!this._spawnTroop) {
      this._spawnTroop = {
        name: "spawnTroop",
        Name: "SpawnTroop",
        number: 9,
        protoType: 11,
        protoName: "spawn_troop",
        oneofIndex: 4,
        type: EffectSpawnTroop,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnTroop;
  }
  get morph() {
    if (!this._morph) {
      this._morph = {
        name: "morph",
        Name: "Morph",
        number: 10,
        protoType: 11,
        protoName: "morph",
        oneofIndex: 4,
        type: EffectMorph,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._morph;
  }
  get morphTroop() {
    if (!this._morphTroop) {
      this._morphTroop = {
        name: "morphTroop",
        Name: "MorphTroop",
        number: 11,
        protoType: 11,
        protoName: "morph_troop",
        oneofIndex: 4,
        type: EffectMorphTroop,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._morphTroop;
  }
  get applyBehavior() {
    if (!this._applyBehavior) {
      this._applyBehavior = {
        name: "applyBehavior",
        Name: "ApplyBehavior",
        number: 12,
        protoType: 11,
        protoName: "apply_behavior",
        oneofIndex: 4,
        type: EffectApplyBehavior,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._applyBehavior;
  }
  get removeBehavior() {
    if (!this._removeBehavior) {
      this._removeBehavior = {
        name: "removeBehavior",
        Name: "RemoveBehavior",
        number: 13,
        protoType: 11,
        protoName: "remove_behavior",
        oneofIndex: 4,
        type: EffectRemoveBehavior,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._removeBehavior;
  }
  get applyTag() {
    if (!this._applyTag) {
      this._applyTag = {
        name: "applyTag",
        Name: "ApplyTag",
        number: 14,
        protoType: 11,
        protoName: "apply_tag",
        oneofIndex: 4,
        type: EffectApplyTag,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._applyTag;
  }
  get removeTag() {
    if (!this._removeTag) {
      this._removeTag = {
        name: "removeTag",
        Name: "RemoveTag",
        number: 15,
        protoType: 11,
        protoName: "remove_tag",
        oneofIndex: 4,
        type: EffectRemoveTag,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._removeTag;
  }
  get switchEffect() {
    if (!this._switchEffect) {
      this._switchEffect = {
        name: "switchEffect",
        Name: "SwitchEffect",
        number: 16,
        protoType: 11,
        protoName: "switch_effect",
        oneofIndex: 4,
        type: EffectSwitch,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._switchEffect;
  }
  get setWaypoints() {
    if (!this._setWaypoints) {
      this._setWaypoints = {
        name: "setWaypoints",
        Name: "SetWaypoints",
        number: 17,
        protoType: 11,
        protoName: "set_waypoints",
        oneofIndex: 4,
        type: EffectSetWaypoints,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setWaypoints;
  }
  get disengage() {
    if (!this._disengage) {
      this._disengage = {
        name: "disengage",
        Name: "Disengage",
        number: 18,
        protoType: 11,
        protoName: "disengage",
        oneofIndex: 4,
        type: EffectDisengage,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disengage;
  }
  get sell() {
    if (!this._sell) {
      this._sell = {
        name: "sell",
        Name: "Sell",
        number: 19,
        protoType: 11,
        protoName: "sell",
        oneofIndex: 4,
        type: EffectSell,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sell;
  }
  get heal() {
    if (!this._heal) {
      this._heal = {
        name: "heal",
        Name: "Heal",
        number: 20,
        protoType: 11,
        protoName: "heal",
        oneofIndex: 4,
        type: EffectHeal,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heal;
  }
  get addGold() {
    if (!this._addGold) {
      this._addGold = {
        name: "addGold",
        Name: "AddGold",
        number: 21,
        protoType: 11,
        protoName: "add_gold",
        oneofIndex: 4,
        type: EffectAddGold,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addGold;
  }
  get teleport() {
    if (!this._teleport) {
      this._teleport = {
        name: "teleport",
        Name: "Teleport",
        number: 22,
        protoType: 11,
        protoName: "teleport",
        oneofIndex: 4,
        type: EffectTeleport,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._teleport;
  }
  get teleportAlongWaypoint() {
    if (!this._teleportAlongWaypoint) {
      this._teleportAlongWaypoint = {
        name: "teleportAlongWaypoint",
        Name: "TeleportAlongWaypoint",
        number: 23,
        protoType: 11,
        protoName: "teleport_along_waypoint",
        oneofIndex: 4,
        type: EffectTeleportAlongWaypoint,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._teleportAlongWaypoint;
  }
  get setRallyPoint() {
    if (!this._setRallyPoint) {
      this._setRallyPoint = {
        name: "setRallyPoint",
        Name: "SetRallyPoint",
        number: 24,
        protoType: 11,
        protoName: "set_rally_point",
        oneofIndex: 4,
        type: EffectSetRallyPoint,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setRallyPoint;
  }
  get set() {
    if (!this._set) {
      this._set = {
        name: "set",
        Name: "Set",
        number: 25,
        protoType: 11,
        protoName: "set",
        oneofIndex: 4,
        type: EffectSet,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._set;
  }
  get enumerateUnitList() {
    if (!this._enumerateUnitList) {
      this._enumerateUnitList = {
        name: "enumerateUnitList",
        Name: "EnumerateUnitList",
        number: 26,
        protoType: 11,
        protoName: "enumerate_unit_list",
        oneofIndex: 4,
        type: EffectEnumerateUnitList,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enumerateUnitList;
  }
  get setBounty() {
    if (!this._setBounty) {
      this._setBounty = {
        name: "setBounty",
        Name: "SetBounty",
        number: 27,
        protoType: 11,
        protoName: "set_bounty_",
        oneofIndex: 4,
        type: EffectSetBounty,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setBounty;
  }
  get remove() {
    if (!this._remove) {
      this._remove = {
        name: "remove",
        Name: "Remove",
        number: 29,
        protoType: 11,
        protoName: "remove",
        oneofIndex: 4,
        type: EffectRemove,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remove;
  }
  get stop() {
    if (!this._stop) {
      this._stop = {
        name: "stop",
        Name: "Stop",
        number: 30,
        protoType: 11,
        protoName: "stop",
        oneofIndex: 4,
        type: EffectStop,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stop;
  }
  get modifyUnit() {
    if (!this._modifyUnit) {
      this._modifyUnit = {
        name: "modifyUnit",
        Name: "ModifyUnit",
        number: 31,
        protoType: 11,
        protoName: "modify_unit",
        oneofIndex: 4,
        type: EffectModifyUnit,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyUnit;
  }
  get issueAbility() {
    if (!this._issueAbility) {
      this._issueAbility = {
        name: "issueAbility",
        Name: "IssueAbility",
        number: 32,
        protoType: 11,
        protoName: "issue_ability",
        oneofIndex: 4,
        type: EffectIssueAbility,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._issueAbility;
  }
  get consumeMana() {
    if (!this._consumeMana) {
      this._consumeMana = {
        name: "consumeMana",
        Name: "ConsumeMana",
        number: 33,
        protoType: 11,
        protoName: "consume_mana",
        oneofIndex: 4,
        type: EffectConsumeMana,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._consumeMana;
  }
  get issueCommand() {
    if (!this._issueCommand) {
      this._issueCommand = {
        name: "issueCommand",
        Name: "IssueCommand",
        number: 34,
        protoType: 11,
        protoName: "issue_command",
        oneofIndex: 4,
        type: EffectIssueCommand,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._issueCommand;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.parent,
        this.launchMissile,
        this.damage,
        this.areaSearch,
        this.persistent,
        this.kill,
        this.spawn,
        this.spawnTroop,
        this.morph,
        this.morphTroop,
        this.applyBehavior,
        this.removeBehavior,
        this.applyTag,
        this.removeTag,
        this.switchEffect,
        this.setWaypoints,
        this.disengage,
        this.sell,
        this.heal,
        this.addGold,
        this.teleport,
        this.teleportAlongWaypoint,
        this.setRallyPoint,
        this.set,
        this.enumerateUnitList,
        this.setBounty,
        this.remove,
        this.stop,
        this.modifyUnit,
        this.issueAbility,
        this.consumeMana,
        this.issueCommand,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "oneofEffectType",
        Name: "OneofEffectType",
        fields: [
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
          this.fields[18],
          this.fields[19],
          this.fields[20],
          this.fields[21],
          this.fields[22],
          this.fields[23],
          this.fields[24],
          this.fields[25],
          this.fields[26],
          this.fields[27],
          this.fields[28],
          this.fields[29],
          this.fields[30],
          this.fields[31],
          this.fields[32],
          this.fields[33],
          this.fields[34],
        ],
      });
    }
    return this._oneofs;
  }
}
Effect.descriptor = new Effect_Descriptor();
export class EffectSet {
  get descriptor() {
    return EffectSet.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._effectList = [];
  }
  isEmpty() {
    if (this._hasTargetType) return false;
    if (this._effectList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSet) {
      return value;
    }
    return EffectSet.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSet();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    result._effectList = JsonToList(json.effectList, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._effectList.length > 0) {
      result.effectList = ArrayToJson(this._effectList, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {string[]}
   */
  get effectList() {
    return this._effectList;
  }
  addEffectList(path, value) {
    return {type: 'ADD', path: path.concat(['effectList']), value};
  }
  setEffectList(path, value) {
    return {type: 'SET', path: path.concat(['effectList']), value: ArrayToJson(value, JsonToString)};
  }
  setEffectListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['effectList', key]), value};
  }
  deleteEffectList(path) {
    return {type: 'DELETE', path: path.concat(['effectList'])};
  }
  deleteEffectListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['effectList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSet(this);
              copy._hasTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new EffectSet(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effectList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSet(this);
              copy._effectList = [];        for (let i of value) {
                copy._effectList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectSet(this);
              copy._effectList = copy._effectList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._effectList.length === 0) {
                return this;
              }
              const copy = new EffectSet(this);
              copy._effectList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._effectList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectSet(this);
              copy._effectList = copy._effectList.slice();
              copy._effectList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectSet(this);
              copy._effectList = copy._effectList.slice(0, path[1]).concat(copy._effectList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._effectList.length) {
            return this;
          }
          const oldValue = this._effectList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectSet(this);
          copy._effectList = copy._effectList.slice();
          copy._effectList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSet} other
   * @returns {EffectSet}
   */
  merge(other) {
    const copy = new EffectSet(this);
    if (other._hasTargetType) {
      copy._hasTargetType = true;
      copy._targetType = other._targetType;
    }
    copy._effectList = this._effectList.concat(other._effectList);
    return copy;
  }
}
EffectSet.default = new EffectSet();
class EffectSet_Builder {
  constructor(value) {
    this._value = new EffectSet(value);
  }
  build() {
    return new EffectSet(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  addAllEffectList(values) {
    this._value._effectList = this._value._effectList.concat(values);
    return this;
  }
  addEffectList(value) {
    this._value._effectList = this._value._effectList.concat([value]);
    return this;
  }
  setEffectList(index, value) {
    this._value._effectList = this._value._effectList.concat();
    this._value._effectList[index] = value;
    return this;
  }
  clearEffectList() {
    this._value._effectList = [];
    return this;
  }
}
EffectSet.Builder = EffectSet_Builder;
class EffectSet_WithParent {
  /**
   * @param {EffectSet} value
   * @param {EffectSet_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSet.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (this._cachedTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = this._value.targetType;
      } else {
        this._cachedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedTargetType;
  }
  get selfEffectList() {
    return this._value.effectList;
  }
  get inherentEffectList() {
    if (!this._inherentEffectList) {
      this._inherentEffectList = this._parent ? this._parent.effectList : [];
    }
    return this._inherentEffectList;
  }
  get effectList() {
    if (!this._allEffectList) {
      this._allEffectList = this._parent ? this._parent.effectList.concat(this.selfEffectList) : this.selfEffectList;
    }
    return this._allEffectList;
  }
  update(current, parent) {
    const result = new EffectSet_WithParent(current, parent);
    return result;
  }
}
EffectSet_WithParent.default = new EffectSet_WithParent(EffectSet.default, null);
EffectSet.WithParent = EffectSet_WithParent;
class EffectSet_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 1,
        protoType: 14,
        protoName: "target_type",
        type: EffectTargetType_Type,
        options: {
          comments: "Used to determine the ability target type if this effect is the first effect of an ability.",
          default: "UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get effectList() {
    if (!this._effectList) {
      this._effectList = {
        name: "effectList",
        Name: "EffectList",
        number: 2,
        protoType: 9,
        protoName: "effect_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The set of effects to create. Effects are executed in order from top to bottom.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.effectList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSet.descriptor = new EffectSet_Descriptor();
class EffectLaunchMissile_ImpactLocationOffset_DirectionType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "SOURCE_TO_TARGET": return 0;
        case "CASTER_TO_TARGET": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectLaunchMissile_ImpactLocationOffset_DirectionType.fromJson(value);
  }
  static fromReact(e) {
    return EffectLaunchMissile_ImpactLocationOffset_DirectionType.fromJson(e);
  }
}
EffectLaunchMissile_ImpactLocationOffset_DirectionType.SOURCE_TO_TARGET = 0;
EffectLaunchMissile_ImpactLocationOffset_DirectionType.CASTER_TO_TARGET = 1;
EffectLaunchMissile_ImpactLocationOffset_DirectionType.default = 0;
EffectLaunchMissile_ImpactLocationOffset_DirectionType.values = {
  SOURCE_TO_TARGET: 0,
  CASTER_TO_TARGET: 1,
};
EffectLaunchMissile_ImpactLocationOffset_DirectionType.names = {
  0: "SOURCE_TO_TARGET",
  1: "CASTER_TO_TARGET",
};
class EffectLaunchMissile_ImpactLocationOffset {
  get descriptor() {
    return EffectLaunchMissile_ImpactLocationOffset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDirection = false;
    this._direction = null;
    this._hasRight = false;
    this._right = null;
    this._hasUp = false;
    this._up = null;
    this._hasForward = false;
    this._forward = null;
  }
  isEmpty() {
    if (this._hasDirection) return false;
    if (this._hasRight) return false;
    if (this._hasUp) return false;
    if (this._hasForward) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectLaunchMissile_ImpactLocationOffset) {
      return value;
    }
    return EffectLaunchMissile_ImpactLocationOffset.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectLaunchMissile_ImpactLocationOffset();
    if (json.direction != null) {
      result._hasDirection = true;
      result._direction = EffectLaunchMissile_ImpactLocationOffset_DirectionType.fromJson(json.direction);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = JsonToDouble.fromJson(json.right);
    }
    if (json.up != null) {
      result._hasUp = true;
      result._up = JsonToDouble.fromJson(json.up);
    }
    if (json.forward != null) {
      result._hasForward = true;
      result._forward = JsonToDouble.fromJson(json.forward);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDirection) {
      result.direction = EffectLaunchMissile_ImpactLocationOffset_DirectionType.toJson(this._direction);
    }
    if (this._hasRight) {
      result.right = JsonToDouble.toJson(this._right);
    }
    if (this._hasUp) {
      result.up = JsonToDouble.toJson(this._up);
    }
    if (this._hasForward) {
      result.forward = JsonToDouble.toJson(this._forward);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get direction() {
    return this._hasDirection ? this._direction : EffectLaunchMissile_ImpactLocationOffset_DirectionType.default;
  }
  get hasDirection() {
    return this._hasDirection;
  }
  setDirection(path, value) {
    return {type: 'SET', path: path.concat(['direction']), value};
  }
  deleteDirection(path) {
    return {type: 'DELETE', path: path.concat(['direction'])};
  }
  /**
   * @returns {number}
   */
  get right() {
    return this._hasRight ? this._right : JsonToDouble.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  /**
   * @returns {number}
   */
  get up() {
    return this._hasUp ? this._up : JsonToDouble.default;
  }
  get hasUp() {
    return this._hasUp;
  }
  setUp(path, value) {
    return {type: 'SET', path: path.concat(['up']), value};
  }
  deleteUp(path) {
    return {type: 'DELETE', path: path.concat(['up'])};
  }
  /**
   * @returns {number}
   */
  get forward() {
    return this._hasForward ? this._forward : JsonToDouble.default;
  }
  get hasForward() {
    return this._hasForward;
  }
  setForward(path, value) {
    return {type: 'SET', path: path.concat(['forward']), value};
  }
  deleteForward(path) {
    return {type: 'DELETE', path: path.concat(['forward'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "direction": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasDirection = true;
              copy._direction = EffectLaunchMissile_ImpactLocationOffset_DirectionType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDirection) {
                return this;
              }
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasDirection = false;
              copy._direction = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasRight = true;
              copy._right = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "up": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasUp = true;
              copy._up = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUp) {
                return this;
              }
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasUp = false;
              copy._up = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasForward = true;
              copy._forward = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForward) {
                return this;
              }
              const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
              copy._hasForward = false;
              copy._forward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectLaunchMissile_ImpactLocationOffset} other
   * @returns {EffectLaunchMissile_ImpactLocationOffset}
   */
  merge(other) {
    const copy = new EffectLaunchMissile_ImpactLocationOffset(this);
    if (other._hasDirection) {
      copy._hasDirection = true;
      copy._direction = other._direction;
    }
    if (other._hasRight) {
      copy._hasRight = true;
      copy._right = other._right;
    }
    if (other._hasUp) {
      copy._hasUp = true;
      copy._up = other._up;
    }
    if (other._hasForward) {
      copy._hasForward = true;
      copy._forward = other._forward;
    }
    return copy;
  }
}
EffectLaunchMissile_ImpactLocationOffset.default = new EffectLaunchMissile_ImpactLocationOffset();
EffectLaunchMissile_ImpactLocationOffset.DirectionType = EffectLaunchMissile_ImpactLocationOffset_DirectionType;
class EffectLaunchMissile_ImpactLocationOffset_Builder {
  constructor(value) {
    this._value = new EffectLaunchMissile_ImpactLocationOffset(value);
  }
  build() {
    return new EffectLaunchMissile_ImpactLocationOffset(this._value);
  }
  setDirection(value) {
    this._value._hasDirection = true;
    this._value._direction = value;
    return this;
  }
  deleteDirection() {
    this._value._hasDirection = false;
    this._value._direction = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
  setUp(value) {
    this._value._hasUp = true;
    this._value._up = value;
    return this;
  }
  deleteUp() {
    this._value._hasUp = false;
    this._value._up = null;
    return this;
  }
  setForward(value) {
    this._value._hasForward = true;
    this._value._forward = value;
    return this;
  }
  deleteForward() {
    this._value._hasForward = false;
    this._value._forward = null;
    return this;
  }
}
EffectLaunchMissile_ImpactLocationOffset.Builder = EffectLaunchMissile_ImpactLocationOffset_Builder;
class EffectLaunchMissile_ImpactLocationOffset_WithParent {
  /**
   * @param {EffectLaunchMissile_ImpactLocationOffset} value
   * @param {EffectLaunchMissile_ImpactLocationOffset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectLaunchMissile_ImpactLocationOffset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDirection() {
    if (this._cachedHasDirection === undefined) {
      if (this._value.hasDirection) {
        this._cachedHasDirection = true;
      } else {
        this._cachedHasDirection = this._parent ? this._parent.hasDirection : false;
      }
    }
    return this._cachedHasDirection;
  }
  get direction() {
    if (this._cachedDirection === undefined) {
      if (this._value.hasDirection) {
        this._cachedDirection = this._value.direction;
      } else {
        this._cachedDirection = this._parent ? this._parent.direction : this._value.direction;
      }
    }
    return this._cachedDirection;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (this._cachedRight === undefined) {
      if (this._value.hasRight) {
        this._cachedRight = this._value.right;
      } else {
        this._cachedRight = this._parent ? this._parent.right : this._value.right;
      }
    }
    return this._cachedRight;
  }
  get hasUp() {
    if (this._cachedHasUp === undefined) {
      if (this._value.hasUp) {
        this._cachedHasUp = true;
      } else {
        this._cachedHasUp = this._parent ? this._parent.hasUp : false;
      }
    }
    return this._cachedHasUp;
  }
  get up() {
    if (this._cachedUp === undefined) {
      if (this._value.hasUp) {
        this._cachedUp = this._value.up;
      } else {
        this._cachedUp = this._parent ? this._parent.up : this._value.up;
      }
    }
    return this._cachedUp;
  }
  get hasForward() {
    if (this._cachedHasForward === undefined) {
      if (this._value.hasForward) {
        this._cachedHasForward = true;
      } else {
        this._cachedHasForward = this._parent ? this._parent.hasForward : false;
      }
    }
    return this._cachedHasForward;
  }
  get forward() {
    if (this._cachedForward === undefined) {
      if (this._value.hasForward) {
        this._cachedForward = this._value.forward;
      } else {
        this._cachedForward = this._parent ? this._parent.forward : this._value.forward;
      }
    }
    return this._cachedForward;
  }
  update(current, parent) {
    const result = new EffectLaunchMissile_ImpactLocationOffset_WithParent(current, parent);
    return result;
  }
}
EffectLaunchMissile_ImpactLocationOffset_WithParent.default = new EffectLaunchMissile_ImpactLocationOffset_WithParent(EffectLaunchMissile_ImpactLocationOffset.default, null);
EffectLaunchMissile_ImpactLocationOffset.WithParent = EffectLaunchMissile_ImpactLocationOffset_WithParent;
class EffectLaunchMissile_ImpactLocationOffset_Descriptor {
  get direction() {
    if (!this._direction) {
      this._direction = {
        name: "direction",
        Name: "Direction",
        number: 1,
        protoType: 14,
        protoName: "direction",
        type: EffectLaunchMissile_ImpactLocationOffset_DirectionType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._direction;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 1,
        protoName: "right",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get up() {
    if (!this._up) {
      this._up = {
        name: "up",
        Name: "Up",
        number: 3,
        protoType: 1,
        protoName: "up",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._up;
  }
  get forward() {
    if (!this._forward) {
      this._forward = {
        name: "forward",
        Name: "Forward",
        number: 4,
        protoType: 1,
        protoName: "forward",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forward;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.direction,
        this.right,
        this.up,
        this.forward,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDirection",
        Name: "DummyOneofForDirection",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUp",
        Name: "DummyOneofForUp",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForward",
        Name: "DummyOneofForForward",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectLaunchMissile_ImpactLocationOffset.descriptor = new EffectLaunchMissile_ImpactLocationOffset_Descriptor();
class EffectLaunchMissile_MissileDeathType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "IMPACT": return 0;
        case "NONE": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectLaunchMissile_MissileDeathType.fromJson(value);
  }
  static fromReact(e) {
    return EffectLaunchMissile_MissileDeathType.fromJson(e);
  }
}
EffectLaunchMissile_MissileDeathType.IMPACT = 0;
EffectLaunchMissile_MissileDeathType.NONE = 1;
EffectLaunchMissile_MissileDeathType.default = 0;
EffectLaunchMissile_MissileDeathType.values = {
  IMPACT: 0,
  NONE: 1,
};
EffectLaunchMissile_MissileDeathType.names = {
  0: "IMPACT",
  1: "NONE",
};
export class EffectLaunchMissile {
  get descriptor() {
    return EffectLaunchMissile.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._hasMissileUnit = false;
    this._missileUnit = null;
    this._hasMissileDeathType = false;
    this._missileDeathType = null;
    this._hasStartEffect = false;
    this._startEffect = null;
    this._hasImpactEffect = false;
    this._effect = null;
    this._hasLaunchLocation = false;
    this._launchLocation = null;
    this._hasImpactLocation = false;
    this._impactLocation = null;
    this._hasDeprecatedLaunchLocationOffset = false;
    this._launchLocationOffset = null;
    this._hasDeprecatedImpactLocationOffset = false;
    this._impactLocationOffset = null;
    this._hasOffsetStart = false;
    this._offsetStart = null;
    this._hasOffsetEnd = false;
    this._offsetEnd = null;
    this._hasLaunchOffset = false;
    this._launchOffset = null;
    this._hasImpactOffset = false;
    this._impactOffset = null;
    this._hasUseMissileHeightAtDestination = false;
    this._useMissileHeightAtDestination = null;
    this._hasMissileEffect = false;
    this._missileEffect = null;
    this._hasMover = false;
    this._mover = null;
    this._hasAreaSearchEffect = false;
    this._areaSearchEffect = null;
    this._hasArriveOnSearchHit = false;
    this._arriveOnSearchHit = null;
    this._hasDynamicSearchArea = false;
    this._dynamicSearchArea = null;
  }
  isEmpty() {
    if (this._hasTargetType) return false;
    if (this._hasMissileUnit) return false;
    if (this._hasMissileDeathType) return false;
    if (this._hasStartEffect) return false;
    if (this._hasImpactEffect) return false;
    if (this._hasLaunchLocation) return false;
    if (this._hasImpactLocation) return false;
    if (this._hasDeprecatedLaunchLocationOffset && !this._launchLocationOffset.isEmpty()) return false;
    if (this._hasDeprecatedImpactLocationOffset && !this._impactLocationOffset.isEmpty()) return false;
    if (this._hasOffsetStart) return false;
    if (this._hasOffsetEnd) return false;
    if (this._hasLaunchOffset && !this._launchOffset.isEmpty()) return false;
    if (this._hasImpactOffset && !this._impactOffset.isEmpty()) return false;
    if (this._hasUseMissileHeightAtDestination) return false;
    if (this._hasMissileEffect) return false;
    if (this._hasMover) return false;
    if (this._hasAreaSearchEffect) return false;
    if (this._hasArriveOnSearchHit) return false;
    if (this._hasDynamicSearchArea) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectLaunchMissile) {
      return value;
    }
    return EffectLaunchMissile.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectLaunchMissile();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    if (json.missileUnit != null) {
      result._hasMissileUnit = true;
      result._missileUnit = JsonToString.fromJson(json.missileUnit);
    }
    if (json.missileDeathType != null) {
      result._hasMissileDeathType = true;
      result._missileDeathType = EffectLaunchMissile_MissileDeathType.fromJson(json.missileDeathType);
    }
    if (json.startEffect != null) {
      result._hasStartEffect = true;
      result._startEffect = JsonToString.fromJson(json.startEffect);
    }
    if (json.effect != null) {
      result._hasImpactEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.launchLocation != null) {
      result._hasLaunchLocation = true;
      result._launchLocation = EffectTarget_Type.fromJson(json.launchLocation);
    }
    if (json.impactLocation != null) {
      result._hasImpactLocation = true;
      result._impactLocation = EffectTarget_Type.fromJson(json.impactLocation);
    }
    if (json.launchLocationOffset != null) {
      result._hasDeprecatedLaunchLocationOffset = true;
      result._launchLocationOffset = EffectLaunchMissile_ImpactLocationOffset.fromJson(json.launchLocationOffset);
    }
    if (json.impactLocationOffset != null) {
      result._hasDeprecatedImpactLocationOffset = true;
      result._impactLocationOffset = EffectLaunchMissile_ImpactLocationOffset.fromJson(json.impactLocationOffset);
    }
    if (json.offsetStart != null) {
      result._hasOffsetStart = true;
      result._offsetStart = EffectTarget_Type.fromJson(json.offsetStart);
    }
    if (json.offsetEnd != null) {
      result._hasOffsetEnd = true;
      result._offsetEnd = EffectTarget_Type.fromJson(json.offsetEnd);
    }
    if (json.launchOffset != null) {
      result._hasLaunchOffset = true;
      result._launchOffset = EffectOffset.fromJson(json.launchOffset);
    }
    if (json.impactOffset != null) {
      result._hasImpactOffset = true;
      result._impactOffset = EffectOffset.fromJson(json.impactOffset);
    }
    if (json.useMissileHeightAtDestination != null) {
      result._hasUseMissileHeightAtDestination = true;
      result._useMissileHeightAtDestination = JsonToBoolean.fromJson(json.useMissileHeightAtDestination);
    }
    if (json.missileEffect != null) {
      result._hasMissileEffect = true;
      result._missileEffect = JsonToString.fromJson(json.missileEffect);
    }
    if (json.mover != null) {
      result._hasMover = true;
      result._mover = JsonToString.fromJson(json.mover);
    }
    if (json.areaSearchEffect != null) {
      result._hasAreaSearchEffect = true;
      result._areaSearchEffect = JsonToString.fromJson(json.areaSearchEffect);
    }
    if (json.arriveOnSearchHit != null) {
      result._hasArriveOnSearchHit = true;
      result._arriveOnSearchHit = JsonToBoolean.fromJson(json.arriveOnSearchHit);
    }
    if (json.dynamicSearchArea != null) {
      result._hasDynamicSearchArea = true;
      result._dynamicSearchArea = JsonToBoolean.fromJson(json.dynamicSearchArea);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._hasMissileUnit) {
      result.missileUnit = JsonToString.toJson(this._missileUnit);
    }
    if (this._hasMissileDeathType) {
      result.missileDeathType = EffectLaunchMissile_MissileDeathType.toJson(this._missileDeathType);
    }
    if (this._hasStartEffect) {
      result.startEffect = JsonToString.toJson(this._startEffect);
    }
    if (this._hasImpactEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasLaunchLocation) {
      result.launchLocation = EffectTarget_Type.toJson(this._launchLocation);
    }
    if (this._hasImpactLocation) {
      result.impactLocation = EffectTarget_Type.toJson(this._impactLocation);
    }
    if (this._hasDeprecatedLaunchLocationOffset && !this._launchLocationOffset.isEmpty()) {
      result.launchLocationOffset = EffectLaunchMissile_ImpactLocationOffset.toJson(this._launchLocationOffset);
    }
    if (this._hasDeprecatedImpactLocationOffset && !this._impactLocationOffset.isEmpty()) {
      result.impactLocationOffset = EffectLaunchMissile_ImpactLocationOffset.toJson(this._impactLocationOffset);
    }
    if (this._hasOffsetStart) {
      result.offsetStart = EffectTarget_Type.toJson(this._offsetStart);
    }
    if (this._hasOffsetEnd) {
      result.offsetEnd = EffectTarget_Type.toJson(this._offsetEnd);
    }
    if (this._hasLaunchOffset && !this._launchOffset.isEmpty()) {
      result.launchOffset = EffectOffset.toJson(this._launchOffset);
    }
    if (this._hasImpactOffset && !this._impactOffset.isEmpty()) {
      result.impactOffset = EffectOffset.toJson(this._impactOffset);
    }
    if (this._hasUseMissileHeightAtDestination) {
      result.useMissileHeightAtDestination = JsonToBoolean.toJson(this._useMissileHeightAtDestination);
    }
    if (this._hasMissileEffect) {
      result.missileEffect = JsonToString.toJson(this._missileEffect);
    }
    if (this._hasMover) {
      result.mover = JsonToString.toJson(this._mover);
    }
    if (this._hasAreaSearchEffect) {
      result.areaSearchEffect = JsonToString.toJson(this._areaSearchEffect);
    }
    if (this._hasArriveOnSearchHit) {
      result.arriveOnSearchHit = JsonToBoolean.toJson(this._arriveOnSearchHit);
    }
    if (this._hasDynamicSearchArea) {
      result.dynamicSearchArea = JsonToBoolean.toJson(this._dynamicSearchArea);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {string}
   */
  get missileUnit() {
    return this._hasMissileUnit ? this._missileUnit : JsonToString.default;
  }
  get hasMissileUnit() {
    return this._hasMissileUnit;
  }
  setMissileUnit(path, value) {
    return {type: 'SET', path: path.concat(['missileUnit']), value};
  }
  deleteMissileUnit(path) {
    return {type: 'DELETE', path: path.concat(['missileUnit'])};
  }
  /**
   * @returns {number}
   */
  get missileDeathType() {
    return this._hasMissileDeathType ? this._missileDeathType : EffectLaunchMissile_MissileDeathType.default;
  }
  get hasMissileDeathType() {
    return this._hasMissileDeathType;
  }
  setMissileDeathType(path, value) {
    return {type: 'SET', path: path.concat(['missileDeathType']), value};
  }
  deleteMissileDeathType(path) {
    return {type: 'DELETE', path: path.concat(['missileDeathType'])};
  }
  /**
   * @returns {string}
   */
  get startEffect() {
    return this._hasStartEffect ? this._startEffect : JsonToString.default;
  }
  get hasStartEffect() {
    return this._hasStartEffect;
  }
  setStartEffect(path, value) {
    return {type: 'SET', path: path.concat(['startEffect']), value};
  }
  deleteStartEffect(path) {
    return {type: 'DELETE', path: path.concat(['startEffect'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasImpactEffect ? this._effect : JsonToString.default;
  }
  get hasImpactEffect() {
    return this._hasImpactEffect;
  }
  setImpactEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteImpactEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {number}
   */
  get launchLocation() {
    return this._hasLaunchLocation ? this._launchLocation : EffectTarget_Type.default;
  }
  get hasLaunchLocation() {
    return this._hasLaunchLocation;
  }
  setLaunchLocation(path, value) {
    return {type: 'SET', path: path.concat(['launchLocation']), value};
  }
  deleteLaunchLocation(path) {
    return {type: 'DELETE', path: path.concat(['launchLocation'])};
  }
  /**
   * @returns {number}
   */
  get impactLocation() {
    return this._hasImpactLocation ? this._impactLocation : EffectTarget_Type.default;
  }
  get hasImpactLocation() {
    return this._hasImpactLocation;
  }
  setImpactLocation(path, value) {
    return {type: 'SET', path: path.concat(['impactLocation']), value};
  }
  deleteImpactLocation(path) {
    return {type: 'DELETE', path: path.concat(['impactLocation'])};
  }
  /**
   * @returns {EffectLaunchMissile_ImpactLocationOffset}
   */
  get launchLocationOffset() {
    return this._hasDeprecatedLaunchLocationOffset ? this._launchLocationOffset : EffectLaunchMissile_ImpactLocationOffset.default;
  }
  get hasDeprecatedLaunchLocationOffset() {
    return this._hasDeprecatedLaunchLocationOffset;
  }
  setDeprecatedLaunchLocationOffset(path, value) {
    return {type: 'SET', path: path.concat(['launchLocationOffset']), value: value.toJson()};
  }
  deleteDeprecatedLaunchLocationOffset(path) {
    return {type: 'DELETE', path: path.concat(['launchLocationOffset'])};
  }
  /**
   * @returns {EffectLaunchMissile_ImpactLocationOffset}
   */
  get impactLocationOffset() {
    return this._hasDeprecatedImpactLocationOffset ? this._impactLocationOffset : EffectLaunchMissile_ImpactLocationOffset.default;
  }
  get hasDeprecatedImpactLocationOffset() {
    return this._hasDeprecatedImpactLocationOffset;
  }
  setDeprecatedImpactLocationOffset(path, value) {
    return {type: 'SET', path: path.concat(['impactLocationOffset']), value: value.toJson()};
  }
  deleteDeprecatedImpactLocationOffset(path) {
    return {type: 'DELETE', path: path.concat(['impactLocationOffset'])};
  }
  /**
   * @returns {number}
   */
  get offsetStart() {
    return this._hasOffsetStart ? this._offsetStart : EffectTarget_Type.default;
  }
  get hasOffsetStart() {
    return this._hasOffsetStart;
  }
  setOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['offsetStart']), value};
  }
  deleteOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['offsetStart'])};
  }
  /**
   * @returns {number}
   */
  get offsetEnd() {
    return this._hasOffsetEnd ? this._offsetEnd : EffectTarget_Type.default;
  }
  get hasOffsetEnd() {
    return this._hasOffsetEnd;
  }
  setOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['offsetEnd']), value};
  }
  deleteOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['offsetEnd'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get launchOffset() {
    return this._hasLaunchOffset ? this._launchOffset : EffectOffset.default;
  }
  get hasLaunchOffset() {
    return this._hasLaunchOffset;
  }
  setLaunchOffset(path, value) {
    return {type: 'SET', path: path.concat(['launchOffset']), value: value.toJson()};
  }
  deleteLaunchOffset(path) {
    return {type: 'DELETE', path: path.concat(['launchOffset'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get impactOffset() {
    return this._hasImpactOffset ? this._impactOffset : EffectOffset.default;
  }
  get hasImpactOffset() {
    return this._hasImpactOffset;
  }
  setImpactOffset(path, value) {
    return {type: 'SET', path: path.concat(['impactOffset']), value: value.toJson()};
  }
  deleteImpactOffset(path) {
    return {type: 'DELETE', path: path.concat(['impactOffset'])};
  }
  /**
   * @returns {boolean}
   */
  get useMissileHeightAtDestination() {
    return this._hasUseMissileHeightAtDestination ? this._useMissileHeightAtDestination : JsonToBoolean.default;
  }
  get hasUseMissileHeightAtDestination() {
    return this._hasUseMissileHeightAtDestination;
  }
  setUseMissileHeightAtDestination(path, value) {
    return {type: 'SET', path: path.concat(['useMissileHeightAtDestination']), value};
  }
  deleteUseMissileHeightAtDestination(path) {
    return {type: 'DELETE', path: path.concat(['useMissileHeightAtDestination'])};
  }
  /**
   * @returns {string}
   */
  get missileEffect() {
    return this._hasMissileEffect ? this._missileEffect : JsonToString.default;
  }
  get hasMissileEffect() {
    return this._hasMissileEffect;
  }
  setMissileEffect(path, value) {
    return {type: 'SET', path: path.concat(['missileEffect']), value};
  }
  deleteMissileEffect(path) {
    return {type: 'DELETE', path: path.concat(['missileEffect'])};
  }
  /**
   * @returns {string}
   */
  get mover() {
    return this._hasMover ? this._mover : JsonToString.default;
  }
  get hasMover() {
    return this._hasMover;
  }
  setMover(path, value) {
    return {type: 'SET', path: path.concat(['mover']), value};
  }
  deleteMover(path) {
    return {type: 'DELETE', path: path.concat(['mover'])};
  }
  /**
   * @returns {string}
   */
  get areaSearchEffect() {
    return this._hasAreaSearchEffect ? this._areaSearchEffect : JsonToString.default;
  }
  get hasAreaSearchEffect() {
    return this._hasAreaSearchEffect;
  }
  setAreaSearchEffect(path, value) {
    return {type: 'SET', path: path.concat(['areaSearchEffect']), value};
  }
  deleteAreaSearchEffect(path) {
    return {type: 'DELETE', path: path.concat(['areaSearchEffect'])};
  }
  /**
   * @returns {boolean}
   */
  get arriveOnSearchHit() {
    return this._hasArriveOnSearchHit ? this._arriveOnSearchHit : JsonToBoolean.default;
  }
  get hasArriveOnSearchHit() {
    return this._hasArriveOnSearchHit;
  }
  setArriveOnSearchHit(path, value) {
    return {type: 'SET', path: path.concat(['arriveOnSearchHit']), value};
  }
  deleteArriveOnSearchHit(path) {
    return {type: 'DELETE', path: path.concat(['arriveOnSearchHit'])};
  }
  /**
   * @returns {boolean}
   */
  get dynamicSearchArea() {
    return this._hasDynamicSearchArea ? this._dynamicSearchArea : JsonToBoolean.default;
  }
  get hasDynamicSearchArea() {
    return this._hasDynamicSearchArea;
  }
  setDynamicSearchArea(path, value) {
    return {type: 'SET', path: path.concat(['dynamicSearchArea']), value};
  }
  deleteDynamicSearchArea(path) {
    return {type: 'DELETE', path: path.concat(['dynamicSearchArea'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missileUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileUnit = true;
              copy._missileUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissileUnit) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileUnit = false;
              copy._missileUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missileDeathType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileDeathType = true;
              copy._missileDeathType = EffectLaunchMissile_MissileDeathType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissileDeathType) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileDeathType = false;
              copy._missileDeathType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasStartEffect = true;
              copy._startEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartEffect) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasStartEffect = false;
              copy._startEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactEffect) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasLaunchLocation = true;
              copy._launchLocation = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchLocation) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasLaunchLocation = false;
              copy._launchLocation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactLocation = true;
              copy._impactLocation = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactLocation) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactLocation = false;
              copy._impactLocation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchLocationOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasDeprecatedLaunchLocationOffset = true;
              copy._launchLocationOffset = EffectLaunchMissile_ImpactLocationOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedLaunchLocationOffset) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasDeprecatedLaunchLocationOffset = false;
              copy._launchLocationOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeprecatedLaunchLocationOffset) {
            const copy = new EffectLaunchMissile(this);
            copy._hasDeprecatedLaunchLocationOffset = true;
            copy._launchLocationOffset = EffectLaunchMissile_ImpactLocationOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._launchLocationOffset.apply(type, path.slice(1), value);
          if (newValue === this._launchLocationOffset) {
            return this;
          }
          const copy = new EffectLaunchMissile(this);
          copy._launchLocationOffset = copy._launchLocationOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "impactLocationOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasDeprecatedImpactLocationOffset = true;
              copy._impactLocationOffset = EffectLaunchMissile_ImpactLocationOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedImpactLocationOffset) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasDeprecatedImpactLocationOffset = false;
              copy._impactLocationOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeprecatedImpactLocationOffset) {
            const copy = new EffectLaunchMissile(this);
            copy._hasDeprecatedImpactLocationOffset = true;
            copy._impactLocationOffset = EffectLaunchMissile_ImpactLocationOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._impactLocationOffset.apply(type, path.slice(1), value);
          if (newValue === this._impactLocationOffset) {
            return this;
          }
          const copy = new EffectLaunchMissile(this);
          copy._impactLocationOffset = copy._impactLocationOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "offsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasOffsetStart = true;
              copy._offsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetStart) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasOffsetStart = false;
              copy._offsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasOffsetEnd = true;
              copy._offsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetEnd) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasOffsetEnd = false;
              copy._offsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasLaunchOffset = true;
              copy._launchOffset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchOffset) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasLaunchOffset = false;
              copy._launchOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLaunchOffset) {
            const copy = new EffectLaunchMissile(this);
            copy._hasLaunchOffset = true;
            copy._launchOffset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._launchOffset.apply(type, path.slice(1), value);
          if (newValue === this._launchOffset) {
            return this;
          }
          const copy = new EffectLaunchMissile(this);
          copy._launchOffset = copy._launchOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "impactOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactOffset = true;
              copy._impactOffset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactOffset) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasImpactOffset = false;
              copy._impactOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasImpactOffset) {
            const copy = new EffectLaunchMissile(this);
            copy._hasImpactOffset = true;
            copy._impactOffset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._impactOffset.apply(type, path.slice(1), value);
          if (newValue === this._impactOffset) {
            return this;
          }
          const copy = new EffectLaunchMissile(this);
          copy._impactOffset = copy._impactOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "useMissileHeightAtDestination": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasUseMissileHeightAtDestination = true;
              copy._useMissileHeightAtDestination = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseMissileHeightAtDestination) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasUseMissileHeightAtDestination = false;
              copy._useMissileHeightAtDestination = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missileEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileEffect = true;
              copy._missileEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissileEffect) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasMissileEffect = false;
              copy._missileEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mover": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasMover = true;
              copy._mover = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMover) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasMover = false;
              copy._mover = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "areaSearchEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasAreaSearchEffect = true;
              copy._areaSearchEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAreaSearchEffect) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasAreaSearchEffect = false;
              copy._areaSearchEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "arriveOnSearchHit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasArriveOnSearchHit = true;
              copy._arriveOnSearchHit = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArriveOnSearchHit) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasArriveOnSearchHit = false;
              copy._arriveOnSearchHit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dynamicSearchArea": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectLaunchMissile(this);
              copy._hasDynamicSearchArea = true;
              copy._dynamicSearchArea = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDynamicSearchArea) {
                return this;
              }
              const copy = new EffectLaunchMissile(this);
              copy._hasDynamicSearchArea = false;
              copy._dynamicSearchArea = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectLaunchMissile} other
   * @returns {EffectLaunchMissile}
   */
  merge(other) {
    const copy = new EffectLaunchMissile(this);
    if (other._hasTargetType) {
      copy._hasTargetType = true;
      copy._targetType = other._targetType;
    }
    if (other._hasMissileUnit) {
      copy._hasMissileUnit = true;
      copy._missileUnit = other._missileUnit;
    }
    if (other._hasMissileDeathType) {
      copy._hasMissileDeathType = true;
      copy._missileDeathType = other._missileDeathType;
    }
    if (other._hasStartEffect) {
      copy._hasStartEffect = true;
      copy._startEffect = other._startEffect;
    }
    if (other._hasImpactEffect) {
      copy._hasImpactEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasLaunchLocation) {
      copy._hasLaunchLocation = true;
      copy._launchLocation = other._launchLocation;
    }
    if (other._hasImpactLocation) {
      copy._hasImpactLocation = true;
      copy._impactLocation = other._impactLocation;
    }
    if (other._hasDeprecatedLaunchLocationOffset) {
      if (copy._hasDeprecatedLaunchLocationOffset) {
        copy._launchLocationOffset = copy.launchLocationOffset.merge(other.launchLocationOffset);
      } else {
        copy._launchLocationOffset = other._launchLocationOffset;
      }
      copy._hasDeprecatedLaunchLocationOffset = true;
    }
    if (other._hasDeprecatedImpactLocationOffset) {
      if (copy._hasDeprecatedImpactLocationOffset) {
        copy._impactLocationOffset = copy.impactLocationOffset.merge(other.impactLocationOffset);
      } else {
        copy._impactLocationOffset = other._impactLocationOffset;
      }
      copy._hasDeprecatedImpactLocationOffset = true;
    }
    if (other._hasOffsetStart) {
      copy._hasOffsetStart = true;
      copy._offsetStart = other._offsetStart;
    }
    if (other._hasOffsetEnd) {
      copy._hasOffsetEnd = true;
      copy._offsetEnd = other._offsetEnd;
    }
    if (other._hasLaunchOffset) {
      if (copy._hasLaunchOffset) {
        copy._launchOffset = copy.launchOffset.merge(other.launchOffset);
      } else {
        copy._launchOffset = other._launchOffset;
      }
      copy._hasLaunchOffset = true;
    }
    if (other._hasImpactOffset) {
      if (copy._hasImpactOffset) {
        copy._impactOffset = copy.impactOffset.merge(other.impactOffset);
      } else {
        copy._impactOffset = other._impactOffset;
      }
      copy._hasImpactOffset = true;
    }
    if (other._hasUseMissileHeightAtDestination) {
      copy._hasUseMissileHeightAtDestination = true;
      copy._useMissileHeightAtDestination = other._useMissileHeightAtDestination;
    }
    if (other._hasMissileEffect) {
      copy._hasMissileEffect = true;
      copy._missileEffect = other._missileEffect;
    }
    if (other._hasMover) {
      copy._hasMover = true;
      copy._mover = other._mover;
    }
    if (other._hasAreaSearchEffect) {
      copy._hasAreaSearchEffect = true;
      copy._areaSearchEffect = other._areaSearchEffect;
    }
    if (other._hasArriveOnSearchHit) {
      copy._hasArriveOnSearchHit = true;
      copy._arriveOnSearchHit = other._arriveOnSearchHit;
    }
    if (other._hasDynamicSearchArea) {
      copy._hasDynamicSearchArea = true;
      copy._dynamicSearchArea = other._dynamicSearchArea;
    }
    return copy;
  }
}
EffectLaunchMissile.default = new EffectLaunchMissile();
EffectLaunchMissile.ImpactLocationOffset = EffectLaunchMissile_ImpactLocationOffset;
EffectLaunchMissile.MissileDeathType = EffectLaunchMissile_MissileDeathType;
class EffectLaunchMissile_Builder {
  constructor(value) {
    this._value = new EffectLaunchMissile(value);
  }
  build() {
    return new EffectLaunchMissile(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setMissileUnit(value) {
    this._value._hasMissileUnit = true;
    this._value._missileUnit = value;
    return this;
  }
  deleteMissileUnit() {
    this._value._hasMissileUnit = false;
    this._value._missileUnit = null;
    return this;
  }
  setMissileDeathType(value) {
    this._value._hasMissileDeathType = true;
    this._value._missileDeathType = value;
    return this;
  }
  deleteMissileDeathType() {
    this._value._hasMissileDeathType = false;
    this._value._missileDeathType = null;
    return this;
  }
  setStartEffect(value) {
    this._value._hasStartEffect = true;
    this._value._startEffect = value;
    return this;
  }
  deleteStartEffect() {
    this._value._hasStartEffect = false;
    this._value._startEffect = null;
    return this;
  }
  setImpactEffect(value) {
    this._value._hasImpactEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteImpactEffect() {
    this._value._hasImpactEffect = false;
    this._value._effect = null;
    return this;
  }
  setLaunchLocation(value) {
    this._value._hasLaunchLocation = true;
    this._value._launchLocation = value;
    return this;
  }
  deleteLaunchLocation() {
    this._value._hasLaunchLocation = false;
    this._value._launchLocation = null;
    return this;
  }
  setImpactLocation(value) {
    this._value._hasImpactLocation = true;
    this._value._impactLocation = value;
    return this;
  }
  deleteImpactLocation() {
    this._value._hasImpactLocation = false;
    this._value._impactLocation = null;
    return this;
  }
  setDeprecatedLaunchLocationOffset(value) {
    this._value._hasDeprecatedLaunchLocationOffset = true;
    this._value._launchLocationOffset = value;
    return this;
  }
  deleteDeprecatedLaunchLocationOffset() {
    this._value._hasDeprecatedLaunchLocationOffset = false;
    this._value._launchLocationOffset = null;
    return this;
  }
  setDeprecatedImpactLocationOffset(value) {
    this._value._hasDeprecatedImpactLocationOffset = true;
    this._value._impactLocationOffset = value;
    return this;
  }
  deleteDeprecatedImpactLocationOffset() {
    this._value._hasDeprecatedImpactLocationOffset = false;
    this._value._impactLocationOffset = null;
    return this;
  }
  setOffsetStart(value) {
    this._value._hasOffsetStart = true;
    this._value._offsetStart = value;
    return this;
  }
  deleteOffsetStart() {
    this._value._hasOffsetStart = false;
    this._value._offsetStart = null;
    return this;
  }
  setOffsetEnd(value) {
    this._value._hasOffsetEnd = true;
    this._value._offsetEnd = value;
    return this;
  }
  deleteOffsetEnd() {
    this._value._hasOffsetEnd = false;
    this._value._offsetEnd = null;
    return this;
  }
  setLaunchOffset(value) {
    this._value._hasLaunchOffset = true;
    this._value._launchOffset = value;
    return this;
  }
  deleteLaunchOffset() {
    this._value._hasLaunchOffset = false;
    this._value._launchOffset = null;
    return this;
  }
  setImpactOffset(value) {
    this._value._hasImpactOffset = true;
    this._value._impactOffset = value;
    return this;
  }
  deleteImpactOffset() {
    this._value._hasImpactOffset = false;
    this._value._impactOffset = null;
    return this;
  }
  setUseMissileHeightAtDestination(value) {
    this._value._hasUseMissileHeightAtDestination = true;
    this._value._useMissileHeightAtDestination = value;
    return this;
  }
  deleteUseMissileHeightAtDestination() {
    this._value._hasUseMissileHeightAtDestination = false;
    this._value._useMissileHeightAtDestination = null;
    return this;
  }
  setMissileEffect(value) {
    this._value._hasMissileEffect = true;
    this._value._missileEffect = value;
    return this;
  }
  deleteMissileEffect() {
    this._value._hasMissileEffect = false;
    this._value._missileEffect = null;
    return this;
  }
  setMover(value) {
    this._value._hasMover = true;
    this._value._mover = value;
    return this;
  }
  deleteMover() {
    this._value._hasMover = false;
    this._value._mover = null;
    return this;
  }
  setAreaSearchEffect(value) {
    this._value._hasAreaSearchEffect = true;
    this._value._areaSearchEffect = value;
    return this;
  }
  deleteAreaSearchEffect() {
    this._value._hasAreaSearchEffect = false;
    this._value._areaSearchEffect = null;
    return this;
  }
  setArriveOnSearchHit(value) {
    this._value._hasArriveOnSearchHit = true;
    this._value._arriveOnSearchHit = value;
    return this;
  }
  deleteArriveOnSearchHit() {
    this._value._hasArriveOnSearchHit = false;
    this._value._arriveOnSearchHit = null;
    return this;
  }
  setDynamicSearchArea(value) {
    this._value._hasDynamicSearchArea = true;
    this._value._dynamicSearchArea = value;
    return this;
  }
  deleteDynamicSearchArea() {
    this._value._hasDynamicSearchArea = false;
    this._value._dynamicSearchArea = null;
    return this;
  }
}
EffectLaunchMissile.Builder = EffectLaunchMissile_Builder;
class EffectLaunchMissile_WithParent {
  /**
   * @param {EffectLaunchMissile} value
   * @param {EffectLaunchMissile_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectLaunchMissile.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (this._cachedTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = this._value.targetType;
      } else {
        this._cachedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedTargetType;
  }
  get hasMissileUnit() {
    if (this._cachedHasMissileUnit === undefined) {
      if (this._value.hasMissileUnit) {
        this._cachedHasMissileUnit = true;
      } else {
        this._cachedHasMissileUnit = this._parent ? this._parent.hasMissileUnit : false;
      }
    }
    return this._cachedHasMissileUnit;
  }
  get missileUnit() {
    if (this._cachedMissileUnit === undefined) {
      if (this._value.hasMissileUnit) {
        this._cachedMissileUnit = this._value.missileUnit;
      } else {
        this._cachedMissileUnit = this._parent ? this._parent.missileUnit : this._value.missileUnit;
      }
    }
    return this._cachedMissileUnit;
  }
  get hasMissileDeathType() {
    if (this._cachedHasMissileDeathType === undefined) {
      if (this._value.hasMissileDeathType) {
        this._cachedHasMissileDeathType = true;
      } else {
        this._cachedHasMissileDeathType = this._parent ? this._parent.hasMissileDeathType : false;
      }
    }
    return this._cachedHasMissileDeathType;
  }
  get missileDeathType() {
    if (this._cachedMissileDeathType === undefined) {
      if (this._value.hasMissileDeathType) {
        this._cachedMissileDeathType = this._value.missileDeathType;
      } else {
        this._cachedMissileDeathType = this._parent ? this._parent.missileDeathType : this._value.missileDeathType;
      }
    }
    return this._cachedMissileDeathType;
  }
  get hasStartEffect() {
    if (this._cachedHasStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedHasStartEffect = true;
      } else {
        this._cachedHasStartEffect = this._parent ? this._parent.hasStartEffect : false;
      }
    }
    return this._cachedHasStartEffect;
  }
  get startEffect() {
    if (this._cachedStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedStartEffect = this._value.startEffect;
      } else {
        this._cachedStartEffect = this._parent ? this._parent.startEffect : this._value.startEffect;
      }
    }
    return this._cachedStartEffect;
  }
  get hasImpactEffect() {
    if (this._cachedHasImpactEffect === undefined) {
      if (this._value.hasImpactEffect) {
        this._cachedHasImpactEffect = true;
      } else {
        this._cachedHasImpactEffect = this._parent ? this._parent.hasImpactEffect : false;
      }
    }
    return this._cachedHasImpactEffect;
  }
  get effect() {
    if (this._cachedImpactEffect === undefined) {
      if (this._value.hasImpactEffect) {
        this._cachedImpactEffect = this._value.effect;
      } else {
        this._cachedImpactEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedImpactEffect;
  }
  get hasLaunchLocation() {
    if (this._cachedHasLaunchLocation === undefined) {
      if (this._value.hasLaunchLocation) {
        this._cachedHasLaunchLocation = true;
      } else {
        this._cachedHasLaunchLocation = this._parent ? this._parent.hasLaunchLocation : false;
      }
    }
    return this._cachedHasLaunchLocation;
  }
  get launchLocation() {
    if (this._cachedLaunchLocation === undefined) {
      if (this._value.hasLaunchLocation) {
        this._cachedLaunchLocation = this._value.launchLocation;
      } else {
        this._cachedLaunchLocation = this._parent ? this._parent.launchLocation : this._value.launchLocation;
      }
    }
    return this._cachedLaunchLocation;
  }
  get hasImpactLocation() {
    if (this._cachedHasImpactLocation === undefined) {
      if (this._value.hasImpactLocation) {
        this._cachedHasImpactLocation = true;
      } else {
        this._cachedHasImpactLocation = this._parent ? this._parent.hasImpactLocation : false;
      }
    }
    return this._cachedHasImpactLocation;
  }
  get impactLocation() {
    if (this._cachedImpactLocation === undefined) {
      if (this._value.hasImpactLocation) {
        this._cachedImpactLocation = this._value.impactLocation;
      } else {
        this._cachedImpactLocation = this._parent ? this._parent.impactLocation : this._value.impactLocation;
      }
    }
    return this._cachedImpactLocation;
  }
  get hasDeprecatedLaunchLocationOffset() {
    if (this._cachedHasDeprecatedLaunchLocationOffset === undefined) {
      if (this._value.hasDeprecatedLaunchLocationOffset) {
        this._cachedHasDeprecatedLaunchLocationOffset = true;
      } else {
        this._cachedHasDeprecatedLaunchLocationOffset = this._parent ? this._parent.hasDeprecatedLaunchLocationOffset : false;
      }
    }
    return this._cachedHasDeprecatedLaunchLocationOffset;
  }
  get launchLocationOffset() {
    if (!this._cachedDeprecatedLaunchLocationOffset) {
      if (this._value.hasDeprecatedLaunchLocationOffset) {
        this._cachedDeprecatedLaunchLocationOffset = new EffectLaunchMissile_ImpactLocationOffset.WithParent(this._value.launchLocationOffset, this._parent && this._parent.hasDeprecatedLaunchLocationOffset ? this._parent.launchLocationOffset : null);
      } else {
        this._cachedDeprecatedLaunchLocationOffset = this._parent ? new EffectLaunchMissile_ImpactLocationOffset.WithParent(EffectLaunchMissile_ImpactLocationOffset.default, this._parent.launchLocationOffset) : EffectLaunchMissile_ImpactLocationOffset.WithParent.default;
      }
    }
    return this._cachedDeprecatedLaunchLocationOffset;
  }
  get hasDeprecatedImpactLocationOffset() {
    if (this._cachedHasDeprecatedImpactLocationOffset === undefined) {
      if (this._value.hasDeprecatedImpactLocationOffset) {
        this._cachedHasDeprecatedImpactLocationOffset = true;
      } else {
        this._cachedHasDeprecatedImpactLocationOffset = this._parent ? this._parent.hasDeprecatedImpactLocationOffset : false;
      }
    }
    return this._cachedHasDeprecatedImpactLocationOffset;
  }
  get impactLocationOffset() {
    if (!this._cachedDeprecatedImpactLocationOffset) {
      if (this._value.hasDeprecatedImpactLocationOffset) {
        this._cachedDeprecatedImpactLocationOffset = new EffectLaunchMissile_ImpactLocationOffset.WithParent(this._value.impactLocationOffset, this._parent && this._parent.hasDeprecatedImpactLocationOffset ? this._parent.impactLocationOffset : null);
      } else {
        this._cachedDeprecatedImpactLocationOffset = this._parent ? new EffectLaunchMissile_ImpactLocationOffset.WithParent(EffectLaunchMissile_ImpactLocationOffset.default, this._parent.impactLocationOffset) : EffectLaunchMissile_ImpactLocationOffset.WithParent.default;
      }
    }
    return this._cachedDeprecatedImpactLocationOffset;
  }
  get hasOffsetStart() {
    if (this._cachedHasOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedHasOffsetStart = true;
      } else {
        this._cachedHasOffsetStart = this._parent ? this._parent.hasOffsetStart : false;
      }
    }
    return this._cachedHasOffsetStart;
  }
  get offsetStart() {
    if (this._cachedOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedOffsetStart = this._value.offsetStart;
      } else {
        this._cachedOffsetStart = this._parent ? this._parent.offsetStart : this._value.offsetStart;
      }
    }
    return this._cachedOffsetStart;
  }
  get hasOffsetEnd() {
    if (this._cachedHasOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedHasOffsetEnd = true;
      } else {
        this._cachedHasOffsetEnd = this._parent ? this._parent.hasOffsetEnd : false;
      }
    }
    return this._cachedHasOffsetEnd;
  }
  get offsetEnd() {
    if (this._cachedOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedOffsetEnd = this._value.offsetEnd;
      } else {
        this._cachedOffsetEnd = this._parent ? this._parent.offsetEnd : this._value.offsetEnd;
      }
    }
    return this._cachedOffsetEnd;
  }
  get hasLaunchOffset() {
    if (this._cachedHasLaunchOffset === undefined) {
      if (this._value.hasLaunchOffset) {
        this._cachedHasLaunchOffset = true;
      } else {
        this._cachedHasLaunchOffset = this._parent ? this._parent.hasLaunchOffset : false;
      }
    }
    return this._cachedHasLaunchOffset;
  }
  get launchOffset() {
    if (!this._cachedLaunchOffset) {
      if (this._value.hasLaunchOffset) {
        this._cachedLaunchOffset = new EffectOffset.WithParent(this._value.launchOffset, this._parent && this._parent.hasLaunchOffset ? this._parent.launchOffset : null);
      } else {
        this._cachedLaunchOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.launchOffset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedLaunchOffset;
  }
  get hasImpactOffset() {
    if (this._cachedHasImpactOffset === undefined) {
      if (this._value.hasImpactOffset) {
        this._cachedHasImpactOffset = true;
      } else {
        this._cachedHasImpactOffset = this._parent ? this._parent.hasImpactOffset : false;
      }
    }
    return this._cachedHasImpactOffset;
  }
  get impactOffset() {
    if (!this._cachedImpactOffset) {
      if (this._value.hasImpactOffset) {
        this._cachedImpactOffset = new EffectOffset.WithParent(this._value.impactOffset, this._parent && this._parent.hasImpactOffset ? this._parent.impactOffset : null);
      } else {
        this._cachedImpactOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.impactOffset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedImpactOffset;
  }
  get hasUseMissileHeightAtDestination() {
    if (this._cachedHasUseMissileHeightAtDestination === undefined) {
      if (this._value.hasUseMissileHeightAtDestination) {
        this._cachedHasUseMissileHeightAtDestination = true;
      } else {
        this._cachedHasUseMissileHeightAtDestination = this._parent ? this._parent.hasUseMissileHeightAtDestination : false;
      }
    }
    return this._cachedHasUseMissileHeightAtDestination;
  }
  get useMissileHeightAtDestination() {
    if (this._cachedUseMissileHeightAtDestination === undefined) {
      if (this._value.hasUseMissileHeightAtDestination) {
        this._cachedUseMissileHeightAtDestination = this._value.useMissileHeightAtDestination;
      } else {
        this._cachedUseMissileHeightAtDestination = this._parent ? this._parent.useMissileHeightAtDestination : this._value.useMissileHeightAtDestination;
      }
    }
    return this._cachedUseMissileHeightAtDestination;
  }
  get hasMissileEffect() {
    if (this._cachedHasMissileEffect === undefined) {
      if (this._value.hasMissileEffect) {
        this._cachedHasMissileEffect = true;
      } else {
        this._cachedHasMissileEffect = this._parent ? this._parent.hasMissileEffect : false;
      }
    }
    return this._cachedHasMissileEffect;
  }
  get missileEffect() {
    if (this._cachedMissileEffect === undefined) {
      if (this._value.hasMissileEffect) {
        this._cachedMissileEffect = this._value.missileEffect;
      } else {
        this._cachedMissileEffect = this._parent ? this._parent.missileEffect : this._value.missileEffect;
      }
    }
    return this._cachedMissileEffect;
  }
  get hasMover() {
    if (this._cachedHasMover === undefined) {
      if (this._value.hasMover) {
        this._cachedHasMover = true;
      } else {
        this._cachedHasMover = this._parent ? this._parent.hasMover : false;
      }
    }
    return this._cachedHasMover;
  }
  get mover() {
    if (this._cachedMover === undefined) {
      if (this._value.hasMover) {
        this._cachedMover = this._value.mover;
      } else {
        this._cachedMover = this._parent ? this._parent.mover : this._value.mover;
      }
    }
    return this._cachedMover;
  }
  get hasAreaSearchEffect() {
    if (this._cachedHasAreaSearchEffect === undefined) {
      if (this._value.hasAreaSearchEffect) {
        this._cachedHasAreaSearchEffect = true;
      } else {
        this._cachedHasAreaSearchEffect = this._parent ? this._parent.hasAreaSearchEffect : false;
      }
    }
    return this._cachedHasAreaSearchEffect;
  }
  get areaSearchEffect() {
    if (this._cachedAreaSearchEffect === undefined) {
      if (this._value.hasAreaSearchEffect) {
        this._cachedAreaSearchEffect = this._value.areaSearchEffect;
      } else {
        this._cachedAreaSearchEffect = this._parent ? this._parent.areaSearchEffect : this._value.areaSearchEffect;
      }
    }
    return this._cachedAreaSearchEffect;
  }
  get hasArriveOnSearchHit() {
    if (this._cachedHasArriveOnSearchHit === undefined) {
      if (this._value.hasArriveOnSearchHit) {
        this._cachedHasArriveOnSearchHit = true;
      } else {
        this._cachedHasArriveOnSearchHit = this._parent ? this._parent.hasArriveOnSearchHit : false;
      }
    }
    return this._cachedHasArriveOnSearchHit;
  }
  get arriveOnSearchHit() {
    if (this._cachedArriveOnSearchHit === undefined) {
      if (this._value.hasArriveOnSearchHit) {
        this._cachedArriveOnSearchHit = this._value.arriveOnSearchHit;
      } else {
        this._cachedArriveOnSearchHit = this._parent ? this._parent.arriveOnSearchHit : this._value.arriveOnSearchHit;
      }
    }
    return this._cachedArriveOnSearchHit;
  }
  get hasDynamicSearchArea() {
    if (this._cachedHasDynamicSearchArea === undefined) {
      if (this._value.hasDynamicSearchArea) {
        this._cachedHasDynamicSearchArea = true;
      } else {
        this._cachedHasDynamicSearchArea = this._parent ? this._parent.hasDynamicSearchArea : false;
      }
    }
    return this._cachedHasDynamicSearchArea;
  }
  get dynamicSearchArea() {
    if (this._cachedDynamicSearchArea === undefined) {
      if (this._value.hasDynamicSearchArea) {
        this._cachedDynamicSearchArea = this._value.dynamicSearchArea;
      } else {
        this._cachedDynamicSearchArea = this._parent ? this._parent.dynamicSearchArea : this._value.dynamicSearchArea;
      }
    }
    return this._cachedDynamicSearchArea;
  }
  update(current, parent) {
    const result = new EffectLaunchMissile_WithParent(current, parent);
    if (this._cachedDeprecatedLaunchLocationOffset && this._value.hasDeprecatedLaunchLocationOffset && current.hasDeprecatedLaunchLocationOffset) {
      if (this._value.launchLocationOffset === current.launchLocationOffset && this._parent === parent) {
        result._cachedDeprecatedLaunchLocationOffset = this._cachedDeprecatedLaunchLocationOffset;
      } else {
        result._cachedDeprecatedLaunchLocationOffset = this._cachedDeprecatedLaunchLocationOffset.update(current.launchLocationOffset, parent && parent.hasDeprecatedLaunchLocationOffset ? parent.launchLocationOffset : null);
      }
    }
    if (this._cachedDeprecatedImpactLocationOffset && this._value.hasDeprecatedImpactLocationOffset && current.hasDeprecatedImpactLocationOffset) {
      if (this._value.impactLocationOffset === current.impactLocationOffset && this._parent === parent) {
        result._cachedDeprecatedImpactLocationOffset = this._cachedDeprecatedImpactLocationOffset;
      } else {
        result._cachedDeprecatedImpactLocationOffset = this._cachedDeprecatedImpactLocationOffset.update(current.impactLocationOffset, parent && parent.hasDeprecatedImpactLocationOffset ? parent.impactLocationOffset : null);
      }
    }
    if (this._cachedLaunchOffset && this._value.hasLaunchOffset && current.hasLaunchOffset) {
      if (this._value.launchOffset === current.launchOffset && this._parent === parent) {
        result._cachedLaunchOffset = this._cachedLaunchOffset;
      } else {
        result._cachedLaunchOffset = this._cachedLaunchOffset.update(current.launchOffset, parent && parent.hasLaunchOffset ? parent.launchOffset : null);
      }
    }
    if (this._cachedImpactOffset && this._value.hasImpactOffset && current.hasImpactOffset) {
      if (this._value.impactOffset === current.impactOffset && this._parent === parent) {
        result._cachedImpactOffset = this._cachedImpactOffset;
      } else {
        result._cachedImpactOffset = this._cachedImpactOffset.update(current.impactOffset, parent && parent.hasImpactOffset ? parent.impactOffset : null);
      }
    }
    return result;
  }
}
EffectLaunchMissile_WithParent.default = new EffectLaunchMissile_WithParent(EffectLaunchMissile.default, null);
EffectLaunchMissile.WithParent = EffectLaunchMissile_WithParent;
class EffectLaunchMissile_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 1,
        protoType: 14,
        protoName: "target_type",
        type: EffectTargetType_Type,
        options: {
          comments: "Determines the target type for the effect.\n",
          default: "UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get missileUnit() {
    if (!this._missileUnit) {
      this._missileUnit = {
        name: "missileUnit",
        Name: "MissileUnit",
        number: 2,
        protoType: 9,
        protoName: "missile_unit",
        type: JsonToString,
        options: {
          comments: "The type of Unit used as a missile. If set to **None**, the unit specified in launch location will be used (typically caster or target, useful to create knockback effects).",
          valueDropdown: "SupportedBaseUnitNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missileUnit;
  }
  get missileDeathType() {
    if (!this._missileDeathType) {
      this._missileDeathType = {
        name: "missileDeathType",
        Name: "MissileDeathType",
        number: 3,
        protoType: 14,
        protoName: "missile_death_type",
        type: EffectLaunchMissile_MissileDeathType,
        options: {
          comments: "Determines what happens to the missile unit on impact.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missileDeathType;
  }
  get startEffect() {
    if (!this._startEffect) {
      this._startEffect = {
        name: "startEffect",
        Name: "StartEffect",
        number: 4,
        protoType: 9,
        protoName: "start_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the missile is launched.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startEffect;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "ImpactEffect",
        number: 5,
        protoType: 9,
        protoName: "impact_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the missile impacts its target.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get launchLocation() {
    if (!this._launchLocation) {
      this._launchLocation = {
        name: "launchLocation",
        Name: "LaunchLocation",
        number: 6,
        protoType: 14,
        protoName: "launch_location",
        type: EffectTarget_Type,
        options: {
          comments: "Where the missile will be launched from.",
          default: "SOURCE_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchLocation;
  }
  get impactLocation() {
    if (!this._impactLocation) {
      this._impactLocation = {
        name: "impactLocation",
        Name: "ImpactLocation",
        number: 7,
        protoType: 14,
        protoName: "impact_location",
        type: EffectTarget_Type,
        options: {
          comments: "Where the missile will impact.",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactLocation;
  }
  get launchLocationOffset() {
    if (!this._launchLocationOffset) {
      this._launchLocationOffset = {
        name: "launchLocationOffset",
        Name: "DeprecatedLaunchLocationOffset",
        number: 1008,
        protoType: 11,
        protoName: "deprecated_launch_location_offset",
        type: EffectLaunchMissile_ImpactLocationOffset,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchLocationOffset;
  }
  get impactLocationOffset() {
    if (!this._impactLocationOffset) {
      this._impactLocationOffset = {
        name: "impactLocationOffset",
        Name: "DeprecatedImpactLocationOffset",
        number: 1009,
        protoType: 11,
        protoName: "deprecated_impact_location_offset",
        type: EffectLaunchMissile_ImpactLocationOffset,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactLocationOffset;
  }
  get offsetStart() {
    if (!this._offsetStart) {
      this._offsetStart = {
        name: "offsetStart",
        Name: "OffsetStart",
        number: 8,
        protoType: 14,
        protoName: "offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Offset start & end together determines the \"facing\" of this effect. This facing will be used to interpret offsets and also will be used as the initial facing of the created missile unit.\nIf offset start & end are both set to non-none values and the specified locations don\'t overlap, the effect will face from start to end.\nIf offset start & end are both specified but are overlapping, and the offset start is an unit (e.g., caster unit), the facing of that unit will be used.\nIf offset start & end are not specified, or specified but cannot determine the facing using the above rules, the facing will be determined by launch & impact location instead using the same rules as above.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetStart;
  }
  get offsetEnd() {
    if (!this._offsetEnd) {
      this._offsetEnd = {
        name: "offsetEnd",
        Name: "OffsetEnd",
        number: 9,
        protoType: 14,
        protoName: "offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetEnd;
  }
  get launchOffset() {
    if (!this._launchOffset) {
      this._launchOffset = {
        name: "launchOffset",
        Name: "LaunchOffset",
        number: 10,
        protoType: 11,
        protoName: "launch_offset",
        type: EffectOffset,
        options: {
          comments: "The offset coordinates for the missile\'s launch location. Offsets are relative to the effect\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchOffset;
  }
  get impactOffset() {
    if (!this._impactOffset) {
      this._impactOffset = {
        name: "impactOffset",
        Name: "ImpactOffset",
        number: 11,
        protoType: 11,
        protoName: "impact_offset",
        type: EffectOffset,
        options: {
          comments: "The offset coordinates for the missile\'s impact location. Offsets are relative to the effect\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactOffset;
  }
  get useMissileHeightAtDestination() {
    if (!this._useMissileHeightAtDestination) {
      this._useMissileHeightAtDestination = {
        name: "useMissileHeightAtDestination",
        Name: "UseMissileHeightAtDestination",
        number: 12,
        protoType: 8,
        protoName: "use_missile_height_at_destination",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the missile unit\'s height will be considered when when calculating the impact location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useMissileHeightAtDestination;
  }
  get missileEffect() {
    if (!this._missileEffect) {
      this._missileEffect = {
        name: "missileEffect",
        Name: "MissileEffect",
        number: 21,
        protoType: 9,
        protoName: "missile_effect",
        type: JsonToString,
        options: {
          comments: "The effect applied to the missile when it\'s created.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missileEffect;
  }
  get mover() {
    if (!this._mover) {
      this._mover = {
        name: "mover",
        Name: "Mover",
        number: 31,
        protoType: 9,
        protoName: "mover",
        type: JsonToString,
        options: {
          comments: "The mover that determines how the missile will travel.",
          valueDropdown: "SupportedMoverNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mover;
  }
  get areaSearchEffect() {
    if (!this._areaSearchEffect) {
      this._areaSearchEffect = {
        name: "areaSearchEffect",
        Name: "AreaSearchEffect",
        number: 41,
        protoType: 9,
        protoName: "area_search_effect",
        type: JsonToString,
        options: {
          comments: "Tie a Search effect to a missile unit, which will apply every update",
          valueDropdown: "SupportedAreaSearchEffectNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._areaSearchEffect;
  }
  get arriveOnSearchHit() {
    if (!this._arriveOnSearchHit) {
      this._arriveOnSearchHit = {
        name: "arriveOnSearchHit",
        Name: "ArriveOnSearchHit",
        number: 42,
        protoType: 8,
        protoName: "arrive_on_search_hit",
        type: JsonToBoolean,
        options: {
          comments: "This flag specifies if the Missile counts as \"HitTarget\" (reached it\'s destination) if the missile \"Search Effect\" finds a target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arriveOnSearchHit;
  }
  get dynamicSearchArea() {
    if (!this._dynamicSearchArea) {
      this._dynamicSearchArea = {
        name: "dynamicSearchArea",
        Name: "DynamicSearchArea",
        number: 43,
        protoType: 8,
        protoName: "dynamic_search_area",
        type: JsonToBoolean,
        options: {
          comments: "If set, if the search effect is a rectangular search, the length will automatically extend to make sure there are no gaps in the search radiuses, based on the speed of the projectile.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dynamicSearchArea;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.missileUnit,
        this.missileDeathType,
        this.startEffect,
        this.effect,
        this.launchLocation,
        this.impactLocation,
        this.launchLocationOffset,
        this.impactLocationOffset,
        this.offsetStart,
        this.offsetEnd,
        this.launchOffset,
        this.impactOffset,
        this.useMissileHeightAtDestination,
        this.missileEffect,
        this.mover,
        this.areaSearchEffect,
        this.arriveOnSearchHit,
        this.dynamicSearchArea,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissileUnit",
        Name: "DummyOneofForMissileUnit",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissileDeathType",
        Name: "DummyOneofForMissileDeathType",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartEffect",
        Name: "DummyOneofForStartEffect",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactEffect",
        Name: "DummyOneofForImpactEffect",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchLocation",
        Name: "DummyOneofForLaunchLocation",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactLocation",
        Name: "DummyOneofForImpactLocation",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedLaunchLocationOffset",
        Name: "DummyOneofForDeprecatedLaunchLocationOffset",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedImpactLocationOffset",
        Name: "DummyOneofForDeprecatedImpactLocationOffset",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetStart",
        Name: "DummyOneofForOffsetStart",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetEnd",
        Name: "DummyOneofForOffsetEnd",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchOffset",
        Name: "DummyOneofForLaunchOffset",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactOffset",
        Name: "DummyOneofForImpactOffset",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseMissileHeightAtDestination",
        Name: "DummyOneofForUseMissileHeightAtDestination",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissileEffect",
        Name: "DummyOneofForMissileEffect",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMover",
        Name: "DummyOneofForMover",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAreaSearchEffect",
        Name: "DummyOneofForAreaSearchEffect",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForArriveOnSearchHit",
        Name: "DummyOneofForArriveOnSearchHit",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDynamicSearchArea",
        Name: "DummyOneofForDynamicSearchArea",
        fields: [
          this.fields[18],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectLaunchMissile.descriptor = new EffectLaunchMissile_Descriptor();
export class EffectDamage {
  get descriptor() {
    return EffectDamage.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasDamageAmount = false;
    this._damageAmount = null;
    this._expressions = [];
    this._expressionsAfterBehaviorModifiers = [];
    this._expressionsAfterDamageResponse = [];
    this._hasCardName = false;
    this._cardName = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasDamageAmount) return false;
    if (this._expressions.length > 0) return false;
    if (this._expressionsAfterBehaviorModifiers.length > 0) return false;
    if (this._expressionsAfterDamageResponse.length > 0) return false;
    if (this._hasCardName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectDamage) {
      return value;
    }
    return EffectDamage.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectDamage();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.damageAmount != null) {
      result._hasDamageAmount = true;
      result._damageAmount = JsonToDouble.fromJson(json.damageAmount);
    }
    result._expressions = JsonToList(json.expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    result._expressionsAfterBehaviorModifiers = JsonToList(json.expressionsAfterBehaviorModifiers, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    result._expressionsAfterDamageResponse = JsonToList(json.expressionsAfterDamageResponse, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasDamageAmount) {
      result.damageAmount = JsonToDouble.toJson(this._damageAmount);
    }
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._expressionsAfterBehaviorModifiers.length > 0) {
      result.expressionsAfterBehaviorModifiers = ArrayToJson(this._expressionsAfterBehaviorModifiers, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._expressionsAfterDamageResponse.length > 0) {
      result.expressionsAfterDamageResponse = ArrayToJson(this._expressionsAfterDamageResponse, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get damageAmount() {
    return this._hasDamageAmount ? this._damageAmount : JsonToDouble.default;
  }
  get hasDamageAmount() {
    return this._hasDamageAmount;
  }
  setDamageAmount(path, value) {
    return {type: 'SET', path: path.concat(['damageAmount']), value};
  }
  deleteDamageAmount(path) {
    return {type: 'DELETE', path: path.concat(['damageAmount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressionsAfterBehaviorModifiers() {
    return this._expressionsAfterBehaviorModifiers;
  }
  addExpressionsAfterBehaviorModifiers(path, value) {
    return {type: 'ADD', path: path.concat(['expressionsAfterBehaviorModifiers']), value: value.toJson()};
  }
  setExpressionsAfterBehaviorModifiers(path, value) {
    return {type: 'SET', path: path.concat(['expressionsAfterBehaviorModifiers']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsAfterBehaviorModifiersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressionsAfterBehaviorModifiers', key]), value: value.toJson()};
  }
  deleteExpressionsAfterBehaviorModifiers(path) {
    return {type: 'DELETE', path: path.concat(['expressionsAfterBehaviorModifiers'])};
  }
  deleteExpressionsAfterBehaviorModifiersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressionsAfterBehaviorModifiers', key])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressionsAfterDamageResponse() {
    return this._expressionsAfterDamageResponse;
  }
  addExpressionsAfterDamageResponse(path, value) {
    return {type: 'ADD', path: path.concat(['expressionsAfterDamageResponse']), value: value.toJson()};
  }
  setExpressionsAfterDamageResponse(path, value) {
    return {type: 'SET', path: path.concat(['expressionsAfterDamageResponse']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsAfterDamageResponseByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressionsAfterDamageResponse', key]), value: value.toJson()};
  }
  deleteExpressionsAfterDamageResponse(path) {
    return {type: 'DELETE', path: path.concat(['expressionsAfterDamageResponse'])};
  }
  deleteExpressionsAfterDamageResponseByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressionsAfterDamageResponse', key])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "damageAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._hasDamageAmount = true;
              copy._damageAmount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageAmount) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._hasDamageAmount = false;
              copy._damageAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectDamage(this);
              copy._expressions = copy._expressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectDamage(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectDamage(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      case "expressionsAfterBehaviorModifiers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterBehaviorModifiers = [];        for (let i of value) {
                copy._expressionsAfterBehaviorModifiers.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterBehaviorModifiers = copy._expressionsAfterBehaviorModifiers.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionsAfterBehaviorModifiers.length === 0) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._expressionsAfterBehaviorModifiers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressionsAfterBehaviorModifiers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterBehaviorModifiers = copy._expressionsAfterBehaviorModifiers.slice();
              copy._expressionsAfterBehaviorModifiers[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterBehaviorModifiers = copy._expressionsAfterBehaviorModifiers.slice(0, path[1]).concat(copy._expressionsAfterBehaviorModifiers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressionsAfterBehaviorModifiers.length) {
            return this;
          }
          const oldValue = this._expressionsAfterBehaviorModifiers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectDamage(this);
          copy._expressionsAfterBehaviorModifiers = copy._expressionsAfterBehaviorModifiers.slice();
          copy._expressionsAfterBehaviorModifiers[key] = newValue;
          return copy;
        }
      }
      case "expressionsAfterDamageResponse": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterDamageResponse = [];        for (let i of value) {
                copy._expressionsAfterDamageResponse.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterDamageResponse = copy._expressionsAfterDamageResponse.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressionsAfterDamageResponse.length === 0) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._expressionsAfterDamageResponse = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressionsAfterDamageResponse.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterDamageResponse = copy._expressionsAfterDamageResponse.slice();
              copy._expressionsAfterDamageResponse[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectDamage(this);
              copy._expressionsAfterDamageResponse = copy._expressionsAfterDamageResponse.slice(0, path[1]).concat(copy._expressionsAfterDamageResponse.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressionsAfterDamageResponse.length) {
            return this;
          }
          const oldValue = this._expressionsAfterDamageResponse[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectDamage(this);
          copy._expressionsAfterDamageResponse = copy._expressionsAfterDamageResponse.slice();
          copy._expressionsAfterDamageResponse[key] = newValue;
          return copy;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDamage(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new EffectDamage(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectDamage} other
   * @returns {EffectDamage}
   */
  merge(other) {
    const copy = new EffectDamage(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasDamageAmount) {
      copy._hasDamageAmount = true;
      copy._damageAmount = other._damageAmount;
    }
    copy._expressions = this._expressions.concat(other._expressions);
    copy._expressionsAfterBehaviorModifiers = this._expressionsAfterBehaviorModifiers.concat(other._expressionsAfterBehaviorModifiers);
    copy._expressionsAfterDamageResponse = this._expressionsAfterDamageResponse.concat(other._expressionsAfterDamageResponse);
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    return copy;
  }
}
EffectDamage.default = new EffectDamage();
class EffectDamage_Builder {
  constructor(value) {
    this._value = new EffectDamage(value);
  }
  build() {
    return new EffectDamage(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setDamageAmount(value) {
    this._value._hasDamageAmount = true;
    this._value._damageAmount = value;
    return this;
  }
  deleteDamageAmount() {
    this._value._hasDamageAmount = false;
    this._value._damageAmount = null;
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
  addAllExpressionsAfterBehaviorModifiers(values) {
    this._value._expressionsAfterBehaviorModifiers = this._value._expressionsAfterBehaviorModifiers.concat(values);
    return this;
  }
  addExpressionsAfterBehaviorModifiers(value) {
    this._value._expressionsAfterBehaviorModifiers = this._value._expressionsAfterBehaviorModifiers.concat([value]);
    return this;
  }
  setExpressionsAfterBehaviorModifiers(index, value) {
    this._value._expressionsAfterBehaviorModifiers = this._value._expressionsAfterBehaviorModifiers.concat();
    this._value._expressionsAfterBehaviorModifiers[index] = value;
    return this;
  }
  clearExpressionsAfterBehaviorModifiers() {
    this._value._expressionsAfterBehaviorModifiers = [];
    return this;
  }
  addAllExpressionsAfterDamageResponse(values) {
    this._value._expressionsAfterDamageResponse = this._value._expressionsAfterDamageResponse.concat(values);
    return this;
  }
  addExpressionsAfterDamageResponse(value) {
    this._value._expressionsAfterDamageResponse = this._value._expressionsAfterDamageResponse.concat([value]);
    return this;
  }
  setExpressionsAfterDamageResponse(index, value) {
    this._value._expressionsAfterDamageResponse = this._value._expressionsAfterDamageResponse.concat();
    this._value._expressionsAfterDamageResponse[index] = value;
    return this;
  }
  clearExpressionsAfterDamageResponse() {
    this._value._expressionsAfterDamageResponse = [];
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
}
EffectDamage.Builder = EffectDamage_Builder;
class EffectDamage_WithParent {
  /**
   * @param {EffectDamage} value
   * @param {EffectDamage_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectDamage.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasDamageAmount() {
    if (this._cachedHasDamageAmount === undefined) {
      if (this._value.hasDamageAmount) {
        this._cachedHasDamageAmount = true;
      } else {
        this._cachedHasDamageAmount = this._parent ? this._parent.hasDamageAmount : false;
      }
    }
    return this._cachedHasDamageAmount;
  }
  get damageAmount() {
    if (this._cachedDamageAmount === undefined) {
      if (this._value.hasDamageAmount) {
        this._cachedDamageAmount = this._value.damageAmount;
      } else {
        this._cachedDamageAmount = this._parent ? this._parent.damageAmount : this._value.damageAmount;
      }
    }
    return this._cachedDamageAmount;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  get selfExpressionsAfterBehaviorModifiers() {
    if (!this._selfExpressionsAfterBehaviorModifiers) {
      this._selfExpressionsAfterBehaviorModifiers = [];
      for (let i of this._value.expressionsAfterBehaviorModifiers) {
        this._selfExpressionsAfterBehaviorModifiers.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressionsAfterBehaviorModifiers;
  }
  get inherentExpressionsAfterBehaviorModifiers() {
    if (!this._inherentExpressionsAfterBehaviorModifiers) {
      this._inherentExpressionsAfterBehaviorModifiers = this._parent ? this._parent.expressionsAfterBehaviorModifiers : [];
    }
    return this._inherentExpressionsAfterBehaviorModifiers;
  }
  get expressionsAfterBehaviorModifiers() {
    if (!this._allExpressionsAfterBehaviorModifiers) {
      this._allExpressionsAfterBehaviorModifiers = this._parent ? this._parent.expressionsAfterBehaviorModifiers.concat(this.selfExpressionsAfterBehaviorModifiers) : this.selfExpressionsAfterBehaviorModifiers;
    }
    return this._allExpressionsAfterBehaviorModifiers;
  }
  get selfExpressionsAfterDamageResponse() {
    if (!this._selfExpressionsAfterDamageResponse) {
      this._selfExpressionsAfterDamageResponse = [];
      for (let i of this._value.expressionsAfterDamageResponse) {
        this._selfExpressionsAfterDamageResponse.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressionsAfterDamageResponse;
  }
  get inherentExpressionsAfterDamageResponse() {
    if (!this._inherentExpressionsAfterDamageResponse) {
      this._inherentExpressionsAfterDamageResponse = this._parent ? this._parent.expressionsAfterDamageResponse : [];
    }
    return this._inherentExpressionsAfterDamageResponse;
  }
  get expressionsAfterDamageResponse() {
    if (!this._allExpressionsAfterDamageResponse) {
      this._allExpressionsAfterDamageResponse = this._parent ? this._parent.expressionsAfterDamageResponse.concat(this.selfExpressionsAfterDamageResponse) : this.selfExpressionsAfterDamageResponse;
    }
    return this._allExpressionsAfterDamageResponse;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  update(current, parent) {
    const result = new EffectDamage_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    if (this._selfExpressionsAfterBehaviorModifiers) {
      if (this._value.expressionsAfterBehaviorModifiers === current.expressionsAfterBehaviorModifiers) {
        result._selfExpressionsAfterBehaviorModifiers = this._selfExpressionsAfterBehaviorModifiers;
      } else {
        result._selfExpressionsAfterBehaviorModifiers = [];
        for (let i = 0; i < current.expressionsAfterBehaviorModifiers.length; i++) {
          const oldValue = this._value.expressionsAfterBehaviorModifiers[i];
          if (oldValue) {
            const oldCache = this._selfExpressionsAfterBehaviorModifiers[i];
            if (oldValue === current.expressionsAfterBehaviorModifiers[i]) {
              result._selfExpressionsAfterBehaviorModifiers[i] = oldCache;
            } else {
              result._selfExpressionsAfterBehaviorModifiers[i] = oldCache.update(current.expressionsAfterBehaviorModifiers[i], null);
            }
          } else {
            result._selfExpressionsAfterBehaviorModifiers[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressionsAfterBehaviorModifiers[i], null);
          }
        }
      }
    }
    if (this._selfExpressionsAfterDamageResponse) {
      if (this._value.expressionsAfterDamageResponse === current.expressionsAfterDamageResponse) {
        result._selfExpressionsAfterDamageResponse = this._selfExpressionsAfterDamageResponse;
      } else {
        result._selfExpressionsAfterDamageResponse = [];
        for (let i = 0; i < current.expressionsAfterDamageResponse.length; i++) {
          const oldValue = this._value.expressionsAfterDamageResponse[i];
          if (oldValue) {
            const oldCache = this._selfExpressionsAfterDamageResponse[i];
            if (oldValue === current.expressionsAfterDamageResponse[i]) {
              result._selfExpressionsAfterDamageResponse[i] = oldCache;
            } else {
              result._selfExpressionsAfterDamageResponse[i] = oldCache.update(current.expressionsAfterDamageResponse[i], null);
            }
          } else {
            result._selfExpressionsAfterDamageResponse[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressionsAfterDamageResponse[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectDamage_WithParent.default = new EffectDamage_WithParent(EffectDamage.default, null);
EffectDamage.WithParent = EffectDamage_WithParent;
class EffectDamage_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to apply damage to.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get damageAmount() {
    if (!this._damageAmount) {
      this._damageAmount = {
        name: "damageAmount",
        Name: "DamageAmount",
        number: 2,
        protoType: 1,
        protoName: "damage_amount",
        type: JsonToDouble,
        options: {
          comments: "The amount of damage to deal.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageAmount;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 3,
        protoType: 11,
        protoName: "expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "The result of each expression listed here will be evaluated and added to the damage amount. The total damage amount will then be passed through any behavior modifiers or damage responses.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get expressionsAfterBehaviorModifiers() {
    if (!this._expressionsAfterBehaviorModifiers) {
      this._expressionsAfterBehaviorModifiers = {
        name: "expressionsAfterBehaviorModifiers",
        Name: "ExpressionsAfterBehaviorModifiers",
        number: 5,
        protoType: 11,
        protoName: "expressions_after_behavior_modifiers",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "The damage value after behavior modifiers are applied will be used when evaulating this expression and the combined value will be used to further apply damage responses.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressionsAfterBehaviorModifiers;
  }
  get expressionsAfterDamageResponse() {
    if (!this._expressionsAfterDamageResponse) {
      this._expressionsAfterDamageResponse = {
        name: "expressionsAfterDamageResponse",
        Name: "ExpressionsAfterDamageResponse",
        number: 6,
        protoType: 11,
        protoName: "expressions_after_damage_response",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "The damage value after damage responses are applied will be used when evaluating this expression and the result will be added to the damage value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressionsAfterDamageResponse;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 4,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          comments: "Name of the card this damage effect is associated with. Used for reporting in-game stats.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.damageAmount,
        this.expressions,
        this.expressionsAfterBehaviorModifiers,
        this.expressionsAfterDamageResponse,
        this.cardName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageAmount",
        Name: "DummyOneofForDamageAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectDamage.descriptor = new EffectDamage_Descriptor();
export class EffectHeal {
  get descriptor() {
    return EffectHeal.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasValueType = false;
    this._valueType = null;
    this._hasHealAmount = false;
    this._healAmount = null;
    this._expressions = [];
    this._hasCardName = false;
    this._cardName = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasValueType) return false;
    if (this._hasHealAmount) return false;
    if (this._expressions.length > 0) return false;
    if (this._hasCardName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectHeal) {
      return value;
    }
    return EffectHeal.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectHeal();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.healAmount != null) {
      result._hasHealAmount = true;
      result._healAmount = JsonToDouble.fromJson(json.healAmount);
    }
    result._expressions = JsonToList(json.expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasHealAmount) {
      result.healAmount = JsonToDouble.toJson(this._healAmount);
    }
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get healAmount() {
    return this._hasHealAmount ? this._healAmount : JsonToDouble.default;
  }
  get hasHealAmount() {
    return this._hasHealAmount;
  }
  setHealAmount(path, value) {
    return {type: 'SET', path: path.concat(['healAmount']), value};
  }
  deleteHealAmount(path) {
    return {type: 'DELETE', path: path.concat(['healAmount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectHeal(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new EffectHeal(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "healAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._hasHealAmount = true;
              copy._healAmount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealAmount) {
                return this;
              }
              const copy = new EffectHeal(this);
              copy._hasHealAmount = false;
              copy._healAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectHeal(this);
              copy._expressions = copy._expressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new EffectHeal(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectHeal(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectHeal(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectHeal(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new EffectHeal(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectHeal} other
   * @returns {EffectHeal}
   */
  merge(other) {
    const copy = new EffectHeal(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasHealAmount) {
      copy._hasHealAmount = true;
      copy._healAmount = other._healAmount;
    }
    copy._expressions = this._expressions.concat(other._expressions);
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    return copy;
  }
}
EffectHeal.default = new EffectHeal();
class EffectHeal_Builder {
  constructor(value) {
    this._value = new EffectHeal(value);
  }
  build() {
    return new EffectHeal(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setHealAmount(value) {
    this._value._hasHealAmount = true;
    this._value._healAmount = value;
    return this;
  }
  deleteHealAmount() {
    this._value._hasHealAmount = false;
    this._value._healAmount = null;
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
}
EffectHeal.Builder = EffectHeal_Builder;
class EffectHeal_WithParent {
  /**
   * @param {EffectHeal} value
   * @param {EffectHeal_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectHeal.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasHealAmount() {
    if (this._cachedHasHealAmount === undefined) {
      if (this._value.hasHealAmount) {
        this._cachedHasHealAmount = true;
      } else {
        this._cachedHasHealAmount = this._parent ? this._parent.hasHealAmount : false;
      }
    }
    return this._cachedHasHealAmount;
  }
  get healAmount() {
    if (this._cachedHealAmount === undefined) {
      if (this._value.hasHealAmount) {
        this._cachedHealAmount = this._value.healAmount;
      } else {
        this._cachedHealAmount = this._parent ? this._parent.healAmount : this._value.healAmount;
      }
    }
    return this._cachedHealAmount;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  update(current, parent) {
    const result = new EffectHeal_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectHeal_WithParent.default = new EffectHeal_WithParent(EffectHeal.default, null);
EffectHeal.WithParent = EffectHeal_WithParent;
class EffectHeal_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to heal.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 2,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
          comments: "Whether to heal a percentage of the target\'s health or an explicit amount.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get healAmount() {
    if (!this._healAmount) {
      this._healAmount = {
        name: "healAmount",
        Name: "HealAmount",
        number: 3,
        protoType: 1,
        protoName: "heal_amount",
        type: JsonToDouble,
        options: {
          comments: "The amount to heal.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healAmount;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 4,
        protoType: 11,
        protoName: "expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 5,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          comments: "Name of the card this heal effect is associated with. Used for reporting in-game stats.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.valueType,
        this.healAmount,
        this.expressions,
        this.cardName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealAmount",
        Name: "DummyOneofForHealAmount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectHeal.descriptor = new EffectHeal_Descriptor();
class EffectModifyUnit_ModifyMana {
  get descriptor() {
    return EffectModifyUnit_ModifyMana.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasModifyType = false;
    this._modifyType = null;
    this._hasValueType = false;
    this._valueType = null;
    this._hasAmount = false;
    this._amount = null;
    this._expressions = [];
  }
  isEmpty() {
    if (this._hasModifyType) return false;
    if (this._hasValueType) return false;
    if (this._hasAmount) return false;
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModifyUnit_ModifyMana) {
      return value;
    }
    return EffectModifyUnit_ModifyMana.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModifyUnit_ModifyMana();
    if (json.modifyType != null) {
      result._hasModifyType = true;
      result._modifyType = EffectModifyUnit_ModifyType.fromJson(json.modifyType);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToDouble.fromJson(json.amount);
    }
    result._expressions = JsonToList(json.expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasModifyType) {
      result.modifyType = EffectModifyUnit_ModifyType.toJson(this._modifyType);
    }
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasAmount) {
      result.amount = JsonToDouble.toJson(this._amount);
    }
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get modifyType() {
    return this._hasModifyType ? this._modifyType : EffectModifyUnit_ModifyType.default;
  }
  get hasModifyType() {
    return this._hasModifyType;
  }
  setModifyType(path, value) {
    return {type: 'SET', path: path.concat(['modifyType']), value};
  }
  deleteModifyType(path) {
    return {type: 'DELETE', path: path.concat(['modifyType'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToDouble.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "modifyType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasModifyType = true;
              copy._modifyType = EffectModifyUnit_ModifyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifyType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasModifyType = false;
              copy._modifyType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasAmount = true;
              copy._amount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._expressions = copy._expressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectModifyUnit_ModifyMana(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectModifyUnit_ModifyMana(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModifyUnit_ModifyMana} other
   * @returns {EffectModifyUnit_ModifyMana}
   */
  merge(other) {
    const copy = new EffectModifyUnit_ModifyMana(this);
    if (other._hasModifyType) {
      copy._hasModifyType = true;
      copy._modifyType = other._modifyType;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
EffectModifyUnit_ModifyMana.default = new EffectModifyUnit_ModifyMana();
class EffectModifyUnit_ModifyMana_Builder {
  constructor(value) {
    this._value = new EffectModifyUnit_ModifyMana(value);
  }
  build() {
    return new EffectModifyUnit_ModifyMana(this._value);
  }
  setModifyType(value) {
    this._value._hasModifyType = true;
    this._value._modifyType = value;
    return this;
  }
  deleteModifyType() {
    this._value._hasModifyType = false;
    this._value._modifyType = null;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
EffectModifyUnit_ModifyMana.Builder = EffectModifyUnit_ModifyMana_Builder;
class EffectModifyUnit_ModifyMana_WithParent {
  /**
   * @param {EffectModifyUnit_ModifyMana} value
   * @param {EffectModifyUnit_ModifyMana_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModifyUnit_ModifyMana.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasModifyType() {
    if (this._cachedHasModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedHasModifyType = true;
      } else {
        this._cachedHasModifyType = this._parent ? this._parent.hasModifyType : false;
      }
    }
    return this._cachedHasModifyType;
  }
  get modifyType() {
    if (this._cachedModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedModifyType = this._value.modifyType;
      } else {
        this._cachedModifyType = this._parent ? this._parent.modifyType : this._value.modifyType;
      }
    }
    return this._cachedModifyType;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new EffectModifyUnit_ModifyMana_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectModifyUnit_ModifyMana_WithParent.default = new EffectModifyUnit_ModifyMana_WithParent(EffectModifyUnit_ModifyMana.default, null);
EffectModifyUnit_ModifyMana.WithParent = EffectModifyUnit_ModifyMana_WithParent;
class EffectModifyUnit_ModifyMana_Descriptor {
  get modifyType() {
    if (!this._modifyType) {
      this._modifyType = {
        name: "modifyType",
        Name: "ModifyType",
        number: 10,
        protoType: 14,
        protoName: "modify_type",
        type: EffectModifyUnit_ModifyType,
        options: {
          comments: "Determine the modify type",
          default: "ADD",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyType;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 1,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
          comments: "Whether to modify mana as percentage or explicit value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 1,
        protoName: "amount",
        type: JsonToDouble,
        options: {
          comments: "The amount of mana to modify.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 3,
        protoType: 11,
        protoName: "expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.modifyType,
        this.valueType,
        this.amount,
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForModifyType",
        Name: "DummyOneofForModifyType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModifyUnit_ModifyMana.descriptor = new EffectModifyUnit_ModifyMana_Descriptor();
class EffectModifyUnit_ModifyShield {
  get descriptor() {
    return EffectModifyUnit_ModifyShield.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasModifyType = false;
    this._modifyType = null;
    this._hasValueType = false;
    this._valueType = null;
    this._hasAmount = false;
    this._amount = null;
    this._expressions = [];
  }
  isEmpty() {
    if (this._hasModifyType) return false;
    if (this._hasValueType) return false;
    if (this._hasAmount) return false;
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModifyUnit_ModifyShield) {
      return value;
    }
    return EffectModifyUnit_ModifyShield.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModifyUnit_ModifyShield();
    if (json.modifyType != null) {
      result._hasModifyType = true;
      result._modifyType = EffectModifyUnit_ModifyType.fromJson(json.modifyType);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToDouble.fromJson(json.amount);
    }
    result._expressions = JsonToList(json.expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasModifyType) {
      result.modifyType = EffectModifyUnit_ModifyType.toJson(this._modifyType);
    }
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasAmount) {
      result.amount = JsonToDouble.toJson(this._amount);
    }
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get modifyType() {
    return this._hasModifyType ? this._modifyType : EffectModifyUnit_ModifyType.default;
  }
  get hasModifyType() {
    return this._hasModifyType;
  }
  setModifyType(path, value) {
    return {type: 'SET', path: path.concat(['modifyType']), value};
  }
  deleteModifyType(path) {
    return {type: 'DELETE', path: path.concat(['modifyType'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToDouble.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "modifyType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasModifyType = true;
              copy._modifyType = EffectModifyUnit_ModifyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifyType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasModifyType = false;
              copy._modifyType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasAmount = true;
              copy._amount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._expressions = copy._expressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectModifyUnit_ModifyShield(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectModifyUnit_ModifyShield(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModifyUnit_ModifyShield} other
   * @returns {EffectModifyUnit_ModifyShield}
   */
  merge(other) {
    const copy = new EffectModifyUnit_ModifyShield(this);
    if (other._hasModifyType) {
      copy._hasModifyType = true;
      copy._modifyType = other._modifyType;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
EffectModifyUnit_ModifyShield.default = new EffectModifyUnit_ModifyShield();
class EffectModifyUnit_ModifyShield_Builder {
  constructor(value) {
    this._value = new EffectModifyUnit_ModifyShield(value);
  }
  build() {
    return new EffectModifyUnit_ModifyShield(this._value);
  }
  setModifyType(value) {
    this._value._hasModifyType = true;
    this._value._modifyType = value;
    return this;
  }
  deleteModifyType() {
    this._value._hasModifyType = false;
    this._value._modifyType = null;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
EffectModifyUnit_ModifyShield.Builder = EffectModifyUnit_ModifyShield_Builder;
class EffectModifyUnit_ModifyShield_WithParent {
  /**
   * @param {EffectModifyUnit_ModifyShield} value
   * @param {EffectModifyUnit_ModifyShield_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModifyUnit_ModifyShield.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasModifyType() {
    if (this._cachedHasModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedHasModifyType = true;
      } else {
        this._cachedHasModifyType = this._parent ? this._parent.hasModifyType : false;
      }
    }
    return this._cachedHasModifyType;
  }
  get modifyType() {
    if (this._cachedModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedModifyType = this._value.modifyType;
      } else {
        this._cachedModifyType = this._parent ? this._parent.modifyType : this._value.modifyType;
      }
    }
    return this._cachedModifyType;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new EffectModifyUnit_ModifyShield_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectModifyUnit_ModifyShield_WithParent.default = new EffectModifyUnit_ModifyShield_WithParent(EffectModifyUnit_ModifyShield.default, null);
EffectModifyUnit_ModifyShield.WithParent = EffectModifyUnit_ModifyShield_WithParent;
class EffectModifyUnit_ModifyShield_Descriptor {
  get modifyType() {
    if (!this._modifyType) {
      this._modifyType = {
        name: "modifyType",
        Name: "ModifyType",
        number: 10,
        protoType: 14,
        protoName: "modify_type",
        type: EffectModifyUnit_ModifyType,
        options: {
          comments: "Determine the modify type",
          default: "ADD",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyType;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 1,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
          comments: "Whether to modify shields as percentage or explicit value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 1,
        protoName: "amount",
        type: JsonToDouble,
        options: {
          comments: "The amount of shields to modify.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 3,
        protoType: 11,
        protoName: "expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.modifyType,
        this.valueType,
        this.amount,
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForModifyType",
        Name: "DummyOneofForModifyType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModifyUnit_ModifyShield.descriptor = new EffectModifyUnit_ModifyShield_Descriptor();
class EffectModifyUnit_ModifyAbilityCooldown {
  get descriptor() {
    return EffectModifyUnit_ModifyAbilityCooldown.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasModifyType = false;
    this._modifyType = null;
    this._oneofAbilityNameTypeCase = 0;
    this._oneofAbilityNameTypeValue = null;
    this._hasValueType = false;
    this._valueType = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasModifyType) return false;
    if (this._oneofAbilityNameTypeCase !== 0) return false;
    if (this._hasValueType) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModifyUnit_ModifyAbilityCooldown) {
      return value;
    }
    return EffectModifyUnit_ModifyAbilityCooldown.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModifyUnit_ModifyAbilityCooldown();
    if (json.modifyType != null) {
      result._hasModifyType = true;
      result._modifyType = EffectModifyUnit_ModifyType.fromJson(json.modifyType);
    }
    if (json.abilityName != null) {
      result._oneofAbilityNameTypeCase = 1;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityName);
    }
    if (json.abilityFamily != null) {
      result._oneofAbilityNameTypeCase = 4;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityFamily);
    }
    if (json.abilityTag != null) {
      result._oneofAbilityNameTypeCase = 5;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityTag);
    }
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToDouble.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasModifyType) {
      result.modifyType = EffectModifyUnit_ModifyType.toJson(this._modifyType);
    }
    switch (this._oneofAbilityNameTypeCase) {
      case 1:
        result.abilityName = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      case 4:
        result.abilityFamily = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      case 5:
        result.abilityTag = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      default:
        break;
    }
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasAmount) {
      result.amount = JsonToDouble.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get modifyType() {
    return this._hasModifyType ? this._modifyType : EffectModifyUnit_ModifyType.default;
  }
  get hasModifyType() {
    return this._hasModifyType;
  }
  setModifyType(path, value) {
    return {type: 'SET', path: path.concat(['modifyType']), value};
  }
  deleteModifyType(path) {
    return {type: 'DELETE', path: path.concat(['modifyType'])};
  }
  get oneofAbilityNameTypeCase() {
    return this._oneofAbilityNameTypeCase;
  }
  deleteOneofAbilityNameType(path) {
    switch (this._oneofAbilityNameTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['abilityName'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['abilityFamily'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['abilityTag'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get abilityName() {
    return this._oneofAbilityNameTypeCase === 1 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityName(path, value) {
    return {type: 'SET', path: path.concat(['abilityName']), value};
  }
  deleteAbilityName(path) {
    return {type: 'DELETE', path: path.concat(['abilityName'])};
  }
  /**
   * @returns {string}
   */
  get abilityFamily() {
    return this._oneofAbilityNameTypeCase === 4 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityFamily(path, value) {
    return {type: 'SET', path: path.concat(['abilityFamily']), value};
  }
  deleteAbilityFamily(path) {
    return {type: 'DELETE', path: path.concat(['abilityFamily'])};
  }
  /**
   * @returns {string}
   */
  get abilityTag() {
    return this._oneofAbilityNameTypeCase === 5 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityTag(path, value) {
    return {type: 'SET', path: path.concat(['abilityTag']), value};
  }
  deleteAbilityTag(path) {
    return {type: 'DELETE', path: path.concat(['abilityTag'])};
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToDouble.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "modifyType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasModifyType = true;
              copy._modifyType = EffectModifyUnit_ModifyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifyType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasModifyType = false;
              copy._modifyType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 1;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 1) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityFamily": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 4;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 4) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 5;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 5) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasAmount = true;
              copy._amount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModifyUnit_ModifyAbilityCooldown} other
   * @returns {EffectModifyUnit_ModifyAbilityCooldown}
   */
  merge(other) {
    const copy = new EffectModifyUnit_ModifyAbilityCooldown(this);
    if (other._hasModifyType) {
      copy._hasModifyType = true;
      copy._modifyType = other._modifyType;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
EffectModifyUnit_ModifyAbilityCooldown.default = new EffectModifyUnit_ModifyAbilityCooldown();
class EffectModifyUnit_ModifyAbilityCooldown_Builder {
  constructor(value) {
    this._value = new EffectModifyUnit_ModifyAbilityCooldown(value);
  }
  build() {
    return new EffectModifyUnit_ModifyAbilityCooldown(this._value);
  }
  setModifyType(value) {
    this._value._hasModifyType = true;
    this._value._modifyType = value;
    return this;
  }
  deleteModifyType() {
    this._value._hasModifyType = false;
    this._value._modifyType = null;
    return this;
  }
  clearoneofAbilityNameType() {
    this._value._oneofAbilityNameTypeCase = 0;
    this._value._oneofAbilityNameTypeValue = null;
    return this;
  }
  setAbilityName(value) {
    this._value._oneofAbilityNameTypeCase = 1;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setAbilityFamily(value) {
    this._value._oneofAbilityNameTypeCase = 4;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setAbilityTag(value) {
    this._value._oneofAbilityNameTypeCase = 5;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
EffectModifyUnit_ModifyAbilityCooldown.Builder = EffectModifyUnit_ModifyAbilityCooldown_Builder;
class EffectModifyUnit_ModifyAbilityCooldown_WithParent {
  /**
   * @param {EffectModifyUnit_ModifyAbilityCooldown} value
   * @param {EffectModifyUnit_ModifyAbilityCooldown_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModifyUnit_ModifyAbilityCooldown.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasModifyType() {
    if (this._cachedHasModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedHasModifyType = true;
      } else {
        this._cachedHasModifyType = this._parent ? this._parent.hasModifyType : false;
      }
    }
    return this._cachedHasModifyType;
  }
  get modifyType() {
    if (this._cachedModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedModifyType = this._value.modifyType;
      } else {
        this._cachedModifyType = this._parent ? this._parent.modifyType : this._value.modifyType;
      }
    }
    return this._cachedModifyType;
  }
  get oneofAbilityNameTypeCase() {
    if (this._cachedoneofAbilityNameTypeCase === undefined) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedoneofAbilityNameTypeCase = this._parent ? this._parent.oneofAbilityNameTypeCase : 0;
      } else {
        this._cachedoneofAbilityNameTypeCase = this._value._oneofAbilityNameTypeCase;
      }
    }
    return this._cachedoneofAbilityNameTypeCase;
  }
  get abilityName() {
    if (!this._cachedAbilityName) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityName = this._parent ? this._parent.abilityName : this._value.abilityName;
      } else {
        this._cachedAbilityName = this._value.abilityName;
      }
    }
    return this._cachedAbilityName;
  }
  get abilityFamily() {
    if (!this._cachedAbilityFamily) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityFamily = this._parent ? this._parent.abilityFamily : this._value.abilityFamily;
      } else {
        this._cachedAbilityFamily = this._value.abilityFamily;
      }
    }
    return this._cachedAbilityFamily;
  }
  get abilityTag() {
    if (!this._cachedAbilityTag) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityTag = this._parent ? this._parent.abilityTag : this._value.abilityTag;
      } else {
        this._cachedAbilityTag = this._value.abilityTag;
      }
    }
    return this._cachedAbilityTag;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new EffectModifyUnit_ModifyAbilityCooldown_WithParent(current, parent);
    return result;
  }
}
EffectModifyUnit_ModifyAbilityCooldown_WithParent.default = new EffectModifyUnit_ModifyAbilityCooldown_WithParent(EffectModifyUnit_ModifyAbilityCooldown.default, null);
EffectModifyUnit_ModifyAbilityCooldown.WithParent = EffectModifyUnit_ModifyAbilityCooldown_WithParent;
class EffectModifyUnit_ModifyAbilityCooldown_Descriptor {
  get modifyType() {
    if (!this._modifyType) {
      this._modifyType = {
        name: "modifyType",
        Name: "ModifyType",
        number: 10,
        protoType: 14,
        protoName: "modify_type",
        type: EffectModifyUnit_ModifyType,
        options: {
          comments: "Determine the modify type",
          default: "SET",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyType;
  }
  get abilityName() {
    if (!this._abilityName) {
      this._abilityName = {
        name: "abilityName",
        Name: "AbilityName",
        number: 1,
        protoType: 9,
        protoName: "ability_name",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The name of the ability to modify cooldown for.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityName;
  }
  get abilityFamily() {
    if (!this._abilityFamily) {
      this._abilityFamily = {
        name: "abilityFamily",
        Name: "AbilityFamily",
        number: 4,
        protoType: 9,
        protoName: "ability_family",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The ability family to modify cooldowns for.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityFamily;
  }
  get abilityTag() {
    if (!this._abilityTag) {
      this._abilityTag = {
        name: "abilityTag",
        Name: "AbilityTag",
        number: 5,
        protoType: 9,
        protoName: "ability_tag",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The ability tags to modify cooldowns for.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityTag;
  }
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 2,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
          comments: "Whether to modify cooldown by a percentage or explicit value (in seconds).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 3,
        protoType: 1,
        protoName: "amount",
        type: JsonToDouble,
        options: {
          comments: "The duration to modify cooldown by.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.modifyType,
        this.abilityName,
        this.abilityFamily,
        this.abilityTag,
        this.valueType,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForModifyType",
        Name: "DummyOneofForModifyType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "oneofAbilityNameType",
        Name: "OneofAbilityNameType",
        fields: [
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModifyUnit_ModifyAbilityCooldown.descriptor = new EffectModifyUnit_ModifyAbilityCooldown_Descriptor();
class EffectModifyUnit_ModifyAbilityChargeCount {
  get descriptor() {
    return EffectModifyUnit_ModifyAbilityChargeCount.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasModifyType = false;
    this._modifyType = null;
    this._oneofAbilityNameTypeCase = 0;
    this._oneofAbilityNameTypeValue = null;
    this._hasAmount = false;
    this._amount = null;
    this._hasClamp = false;
    this._clamp = null;
  }
  isEmpty() {
    if (this._hasModifyType) return false;
    if (this._oneofAbilityNameTypeCase !== 0) return false;
    if (this._hasAmount) return false;
    if (this._hasClamp) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModifyUnit_ModifyAbilityChargeCount) {
      return value;
    }
    return EffectModifyUnit_ModifyAbilityChargeCount.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModifyUnit_ModifyAbilityChargeCount();
    if (json.modifyType != null) {
      result._hasModifyType = true;
      result._modifyType = EffectModifyUnit_ModifyType.fromJson(json.modifyType);
    }
    if (json.abilityName != null) {
      result._oneofAbilityNameTypeCase = 1;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityName);
    }
    if (json.abilityFamily != null) {
      result._oneofAbilityNameTypeCase = 4;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityFamily);
    }
    if (json.abilityTag != null) {
      result._oneofAbilityNameTypeCase = 5;
      result._oneofAbilityNameTypeValue = JsonToString.fromJson(json.abilityTag);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.clamp != null) {
      result._hasClamp = true;
      result._clamp = JsonToBoolean.fromJson(json.clamp);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasModifyType) {
      result.modifyType = EffectModifyUnit_ModifyType.toJson(this._modifyType);
    }
    switch (this._oneofAbilityNameTypeCase) {
      case 1:
        result.abilityName = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      case 4:
        result.abilityFamily = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      case 5:
        result.abilityTag = JsonToString.toJson(this._oneofAbilityNameTypeValue);
        break;
      default:
        break;
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasClamp) {
      result.clamp = JsonToBoolean.toJson(this._clamp);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get modifyType() {
    return this._hasModifyType ? this._modifyType : EffectModifyUnit_ModifyType.default;
  }
  get hasModifyType() {
    return this._hasModifyType;
  }
  setModifyType(path, value) {
    return {type: 'SET', path: path.concat(['modifyType']), value};
  }
  deleteModifyType(path) {
    return {type: 'DELETE', path: path.concat(['modifyType'])};
  }
  get oneofAbilityNameTypeCase() {
    return this._oneofAbilityNameTypeCase;
  }
  deleteOneofAbilityNameType(path) {
    switch (this._oneofAbilityNameTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['abilityName'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['abilityFamily'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['abilityTag'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get abilityName() {
    return this._oneofAbilityNameTypeCase === 1 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityName(path, value) {
    return {type: 'SET', path: path.concat(['abilityName']), value};
  }
  deleteAbilityName(path) {
    return {type: 'DELETE', path: path.concat(['abilityName'])};
  }
  /**
   * @returns {string}
   */
  get abilityFamily() {
    return this._oneofAbilityNameTypeCase === 4 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityFamily(path, value) {
    return {type: 'SET', path: path.concat(['abilityFamily']), value};
  }
  deleteAbilityFamily(path) {
    return {type: 'DELETE', path: path.concat(['abilityFamily'])};
  }
  /**
   * @returns {string}
   */
  get abilityTag() {
    return this._oneofAbilityNameTypeCase === 5 ? this._oneofAbilityNameTypeValue : JsonToString.default;
  }
  setAbilityTag(path, value) {
    return {type: 'SET', path: path.concat(['abilityTag']), value};
  }
  deleteAbilityTag(path) {
    return {type: 'DELETE', path: path.concat(['abilityTag'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {boolean}
   */
  get clamp() {
    return this._hasClamp ? this._clamp : JsonToBoolean.default;
  }
  get hasClamp() {
    return this._hasClamp;
  }
  setClamp(path, value) {
    return {type: 'SET', path: path.concat(['clamp']), value};
  }
  deleteClamp(path) {
    return {type: 'DELETE', path: path.concat(['clamp'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "modifyType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasModifyType = true;
              copy._modifyType = EffectModifyUnit_ModifyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModifyType) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasModifyType = false;
              copy._modifyType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 1;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 1) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityFamily": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 4;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 4) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 5;
              copy._oneofAbilityNameTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityNameTypeCase !== 5) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._oneofAbilityNameTypeCase = 0;
              copy._oneofAbilityNameTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clamp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasClamp = true;
              copy._clamp = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClamp) {
                return this;
              }
              const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
              copy._hasClamp = false;
              copy._clamp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModifyUnit_ModifyAbilityChargeCount} other
   * @returns {EffectModifyUnit_ModifyAbilityChargeCount}
   */
  merge(other) {
    const copy = new EffectModifyUnit_ModifyAbilityChargeCount(this);
    if (other._hasModifyType) {
      copy._hasModifyType = true;
      copy._modifyType = other._modifyType;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._oneofAbilityNameTypeCase === 1) {
      copy._oneofAbilityNameTypeCase = 1;
      copy._oneofAbilityNameTypeValue = other._oneofAbilityNameTypeValue;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasClamp) {
      copy._hasClamp = true;
      copy._clamp = other._clamp;
    }
    return copy;
  }
}
EffectModifyUnit_ModifyAbilityChargeCount.default = new EffectModifyUnit_ModifyAbilityChargeCount();
class EffectModifyUnit_ModifyAbilityChargeCount_Builder {
  constructor(value) {
    this._value = new EffectModifyUnit_ModifyAbilityChargeCount(value);
  }
  build() {
    return new EffectModifyUnit_ModifyAbilityChargeCount(this._value);
  }
  setModifyType(value) {
    this._value._hasModifyType = true;
    this._value._modifyType = value;
    return this;
  }
  deleteModifyType() {
    this._value._hasModifyType = false;
    this._value._modifyType = null;
    return this;
  }
  clearoneofAbilityNameType() {
    this._value._oneofAbilityNameTypeCase = 0;
    this._value._oneofAbilityNameTypeValue = null;
    return this;
  }
  setAbilityName(value) {
    this._value._oneofAbilityNameTypeCase = 1;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setAbilityFamily(value) {
    this._value._oneofAbilityNameTypeCase = 4;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setAbilityTag(value) {
    this._value._oneofAbilityNameTypeCase = 5;
    this._value._oneofAbilityNameTypeValue = value;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setClamp(value) {
    this._value._hasClamp = true;
    this._value._clamp = value;
    return this;
  }
  deleteClamp() {
    this._value._hasClamp = false;
    this._value._clamp = null;
    return this;
  }
}
EffectModifyUnit_ModifyAbilityChargeCount.Builder = EffectModifyUnit_ModifyAbilityChargeCount_Builder;
class EffectModifyUnit_ModifyAbilityChargeCount_WithParent {
  /**
   * @param {EffectModifyUnit_ModifyAbilityChargeCount} value
   * @param {EffectModifyUnit_ModifyAbilityChargeCount_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModifyUnit_ModifyAbilityChargeCount.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasModifyType() {
    if (this._cachedHasModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedHasModifyType = true;
      } else {
        this._cachedHasModifyType = this._parent ? this._parent.hasModifyType : false;
      }
    }
    return this._cachedHasModifyType;
  }
  get modifyType() {
    if (this._cachedModifyType === undefined) {
      if (this._value.hasModifyType) {
        this._cachedModifyType = this._value.modifyType;
      } else {
        this._cachedModifyType = this._parent ? this._parent.modifyType : this._value.modifyType;
      }
    }
    return this._cachedModifyType;
  }
  get oneofAbilityNameTypeCase() {
    if (this._cachedoneofAbilityNameTypeCase === undefined) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedoneofAbilityNameTypeCase = this._parent ? this._parent.oneofAbilityNameTypeCase : 0;
      } else {
        this._cachedoneofAbilityNameTypeCase = this._value._oneofAbilityNameTypeCase;
      }
    }
    return this._cachedoneofAbilityNameTypeCase;
  }
  get abilityName() {
    if (!this._cachedAbilityName) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityName = this._parent ? this._parent.abilityName : this._value.abilityName;
      } else {
        this._cachedAbilityName = this._value.abilityName;
      }
    }
    return this._cachedAbilityName;
  }
  get abilityFamily() {
    if (!this._cachedAbilityFamily) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityFamily = this._parent ? this._parent.abilityFamily : this._value.abilityFamily;
      } else {
        this._cachedAbilityFamily = this._value.abilityFamily;
      }
    }
    return this._cachedAbilityFamily;
  }
  get abilityTag() {
    if (!this._cachedAbilityTag) {
      if (this._value._oneofAbilityNameTypeCase === 0) {
        this._cachedAbilityTag = this._parent ? this._parent.abilityTag : this._value.abilityTag;
      } else {
        this._cachedAbilityTag = this._value.abilityTag;
      }
    }
    return this._cachedAbilityTag;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasClamp() {
    if (this._cachedHasClamp === undefined) {
      if (this._value.hasClamp) {
        this._cachedHasClamp = true;
      } else {
        this._cachedHasClamp = this._parent ? this._parent.hasClamp : false;
      }
    }
    return this._cachedHasClamp;
  }
  get clamp() {
    if (this._cachedClamp === undefined) {
      if (this._value.hasClamp) {
        this._cachedClamp = this._value.clamp;
      } else {
        this._cachedClamp = this._parent ? this._parent.clamp : this._value.clamp;
      }
    }
    return this._cachedClamp;
  }
  update(current, parent) {
    const result = new EffectModifyUnit_ModifyAbilityChargeCount_WithParent(current, parent);
    return result;
  }
}
EffectModifyUnit_ModifyAbilityChargeCount_WithParent.default = new EffectModifyUnit_ModifyAbilityChargeCount_WithParent(EffectModifyUnit_ModifyAbilityChargeCount.default, null);
EffectModifyUnit_ModifyAbilityChargeCount.WithParent = EffectModifyUnit_ModifyAbilityChargeCount_WithParent;
class EffectModifyUnit_ModifyAbilityChargeCount_Descriptor {
  get modifyType() {
    if (!this._modifyType) {
      this._modifyType = {
        name: "modifyType",
        Name: "ModifyType",
        number: 10,
        protoType: 14,
        protoName: "modify_type",
        type: EffectModifyUnit_ModifyType,
        options: {
          comments: "Determine the modify type",
          default: "ADD",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyType;
  }
  get abilityName() {
    if (!this._abilityName) {
      this._abilityName = {
        name: "abilityName",
        Name: "AbilityName",
        number: 1,
        protoType: 9,
        protoName: "ability_name",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The name of the ability to modify charge count for.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityName;
  }
  get abilityFamily() {
    if (!this._abilityFamily) {
      this._abilityFamily = {
        name: "abilityFamily",
        Name: "AbilityFamily",
        number: 4,
        protoType: 9,
        protoName: "ability_family",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The ability family to modify charge count for.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityFamily;
  }
  get abilityTag() {
    if (!this._abilityTag) {
      this._abilityTag = {
        name: "abilityTag",
        Name: "AbilityTag",
        number: 5,
        protoType: 9,
        protoName: "ability_tag",
        oneofIndex: 1,
        type: JsonToString,
        options: {
          comments: "The ability tags to modify charge count for.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityTag;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 3,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          comments: "The amount to modify charge count by.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get clamp() {
    if (!this._clamp) {
      this._clamp = {
        name: "clamp",
        Name: "Clamp",
        number: 6,
        protoType: 8,
        protoName: "clamp",
        type: JsonToBoolean,
        options: {
          comments: "When checked, clamp charge count between 0 and max charge count.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clamp;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.modifyType,
        this.abilityName,
        this.abilityFamily,
        this.abilityTag,
        this.amount,
        this.clamp,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForModifyType",
        Name: "DummyOneofForModifyType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "oneofAbilityNameType",
        Name: "OneofAbilityNameType",
        fields: [
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClamp",
        Name: "DummyOneofForClamp",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModifyUnit_ModifyAbilityChargeCount.descriptor = new EffectModifyUnit_ModifyAbilityChargeCount_Descriptor();
class EffectModifyUnit_ModifyType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE_MODIFY_TYPE": return 0;
        case "ADD": return 1;
        case "SET": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectModifyUnit_ModifyType.fromJson(value);
  }
  static fromReact(e) {
    return EffectModifyUnit_ModifyType.fromJson(e);
  }
}
EffectModifyUnit_ModifyType.NONE_MODIFY_TYPE = 0;
EffectModifyUnit_ModifyType.ADD = 1;
EffectModifyUnit_ModifyType.SET = 2;
EffectModifyUnit_ModifyType.default = 0;
EffectModifyUnit_ModifyType.values = {
  NONE_MODIFY_TYPE: 0,
  ADD: 1,
  SET: 2,
};
EffectModifyUnit_ModifyType.names = {
  0: "NONE_MODIFY_TYPE",
  1: "ADD",
  2: "SET",
};
export class EffectModifyUnit {
  get descriptor() {
    return EffectModifyUnit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._oneofModifyUnitTypeCase = 0;
    this._oneofModifyUnitTypeValue = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._oneofModifyUnitTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModifyUnit) {
      return value;
    }
    return EffectModifyUnit.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModifyUnit();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.modifyMana != null) {
      result._oneofModifyUnitTypeCase = 11;
      result._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyMana.fromJson(json.modifyMana);
    }
    if (json.modifyShield != null) {
      result._oneofModifyUnitTypeCase = 12;
      result._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyShield.fromJson(json.modifyShield);
    }
    if (json.modifyAbilityCooldown != null) {
      result._oneofModifyUnitTypeCase = 13;
      result._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityCooldown.fromJson(json.modifyAbilityCooldown);
    }
    if (json.modifyAbilityChargeCount != null) {
      result._oneofModifyUnitTypeCase = 14;
      result._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityChargeCount.fromJson(json.modifyAbilityChargeCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    switch (this._oneofModifyUnitTypeCase) {
      case 11:
        result.modifyMana = EffectModifyUnit_ModifyMana.toJson(this._oneofModifyUnitTypeValue);
        break;
      case 12:
        result.modifyShield = EffectModifyUnit_ModifyShield.toJson(this._oneofModifyUnitTypeValue);
        break;
      case 13:
        result.modifyAbilityCooldown = EffectModifyUnit_ModifyAbilityCooldown.toJson(this._oneofModifyUnitTypeValue);
        break;
      case 14:
        result.modifyAbilityChargeCount = EffectModifyUnit_ModifyAbilityChargeCount.toJson(this._oneofModifyUnitTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  get oneofModifyUnitTypeCase() {
    return this._oneofModifyUnitTypeCase;
  }
  deleteOneofModifyUnitType(path) {
    switch (this._oneofModifyUnitTypeCase) {
      default:
      case 11: {
        return {type: 'DELETE', path: path.concat(['modifyMana'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['modifyShield'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['modifyAbilityCooldown'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['modifyAbilityChargeCount'])};
      }
    }
  }
  /**
   * @returns {EffectModifyUnit_ModifyMana}
   */
  get modifyMana() {
    return this._oneofModifyUnitTypeCase === 11 ? this._oneofModifyUnitTypeValue : EffectModifyUnit_ModifyMana.default;
  }
  setModifyMana(path, value) {
    return {type: 'SET', path: path.concat(['modifyMana']), value: value.toJson()};
  }
  deleteModifyMana(path) {
    return {type: 'DELETE', path: path.concat(['modifyMana'])};
  }
  /**
   * @returns {EffectModifyUnit_ModifyShield}
   */
  get modifyShield() {
    return this._oneofModifyUnitTypeCase === 12 ? this._oneofModifyUnitTypeValue : EffectModifyUnit_ModifyShield.default;
  }
  setModifyShield(path, value) {
    return {type: 'SET', path: path.concat(['modifyShield']), value: value.toJson()};
  }
  deleteModifyShield(path) {
    return {type: 'DELETE', path: path.concat(['modifyShield'])};
  }
  /**
   * @returns {EffectModifyUnit_ModifyAbilityCooldown}
   */
  get modifyAbilityCooldown() {
    return this._oneofModifyUnitTypeCase === 13 ? this._oneofModifyUnitTypeValue : EffectModifyUnit_ModifyAbilityCooldown.default;
  }
  setModifyAbilityCooldown(path, value) {
    return {type: 'SET', path: path.concat(['modifyAbilityCooldown']), value: value.toJson()};
  }
  deleteModifyAbilityCooldown(path) {
    return {type: 'DELETE', path: path.concat(['modifyAbilityCooldown'])};
  }
  /**
   * @returns {EffectModifyUnit_ModifyAbilityChargeCount}
   */
  get modifyAbilityChargeCount() {
    return this._oneofModifyUnitTypeCase === 14 ? this._oneofModifyUnitTypeValue : EffectModifyUnit_ModifyAbilityChargeCount.default;
  }
  setModifyAbilityChargeCount(path, value) {
    return {type: 'SET', path: path.concat(['modifyAbilityChargeCount']), value: value.toJson()};
  }
  deleteModifyAbilityChargeCount(path) {
    return {type: 'DELETE', path: path.concat(['modifyAbilityChargeCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectModifyUnit(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modifyMana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 11;
              copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyMana.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofModifyUnitTypeCase !== 11) {
                return this;
              }
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 0;
              copy._oneofModifyUnitTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofModifyUnitTypeCase !== 11) {
            const copy = new EffectModifyUnit(this);
            copy._oneofModifyUnitTypeCase = 11;
            copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyMana.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modifyMana.apply(type, path.slice(1), value);
          if (newValue === this.modifyMana) {
            return this;
          }
          const copy = new EffectModifyUnit(this);
          copy._oneofModifyUnitTypeCase = 11;
          copy._oneofModifyUnitTypeValue = newValue;
          return copy;
        }
      }
      case "modifyShield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 12;
              copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyShield.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofModifyUnitTypeCase !== 12) {
                return this;
              }
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 0;
              copy._oneofModifyUnitTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofModifyUnitTypeCase !== 12) {
            const copy = new EffectModifyUnit(this);
            copy._oneofModifyUnitTypeCase = 12;
            copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyShield.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modifyShield.apply(type, path.slice(1), value);
          if (newValue === this.modifyShield) {
            return this;
          }
          const copy = new EffectModifyUnit(this);
          copy._oneofModifyUnitTypeCase = 12;
          copy._oneofModifyUnitTypeValue = newValue;
          return copy;
        }
      }
      case "modifyAbilityCooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 13;
              copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityCooldown.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofModifyUnitTypeCase !== 13) {
                return this;
              }
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 0;
              copy._oneofModifyUnitTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofModifyUnitTypeCase !== 13) {
            const copy = new EffectModifyUnit(this);
            copy._oneofModifyUnitTypeCase = 13;
            copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityCooldown.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modifyAbilityCooldown.apply(type, path.slice(1), value);
          if (newValue === this.modifyAbilityCooldown) {
            return this;
          }
          const copy = new EffectModifyUnit(this);
          copy._oneofModifyUnitTypeCase = 13;
          copy._oneofModifyUnitTypeValue = newValue;
          return copy;
        }
      }
      case "modifyAbilityChargeCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 14;
              copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityChargeCount.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofModifyUnitTypeCase !== 14) {
                return this;
              }
              const copy = new EffectModifyUnit(this);
              copy._oneofModifyUnitTypeCase = 0;
              copy._oneofModifyUnitTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofModifyUnitTypeCase !== 14) {
            const copy = new EffectModifyUnit(this);
            copy._oneofModifyUnitTypeCase = 14;
            copy._oneofModifyUnitTypeValue = EffectModifyUnit_ModifyAbilityChargeCount.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modifyAbilityChargeCount.apply(type, path.slice(1), value);
          if (newValue === this.modifyAbilityChargeCount) {
            return this;
          }
          const copy = new EffectModifyUnit(this);
          copy._oneofModifyUnitTypeCase = 14;
          copy._oneofModifyUnitTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModifyUnit} other
   * @returns {EffectModifyUnit}
   */
  merge(other) {
    const copy = new EffectModifyUnit(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._oneofModifyUnitTypeCase === 11) {
      if (this._oneofModifyUnitTypeCase === 11) {
        copy._oneofModifyUnitTypeValue = copy._oneofModifyUnitTypeValue.merge(other._oneofModifyUnitTypeValue);
      } else {
        copy._oneofModifyUnitTypeValue = other._oneofModifyUnitTypeValue;
      }
      copy._oneofModifyUnitTypeCase = 11;
    }
    if (other._oneofModifyUnitTypeCase === 11) {
      if (this._oneofModifyUnitTypeCase === 11) {
        copy._oneofModifyUnitTypeValue = copy._oneofModifyUnitTypeValue.merge(other._oneofModifyUnitTypeValue);
      } else {
        copy._oneofModifyUnitTypeValue = other._oneofModifyUnitTypeValue;
      }
      copy._oneofModifyUnitTypeCase = 11;
    }
    if (other._oneofModifyUnitTypeCase === 11) {
      if (this._oneofModifyUnitTypeCase === 11) {
        copy._oneofModifyUnitTypeValue = copy._oneofModifyUnitTypeValue.merge(other._oneofModifyUnitTypeValue);
      } else {
        copy._oneofModifyUnitTypeValue = other._oneofModifyUnitTypeValue;
      }
      copy._oneofModifyUnitTypeCase = 11;
    }
    if (other._oneofModifyUnitTypeCase === 11) {
      if (this._oneofModifyUnitTypeCase === 11) {
        copy._oneofModifyUnitTypeValue = copy._oneofModifyUnitTypeValue.merge(other._oneofModifyUnitTypeValue);
      } else {
        copy._oneofModifyUnitTypeValue = other._oneofModifyUnitTypeValue;
      }
      copy._oneofModifyUnitTypeCase = 11;
    }
    return copy;
  }
}
EffectModifyUnit.default = new EffectModifyUnit();
EffectModifyUnit.ModifyMana = EffectModifyUnit_ModifyMana;
EffectModifyUnit.ModifyShield = EffectModifyUnit_ModifyShield;
EffectModifyUnit.ModifyAbilityCooldown = EffectModifyUnit_ModifyAbilityCooldown;
EffectModifyUnit.ModifyAbilityChargeCount = EffectModifyUnit_ModifyAbilityChargeCount;
EffectModifyUnit.ModifyType = EffectModifyUnit_ModifyType;
class EffectModifyUnit_Builder {
  constructor(value) {
    this._value = new EffectModifyUnit(value);
  }
  build() {
    return new EffectModifyUnit(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  clearoneofModifyUnitType() {
    this._value._oneofModifyUnitTypeCase = 0;
    this._value._oneofModifyUnitTypeValue = null;
    return this;
  }
  setModifyMana(value) {
    this._value._oneofModifyUnitTypeCase = 11;
    this._value._oneofModifyUnitTypeValue = value;
    return this;
  }
  setModifyShield(value) {
    this._value._oneofModifyUnitTypeCase = 12;
    this._value._oneofModifyUnitTypeValue = value;
    return this;
  }
  setModifyAbilityCooldown(value) {
    this._value._oneofModifyUnitTypeCase = 13;
    this._value._oneofModifyUnitTypeValue = value;
    return this;
  }
  setModifyAbilityChargeCount(value) {
    this._value._oneofModifyUnitTypeCase = 14;
    this._value._oneofModifyUnitTypeValue = value;
    return this;
  }
}
EffectModifyUnit.Builder = EffectModifyUnit_Builder;
class EffectModifyUnit_WithParent {
  /**
   * @param {EffectModifyUnit} value
   * @param {EffectModifyUnit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModifyUnit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get oneofModifyUnitTypeCase() {
    if (this._cachedoneofModifyUnitTypeCase === undefined) {
      if (this._value._oneofModifyUnitTypeCase === 0) {
        this._cachedoneofModifyUnitTypeCase = this._parent ? this._parent.oneofModifyUnitTypeCase : 0;
      } else {
        this._cachedoneofModifyUnitTypeCase = this._value._oneofModifyUnitTypeCase;
      }
    }
    return this._cachedoneofModifyUnitTypeCase;
  }
  get modifyMana() {
    if (!this._cachedModifyMana) {
      if (this._value._oneofModifyUnitTypeCase === 0) {
        this._cachedModifyMana = this._parent ? new EffectModifyUnit_ModifyMana.WithParent(EffectModifyUnit_ModifyMana.default, this._parent.modifyMana) : this._value.modifyMana;
      } else if (this._value._oneofModifyUnitTypeCase === 11) {
        this._cachedModifyMana = new EffectModifyUnit_ModifyMana.WithParent(this._value.modifyMana, this._parent && this._parent.oneofModifyUnitTypeCase === 11 ? this._parent.modifyMana : null);
      } else {
        this._cachedModifyMana = EffectModifyUnit_ModifyMana.WithParent.default;
      }
    }
    return this._cachedModifyMana;
  }
  get modifyShield() {
    if (!this._cachedModifyShield) {
      if (this._value._oneofModifyUnitTypeCase === 0) {
        this._cachedModifyShield = this._parent ? new EffectModifyUnit_ModifyShield.WithParent(EffectModifyUnit_ModifyShield.default, this._parent.modifyShield) : this._value.modifyShield;
      } else if (this._value._oneofModifyUnitTypeCase === 12) {
        this._cachedModifyShield = new EffectModifyUnit_ModifyShield.WithParent(this._value.modifyShield, this._parent && this._parent.oneofModifyUnitTypeCase === 12 ? this._parent.modifyShield : null);
      } else {
        this._cachedModifyShield = EffectModifyUnit_ModifyShield.WithParent.default;
      }
    }
    return this._cachedModifyShield;
  }
  get modifyAbilityCooldown() {
    if (!this._cachedModifyAbilityCooldown) {
      if (this._value._oneofModifyUnitTypeCase === 0) {
        this._cachedModifyAbilityCooldown = this._parent ? new EffectModifyUnit_ModifyAbilityCooldown.WithParent(EffectModifyUnit_ModifyAbilityCooldown.default, this._parent.modifyAbilityCooldown) : this._value.modifyAbilityCooldown;
      } else if (this._value._oneofModifyUnitTypeCase === 13) {
        this._cachedModifyAbilityCooldown = new EffectModifyUnit_ModifyAbilityCooldown.WithParent(this._value.modifyAbilityCooldown, this._parent && this._parent.oneofModifyUnitTypeCase === 13 ? this._parent.modifyAbilityCooldown : null);
      } else {
        this._cachedModifyAbilityCooldown = EffectModifyUnit_ModifyAbilityCooldown.WithParent.default;
      }
    }
    return this._cachedModifyAbilityCooldown;
  }
  get modifyAbilityChargeCount() {
    if (!this._cachedModifyAbilityChargeCount) {
      if (this._value._oneofModifyUnitTypeCase === 0) {
        this._cachedModifyAbilityChargeCount = this._parent ? new EffectModifyUnit_ModifyAbilityChargeCount.WithParent(EffectModifyUnit_ModifyAbilityChargeCount.default, this._parent.modifyAbilityChargeCount) : this._value.modifyAbilityChargeCount;
      } else if (this._value._oneofModifyUnitTypeCase === 14) {
        this._cachedModifyAbilityChargeCount = new EffectModifyUnit_ModifyAbilityChargeCount.WithParent(this._value.modifyAbilityChargeCount, this._parent && this._parent.oneofModifyUnitTypeCase === 14 ? this._parent.modifyAbilityChargeCount : null);
      } else {
        this._cachedModifyAbilityChargeCount = EffectModifyUnit_ModifyAbilityChargeCount.WithParent.default;
      }
    }
    return this._cachedModifyAbilityChargeCount;
  }
  update(current, parent) {
    const result = new EffectModifyUnit_WithParent(current, parent);
    if (this._cachedModifyMana && this._value._oneofModifyUnitTypeCase === 11 && current._oneofModifyUnitTypeCase === 11) {
      if (this._value.modifyMana === current.modifyMana && this._parent === parent) {
        result._cachedModifyMana = this._cachedModifyMana;
      } else {
        result._cachedModifyMana = this._cachedModifyMana.update(current.modifyMana, parent && parent.oneofModifyUnitTypeCase === 11 ? parent.modifyMana : null);
      }
    }
    if (this._cachedModifyShield && this._value._oneofModifyUnitTypeCase === 12 && current._oneofModifyUnitTypeCase === 12) {
      if (this._value.modifyShield === current.modifyShield && this._parent === parent) {
        result._cachedModifyShield = this._cachedModifyShield;
      } else {
        result._cachedModifyShield = this._cachedModifyShield.update(current.modifyShield, parent && parent.oneofModifyUnitTypeCase === 12 ? parent.modifyShield : null);
      }
    }
    if (this._cachedModifyAbilityCooldown && this._value._oneofModifyUnitTypeCase === 13 && current._oneofModifyUnitTypeCase === 13) {
      if (this._value.modifyAbilityCooldown === current.modifyAbilityCooldown && this._parent === parent) {
        result._cachedModifyAbilityCooldown = this._cachedModifyAbilityCooldown;
      } else {
        result._cachedModifyAbilityCooldown = this._cachedModifyAbilityCooldown.update(current.modifyAbilityCooldown, parent && parent.oneofModifyUnitTypeCase === 13 ? parent.modifyAbilityCooldown : null);
      }
    }
    if (this._cachedModifyAbilityChargeCount && this._value._oneofModifyUnitTypeCase === 14 && current._oneofModifyUnitTypeCase === 14) {
      if (this._value.modifyAbilityChargeCount === current.modifyAbilityChargeCount && this._parent === parent) {
        result._cachedModifyAbilityChargeCount = this._cachedModifyAbilityChargeCount;
      } else {
        result._cachedModifyAbilityChargeCount = this._cachedModifyAbilityChargeCount.update(current.modifyAbilityChargeCount, parent && parent.oneofModifyUnitTypeCase === 14 ? parent.modifyAbilityChargeCount : null);
      }
    }
    return result;
  }
}
EffectModifyUnit_WithParent.default = new EffectModifyUnit_WithParent(EffectModifyUnit.default, null);
EffectModifyUnit.WithParent = EffectModifyUnit_WithParent;
class EffectModifyUnit_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to modify",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get modifyMana() {
    if (!this._modifyMana) {
      this._modifyMana = {
        name: "modifyMana",
        Name: "ModifyMana",
        number: 11,
        protoType: 11,
        protoName: "modify_mana",
        oneofIndex: 1,
        type: EffectModifyUnit_ModifyMana,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyMana;
  }
  get modifyShield() {
    if (!this._modifyShield) {
      this._modifyShield = {
        name: "modifyShield",
        Name: "ModifyShield",
        number: 12,
        protoType: 11,
        protoName: "modify_shield",
        oneofIndex: 1,
        type: EffectModifyUnit_ModifyShield,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyShield;
  }
  get modifyAbilityCooldown() {
    if (!this._modifyAbilityCooldown) {
      this._modifyAbilityCooldown = {
        name: "modifyAbilityCooldown",
        Name: "ModifyAbilityCooldown",
        number: 13,
        protoType: 11,
        protoName: "modify_ability_cooldown",
        oneofIndex: 1,
        type: EffectModifyUnit_ModifyAbilityCooldown,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyAbilityCooldown;
  }
  get modifyAbilityChargeCount() {
    if (!this._modifyAbilityChargeCount) {
      this._modifyAbilityChargeCount = {
        name: "modifyAbilityChargeCount",
        Name: "ModifyAbilityChargeCount",
        number: 14,
        protoType: 11,
        protoName: "modify_ability_charge_count",
        oneofIndex: 1,
        type: EffectModifyUnit_ModifyAbilityChargeCount,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modifyAbilityChargeCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.modifyMana,
        this.modifyShield,
        this.modifyAbilityCooldown,
        this.modifyAbilityChargeCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "oneofModifyUnitType",
        Name: "OneofModifyUnitType",
        fields: [
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModifyUnit.descriptor = new EffectModifyUnit_Descriptor();
class EffectAreaSearch_IncludeFlags {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NORMAL": return 0;
        case "INCLUDE": return 1;
        case "EXCLUDE": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectAreaSearch_IncludeFlags.fromJson(value);
  }
  static fromReact(e) {
    return EffectAreaSearch_IncludeFlags.fromJson(e);
  }
}
EffectAreaSearch_IncludeFlags.NORMAL = 0;
EffectAreaSearch_IncludeFlags.INCLUDE = 1;
EffectAreaSearch_IncludeFlags.EXCLUDE = 2;
EffectAreaSearch_IncludeFlags.default = 0;
EffectAreaSearch_IncludeFlags.values = {
  NORMAL: 0,
  INCLUDE: 1,
  EXCLUDE: 2,
};
EffectAreaSearch_IncludeFlags.names = {
  0: "NORMAL",
  1: "INCLUDE",
  2: "EXCLUDE",
};
export class EffectAreaSearch {
  get descriptor() {
    return EffectAreaSearch.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedTargetType = false;
    this._targetType = null;
    this._hasDebugDraw = false;
    this._debugDraw = null;
    this._hasDeprecatedRange = false;
    this._range = null;
    this._hasDistanceCheckMode = false;
    this._distanceCheckMode = null;
    this._hasDistanceExtendMode = false;
    this._distanceExtendMode = null;
    this._hasAreaSearchType = false;
    this._areaSearchType = null;
    this._hasMaxUnitCount = false;
    this._maxUnitCount = null;
    this._hasDeprecatedSearchFilter = false;
    this._searchFilter = null;
    this._hasCaster = false;
    this._caster = null;
    this._hasSource = false;
    this._source = null;
    this._hasTarget = false;
    this._target = null;
    this._hasFilter = false;
    this._filter = null;
    this._requiredTags = [];
    this._excludedTags = [];
    this._validators = [];
    this._requiredTagNames = [];
    this._excludedTagNames = [];
    this._hasEffect = false;
    this._effect = null;
    this._hasMissingEffect = false;
    this._missingEffect = null;
    this._hasLocation = false;
    this._location = null;
    this._hasUseSourceFacing = false;
    this._useSourceFacing = null;
    this._hasFacingAdjustment = false;
    this._facingAdjustment = null;
    this._hasOffsetStart = false;
    this._offsetStart = null;
    this._hasOffsetEnd = false;
    this._offsetEnd = null;
    this._hasOffset = false;
    this._offset = null;
  }
  isEmpty() {
    if (this._hasDeprecatedTargetType) return false;
    if (this._hasDebugDraw) return false;
    if (this._hasDeprecatedRange) return false;
    if (this._hasDistanceCheckMode) return false;
    if (this._hasDistanceExtendMode) return false;
    if (this._hasAreaSearchType && !this._areaSearchType.isEmpty()) return false;
    if (this._hasMaxUnitCount) return false;
    if (this._hasDeprecatedSearchFilter && !this._searchFilter.isEmpty()) return false;
    if (this._hasCaster) return false;
    if (this._hasSource) return false;
    if (this._hasTarget) return false;
    if (this._hasFilter && !this._filter.isEmpty()) return false;
    if (this._requiredTags.length > 0) return false;
    if (this._excludedTags.length > 0) return false;
    if (this._validators.length > 0) return false;
    if (this._requiredTagNames.length > 0) return false;
    if (this._excludedTagNames.length > 0) return false;
    if (this._hasEffect) return false;
    if (this._hasMissingEffect) return false;
    if (this._hasLocation) return false;
    if (this._hasUseSourceFacing) return false;
    if (this._hasFacingAdjustment) return false;
    if (this._hasOffsetStart) return false;
    if (this._hasOffsetEnd) return false;
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectAreaSearch) {
      return value;
    }
    return EffectAreaSearch.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectAreaSearch();
    if (json.targetType != null) {
      result._hasDeprecatedTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    if (json.debugDraw != null) {
      result._hasDebugDraw = true;
      result._debugDraw = JsonToBoolean.fromJson(json.debugDraw);
    }
    if (json.range != null) {
      result._hasDeprecatedRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.distanceCheckMode != null) {
      result._hasDistanceCheckMode = true;
      result._distanceCheckMode = DistanceCheckModes.fromJson(json.distanceCheckMode);
    }
    if (json.distanceExtendMode != null) {
      result._hasDistanceExtendMode = true;
      result._distanceExtendMode = DistanceExtendModes.fromJson(json.distanceExtendMode);
    }
    if (json.areaSearchType != null) {
      result._hasAreaSearchType = true;
      result._areaSearchType = AreaSearchType.fromJson(json.areaSearchType);
    }
    if (json.maxUnitCount != null) {
      result._hasMaxUnitCount = true;
      result._maxUnitCount = JsonToInt32.fromJson(json.maxUnitCount);
    }
    if (json.searchFilter != null) {
      result._hasDeprecatedSearchFilter = true;
      result._searchFilter = OldSearchFilter.fromJson(json.searchFilter);
    }
    if (json.caster != null) {
      result._hasCaster = true;
      result._caster = EffectAreaSearch_IncludeFlags.fromJson(json.caster);
    }
    if (json.source != null) {
      result._hasSource = true;
      result._source = EffectAreaSearch_IncludeFlags.fromJson(json.source);
    }
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectAreaSearch_IncludeFlags.fromJson(json.target);
    }
    if (json.filter != null) {
      result._hasFilter = true;
      result._filter = SearchFilter.fromJson(json.filter);
    }
    result._requiredTags = JsonToList(json.requiredTags, JsonToInt32);
    result._excludedTags = JsonToList(json.excludedTags, JsonToInt32);
    result._validators = JsonToList(json.validators, JsonToString);
    result._requiredTagNames = JsonToList(json.requiredTagNames, JsonToString);
    result._excludedTagNames = JsonToList(json.excludedTagNames, JsonToString);
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.missingEffect != null) {
      result._hasMissingEffect = true;
      result._missingEffect = JsonToString.fromJson(json.missingEffect);
    }
    if (json.location != null) {
      result._hasLocation = true;
      result._location = EffectTarget_Type.fromJson(json.location);
    }
    if (json.useSourceFacing != null) {
      result._hasUseSourceFacing = true;
      result._useSourceFacing = JsonToBoolean.fromJson(json.useSourceFacing);
    }
    if (json.facingAdjustment != null) {
      result._hasFacingAdjustment = true;
      result._facingAdjustment = JsonToDouble.fromJson(json.facingAdjustment);
    }
    if (json.offsetStart != null) {
      result._hasOffsetStart = true;
      result._offsetStart = EffectTarget_Type.fromJson(json.offsetStart);
    }
    if (json.offsetEnd != null) {
      result._hasOffsetEnd = true;
      result._offsetEnd = EffectTarget_Type.fromJson(json.offsetEnd);
    }
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = EffectOffset.fromJson(json.offset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._hasDebugDraw) {
      result.debugDraw = JsonToBoolean.toJson(this._debugDraw);
    }
    if (this._hasDeprecatedRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasDistanceCheckMode) {
      result.distanceCheckMode = DistanceCheckModes.toJson(this._distanceCheckMode);
    }
    if (this._hasDistanceExtendMode) {
      result.distanceExtendMode = DistanceExtendModes.toJson(this._distanceExtendMode);
    }
    if (this._hasAreaSearchType && !this._areaSearchType.isEmpty()) {
      result.areaSearchType = AreaSearchType.toJson(this._areaSearchType);
    }
    if (this._hasMaxUnitCount) {
      result.maxUnitCount = JsonToInt32.toJson(this._maxUnitCount);
    }
    if (this._hasDeprecatedSearchFilter && !this._searchFilter.isEmpty()) {
      result.searchFilter = OldSearchFilter.toJson(this._searchFilter);
    }
    if (this._hasCaster) {
      result.caster = EffectAreaSearch_IncludeFlags.toJson(this._caster);
    }
    if (this._hasSource) {
      result.source = EffectAreaSearch_IncludeFlags.toJson(this._source);
    }
    if (this._hasTarget) {
      result.target = EffectAreaSearch_IncludeFlags.toJson(this._target);
    }
    if (this._hasFilter && !this._filter.isEmpty()) {
      result.filter = SearchFilter.toJson(this._filter);
    }
    if (this._requiredTags.length > 0) {
      result.requiredTags = ArrayToJson(this._requiredTags, JsonToInt32);
    }
    if (this._excludedTags.length > 0) {
      result.excludedTags = ArrayToJson(this._excludedTags, JsonToInt32);
    }
    if (this._validators.length > 0) {
      result.validators = ArrayToJson(this._validators, JsonToString);
    }
    if (this._requiredTagNames.length > 0) {
      result.requiredTagNames = ArrayToJson(this._requiredTagNames, JsonToString);
    }
    if (this._excludedTagNames.length > 0) {
      result.excludedTagNames = ArrayToJson(this._excludedTagNames, JsonToString);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasMissingEffect) {
      result.missingEffect = JsonToString.toJson(this._missingEffect);
    }
    if (this._hasLocation) {
      result.location = EffectTarget_Type.toJson(this._location);
    }
    if (this._hasUseSourceFacing) {
      result.useSourceFacing = JsonToBoolean.toJson(this._useSourceFacing);
    }
    if (this._hasFacingAdjustment) {
      result.facingAdjustment = JsonToDouble.toJson(this._facingAdjustment);
    }
    if (this._hasOffsetStart) {
      result.offsetStart = EffectTarget_Type.toJson(this._offsetStart);
    }
    if (this._hasOffsetEnd) {
      result.offsetEnd = EffectTarget_Type.toJson(this._offsetEnd);
    }
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = EffectOffset.toJson(this._offset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasDeprecatedTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasDeprecatedTargetType() {
    return this._hasDeprecatedTargetType;
  }
  setDeprecatedTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteDeprecatedTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {boolean}
   */
  get debugDraw() {
    return this._hasDebugDraw ? this._debugDraw : JsonToBoolean.default;
  }
  get hasDebugDraw() {
    return this._hasDebugDraw;
  }
  setDebugDraw(path, value) {
    return {type: 'SET', path: path.concat(['debugDraw']), value};
  }
  deleteDebugDraw(path) {
    return {type: 'DELETE', path: path.concat(['debugDraw'])};
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasDeprecatedRange ? this._range : JsonToDouble.default;
  }
  get hasDeprecatedRange() {
    return this._hasDeprecatedRange;
  }
  setDeprecatedRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteDeprecatedRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {number}
   */
  get distanceCheckMode() {
    return this._hasDistanceCheckMode ? this._distanceCheckMode : DistanceCheckModes.default;
  }
  get hasDistanceCheckMode() {
    return this._hasDistanceCheckMode;
  }
  setDistanceCheckMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceCheckMode']), value};
  }
  deleteDistanceCheckMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceCheckMode'])};
  }
  /**
   * @returns {number}
   */
  get distanceExtendMode() {
    return this._hasDistanceExtendMode ? this._distanceExtendMode : DistanceExtendModes.default;
  }
  get hasDistanceExtendMode() {
    return this._hasDistanceExtendMode;
  }
  setDistanceExtendMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceExtendMode']), value};
  }
  deleteDistanceExtendMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceExtendMode'])};
  }
  /**
   * @returns {AreaSearchType}
   */
  get areaSearchType() {
    return this._hasAreaSearchType ? this._areaSearchType : AreaSearchType.default;
  }
  get hasAreaSearchType() {
    return this._hasAreaSearchType;
  }
  setAreaSearchType(path, value) {
    return {type: 'SET', path: path.concat(['areaSearchType']), value: value.toJson()};
  }
  deleteAreaSearchType(path) {
    return {type: 'DELETE', path: path.concat(['areaSearchType'])};
  }
  /**
   * @returns {number}
   */
  get maxUnitCount() {
    return this._hasMaxUnitCount ? this._maxUnitCount : JsonToInt32.default;
  }
  get hasMaxUnitCount() {
    return this._hasMaxUnitCount;
  }
  setMaxUnitCount(path, value) {
    return {type: 'SET', path: path.concat(['maxUnitCount']), value};
  }
  deleteMaxUnitCount(path) {
    return {type: 'DELETE', path: path.concat(['maxUnitCount'])};
  }
  /**
   * @returns {OldSearchFilter}
   */
  get searchFilter() {
    return this._hasDeprecatedSearchFilter ? this._searchFilter : OldSearchFilter.default;
  }
  get hasDeprecatedSearchFilter() {
    return this._hasDeprecatedSearchFilter;
  }
  setDeprecatedSearchFilter(path, value) {
    return {type: 'SET', path: path.concat(['searchFilter']), value: value.toJson()};
  }
  deleteDeprecatedSearchFilter(path) {
    return {type: 'DELETE', path: path.concat(['searchFilter'])};
  }
  /**
   * @returns {number}
   */
  get caster() {
    return this._hasCaster ? this._caster : EffectAreaSearch_IncludeFlags.default;
  }
  get hasCaster() {
    return this._hasCaster;
  }
  setCaster(path, value) {
    return {type: 'SET', path: path.concat(['caster']), value};
  }
  deleteCaster(path) {
    return {type: 'DELETE', path: path.concat(['caster'])};
  }
  /**
   * @returns {number}
   */
  get source() {
    return this._hasSource ? this._source : EffectAreaSearch_IncludeFlags.default;
  }
  get hasSource() {
    return this._hasSource;
  }
  setSource(path, value) {
    return {type: 'SET', path: path.concat(['source']), value};
  }
  deleteSource(path) {
    return {type: 'DELETE', path: path.concat(['source'])};
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectAreaSearch_IncludeFlags.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {SearchFilter}
   */
  get filter() {
    return this._hasFilter ? this._filter : SearchFilter.default;
  }
  get hasFilter() {
    return this._hasFilter;
  }
  setFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {number[]}
   */
  get requiredTags() {
    return this._requiredTags;
  }
  addDeprecatedRequiredTags(path, value) {
    return {type: 'ADD', path: path.concat(['requiredTags']), value};
  }
  setDeprecatedRequiredTags(path, value) {
    return {type: 'SET', path: path.concat(['requiredTags']), value: ArrayToJson(value, JsonToInt32)};
  }
  setDeprecatedRequiredTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['requiredTags', key]), value};
  }
  deleteDeprecatedRequiredTags(path) {
    return {type: 'DELETE', path: path.concat(['requiredTags'])};
  }
  deleteDeprecatedRequiredTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['requiredTags', key])};
  }
  /**
   * @returns {number[]}
   */
  get excludedTags() {
    return this._excludedTags;
  }
  addDeprecatedExcludedTags(path, value) {
    return {type: 'ADD', path: path.concat(['excludedTags']), value};
  }
  setDeprecatedExcludedTags(path, value) {
    return {type: 'SET', path: path.concat(['excludedTags']), value: ArrayToJson(value, JsonToInt32)};
  }
  setDeprecatedExcludedTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['excludedTags', key]), value};
  }
  deleteDeprecatedExcludedTags(path) {
    return {type: 'DELETE', path: path.concat(['excludedTags'])};
  }
  deleteDeprecatedExcludedTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['excludedTags', key])};
  }
  /**
   * @returns {string[]}
   */
  get validators() {
    return this._validators;
  }
  addValidators(path, value) {
    return {type: 'ADD', path: path.concat(['validators']), value};
  }
  setValidators(path, value) {
    return {type: 'SET', path: path.concat(['validators']), value: ArrayToJson(value, JsonToString)};
  }
  setValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['validators', key]), value};
  }
  deleteValidators(path) {
    return {type: 'DELETE', path: path.concat(['validators'])};
  }
  deleteValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['validators', key])};
  }
  /**
   * @returns {string[]}
   */
  get requiredTagNames() {
    return this._requiredTagNames;
  }
  addRequiredTagNames(path, value) {
    return {type: 'ADD', path: path.concat(['requiredTagNames']), value};
  }
  setRequiredTagNames(path, value) {
    return {type: 'SET', path: path.concat(['requiredTagNames']), value: ArrayToJson(value, JsonToString)};
  }
  setRequiredTagNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['requiredTagNames', key]), value};
  }
  deleteRequiredTagNames(path) {
    return {type: 'DELETE', path: path.concat(['requiredTagNames'])};
  }
  deleteRequiredTagNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['requiredTagNames', key])};
  }
  /**
   * @returns {string[]}
   */
  get excludedTagNames() {
    return this._excludedTagNames;
  }
  addExcludedTagNames(path, value) {
    return {type: 'ADD', path: path.concat(['excludedTagNames']), value};
  }
  setExcludedTagNames(path, value) {
    return {type: 'SET', path: path.concat(['excludedTagNames']), value: ArrayToJson(value, JsonToString)};
  }
  setExcludedTagNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['excludedTagNames', key]), value};
  }
  deleteExcludedTagNames(path) {
    return {type: 'DELETE', path: path.concat(['excludedTagNames'])};
  }
  deleteExcludedTagNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['excludedTagNames', key])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {string}
   */
  get missingEffect() {
    return this._hasMissingEffect ? this._missingEffect : JsonToString.default;
  }
  get hasMissingEffect() {
    return this._hasMissingEffect;
  }
  setMissingEffect(path, value) {
    return {type: 'SET', path: path.concat(['missingEffect']), value};
  }
  deleteMissingEffect(path) {
    return {type: 'DELETE', path: path.concat(['missingEffect'])};
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : EffectTarget_Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  /**
   * @returns {boolean}
   */
  get useSourceFacing() {
    return this._hasUseSourceFacing ? this._useSourceFacing : JsonToBoolean.default;
  }
  get hasUseSourceFacing() {
    return this._hasUseSourceFacing;
  }
  setUseSourceFacing(path, value) {
    return {type: 'SET', path: path.concat(['useSourceFacing']), value};
  }
  deleteUseSourceFacing(path) {
    return {type: 'DELETE', path: path.concat(['useSourceFacing'])};
  }
  /**
   * @returns {number}
   */
  get facingAdjustment() {
    return this._hasFacingAdjustment ? this._facingAdjustment : JsonToDouble.default;
  }
  get hasFacingAdjustment() {
    return this._hasFacingAdjustment;
  }
  setFacingAdjustment(path, value) {
    return {type: 'SET', path: path.concat(['facingAdjustment']), value};
  }
  deleteFacingAdjustment(path) {
    return {type: 'DELETE', path: path.concat(['facingAdjustment'])};
  }
  /**
   * @returns {number}
   */
  get offsetStart() {
    return this._hasOffsetStart ? this._offsetStart : EffectTarget_Type.default;
  }
  get hasOffsetStart() {
    return this._hasOffsetStart;
  }
  setOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['offsetStart']), value};
  }
  deleteOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['offsetStart'])};
  }
  /**
   * @returns {number}
   */
  get offsetEnd() {
    return this._hasOffsetEnd ? this._offsetEnd : EffectTarget_Type.default;
  }
  get hasOffsetEnd() {
    return this._hasOffsetEnd;
  }
  setOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['offsetEnd']), value};
  }
  deleteOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['offsetEnd'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get offset() {
    return this._hasOffset ? this._offset : EffectOffset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedTargetType) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "debugDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDebugDraw = true;
              copy._debugDraw = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDebugDraw) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDebugDraw = false;
              copy._debugDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedRange) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceCheckMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDistanceCheckMode = true;
              copy._distanceCheckMode = DistanceCheckModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceCheckMode) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDistanceCheckMode = false;
              copy._distanceCheckMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceExtendMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDistanceExtendMode = true;
              copy._distanceExtendMode = DistanceExtendModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceExtendMode) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDistanceExtendMode = false;
              copy._distanceExtendMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "areaSearchType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasAreaSearchType = true;
              copy._areaSearchType = AreaSearchType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAreaSearchType) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasAreaSearchType = false;
              copy._areaSearchType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAreaSearchType) {
            const copy = new EffectAreaSearch(this);
            copy._hasAreaSearchType = true;
            copy._areaSearchType = AreaSearchType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._areaSearchType.apply(type, path.slice(1), value);
          if (newValue === this._areaSearchType) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._areaSearchType = copy._areaSearchType.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "maxUnitCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasMaxUnitCount = true;
              copy._maxUnitCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxUnitCount) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasMaxUnitCount = false;
              copy._maxUnitCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "searchFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedSearchFilter = true;
              copy._searchFilter = OldSearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedSearchFilter) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasDeprecatedSearchFilter = false;
              copy._searchFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeprecatedSearchFilter) {
            const copy = new EffectAreaSearch(this);
            copy._hasDeprecatedSearchFilter = true;
            copy._searchFilter = OldSearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._searchFilter.apply(type, path.slice(1), value);
          if (newValue === this._searchFilter) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._searchFilter = copy._searchFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "caster": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasCaster = true;
              copy._caster = EffectAreaSearch_IncludeFlags.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCaster) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasCaster = false;
              copy._caster = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "source": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasSource = true;
              copy._source = EffectAreaSearch_IncludeFlags.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSource) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasSource = false;
              copy._source = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasTarget = true;
              copy._target = EffectAreaSearch_IncludeFlags.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasFilter = true;
              copy._filter = SearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFilter) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFilter) {
            const copy = new EffectAreaSearch(this);
            copy._hasFilter = true;
            copy._filter = SearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "requiredTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTags = [];        for (let i of value) {
                copy._requiredTags.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTags = copy._requiredTags.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._requiredTags.length === 0) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._requiredTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._requiredTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTags = copy._requiredTags.slice();
              copy._requiredTags[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTags = copy._requiredTags.slice(0, path[1]).concat(copy._requiredTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._requiredTags.length) {
            return this;
          }
          const oldValue = this._requiredTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._requiredTags = copy._requiredTags.slice();
          copy._requiredTags[key] = newValue;
          return copy;
        }
      }
      case "excludedTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTags = [];        for (let i of value) {
                copy._excludedTags.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTags = copy._excludedTags.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._excludedTags.length === 0) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._excludedTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._excludedTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTags = copy._excludedTags.slice();
              copy._excludedTags[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTags = copy._excludedTags.slice(0, path[1]).concat(copy._excludedTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._excludedTags.length) {
            return this;
          }
          const oldValue = this._excludedTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._excludedTags = copy._excludedTags.slice();
          copy._excludedTags[key] = newValue;
          return copy;
        }
      }
      case "validators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._validators = [];        for (let i of value) {
                copy._validators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectAreaSearch(this);
              copy._validators = copy._validators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._validators.length === 0) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._validators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._validators = copy._validators.slice();
              copy._validators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectAreaSearch(this);
              copy._validators = copy._validators.slice(0, path[1]).concat(copy._validators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._validators.length) {
            return this;
          }
          const oldValue = this._validators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._validators = copy._validators.slice();
          copy._validators[key] = newValue;
          return copy;
        }
      }
      case "requiredTagNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTagNames = [];        for (let i of value) {
                copy._requiredTagNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTagNames = copy._requiredTagNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._requiredTagNames.length === 0) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._requiredTagNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._requiredTagNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTagNames = copy._requiredTagNames.slice();
              copy._requiredTagNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectAreaSearch(this);
              copy._requiredTagNames = copy._requiredTagNames.slice(0, path[1]).concat(copy._requiredTagNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._requiredTagNames.length) {
            return this;
          }
          const oldValue = this._requiredTagNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._requiredTagNames = copy._requiredTagNames.slice();
          copy._requiredTagNames[key] = newValue;
          return copy;
        }
      }
      case "excludedTagNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTagNames = [];        for (let i of value) {
                copy._excludedTagNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTagNames = copy._excludedTagNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._excludedTagNames.length === 0) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._excludedTagNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._excludedTagNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTagNames = copy._excludedTagNames.slice();
              copy._excludedTagNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectAreaSearch(this);
              copy._excludedTagNames = copy._excludedTagNames.slice(0, path[1]).concat(copy._excludedTagNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._excludedTagNames.length) {
            return this;
          }
          const oldValue = this._excludedTagNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._excludedTagNames = copy._excludedTagNames.slice();
          copy._excludedTagNames[key] = newValue;
          return copy;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missingEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasMissingEffect = true;
              copy._missingEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissingEffect) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasMissingEffect = false;
              copy._missingEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasLocation = true;
              copy._location = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useSourceFacing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasUseSourceFacing = true;
              copy._useSourceFacing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseSourceFacing) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasUseSourceFacing = false;
              copy._useSourceFacing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "facingAdjustment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasFacingAdjustment = true;
              copy._facingAdjustment = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFacingAdjustment) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasFacingAdjustment = false;
              copy._facingAdjustment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasOffsetStart = true;
              copy._offsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetStart) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasOffsetStart = false;
              copy._offsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasOffsetEnd = true;
              copy._offsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetEnd) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasOffsetEnd = false;
              copy._offsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAreaSearch(this);
              copy._hasOffset = true;
              copy._offset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new EffectAreaSearch(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new EffectAreaSearch(this);
            copy._hasOffset = true;
            copy._offset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new EffectAreaSearch(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectAreaSearch} other
   * @returns {EffectAreaSearch}
   */
  merge(other) {
    const copy = new EffectAreaSearch(this);
    if (other._hasDeprecatedTargetType) {
      copy._hasDeprecatedTargetType = true;
      copy._targetType = other._targetType;
    }
    if (other._hasDebugDraw) {
      copy._hasDebugDraw = true;
      copy._debugDraw = other._debugDraw;
    }
    if (other._hasDeprecatedRange) {
      copy._hasDeprecatedRange = true;
      copy._range = other._range;
    }
    if (other._hasDistanceCheckMode) {
      copy._hasDistanceCheckMode = true;
      copy._distanceCheckMode = other._distanceCheckMode;
    }
    if (other._hasDistanceExtendMode) {
      copy._hasDistanceExtendMode = true;
      copy._distanceExtendMode = other._distanceExtendMode;
    }
    if (other._hasAreaSearchType) {
      if (copy._hasAreaSearchType) {
        copy._areaSearchType = copy.areaSearchType.merge(other.areaSearchType);
      } else {
        copy._areaSearchType = other._areaSearchType;
      }
      copy._hasAreaSearchType = true;
    }
    if (other._hasMaxUnitCount) {
      copy._hasMaxUnitCount = true;
      copy._maxUnitCount = other._maxUnitCount;
    }
    if (other._hasDeprecatedSearchFilter) {
      if (copy._hasDeprecatedSearchFilter) {
        copy._searchFilter = copy.searchFilter.merge(other.searchFilter);
      } else {
        copy._searchFilter = other._searchFilter;
      }
      copy._hasDeprecatedSearchFilter = true;
    }
    if (other._hasCaster) {
      copy._hasCaster = true;
      copy._caster = other._caster;
    }
    if (other._hasSource) {
      copy._hasSource = true;
      copy._source = other._source;
    }
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasFilter) {
      if (copy._hasFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasFilter = true;
    }
    copy._requiredTags = this._requiredTags.concat(other._requiredTags);
    copy._excludedTags = this._excludedTags.concat(other._excludedTags);
    copy._validators = this._validators.concat(other._validators);
    copy._requiredTagNames = this._requiredTagNames.concat(other._requiredTagNames);
    copy._excludedTagNames = this._excludedTagNames.concat(other._excludedTagNames);
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasMissingEffect) {
      copy._hasMissingEffect = true;
      copy._missingEffect = other._missingEffect;
    }
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    if (other._hasUseSourceFacing) {
      copy._hasUseSourceFacing = true;
      copy._useSourceFacing = other._useSourceFacing;
    }
    if (other._hasFacingAdjustment) {
      copy._hasFacingAdjustment = true;
      copy._facingAdjustment = other._facingAdjustment;
    }
    if (other._hasOffsetStart) {
      copy._hasOffsetStart = true;
      copy._offsetStart = other._offsetStart;
    }
    if (other._hasOffsetEnd) {
      copy._hasOffsetEnd = true;
      copy._offsetEnd = other._offsetEnd;
    }
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    return copy;
  }
}
EffectAreaSearch.default = new EffectAreaSearch();
EffectAreaSearch.IncludeFlags = EffectAreaSearch_IncludeFlags;
class EffectAreaSearch_Builder {
  constructor(value) {
    this._value = new EffectAreaSearch(value);
  }
  build() {
    return new EffectAreaSearch(this._value);
  }
  setDeprecatedTargetType(value) {
    this._value._hasDeprecatedTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteDeprecatedTargetType() {
    this._value._hasDeprecatedTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setDebugDraw(value) {
    this._value._hasDebugDraw = true;
    this._value._debugDraw = value;
    return this;
  }
  deleteDebugDraw() {
    this._value._hasDebugDraw = false;
    this._value._debugDraw = null;
    return this;
  }
  setDeprecatedRange(value) {
    this._value._hasDeprecatedRange = true;
    this._value._range = value;
    return this;
  }
  deleteDeprecatedRange() {
    this._value._hasDeprecatedRange = false;
    this._value._range = null;
    return this;
  }
  setDistanceCheckMode(value) {
    this._value._hasDistanceCheckMode = true;
    this._value._distanceCheckMode = value;
    return this;
  }
  deleteDistanceCheckMode() {
    this._value._hasDistanceCheckMode = false;
    this._value._distanceCheckMode = null;
    return this;
  }
  setDistanceExtendMode(value) {
    this._value._hasDistanceExtendMode = true;
    this._value._distanceExtendMode = value;
    return this;
  }
  deleteDistanceExtendMode() {
    this._value._hasDistanceExtendMode = false;
    this._value._distanceExtendMode = null;
    return this;
  }
  setAreaSearchType(value) {
    this._value._hasAreaSearchType = true;
    this._value._areaSearchType = value;
    return this;
  }
  deleteAreaSearchType() {
    this._value._hasAreaSearchType = false;
    this._value._areaSearchType = null;
    return this;
  }
  setMaxUnitCount(value) {
    this._value._hasMaxUnitCount = true;
    this._value._maxUnitCount = value;
    return this;
  }
  deleteMaxUnitCount() {
    this._value._hasMaxUnitCount = false;
    this._value._maxUnitCount = null;
    return this;
  }
  setDeprecatedSearchFilter(value) {
    this._value._hasDeprecatedSearchFilter = true;
    this._value._searchFilter = value;
    return this;
  }
  deleteDeprecatedSearchFilter() {
    this._value._hasDeprecatedSearchFilter = false;
    this._value._searchFilter = null;
    return this;
  }
  setCaster(value) {
    this._value._hasCaster = true;
    this._value._caster = value;
    return this;
  }
  deleteCaster() {
    this._value._hasCaster = false;
    this._value._caster = null;
    return this;
  }
  setSource(value) {
    this._value._hasSource = true;
    this._value._source = value;
    return this;
  }
  deleteSource() {
    this._value._hasSource = false;
    this._value._source = null;
    return this;
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setFilter(value) {
    this._value._hasFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteFilter() {
    this._value._hasFilter = false;
    this._value._filter = null;
    return this;
  }
  addAllDeprecatedRequiredTags(values) {
    this._value._requiredTags = this._value._requiredTags.concat(values);
    return this;
  }
  addDeprecatedRequiredTags(value) {
    this._value._requiredTags = this._value._requiredTags.concat([value]);
    return this;
  }
  setDeprecatedRequiredTags(index, value) {
    this._value._requiredTags = this._value._requiredTags.concat();
    this._value._requiredTags[index] = value;
    return this;
  }
  clearDeprecatedRequiredTags() {
    this._value._requiredTags = [];
    return this;
  }
  addAllDeprecatedExcludedTags(values) {
    this._value._excludedTags = this._value._excludedTags.concat(values);
    return this;
  }
  addDeprecatedExcludedTags(value) {
    this._value._excludedTags = this._value._excludedTags.concat([value]);
    return this;
  }
  setDeprecatedExcludedTags(index, value) {
    this._value._excludedTags = this._value._excludedTags.concat();
    this._value._excludedTags[index] = value;
    return this;
  }
  clearDeprecatedExcludedTags() {
    this._value._excludedTags = [];
    return this;
  }
  addAllValidators(values) {
    this._value._validators = this._value._validators.concat(values);
    return this;
  }
  addValidators(value) {
    this._value._validators = this._value._validators.concat([value]);
    return this;
  }
  setValidators(index, value) {
    this._value._validators = this._value._validators.concat();
    this._value._validators[index] = value;
    return this;
  }
  clearValidators() {
    this._value._validators = [];
    return this;
  }
  addAllRequiredTagNames(values) {
    this._value._requiredTagNames = this._value._requiredTagNames.concat(values);
    return this;
  }
  addRequiredTagNames(value) {
    this._value._requiredTagNames = this._value._requiredTagNames.concat([value]);
    return this;
  }
  setRequiredTagNames(index, value) {
    this._value._requiredTagNames = this._value._requiredTagNames.concat();
    this._value._requiredTagNames[index] = value;
    return this;
  }
  clearRequiredTagNames() {
    this._value._requiredTagNames = [];
    return this;
  }
  addAllExcludedTagNames(values) {
    this._value._excludedTagNames = this._value._excludedTagNames.concat(values);
    return this;
  }
  addExcludedTagNames(value) {
    this._value._excludedTagNames = this._value._excludedTagNames.concat([value]);
    return this;
  }
  setExcludedTagNames(index, value) {
    this._value._excludedTagNames = this._value._excludedTagNames.concat();
    this._value._excludedTagNames[index] = value;
    return this;
  }
  clearExcludedTagNames() {
    this._value._excludedTagNames = [];
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setMissingEffect(value) {
    this._value._hasMissingEffect = true;
    this._value._missingEffect = value;
    return this;
  }
  deleteMissingEffect() {
    this._value._hasMissingEffect = false;
    this._value._missingEffect = null;
    return this;
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
  setUseSourceFacing(value) {
    this._value._hasUseSourceFacing = true;
    this._value._useSourceFacing = value;
    return this;
  }
  deleteUseSourceFacing() {
    this._value._hasUseSourceFacing = false;
    this._value._useSourceFacing = null;
    return this;
  }
  setFacingAdjustment(value) {
    this._value._hasFacingAdjustment = true;
    this._value._facingAdjustment = value;
    return this;
  }
  deleteFacingAdjustment() {
    this._value._hasFacingAdjustment = false;
    this._value._facingAdjustment = null;
    return this;
  }
  setOffsetStart(value) {
    this._value._hasOffsetStart = true;
    this._value._offsetStart = value;
    return this;
  }
  deleteOffsetStart() {
    this._value._hasOffsetStart = false;
    this._value._offsetStart = null;
    return this;
  }
  setOffsetEnd(value) {
    this._value._hasOffsetEnd = true;
    this._value._offsetEnd = value;
    return this;
  }
  deleteOffsetEnd() {
    this._value._hasOffsetEnd = false;
    this._value._offsetEnd = null;
    return this;
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
}
EffectAreaSearch.Builder = EffectAreaSearch_Builder;
class EffectAreaSearch_WithParent {
  /**
   * @param {EffectAreaSearch} value
   * @param {EffectAreaSearch_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectAreaSearch.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedTargetType() {
    if (this._cachedHasDeprecatedTargetType === undefined) {
      if (this._value.hasDeprecatedTargetType) {
        this._cachedHasDeprecatedTargetType = true;
      } else {
        this._cachedHasDeprecatedTargetType = this._parent ? this._parent.hasDeprecatedTargetType : false;
      }
    }
    return this._cachedHasDeprecatedTargetType;
  }
  get targetType() {
    if (this._cachedDeprecatedTargetType === undefined) {
      if (this._value.hasDeprecatedTargetType) {
        this._cachedDeprecatedTargetType = this._value.targetType;
      } else {
        this._cachedDeprecatedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedDeprecatedTargetType;
  }
  get hasDebugDraw() {
    if (this._cachedHasDebugDraw === undefined) {
      if (this._value.hasDebugDraw) {
        this._cachedHasDebugDraw = true;
      } else {
        this._cachedHasDebugDraw = this._parent ? this._parent.hasDebugDraw : false;
      }
    }
    return this._cachedHasDebugDraw;
  }
  get debugDraw() {
    if (this._cachedDebugDraw === undefined) {
      if (this._value.hasDebugDraw) {
        this._cachedDebugDraw = this._value.debugDraw;
      } else {
        this._cachedDebugDraw = this._parent ? this._parent.debugDraw : this._value.debugDraw;
      }
    }
    return this._cachedDebugDraw;
  }
  get hasDeprecatedRange() {
    if (this._cachedHasDeprecatedRange === undefined) {
      if (this._value.hasDeprecatedRange) {
        this._cachedHasDeprecatedRange = true;
      } else {
        this._cachedHasDeprecatedRange = this._parent ? this._parent.hasDeprecatedRange : false;
      }
    }
    return this._cachedHasDeprecatedRange;
  }
  get range() {
    if (this._cachedDeprecatedRange === undefined) {
      if (this._value.hasDeprecatedRange) {
        this._cachedDeprecatedRange = this._value.range;
      } else {
        this._cachedDeprecatedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedDeprecatedRange;
  }
  get hasDistanceCheckMode() {
    if (this._cachedHasDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedHasDistanceCheckMode = true;
      } else {
        this._cachedHasDistanceCheckMode = this._parent ? this._parent.hasDistanceCheckMode : false;
      }
    }
    return this._cachedHasDistanceCheckMode;
  }
  get distanceCheckMode() {
    if (this._cachedDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedDistanceCheckMode = this._value.distanceCheckMode;
      } else {
        this._cachedDistanceCheckMode = this._parent ? this._parent.distanceCheckMode : this._value.distanceCheckMode;
      }
    }
    return this._cachedDistanceCheckMode;
  }
  get hasDistanceExtendMode() {
    if (this._cachedHasDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedHasDistanceExtendMode = true;
      } else {
        this._cachedHasDistanceExtendMode = this._parent ? this._parent.hasDistanceExtendMode : false;
      }
    }
    return this._cachedHasDistanceExtendMode;
  }
  get distanceExtendMode() {
    if (this._cachedDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedDistanceExtendMode = this._value.distanceExtendMode;
      } else {
        this._cachedDistanceExtendMode = this._parent ? this._parent.distanceExtendMode : this._value.distanceExtendMode;
      }
    }
    return this._cachedDistanceExtendMode;
  }
  get hasAreaSearchType() {
    if (this._cachedHasAreaSearchType === undefined) {
      if (this._value.hasAreaSearchType) {
        this._cachedHasAreaSearchType = true;
      } else {
        this._cachedHasAreaSearchType = this._parent ? this._parent.hasAreaSearchType : false;
      }
    }
    return this._cachedHasAreaSearchType;
  }
  get areaSearchType() {
    if (!this._cachedAreaSearchType) {
      if (this._value.hasAreaSearchType) {
        this._cachedAreaSearchType = new AreaSearchType.WithParent(this._value.areaSearchType, this._parent && this._parent.hasAreaSearchType ? this._parent.areaSearchType : null);
      } else {
        this._cachedAreaSearchType = this._parent ? new AreaSearchType.WithParent(AreaSearchType.default, this._parent.areaSearchType) : AreaSearchType.WithParent.default;
      }
    }
    return this._cachedAreaSearchType;
  }
  get hasMaxUnitCount() {
    if (this._cachedHasMaxUnitCount === undefined) {
      if (this._value.hasMaxUnitCount) {
        this._cachedHasMaxUnitCount = true;
      } else {
        this._cachedHasMaxUnitCount = this._parent ? this._parent.hasMaxUnitCount : false;
      }
    }
    return this._cachedHasMaxUnitCount;
  }
  get maxUnitCount() {
    if (this._cachedMaxUnitCount === undefined) {
      if (this._value.hasMaxUnitCount) {
        this._cachedMaxUnitCount = this._value.maxUnitCount;
      } else {
        this._cachedMaxUnitCount = this._parent ? this._parent.maxUnitCount : this._value.maxUnitCount;
      }
    }
    return this._cachedMaxUnitCount;
  }
  get hasDeprecatedSearchFilter() {
    if (this._cachedHasDeprecatedSearchFilter === undefined) {
      if (this._value.hasDeprecatedSearchFilter) {
        this._cachedHasDeprecatedSearchFilter = true;
      } else {
        this._cachedHasDeprecatedSearchFilter = this._parent ? this._parent.hasDeprecatedSearchFilter : false;
      }
    }
    return this._cachedHasDeprecatedSearchFilter;
  }
  get searchFilter() {
    if (!this._cachedDeprecatedSearchFilter) {
      if (this._value.hasDeprecatedSearchFilter) {
        this._cachedDeprecatedSearchFilter = new OldSearchFilter.WithParent(this._value.searchFilter, this._parent && this._parent.hasDeprecatedSearchFilter ? this._parent.searchFilter : null);
      } else {
        this._cachedDeprecatedSearchFilter = this._parent ? new OldSearchFilter.WithParent(OldSearchFilter.default, this._parent.searchFilter) : OldSearchFilter.WithParent.default;
      }
    }
    return this._cachedDeprecatedSearchFilter;
  }
  get hasCaster() {
    if (this._cachedHasCaster === undefined) {
      if (this._value.hasCaster) {
        this._cachedHasCaster = true;
      } else {
        this._cachedHasCaster = this._parent ? this._parent.hasCaster : false;
      }
    }
    return this._cachedHasCaster;
  }
  get caster() {
    if (this._cachedCaster === undefined) {
      if (this._value.hasCaster) {
        this._cachedCaster = this._value.caster;
      } else {
        this._cachedCaster = this._parent ? this._parent.caster : this._value.caster;
      }
    }
    return this._cachedCaster;
  }
  get hasSource() {
    if (this._cachedHasSource === undefined) {
      if (this._value.hasSource) {
        this._cachedHasSource = true;
      } else {
        this._cachedHasSource = this._parent ? this._parent.hasSource : false;
      }
    }
    return this._cachedHasSource;
  }
  get source() {
    if (this._cachedSource === undefined) {
      if (this._value.hasSource) {
        this._cachedSource = this._value.source;
      } else {
        this._cachedSource = this._parent ? this._parent.source : this._value.source;
      }
    }
    return this._cachedSource;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasFilter() {
    if (this._cachedHasFilter === undefined) {
      if (this._value.hasFilter) {
        this._cachedHasFilter = true;
      } else {
        this._cachedHasFilter = this._parent ? this._parent.hasFilter : false;
      }
    }
    return this._cachedHasFilter;
  }
  get filter() {
    if (!this._cachedFilter) {
      if (this._value.hasFilter) {
        this._cachedFilter = new SearchFilter.WithParent(this._value.filter, this._parent && this._parent.hasFilter ? this._parent.filter : null);
      } else {
        this._cachedFilter = this._parent ? new SearchFilter.WithParent(SearchFilter.default, this._parent.filter) : SearchFilter.WithParent.default;
      }
    }
    return this._cachedFilter;
  }
  get selfDeprecatedRequiredTags() {
    return this._value.requiredTags;
  }
  get inherentDeprecatedRequiredTags() {
    if (!this._inherentDeprecatedRequiredTags) {
      this._inherentDeprecatedRequiredTags = this._parent ? this._parent.requiredTags : [];
    }
    return this._inherentDeprecatedRequiredTags;
  }
  get requiredTags() {
    if (!this._allDeprecatedRequiredTags) {
      this._allDeprecatedRequiredTags = this._parent ? this._parent.requiredTags.concat(this.selfDeprecatedRequiredTags) : this.selfDeprecatedRequiredTags;
    }
    return this._allDeprecatedRequiredTags;
  }
  get selfDeprecatedExcludedTags() {
    return this._value.excludedTags;
  }
  get inherentDeprecatedExcludedTags() {
    if (!this._inherentDeprecatedExcludedTags) {
      this._inherentDeprecatedExcludedTags = this._parent ? this._parent.excludedTags : [];
    }
    return this._inherentDeprecatedExcludedTags;
  }
  get excludedTags() {
    if (!this._allDeprecatedExcludedTags) {
      this._allDeprecatedExcludedTags = this._parent ? this._parent.excludedTags.concat(this.selfDeprecatedExcludedTags) : this.selfDeprecatedExcludedTags;
    }
    return this._allDeprecatedExcludedTags;
  }
  get selfValidators() {
    return this._value.validators;
  }
  get inherentValidators() {
    if (!this._inherentValidators) {
      this._inherentValidators = this._parent ? this._parent.validators : [];
    }
    return this._inherentValidators;
  }
  get validators() {
    if (!this._allValidators) {
      this._allValidators = this._parent ? this._parent.validators.concat(this.selfValidators) : this.selfValidators;
    }
    return this._allValidators;
  }
  get selfRequiredTagNames() {
    return this._value.requiredTagNames;
  }
  get inherentRequiredTagNames() {
    if (!this._inherentRequiredTagNames) {
      this._inherentRequiredTagNames = this._parent ? this._parent.requiredTagNames : [];
    }
    return this._inherentRequiredTagNames;
  }
  get requiredTagNames() {
    if (!this._allRequiredTagNames) {
      this._allRequiredTagNames = this._parent ? this._parent.requiredTagNames.concat(this.selfRequiredTagNames) : this.selfRequiredTagNames;
    }
    return this._allRequiredTagNames;
  }
  get selfExcludedTagNames() {
    return this._value.excludedTagNames;
  }
  get inherentExcludedTagNames() {
    if (!this._inherentExcludedTagNames) {
      this._inherentExcludedTagNames = this._parent ? this._parent.excludedTagNames : [];
    }
    return this._inherentExcludedTagNames;
  }
  get excludedTagNames() {
    if (!this._allExcludedTagNames) {
      this._allExcludedTagNames = this._parent ? this._parent.excludedTagNames.concat(this.selfExcludedTagNames) : this.selfExcludedTagNames;
    }
    return this._allExcludedTagNames;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasMissingEffect() {
    if (this._cachedHasMissingEffect === undefined) {
      if (this._value.hasMissingEffect) {
        this._cachedHasMissingEffect = true;
      } else {
        this._cachedHasMissingEffect = this._parent ? this._parent.hasMissingEffect : false;
      }
    }
    return this._cachedHasMissingEffect;
  }
  get missingEffect() {
    if (this._cachedMissingEffect === undefined) {
      if (this._value.hasMissingEffect) {
        this._cachedMissingEffect = this._value.missingEffect;
      } else {
        this._cachedMissingEffect = this._parent ? this._parent.missingEffect : this._value.missingEffect;
      }
    }
    return this._cachedMissingEffect;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  get hasUseSourceFacing() {
    if (this._cachedHasUseSourceFacing === undefined) {
      if (this._value.hasUseSourceFacing) {
        this._cachedHasUseSourceFacing = true;
      } else {
        this._cachedHasUseSourceFacing = this._parent ? this._parent.hasUseSourceFacing : false;
      }
    }
    return this._cachedHasUseSourceFacing;
  }
  get useSourceFacing() {
    if (this._cachedUseSourceFacing === undefined) {
      if (this._value.hasUseSourceFacing) {
        this._cachedUseSourceFacing = this._value.useSourceFacing;
      } else {
        this._cachedUseSourceFacing = this._parent ? this._parent.useSourceFacing : this._value.useSourceFacing;
      }
    }
    return this._cachedUseSourceFacing;
  }
  get hasFacingAdjustment() {
    if (this._cachedHasFacingAdjustment === undefined) {
      if (this._value.hasFacingAdjustment) {
        this._cachedHasFacingAdjustment = true;
      } else {
        this._cachedHasFacingAdjustment = this._parent ? this._parent.hasFacingAdjustment : false;
      }
    }
    return this._cachedHasFacingAdjustment;
  }
  get facingAdjustment() {
    if (this._cachedFacingAdjustment === undefined) {
      if (this._value.hasFacingAdjustment) {
        this._cachedFacingAdjustment = this._value.facingAdjustment;
      } else {
        this._cachedFacingAdjustment = this._parent ? this._parent.facingAdjustment : this._value.facingAdjustment;
      }
    }
    return this._cachedFacingAdjustment;
  }
  get hasOffsetStart() {
    if (this._cachedHasOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedHasOffsetStart = true;
      } else {
        this._cachedHasOffsetStart = this._parent ? this._parent.hasOffsetStart : false;
      }
    }
    return this._cachedHasOffsetStart;
  }
  get offsetStart() {
    if (this._cachedOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedOffsetStart = this._value.offsetStart;
      } else {
        this._cachedOffsetStart = this._parent ? this._parent.offsetStart : this._value.offsetStart;
      }
    }
    return this._cachedOffsetStart;
  }
  get hasOffsetEnd() {
    if (this._cachedHasOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedHasOffsetEnd = true;
      } else {
        this._cachedHasOffsetEnd = this._parent ? this._parent.hasOffsetEnd : false;
      }
    }
    return this._cachedHasOffsetEnd;
  }
  get offsetEnd() {
    if (this._cachedOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedOffsetEnd = this._value.offsetEnd;
      } else {
        this._cachedOffsetEnd = this._parent ? this._parent.offsetEnd : this._value.offsetEnd;
      }
    }
    return this._cachedOffsetEnd;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new EffectOffset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.offset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  update(current, parent) {
    const result = new EffectAreaSearch_WithParent(current, parent);
    if (this._cachedAreaSearchType && this._value.hasAreaSearchType && current.hasAreaSearchType) {
      if (this._value.areaSearchType === current.areaSearchType && this._parent === parent) {
        result._cachedAreaSearchType = this._cachedAreaSearchType;
      } else {
        result._cachedAreaSearchType = this._cachedAreaSearchType.update(current.areaSearchType, parent && parent.hasAreaSearchType ? parent.areaSearchType : null);
      }
    }
    if (this._cachedDeprecatedSearchFilter && this._value.hasDeprecatedSearchFilter && current.hasDeprecatedSearchFilter) {
      if (this._value.searchFilter === current.searchFilter && this._parent === parent) {
        result._cachedDeprecatedSearchFilter = this._cachedDeprecatedSearchFilter;
      } else {
        result._cachedDeprecatedSearchFilter = this._cachedDeprecatedSearchFilter.update(current.searchFilter, parent && parent.hasDeprecatedSearchFilter ? parent.searchFilter : null);
      }
    }
    if (this._cachedFilter && this._value.hasFilter && current.hasFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedFilter = this._cachedFilter;
      } else {
        result._cachedFilter = this._cachedFilter.update(current.filter, parent && parent.hasFilter ? parent.filter : null);
      }
    }
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
EffectAreaSearch_WithParent.default = new EffectAreaSearch_WithParent(EffectAreaSearch.default, null);
EffectAreaSearch.WithParent = EffectAreaSearch_WithParent;
class EffectAreaSearch_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "DeprecatedTargetType",
        number: 1,
        protoType: 14,
        protoName: "deprecated_target_type",
        type: EffectTargetType_Type,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get debugDraw() {
    if (!this._debugDraw) {
      this._debugDraw = {
        name: "debugDraw",
        Name: "DebugDraw",
        number: 2,
        protoType: 8,
        protoName: "debug_draw",
        type: JsonToBoolean,
        options: {
          comments: "When checked, shows the area of this search effect in-game.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._debugDraw;
  }
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "DeprecatedRange",
        number: 1003,
        protoType: 1,
        protoName: "deprecated_range",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get distanceCheckMode() {
    if (!this._distanceCheckMode) {
      this._distanceCheckMode = {
        name: "distanceCheckMode",
        Name: "DistanceCheckMode",
        number: 3,
        protoType: 14,
        protoName: "distance_check_mode",
        type: DistanceCheckModes,
        options: {
          comments: "Determines whether to consider unit radius or center point when finding targets.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceCheckMode;
  }
  get distanceExtendMode() {
    if (!this._distanceExtendMode) {
      this._distanceExtendMode = {
        name: "distanceExtendMode",
        Name: "DistanceExtendMode",
        number: 4,
        protoType: 14,
        protoName: "distance_extend_mode",
        type: DistanceExtendModes,
        options: {
          comments: "Determines whether to extend the search radius by the source unit\'s radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceExtendMode;
  }
  get areaSearchType() {
    if (!this._areaSearchType) {
      this._areaSearchType = {
        name: "areaSearchType",
        Name: "AreaSearchType",
        number: 5,
        protoType: 11,
        protoName: "area_search_type",
        type: AreaSearchType,
        options: {
          comments: "Determines whether to search in a circle, arc, rectangle, or the source unit\'s children units.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._areaSearchType;
  }
  get maxUnitCount() {
    if (!this._maxUnitCount) {
      this._maxUnitCount = {
        name: "maxUnitCount",
        Name: "MaxUnitCount",
        number: 6,
        protoType: 5,
        protoName: "max_unit_count",
        type: JsonToInt32,
        options: {
          comments: "The maximum number of units that will be found by the search.",
          default: "No limit",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxUnitCount;
  }
  get searchFilter() {
    if (!this._searchFilter) {
      this._searchFilter = {
        name: "searchFilter",
        Name: "DeprecatedSearchFilter",
        number: 1007,
        protoType: 11,
        protoName: "deprecated_search_filter",
        type: OldSearchFilter,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._searchFilter;
  }
  get caster() {
    if (!this._caster) {
      this._caster = {
        name: "caster",
        Name: "Caster",
        number: 7,
        protoType: 14,
        protoName: "caster",
        type: EffectAreaSearch_IncludeFlags,
        options: {
          comments: "Whether to automatically include or exclude the effect caster.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._caster;
  }
  get source() {
    if (!this._source) {
      this._source = {
        name: "source",
        Name: "Source",
        number: 8,
        protoType: 14,
        protoName: "source",
        type: EffectAreaSearch_IncludeFlags,
        options: {
          comments: "Whether to automatically include or exclude the effect source.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._source;
  }
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 9,
        protoType: 14,
        protoName: "target",
        type: EffectAreaSearch_IncludeFlags,
        options: {
          comments: "Whether to automatically include or exclude the effect target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "Filter",
        number: 10,
        protoType: 11,
        protoName: "filter",
        type: SearchFilter,
        options: {
          comments: "Parameters for which targets are valid for the search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get requiredTags() {
    if (!this._requiredTags) {
      this._requiredTags = {
        name: "requiredTags",
        Name: "DeprecatedRequiredTags",
        number: 1011,
        protoType: 5,
        protoName: "deprecated_required_tags",
        type: JsonToInt32,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredTags;
  }
  get excludedTags() {
    if (!this._excludedTags) {
      this._excludedTags = {
        name: "excludedTags",
        Name: "DeprecatedExcludedTags",
        number: 1012,
        protoType: 5,
        protoName: "deprecated_excluded_tags",
        type: JsonToInt32,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._excludedTags;
  }
  get validators() {
    if (!this._validators) {
      this._validators = {
        name: "validators",
        Name: "Validators",
        number: 11,
        protoType: 9,
        protoName: "validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Targets must pass these validators to be considered valid targets.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validators;
  }
  get requiredTagNames() {
    if (!this._requiredTagNames) {
      this._requiredTagNames = {
        name: "requiredTagNames",
        Name: "RequiredTagNames",
        number: 12,
        protoType: 9,
        protoName: "required_tag_names",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If set, units must have these tags to be considered valid targets.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredTagNames;
  }
  get excludedTagNames() {
    if (!this._excludedTagNames) {
      this._excludedTagNames = {
        name: "excludedTagNames",
        Name: "ExcludedTagNames",
        number: 13,
        protoType: 9,
        protoName: "excluded_tag_names",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If set, units with these tags will be excluded from the search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._excludedTagNames;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 14,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect created on targets found by the search.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get missingEffect() {
    if (!this._missingEffect) {
      this._missingEffect = {
        name: "missingEffect",
        Name: "MissingEffect",
        number: 15,
        protoType: 9,
        protoName: "missing_effect",
        type: JsonToString,
        options: {
          comments: "This effect is created if the number of targets found is less than the Max Unit Count (if set). This effect is created for each missing target. Ex: if the Max Unit Count is 3 but only 1 target is found, then the Effect will executed once on the target and the Missing Effect will be executed twice at the search location.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missingEffect;
  }
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 21,
        protoType: 14,
        protoName: "location",
        type: EffectTarget_Type,
        options: {
          comments: "Where the search is created.",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get useSourceFacing() {
    if (!this._useSourceFacing) {
      this._useSourceFacing = {
        name: "useSourceFacing",
        Name: "UseSourceFacing",
        number: 22,
        protoType: 8,
        protoName: "use_source_facing",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the search\'s facing will be set to the source unit\'s facing (before facing adjustment is applied).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useSourceFacing;
  }
  get facingAdjustment() {
    if (!this._facingAdjustment) {
      this._facingAdjustment = {
        name: "facingAdjustment",
        Name: "FacingAdjustment",
        number: 23,
        protoType: 1,
        protoName: "facing_adjustment",
        type: JsonToDouble,
        options: {
          comments: "The angle to offset the search\'s facing by.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._facingAdjustment;
  }
  get offsetStart() {
    if (!this._offsetStart) {
      this._offsetStart = {
        name: "offsetStart",
        Name: "OffsetStart",
        number: 24,
        protoType: 14,
        protoName: "offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset End to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
          default: "SOURCE_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetStart;
  }
  get offsetEnd() {
    if (!this._offsetEnd) {
      this._offsetEnd = {
        name: "offsetEnd",
        Name: "OffsetEnd",
        number: 25,
        protoType: 14,
        protoName: "offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetEnd;
  }
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 26,
        protoType: 11,
        protoName: "offset",
        type: EffectOffset,
        options: {
          comments: "The offset coordinates for this effect.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.debugDraw,
        this.range,
        this.distanceCheckMode,
        this.distanceExtendMode,
        this.areaSearchType,
        this.maxUnitCount,
        this.searchFilter,
        this.caster,
        this.source,
        this.target,
        this.filter,
        this.requiredTags,
        this.excludedTags,
        this.validators,
        this.requiredTagNames,
        this.excludedTagNames,
        this.effect,
        this.missingEffect,
        this.location,
        this.useSourceFacing,
        this.facingAdjustment,
        this.offsetStart,
        this.offsetEnd,
        this.offset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedTargetType",
        Name: "DummyOneofForDeprecatedTargetType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDebugDraw",
        Name: "DummyOneofForDebugDraw",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedRange",
        Name: "DummyOneofForDeprecatedRange",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceCheckMode",
        Name: "DummyOneofForDistanceCheckMode",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceExtendMode",
        Name: "DummyOneofForDistanceExtendMode",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAreaSearchType",
        Name: "DummyOneofForAreaSearchType",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxUnitCount",
        Name: "DummyOneofForMaxUnitCount",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedSearchFilter",
        Name: "DummyOneofForDeprecatedSearchFilter",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCaster",
        Name: "DummyOneofForCaster",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSource",
        Name: "DummyOneofForSource",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFilter",
        Name: "DummyOneofForFilter",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissingEffect",
        Name: "DummyOneofForMissingEffect",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseSourceFacing",
        Name: "DummyOneofForUseSourceFacing",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFacingAdjustment",
        Name: "DummyOneofForFacingAdjustment",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetStart",
        Name: "DummyOneofForOffsetStart",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetEnd",
        Name: "DummyOneofForOffsetEnd",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffset",
        Name: "DummyOneofForOffset",
        fields: [
          this.fields[24],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectAreaSearch.descriptor = new EffectAreaSearch_Descriptor();
export class AreaSearchType {
  get descriptor() {
    return AreaSearchType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofAreaSearchTypeCase = 0;
    this._oneofAreaSearchTypeValue = null;
  }
  isEmpty() {
    if (this._oneofAreaSearchTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AreaSearchType) {
      return value;
    }
    return AreaSearchType.fromJson(value);
  }
  static fromJson(json) {
    const result = new AreaSearchType();
    if (json.circle != null) {
      result._oneofAreaSearchTypeCase = 1;
      result._oneofAreaSearchTypeValue = AreaSearchCircle.fromJson(json.circle);
    }
    if (json.circleSector != null) {
      result._oneofAreaSearchTypeCase = 2;
      result._oneofAreaSearchTypeValue = AreaSearchCircleSector.fromJson(json.circleSector);
    }
    if (json.rectangle != null) {
      result._oneofAreaSearchTypeCase = 3;
      result._oneofAreaSearchTypeValue = AreaSearchRectangle.fromJson(json.rectangle);
    }
    if (json.children != null) {
      result._oneofAreaSearchTypeCase = 4;
      result._oneofAreaSearchTypeValue = AreaSearchChildrenUnits.fromJson(json.children);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofAreaSearchTypeCase) {
      case 1:
        result.circle = AreaSearchCircle.toJson(this._oneofAreaSearchTypeValue);
        break;
      case 2:
        result.circleSector = AreaSearchCircleSector.toJson(this._oneofAreaSearchTypeValue);
        break;
      case 3:
        result.rectangle = AreaSearchRectangle.toJson(this._oneofAreaSearchTypeValue);
        break;
      case 4:
        result.children = AreaSearchChildrenUnits.toJson(this._oneofAreaSearchTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofAreaSearchTypeCase() {
    return this._oneofAreaSearchTypeCase;
  }
  deleteOneofAreaSearchType(path) {
    switch (this._oneofAreaSearchTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['circle'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['circleSector'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['rectangle'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['children'])};
      }
    }
  }
  /**
   * @returns {AreaSearchCircle}
   */
  get circle() {
    return this._oneofAreaSearchTypeCase === 1 ? this._oneofAreaSearchTypeValue : AreaSearchCircle.default;
  }
  setCircle(path, value) {
    return {type: 'SET', path: path.concat(['circle']), value: value.toJson()};
  }
  deleteCircle(path) {
    return {type: 'DELETE', path: path.concat(['circle'])};
  }
  /**
   * @returns {AreaSearchCircleSector}
   */
  get circleSector() {
    return this._oneofAreaSearchTypeCase === 2 ? this._oneofAreaSearchTypeValue : AreaSearchCircleSector.default;
  }
  setCircleSector(path, value) {
    return {type: 'SET', path: path.concat(['circleSector']), value: value.toJson()};
  }
  deleteCircleSector(path) {
    return {type: 'DELETE', path: path.concat(['circleSector'])};
  }
  /**
   * @returns {AreaSearchRectangle}
   */
  get rectangle() {
    return this._oneofAreaSearchTypeCase === 3 ? this._oneofAreaSearchTypeValue : AreaSearchRectangle.default;
  }
  setRectangle(path, value) {
    return {type: 'SET', path: path.concat(['rectangle']), value: value.toJson()};
  }
  deleteRectangle(path) {
    return {type: 'DELETE', path: path.concat(['rectangle'])};
  }
  /**
   * @returns {AreaSearchChildrenUnits}
   */
  get children() {
    return this._oneofAreaSearchTypeCase === 4 ? this._oneofAreaSearchTypeValue : AreaSearchChildrenUnits.default;
  }
  setChildren(path, value) {
    return {type: 'SET', path: path.concat(['children']), value: value.toJson()};
  }
  deleteChildren(path) {
    return {type: 'DELETE', path: path.concat(['children'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "circle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 1;
              copy._oneofAreaSearchTypeValue = AreaSearchCircle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAreaSearchTypeCase !== 1) {
                return this;
              }
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 0;
              copy._oneofAreaSearchTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofAreaSearchTypeCase !== 1) {
            const copy = new AreaSearchType(this);
            copy._oneofAreaSearchTypeCase = 1;
            copy._oneofAreaSearchTypeValue = AreaSearchCircle.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.circle.apply(type, path.slice(1), value);
          if (newValue === this.circle) {
            return this;
          }
          const copy = new AreaSearchType(this);
          copy._oneofAreaSearchTypeCase = 1;
          copy._oneofAreaSearchTypeValue = newValue;
          return copy;
        }
      }
      case "circleSector": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 2;
              copy._oneofAreaSearchTypeValue = AreaSearchCircleSector.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAreaSearchTypeCase !== 2) {
                return this;
              }
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 0;
              copy._oneofAreaSearchTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofAreaSearchTypeCase !== 2) {
            const copy = new AreaSearchType(this);
            copy._oneofAreaSearchTypeCase = 2;
            copy._oneofAreaSearchTypeValue = AreaSearchCircleSector.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.circleSector.apply(type, path.slice(1), value);
          if (newValue === this.circleSector) {
            return this;
          }
          const copy = new AreaSearchType(this);
          copy._oneofAreaSearchTypeCase = 2;
          copy._oneofAreaSearchTypeValue = newValue;
          return copy;
        }
      }
      case "rectangle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 3;
              copy._oneofAreaSearchTypeValue = AreaSearchRectangle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAreaSearchTypeCase !== 3) {
                return this;
              }
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 0;
              copy._oneofAreaSearchTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofAreaSearchTypeCase !== 3) {
            const copy = new AreaSearchType(this);
            copy._oneofAreaSearchTypeCase = 3;
            copy._oneofAreaSearchTypeValue = AreaSearchRectangle.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.rectangle.apply(type, path.slice(1), value);
          if (newValue === this.rectangle) {
            return this;
          }
          const copy = new AreaSearchType(this);
          copy._oneofAreaSearchTypeCase = 3;
          copy._oneofAreaSearchTypeValue = newValue;
          return copy;
        }
      }
      case "children": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 4;
              copy._oneofAreaSearchTypeValue = AreaSearchChildrenUnits.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAreaSearchTypeCase !== 4) {
                return this;
              }
              const copy = new AreaSearchType(this);
              copy._oneofAreaSearchTypeCase = 0;
              copy._oneofAreaSearchTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofAreaSearchTypeCase !== 4) {
            const copy = new AreaSearchType(this);
            copy._oneofAreaSearchTypeCase = 4;
            copy._oneofAreaSearchTypeValue = AreaSearchChildrenUnits.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.children.apply(type, path.slice(1), value);
          if (newValue === this.children) {
            return this;
          }
          const copy = new AreaSearchType(this);
          copy._oneofAreaSearchTypeCase = 4;
          copy._oneofAreaSearchTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AreaSearchType} other
   * @returns {AreaSearchType}
   */
  merge(other) {
    const copy = new AreaSearchType(this);
    if (other._oneofAreaSearchTypeCase === 1) {
      if (this._oneofAreaSearchTypeCase === 1) {
        copy._oneofAreaSearchTypeValue = copy._oneofAreaSearchTypeValue.merge(other._oneofAreaSearchTypeValue);
      } else {
        copy._oneofAreaSearchTypeValue = other._oneofAreaSearchTypeValue;
      }
      copy._oneofAreaSearchTypeCase = 1;
    }
    if (other._oneofAreaSearchTypeCase === 1) {
      if (this._oneofAreaSearchTypeCase === 1) {
        copy._oneofAreaSearchTypeValue = copy._oneofAreaSearchTypeValue.merge(other._oneofAreaSearchTypeValue);
      } else {
        copy._oneofAreaSearchTypeValue = other._oneofAreaSearchTypeValue;
      }
      copy._oneofAreaSearchTypeCase = 1;
    }
    if (other._oneofAreaSearchTypeCase === 1) {
      if (this._oneofAreaSearchTypeCase === 1) {
        copy._oneofAreaSearchTypeValue = copy._oneofAreaSearchTypeValue.merge(other._oneofAreaSearchTypeValue);
      } else {
        copy._oneofAreaSearchTypeValue = other._oneofAreaSearchTypeValue;
      }
      copy._oneofAreaSearchTypeCase = 1;
    }
    if (other._oneofAreaSearchTypeCase === 1) {
      if (this._oneofAreaSearchTypeCase === 1) {
        copy._oneofAreaSearchTypeValue = copy._oneofAreaSearchTypeValue.merge(other._oneofAreaSearchTypeValue);
      } else {
        copy._oneofAreaSearchTypeValue = other._oneofAreaSearchTypeValue;
      }
      copy._oneofAreaSearchTypeCase = 1;
    }
    return copy;
  }
}
AreaSearchType.default = new AreaSearchType();
class AreaSearchType_Builder {
  constructor(value) {
    this._value = new AreaSearchType(value);
  }
  build() {
    return new AreaSearchType(this._value);
  }
  clearoneofAreaSearchType() {
    this._value._oneofAreaSearchTypeCase = 0;
    this._value._oneofAreaSearchTypeValue = null;
    return this;
  }
  setCircle(value) {
    this._value._oneofAreaSearchTypeCase = 1;
    this._value._oneofAreaSearchTypeValue = value;
    return this;
  }
  setCircleSector(value) {
    this._value._oneofAreaSearchTypeCase = 2;
    this._value._oneofAreaSearchTypeValue = value;
    return this;
  }
  setRectangle(value) {
    this._value._oneofAreaSearchTypeCase = 3;
    this._value._oneofAreaSearchTypeValue = value;
    return this;
  }
  setChildren(value) {
    this._value._oneofAreaSearchTypeCase = 4;
    this._value._oneofAreaSearchTypeValue = value;
    return this;
  }
}
AreaSearchType.Builder = AreaSearchType_Builder;
class AreaSearchType_WithParent {
  /**
   * @param {AreaSearchType} value
   * @param {AreaSearchType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AreaSearchType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofAreaSearchTypeCase() {
    if (this._cachedoneofAreaSearchTypeCase === undefined) {
      if (this._value._oneofAreaSearchTypeCase === 0) {
        this._cachedoneofAreaSearchTypeCase = this._parent ? this._parent.oneofAreaSearchTypeCase : 0;
      } else {
        this._cachedoneofAreaSearchTypeCase = this._value._oneofAreaSearchTypeCase;
      }
    }
    return this._cachedoneofAreaSearchTypeCase;
  }
  get circle() {
    if (!this._cachedCircle) {
      if (this._value._oneofAreaSearchTypeCase === 0) {
        this._cachedCircle = this._parent ? new AreaSearchCircle.WithParent(AreaSearchCircle.default, this._parent.circle) : this._value.circle;
      } else if (this._value._oneofAreaSearchTypeCase === 1) {
        this._cachedCircle = new AreaSearchCircle.WithParent(this._value.circle, this._parent && this._parent.oneofAreaSearchTypeCase === 1 ? this._parent.circle : null);
      } else {
        this._cachedCircle = AreaSearchCircle.WithParent.default;
      }
    }
    return this._cachedCircle;
  }
  get circleSector() {
    if (!this._cachedCircleSector) {
      if (this._value._oneofAreaSearchTypeCase === 0) {
        this._cachedCircleSector = this._parent ? new AreaSearchCircleSector.WithParent(AreaSearchCircleSector.default, this._parent.circleSector) : this._value.circleSector;
      } else if (this._value._oneofAreaSearchTypeCase === 2) {
        this._cachedCircleSector = new AreaSearchCircleSector.WithParent(this._value.circleSector, this._parent && this._parent.oneofAreaSearchTypeCase === 2 ? this._parent.circleSector : null);
      } else {
        this._cachedCircleSector = AreaSearchCircleSector.WithParent.default;
      }
    }
    return this._cachedCircleSector;
  }
  get rectangle() {
    if (!this._cachedRectangle) {
      if (this._value._oneofAreaSearchTypeCase === 0) {
        this._cachedRectangle = this._parent ? new AreaSearchRectangle.WithParent(AreaSearchRectangle.default, this._parent.rectangle) : this._value.rectangle;
      } else if (this._value._oneofAreaSearchTypeCase === 3) {
        this._cachedRectangle = new AreaSearchRectangle.WithParent(this._value.rectangle, this._parent && this._parent.oneofAreaSearchTypeCase === 3 ? this._parent.rectangle : null);
      } else {
        this._cachedRectangle = AreaSearchRectangle.WithParent.default;
      }
    }
    return this._cachedRectangle;
  }
  get children() {
    if (!this._cachedChildren) {
      if (this._value._oneofAreaSearchTypeCase === 0) {
        this._cachedChildren = this._parent ? new AreaSearchChildrenUnits.WithParent(AreaSearchChildrenUnits.default, this._parent.children) : this._value.children;
      } else if (this._value._oneofAreaSearchTypeCase === 4) {
        this._cachedChildren = new AreaSearchChildrenUnits.WithParent(this._value.children, this._parent && this._parent.oneofAreaSearchTypeCase === 4 ? this._parent.children : null);
      } else {
        this._cachedChildren = AreaSearchChildrenUnits.WithParent.default;
      }
    }
    return this._cachedChildren;
  }
  update(current, parent) {
    const result = new AreaSearchType_WithParent(current, parent);
    if (this._cachedCircle && this._value._oneofAreaSearchTypeCase === 1 && current._oneofAreaSearchTypeCase === 1) {
      if (this._value.circle === current.circle && this._parent === parent) {
        result._cachedCircle = this._cachedCircle;
      } else {
        result._cachedCircle = this._cachedCircle.update(current.circle, parent && parent.oneofAreaSearchTypeCase === 1 ? parent.circle : null);
      }
    }
    if (this._cachedCircleSector && this._value._oneofAreaSearchTypeCase === 2 && current._oneofAreaSearchTypeCase === 2) {
      if (this._value.circleSector === current.circleSector && this._parent === parent) {
        result._cachedCircleSector = this._cachedCircleSector;
      } else {
        result._cachedCircleSector = this._cachedCircleSector.update(current.circleSector, parent && parent.oneofAreaSearchTypeCase === 2 ? parent.circleSector : null);
      }
    }
    if (this._cachedRectangle && this._value._oneofAreaSearchTypeCase === 3 && current._oneofAreaSearchTypeCase === 3) {
      if (this._value.rectangle === current.rectangle && this._parent === parent) {
        result._cachedRectangle = this._cachedRectangle;
      } else {
        result._cachedRectangle = this._cachedRectangle.update(current.rectangle, parent && parent.oneofAreaSearchTypeCase === 3 ? parent.rectangle : null);
      }
    }
    if (this._cachedChildren && this._value._oneofAreaSearchTypeCase === 4 && current._oneofAreaSearchTypeCase === 4) {
      if (this._value.children === current.children && this._parent === parent) {
        result._cachedChildren = this._cachedChildren;
      } else {
        result._cachedChildren = this._cachedChildren.update(current.children, parent && parent.oneofAreaSearchTypeCase === 4 ? parent.children : null);
      }
    }
    return result;
  }
}
AreaSearchType_WithParent.default = new AreaSearchType_WithParent(AreaSearchType.default, null);
AreaSearchType.WithParent = AreaSearchType_WithParent;
class AreaSearchType_Descriptor {
  get circle() {
    if (!this._circle) {
      this._circle = {
        name: "circle",
        Name: "Circle",
        number: 1,
        protoType: 11,
        protoName: "circle",
        oneofIndex: 0,
        type: AreaSearchCircle,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._circle;
  }
  get circleSector() {
    if (!this._circleSector) {
      this._circleSector = {
        name: "circleSector",
        Name: "CircleSector",
        number: 2,
        protoType: 11,
        protoName: "circle_sector",
        oneofIndex: 0,
        type: AreaSearchCircleSector,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._circleSector;
  }
  get rectangle() {
    if (!this._rectangle) {
      this._rectangle = {
        name: "rectangle",
        Name: "Rectangle",
        number: 3,
        protoType: 11,
        protoName: "rectangle",
        oneofIndex: 0,
        type: AreaSearchRectangle,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rectangle;
  }
  get children() {
    if (!this._children) {
      this._children = {
        name: "children",
        Name: "Children",
        number: 4,
        protoType: 11,
        protoName: "children",
        oneofIndex: 0,
        type: AreaSearchChildrenUnits,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._children;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.circle,
        this.circleSector,
        this.rectangle,
        this.children,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofAreaSearchType",
        Name: "OneofAreaSearchType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
AreaSearchType.descriptor = new AreaSearchType_Descriptor();
export class AreaSearchCircle {
  get descriptor() {
    return AreaSearchCircle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRadius = false;
    this._radius = null;
    this._radiusExpressions = [];
  }
  isEmpty() {
    if (this._hasRadius) return false;
    if (this._radiusExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AreaSearchCircle) {
      return value;
    }
    return AreaSearchCircle.fromJson(value);
  }
  static fromJson(json) {
    const result = new AreaSearchCircle();
    if (json.radius != null) {
      result._hasRadius = true;
      result._radius = JsonToDouble.fromJson(json.radius);
    }
    result._radiusExpressions = JsonToList(json.radiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRadius) {
      result.radius = JsonToDouble.toJson(this._radius);
    }
    if (this._radiusExpressions.length > 0) {
      result.radiusExpressions = ArrayToJson(this._radiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get radius() {
    return this._hasRadius ? this._radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['radius'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get radiusExpressions() {
    return this._radiusExpressions;
  }
  addRadiusExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['radiusExpressions']), value: value.toJson()};
  }
  setRadiusExpressions(path, value) {
    return {type: 'SET', path: path.concat(['radiusExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setRadiusExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['radiusExpressions', key]), value: value.toJson()};
  }
  deleteRadiusExpressions(path) {
    return {type: 'DELETE', path: path.concat(['radiusExpressions'])};
  }
  deleteRadiusExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['radiusExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircle(this);
              copy._hasRadius = true;
              copy._radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new AreaSearchCircle(this);
              copy._hasRadius = false;
              copy._radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "radiusExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircle(this);
              copy._radiusExpressions = [];        for (let i of value) {
                copy._radiusExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchCircle(this);
              copy._radiusExpressions = copy._radiusExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._radiusExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchCircle(this);
              copy._radiusExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._radiusExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircle(this);
              copy._radiusExpressions = copy._radiusExpressions.slice();
              copy._radiusExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchCircle(this);
              copy._radiusExpressions = copy._radiusExpressions.slice(0, path[1]).concat(copy._radiusExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._radiusExpressions.length) {
            return this;
          }
          const oldValue = this._radiusExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchCircle(this);
          copy._radiusExpressions = copy._radiusExpressions.slice();
          copy._radiusExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AreaSearchCircle} other
   * @returns {AreaSearchCircle}
   */
  merge(other) {
    const copy = new AreaSearchCircle(this);
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._radius = other._radius;
    }
    copy._radiusExpressions = this._radiusExpressions.concat(other._radiusExpressions);
    return copy;
  }
}
AreaSearchCircle.default = new AreaSearchCircle();
class AreaSearchCircle_Builder {
  constructor(value) {
    this._value = new AreaSearchCircle(value);
  }
  build() {
    return new AreaSearchCircle(this._value);
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._radius = null;
    return this;
  }
  addAllRadiusExpressions(values) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat(values);
    return this;
  }
  addRadiusExpressions(value) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat([value]);
    return this;
  }
  setRadiusExpressions(index, value) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat();
    this._value._radiusExpressions[index] = value;
    return this;
  }
  clearRadiusExpressions() {
    this._value._radiusExpressions = [];
    return this;
  }
}
AreaSearchCircle.Builder = AreaSearchCircle_Builder;
class AreaSearchCircle_WithParent {
  /**
   * @param {AreaSearchCircle} value
   * @param {AreaSearchCircle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AreaSearchCircle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.radius : this._value.radius;
      }
    }
    return this._cachedRadius;
  }
  get selfRadiusExpressions() {
    if (!this._selfRadiusExpressions) {
      this._selfRadiusExpressions = [];
      for (let i of this._value.radiusExpressions) {
        this._selfRadiusExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfRadiusExpressions;
  }
  get inherentRadiusExpressions() {
    if (!this._inherentRadiusExpressions) {
      this._inherentRadiusExpressions = this._parent ? this._parent.radiusExpressions : [];
    }
    return this._inherentRadiusExpressions;
  }
  get radiusExpressions() {
    if (!this._allRadiusExpressions) {
      this._allRadiusExpressions = this._parent ? this._parent.radiusExpressions.concat(this.selfRadiusExpressions) : this.selfRadiusExpressions;
    }
    return this._allRadiusExpressions;
  }
  update(current, parent) {
    const result = new AreaSearchCircle_WithParent(current, parent);
    if (this._selfRadiusExpressions) {
      if (this._value.radiusExpressions === current.radiusExpressions) {
        result._selfRadiusExpressions = this._selfRadiusExpressions;
      } else {
        result._selfRadiusExpressions = [];
        for (let i = 0; i < current.radiusExpressions.length; i++) {
          const oldValue = this._value.radiusExpressions[i];
          if (oldValue) {
            const oldCache = this._selfRadiusExpressions[i];
            if (oldValue === current.radiusExpressions[i]) {
              result._selfRadiusExpressions[i] = oldCache;
            } else {
              result._selfRadiusExpressions[i] = oldCache.update(current.radiusExpressions[i], null);
            }
          } else {
            result._selfRadiusExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.radiusExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
AreaSearchCircle_WithParent.default = new AreaSearchCircle_WithParent(AreaSearchCircle.default, null);
AreaSearchCircle.WithParent = AreaSearchCircle_WithParent;
class AreaSearchCircle_Descriptor {
  get radius() {
    if (!this._radius) {
      this._radius = {
        name: "radius",
        Name: "Radius",
        number: 1,
        protoType: 1,
        protoName: "radius",
        type: JsonToDouble,
        options: {
          comments: "Sets the radius of the circle to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radius;
  }
  get radiusExpressions() {
    if (!this._radiusExpressions) {
      this._radiusExpressions = {
        name: "radiusExpressions",
        Name: "RadiusExpressions",
        number: 2,
        protoType: 11,
        protoName: "radius_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **radius** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radiusExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.radius,
        this.radiusExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
AreaSearchCircle.descriptor = new AreaSearchCircle_Descriptor();
export class AreaSearchCircleSector {
  get descriptor() {
    return AreaSearchCircleSector.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOuterRadius = false;
    this._outerRadius = null;
    this._outerRadiusExpressions = [];
    this._hasInnerRadius = false;
    this._innerRadius = null;
    this._innerRadiusExpressions = [];
    this._hasAngle = false;
    this._angle = null;
    this._angleExpressions = [];
  }
  isEmpty() {
    if (this._hasOuterRadius) return false;
    if (this._outerRadiusExpressions.length > 0) return false;
    if (this._hasInnerRadius) return false;
    if (this._innerRadiusExpressions.length > 0) return false;
    if (this._hasAngle) return false;
    if (this._angleExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AreaSearchCircleSector) {
      return value;
    }
    return AreaSearchCircleSector.fromJson(value);
  }
  static fromJson(json) {
    const result = new AreaSearchCircleSector();
    if (json.outerRadius != null) {
      result._hasOuterRadius = true;
      result._outerRadius = JsonToDouble.fromJson(json.outerRadius);
    }
    result._outerRadiusExpressions = JsonToList(json.outerRadiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.innerRadius != null) {
      result._hasInnerRadius = true;
      result._innerRadius = JsonToDouble.fromJson(json.innerRadius);
    }
    result._innerRadiusExpressions = JsonToList(json.innerRadiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.angle != null) {
      result._hasAngle = true;
      result._angle = JsonToDouble.fromJson(json.angle);
    }
    result._angleExpressions = JsonToList(json.angleExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOuterRadius) {
      result.outerRadius = JsonToDouble.toJson(this._outerRadius);
    }
    if (this._outerRadiusExpressions.length > 0) {
      result.outerRadiusExpressions = ArrayToJson(this._outerRadiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasInnerRadius) {
      result.innerRadius = JsonToDouble.toJson(this._innerRadius);
    }
    if (this._innerRadiusExpressions.length > 0) {
      result.innerRadiusExpressions = ArrayToJson(this._innerRadiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasAngle) {
      result.angle = JsonToDouble.toJson(this._angle);
    }
    if (this._angleExpressions.length > 0) {
      result.angleExpressions = ArrayToJson(this._angleExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get outerRadius() {
    return this._hasOuterRadius ? this._outerRadius : JsonToDouble.default;
  }
  get hasOuterRadius() {
    return this._hasOuterRadius;
  }
  setOuterRadius(path, value) {
    return {type: 'SET', path: path.concat(['outerRadius']), value};
  }
  deleteOuterRadius(path) {
    return {type: 'DELETE', path: path.concat(['outerRadius'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get outerRadiusExpressions() {
    return this._outerRadiusExpressions;
  }
  addOuterRadiusExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['outerRadiusExpressions']), value: value.toJson()};
  }
  setOuterRadiusExpressions(path, value) {
    return {type: 'SET', path: path.concat(['outerRadiusExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setOuterRadiusExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['outerRadiusExpressions', key]), value: value.toJson()};
  }
  deleteOuterRadiusExpressions(path) {
    return {type: 'DELETE', path: path.concat(['outerRadiusExpressions'])};
  }
  deleteOuterRadiusExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['outerRadiusExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get innerRadius() {
    return this._hasInnerRadius ? this._innerRadius : JsonToDouble.default;
  }
  get hasInnerRadius() {
    return this._hasInnerRadius;
  }
  setInnerRadius(path, value) {
    return {type: 'SET', path: path.concat(['innerRadius']), value};
  }
  deleteInnerRadius(path) {
    return {type: 'DELETE', path: path.concat(['innerRadius'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get innerRadiusExpressions() {
    return this._innerRadiusExpressions;
  }
  addInnerRadiusExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['innerRadiusExpressions']), value: value.toJson()};
  }
  setInnerRadiusExpressions(path, value) {
    return {type: 'SET', path: path.concat(['innerRadiusExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setInnerRadiusExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['innerRadiusExpressions', key]), value: value.toJson()};
  }
  deleteInnerRadiusExpressions(path) {
    return {type: 'DELETE', path: path.concat(['innerRadiusExpressions'])};
  }
  deleteInnerRadiusExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['innerRadiusExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get angle() {
    return this._hasAngle ? this._angle : JsonToDouble.default;
  }
  get hasAngle() {
    return this._hasAngle;
  }
  setAngle(path, value) {
    return {type: 'SET', path: path.concat(['angle']), value};
  }
  deleteAngle(path) {
    return {type: 'DELETE', path: path.concat(['angle'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get angleExpressions() {
    return this._angleExpressions;
  }
  addAngleExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['angleExpressions']), value: value.toJson()};
  }
  setAngleExpressions(path, value) {
    return {type: 'SET', path: path.concat(['angleExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setAngleExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['angleExpressions', key]), value: value.toJson()};
  }
  deleteAngleExpressions(path) {
    return {type: 'DELETE', path: path.concat(['angleExpressions'])};
  }
  deleteAngleExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['angleExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "outerRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._hasOuterRadius = true;
              copy._outerRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOuterRadius) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._hasOuterRadius = false;
              copy._outerRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "outerRadiusExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._outerRadiusExpressions = [];        for (let i of value) {
                copy._outerRadiusExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchCircleSector(this);
              copy._outerRadiusExpressions = copy._outerRadiusExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._outerRadiusExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._outerRadiusExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._outerRadiusExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._outerRadiusExpressions = copy._outerRadiusExpressions.slice();
              copy._outerRadiusExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchCircleSector(this);
              copy._outerRadiusExpressions = copy._outerRadiusExpressions.slice(0, path[1]).concat(copy._outerRadiusExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._outerRadiusExpressions.length) {
            return this;
          }
          const oldValue = this._outerRadiusExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchCircleSector(this);
          copy._outerRadiusExpressions = copy._outerRadiusExpressions.slice();
          copy._outerRadiusExpressions[key] = newValue;
          return copy;
        }
      }
      case "innerRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._hasInnerRadius = true;
              copy._innerRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInnerRadius) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._hasInnerRadius = false;
              copy._innerRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "innerRadiusExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._innerRadiusExpressions = [];        for (let i of value) {
                copy._innerRadiusExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchCircleSector(this);
              copy._innerRadiusExpressions = copy._innerRadiusExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._innerRadiusExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._innerRadiusExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._innerRadiusExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._innerRadiusExpressions = copy._innerRadiusExpressions.slice();
              copy._innerRadiusExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchCircleSector(this);
              copy._innerRadiusExpressions = copy._innerRadiusExpressions.slice(0, path[1]).concat(copy._innerRadiusExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._innerRadiusExpressions.length) {
            return this;
          }
          const oldValue = this._innerRadiusExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchCircleSector(this);
          copy._innerRadiusExpressions = copy._innerRadiusExpressions.slice();
          copy._innerRadiusExpressions[key] = newValue;
          return copy;
        }
      }
      case "angle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._hasAngle = true;
              copy._angle = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAngle) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._hasAngle = false;
              copy._angle = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "angleExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._angleExpressions = [];        for (let i of value) {
                copy._angleExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchCircleSector(this);
              copy._angleExpressions = copy._angleExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._angleExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchCircleSector(this);
              copy._angleExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._angleExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchCircleSector(this);
              copy._angleExpressions = copy._angleExpressions.slice();
              copy._angleExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchCircleSector(this);
              copy._angleExpressions = copy._angleExpressions.slice(0, path[1]).concat(copy._angleExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._angleExpressions.length) {
            return this;
          }
          const oldValue = this._angleExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchCircleSector(this);
          copy._angleExpressions = copy._angleExpressions.slice();
          copy._angleExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AreaSearchCircleSector} other
   * @returns {AreaSearchCircleSector}
   */
  merge(other) {
    const copy = new AreaSearchCircleSector(this);
    if (other._hasOuterRadius) {
      copy._hasOuterRadius = true;
      copy._outerRadius = other._outerRadius;
    }
    copy._outerRadiusExpressions = this._outerRadiusExpressions.concat(other._outerRadiusExpressions);
    if (other._hasInnerRadius) {
      copy._hasInnerRadius = true;
      copy._innerRadius = other._innerRadius;
    }
    copy._innerRadiusExpressions = this._innerRadiusExpressions.concat(other._innerRadiusExpressions);
    if (other._hasAngle) {
      copy._hasAngle = true;
      copy._angle = other._angle;
    }
    copy._angleExpressions = this._angleExpressions.concat(other._angleExpressions);
    return copy;
  }
}
AreaSearchCircleSector.default = new AreaSearchCircleSector();
class AreaSearchCircleSector_Builder {
  constructor(value) {
    this._value = new AreaSearchCircleSector(value);
  }
  build() {
    return new AreaSearchCircleSector(this._value);
  }
  setOuterRadius(value) {
    this._value._hasOuterRadius = true;
    this._value._outerRadius = value;
    return this;
  }
  deleteOuterRadius() {
    this._value._hasOuterRadius = false;
    this._value._outerRadius = null;
    return this;
  }
  addAllOuterRadiusExpressions(values) {
    this._value._outerRadiusExpressions = this._value._outerRadiusExpressions.concat(values);
    return this;
  }
  addOuterRadiusExpressions(value) {
    this._value._outerRadiusExpressions = this._value._outerRadiusExpressions.concat([value]);
    return this;
  }
  setOuterRadiusExpressions(index, value) {
    this._value._outerRadiusExpressions = this._value._outerRadiusExpressions.concat();
    this._value._outerRadiusExpressions[index] = value;
    return this;
  }
  clearOuterRadiusExpressions() {
    this._value._outerRadiusExpressions = [];
    return this;
  }
  setInnerRadius(value) {
    this._value._hasInnerRadius = true;
    this._value._innerRadius = value;
    return this;
  }
  deleteInnerRadius() {
    this._value._hasInnerRadius = false;
    this._value._innerRadius = null;
    return this;
  }
  addAllInnerRadiusExpressions(values) {
    this._value._innerRadiusExpressions = this._value._innerRadiusExpressions.concat(values);
    return this;
  }
  addInnerRadiusExpressions(value) {
    this._value._innerRadiusExpressions = this._value._innerRadiusExpressions.concat([value]);
    return this;
  }
  setInnerRadiusExpressions(index, value) {
    this._value._innerRadiusExpressions = this._value._innerRadiusExpressions.concat();
    this._value._innerRadiusExpressions[index] = value;
    return this;
  }
  clearInnerRadiusExpressions() {
    this._value._innerRadiusExpressions = [];
    return this;
  }
  setAngle(value) {
    this._value._hasAngle = true;
    this._value._angle = value;
    return this;
  }
  deleteAngle() {
    this._value._hasAngle = false;
    this._value._angle = null;
    return this;
  }
  addAllAngleExpressions(values) {
    this._value._angleExpressions = this._value._angleExpressions.concat(values);
    return this;
  }
  addAngleExpressions(value) {
    this._value._angleExpressions = this._value._angleExpressions.concat([value]);
    return this;
  }
  setAngleExpressions(index, value) {
    this._value._angleExpressions = this._value._angleExpressions.concat();
    this._value._angleExpressions[index] = value;
    return this;
  }
  clearAngleExpressions() {
    this._value._angleExpressions = [];
    return this;
  }
}
AreaSearchCircleSector.Builder = AreaSearchCircleSector_Builder;
class AreaSearchCircleSector_WithParent {
  /**
   * @param {AreaSearchCircleSector} value
   * @param {AreaSearchCircleSector_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AreaSearchCircleSector.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOuterRadius() {
    if (this._cachedHasOuterRadius === undefined) {
      if (this._value.hasOuterRadius) {
        this._cachedHasOuterRadius = true;
      } else {
        this._cachedHasOuterRadius = this._parent ? this._parent.hasOuterRadius : false;
      }
    }
    return this._cachedHasOuterRadius;
  }
  get outerRadius() {
    if (this._cachedOuterRadius === undefined) {
      if (this._value.hasOuterRadius) {
        this._cachedOuterRadius = this._value.outerRadius;
      } else {
        this._cachedOuterRadius = this._parent ? this._parent.outerRadius : this._value.outerRadius;
      }
    }
    return this._cachedOuterRadius;
  }
  get selfOuterRadiusExpressions() {
    if (!this._selfOuterRadiusExpressions) {
      this._selfOuterRadiusExpressions = [];
      for (let i of this._value.outerRadiusExpressions) {
        this._selfOuterRadiusExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfOuterRadiusExpressions;
  }
  get inherentOuterRadiusExpressions() {
    if (!this._inherentOuterRadiusExpressions) {
      this._inherentOuterRadiusExpressions = this._parent ? this._parent.outerRadiusExpressions : [];
    }
    return this._inherentOuterRadiusExpressions;
  }
  get outerRadiusExpressions() {
    if (!this._allOuterRadiusExpressions) {
      this._allOuterRadiusExpressions = this._parent ? this._parent.outerRadiusExpressions.concat(this.selfOuterRadiusExpressions) : this.selfOuterRadiusExpressions;
    }
    return this._allOuterRadiusExpressions;
  }
  get hasInnerRadius() {
    if (this._cachedHasInnerRadius === undefined) {
      if (this._value.hasInnerRadius) {
        this._cachedHasInnerRadius = true;
      } else {
        this._cachedHasInnerRadius = this._parent ? this._parent.hasInnerRadius : false;
      }
    }
    return this._cachedHasInnerRadius;
  }
  get innerRadius() {
    if (this._cachedInnerRadius === undefined) {
      if (this._value.hasInnerRadius) {
        this._cachedInnerRadius = this._value.innerRadius;
      } else {
        this._cachedInnerRadius = this._parent ? this._parent.innerRadius : this._value.innerRadius;
      }
    }
    return this._cachedInnerRadius;
  }
  get selfInnerRadiusExpressions() {
    if (!this._selfInnerRadiusExpressions) {
      this._selfInnerRadiusExpressions = [];
      for (let i of this._value.innerRadiusExpressions) {
        this._selfInnerRadiusExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfInnerRadiusExpressions;
  }
  get inherentInnerRadiusExpressions() {
    if (!this._inherentInnerRadiusExpressions) {
      this._inherentInnerRadiusExpressions = this._parent ? this._parent.innerRadiusExpressions : [];
    }
    return this._inherentInnerRadiusExpressions;
  }
  get innerRadiusExpressions() {
    if (!this._allInnerRadiusExpressions) {
      this._allInnerRadiusExpressions = this._parent ? this._parent.innerRadiusExpressions.concat(this.selfInnerRadiusExpressions) : this.selfInnerRadiusExpressions;
    }
    return this._allInnerRadiusExpressions;
  }
  get hasAngle() {
    if (this._cachedHasAngle === undefined) {
      if (this._value.hasAngle) {
        this._cachedHasAngle = true;
      } else {
        this._cachedHasAngle = this._parent ? this._parent.hasAngle : false;
      }
    }
    return this._cachedHasAngle;
  }
  get angle() {
    if (this._cachedAngle === undefined) {
      if (this._value.hasAngle) {
        this._cachedAngle = this._value.angle;
      } else {
        this._cachedAngle = this._parent ? this._parent.angle : this._value.angle;
      }
    }
    return this._cachedAngle;
  }
  get selfAngleExpressions() {
    if (!this._selfAngleExpressions) {
      this._selfAngleExpressions = [];
      for (let i of this._value.angleExpressions) {
        this._selfAngleExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfAngleExpressions;
  }
  get inherentAngleExpressions() {
    if (!this._inherentAngleExpressions) {
      this._inherentAngleExpressions = this._parent ? this._parent.angleExpressions : [];
    }
    return this._inherentAngleExpressions;
  }
  get angleExpressions() {
    if (!this._allAngleExpressions) {
      this._allAngleExpressions = this._parent ? this._parent.angleExpressions.concat(this.selfAngleExpressions) : this.selfAngleExpressions;
    }
    return this._allAngleExpressions;
  }
  update(current, parent) {
    const result = new AreaSearchCircleSector_WithParent(current, parent);
    if (this._selfOuterRadiusExpressions) {
      if (this._value.outerRadiusExpressions === current.outerRadiusExpressions) {
        result._selfOuterRadiusExpressions = this._selfOuterRadiusExpressions;
      } else {
        result._selfOuterRadiusExpressions = [];
        for (let i = 0; i < current.outerRadiusExpressions.length; i++) {
          const oldValue = this._value.outerRadiusExpressions[i];
          if (oldValue) {
            const oldCache = this._selfOuterRadiusExpressions[i];
            if (oldValue === current.outerRadiusExpressions[i]) {
              result._selfOuterRadiusExpressions[i] = oldCache;
            } else {
              result._selfOuterRadiusExpressions[i] = oldCache.update(current.outerRadiusExpressions[i], null);
            }
          } else {
            result._selfOuterRadiusExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.outerRadiusExpressions[i], null);
          }
        }
      }
    }
    if (this._selfInnerRadiusExpressions) {
      if (this._value.innerRadiusExpressions === current.innerRadiusExpressions) {
        result._selfInnerRadiusExpressions = this._selfInnerRadiusExpressions;
      } else {
        result._selfInnerRadiusExpressions = [];
        for (let i = 0; i < current.innerRadiusExpressions.length; i++) {
          const oldValue = this._value.innerRadiusExpressions[i];
          if (oldValue) {
            const oldCache = this._selfInnerRadiusExpressions[i];
            if (oldValue === current.innerRadiusExpressions[i]) {
              result._selfInnerRadiusExpressions[i] = oldCache;
            } else {
              result._selfInnerRadiusExpressions[i] = oldCache.update(current.innerRadiusExpressions[i], null);
            }
          } else {
            result._selfInnerRadiusExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.innerRadiusExpressions[i], null);
          }
        }
      }
    }
    if (this._selfAngleExpressions) {
      if (this._value.angleExpressions === current.angleExpressions) {
        result._selfAngleExpressions = this._selfAngleExpressions;
      } else {
        result._selfAngleExpressions = [];
        for (let i = 0; i < current.angleExpressions.length; i++) {
          const oldValue = this._value.angleExpressions[i];
          if (oldValue) {
            const oldCache = this._selfAngleExpressions[i];
            if (oldValue === current.angleExpressions[i]) {
              result._selfAngleExpressions[i] = oldCache;
            } else {
              result._selfAngleExpressions[i] = oldCache.update(current.angleExpressions[i], null);
            }
          } else {
            result._selfAngleExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.angleExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
AreaSearchCircleSector_WithParent.default = new AreaSearchCircleSector_WithParent(AreaSearchCircleSector.default, null);
AreaSearchCircleSector.WithParent = AreaSearchCircleSector_WithParent;
class AreaSearchCircleSector_Descriptor {
  get outerRadius() {
    if (!this._outerRadius) {
      this._outerRadius = {
        name: "outerRadius",
        Name: "OuterRadius",
        number: 1,
        protoType: 1,
        protoName: "outer_radius",
        type: JsonToDouble,
        options: {
          comments: "Sets the outer radius of the circle sector to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._outerRadius;
  }
  get outerRadiusExpressions() {
    if (!this._outerRadiusExpressions) {
      this._outerRadiusExpressions = {
        name: "outerRadiusExpressions",
        Name: "OuterRadiusExpressions",
        number: 4,
        protoType: 11,
        protoName: "outer_radius_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **outer radius** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._outerRadiusExpressions;
  }
  get innerRadius() {
    if (!this._innerRadius) {
      this._innerRadius = {
        name: "innerRadius",
        Name: "InnerRadius",
        number: 2,
        protoType: 1,
        protoName: "inner_radius",
        type: JsonToDouble,
        options: {
          comments: "Sets the inner radius of the circle sector to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._innerRadius;
  }
  get innerRadiusExpressions() {
    if (!this._innerRadiusExpressions) {
      this._innerRadiusExpressions = {
        name: "innerRadiusExpressions",
        Name: "InnerRadiusExpressions",
        number: 5,
        protoType: 11,
        protoName: "inner_radius_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **inner radius** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._innerRadiusExpressions;
  }
  get angle() {
    if (!this._angle) {
      this._angle = {
        name: "angle",
        Name: "Angle",
        number: 3,
        protoType: 1,
        protoName: "angle",
        type: JsonToDouble,
        options: {
          comments: "Sets the angle of the circle sector to search. Used to make a search occur in an arc.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._angle;
  }
  get angleExpressions() {
    if (!this._angleExpressions) {
      this._angleExpressions = {
        name: "angleExpressions",
        Name: "AngleExpressions",
        number: 6,
        protoType: 11,
        protoName: "angle_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **angle** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._angleExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.outerRadius,
        this.outerRadiusExpressions,
        this.innerRadius,
        this.innerRadiusExpressions,
        this.angle,
        this.angleExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOuterRadius",
        Name: "DummyOneofForOuterRadius",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInnerRadius",
        Name: "DummyOneofForInnerRadius",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAngle",
        Name: "DummyOneofForAngle",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
AreaSearchCircleSector.descriptor = new AreaSearchCircleSector_Descriptor();
export class AreaSearchRectangle {
  get descriptor() {
    return AreaSearchRectangle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWidth = false;
    this._width = null;
    this._widthExpressions = [];
    this._hasLength = false;
    this._length = null;
    this._lengthExpressions = [];
  }
  isEmpty() {
    if (this._hasWidth) return false;
    if (this._widthExpressions.length > 0) return false;
    if (this._hasLength) return false;
    if (this._lengthExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AreaSearchRectangle) {
      return value;
    }
    return AreaSearchRectangle.fromJson(value);
  }
  static fromJson(json) {
    const result = new AreaSearchRectangle();
    if (json.width != null) {
      result._hasWidth = true;
      result._width = JsonToDouble.fromJson(json.width);
    }
    result._widthExpressions = JsonToList(json.widthExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.length != null) {
      result._hasLength = true;
      result._length = JsonToDouble.fromJson(json.length);
    }
    result._lengthExpressions = JsonToList(json.lengthExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWidth) {
      result.width = JsonToDouble.toJson(this._width);
    }
    if (this._widthExpressions.length > 0) {
      result.widthExpressions = ArrayToJson(this._widthExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasLength) {
      result.length = JsonToDouble.toJson(this._length);
    }
    if (this._lengthExpressions.length > 0) {
      result.lengthExpressions = ArrayToJson(this._lengthExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get width() {
    return this._hasWidth ? this._width : JsonToDouble.default;
  }
  get hasWidth() {
    return this._hasWidth;
  }
  setWidth(path, value) {
    return {type: 'SET', path: path.concat(['width']), value};
  }
  deleteWidth(path) {
    return {type: 'DELETE', path: path.concat(['width'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get widthExpressions() {
    return this._widthExpressions;
  }
  addWidthExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['widthExpressions']), value: value.toJson()};
  }
  setWidthExpressions(path, value) {
    return {type: 'SET', path: path.concat(['widthExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setWidthExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['widthExpressions', key]), value: value.toJson()};
  }
  deleteWidthExpressions(path) {
    return {type: 'DELETE', path: path.concat(['widthExpressions'])};
  }
  deleteWidthExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['widthExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get length() {
    return this._hasLength ? this._length : JsonToDouble.default;
  }
  get hasLength() {
    return this._hasLength;
  }
  setLength(path, value) {
    return {type: 'SET', path: path.concat(['length']), value};
  }
  deleteLength(path) {
    return {type: 'DELETE', path: path.concat(['length'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get lengthExpressions() {
    return this._lengthExpressions;
  }
  addLengthExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['lengthExpressions']), value: value.toJson()};
  }
  setLengthExpressions(path, value) {
    return {type: 'SET', path: path.concat(['lengthExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setLengthExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['lengthExpressions', key]), value: value.toJson()};
  }
  deleteLengthExpressions(path) {
    return {type: 'DELETE', path: path.concat(['lengthExpressions'])};
  }
  deleteLengthExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['lengthExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "width": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._hasWidth = true;
              copy._width = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWidth) {
                return this;
              }
              const copy = new AreaSearchRectangle(this);
              copy._hasWidth = false;
              copy._width = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "widthExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._widthExpressions = [];        for (let i of value) {
                copy._widthExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchRectangle(this);
              copy._widthExpressions = copy._widthExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._widthExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchRectangle(this);
              copy._widthExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._widthExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._widthExpressions = copy._widthExpressions.slice();
              copy._widthExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchRectangle(this);
              copy._widthExpressions = copy._widthExpressions.slice(0, path[1]).concat(copy._widthExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._widthExpressions.length) {
            return this;
          }
          const oldValue = this._widthExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchRectangle(this);
          copy._widthExpressions = copy._widthExpressions.slice();
          copy._widthExpressions[key] = newValue;
          return copy;
        }
      }
      case "length": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._hasLength = true;
              copy._length = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLength) {
                return this;
              }
              const copy = new AreaSearchRectangle(this);
              copy._hasLength = false;
              copy._length = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "lengthExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._lengthExpressions = [];        for (let i of value) {
                copy._lengthExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AreaSearchRectangle(this);
              copy._lengthExpressions = copy._lengthExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._lengthExpressions.length === 0) {
                return this;
              }
              const copy = new AreaSearchRectangle(this);
              copy._lengthExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._lengthExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AreaSearchRectangle(this);
              copy._lengthExpressions = copy._lengthExpressions.slice();
              copy._lengthExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AreaSearchRectangle(this);
              copy._lengthExpressions = copy._lengthExpressions.slice(0, path[1]).concat(copy._lengthExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._lengthExpressions.length) {
            return this;
          }
          const oldValue = this._lengthExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AreaSearchRectangle(this);
          copy._lengthExpressions = copy._lengthExpressions.slice();
          copy._lengthExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AreaSearchRectangle} other
   * @returns {AreaSearchRectangle}
   */
  merge(other) {
    const copy = new AreaSearchRectangle(this);
    if (other._hasWidth) {
      copy._hasWidth = true;
      copy._width = other._width;
    }
    copy._widthExpressions = this._widthExpressions.concat(other._widthExpressions);
    if (other._hasLength) {
      copy._hasLength = true;
      copy._length = other._length;
    }
    copy._lengthExpressions = this._lengthExpressions.concat(other._lengthExpressions);
    return copy;
  }
}
AreaSearchRectangle.default = new AreaSearchRectangle();
class AreaSearchRectangle_Builder {
  constructor(value) {
    this._value = new AreaSearchRectangle(value);
  }
  build() {
    return new AreaSearchRectangle(this._value);
  }
  setWidth(value) {
    this._value._hasWidth = true;
    this._value._width = value;
    return this;
  }
  deleteWidth() {
    this._value._hasWidth = false;
    this._value._width = null;
    return this;
  }
  addAllWidthExpressions(values) {
    this._value._widthExpressions = this._value._widthExpressions.concat(values);
    return this;
  }
  addWidthExpressions(value) {
    this._value._widthExpressions = this._value._widthExpressions.concat([value]);
    return this;
  }
  setWidthExpressions(index, value) {
    this._value._widthExpressions = this._value._widthExpressions.concat();
    this._value._widthExpressions[index] = value;
    return this;
  }
  clearWidthExpressions() {
    this._value._widthExpressions = [];
    return this;
  }
  setLength(value) {
    this._value._hasLength = true;
    this._value._length = value;
    return this;
  }
  deleteLength() {
    this._value._hasLength = false;
    this._value._length = null;
    return this;
  }
  addAllLengthExpressions(values) {
    this._value._lengthExpressions = this._value._lengthExpressions.concat(values);
    return this;
  }
  addLengthExpressions(value) {
    this._value._lengthExpressions = this._value._lengthExpressions.concat([value]);
    return this;
  }
  setLengthExpressions(index, value) {
    this._value._lengthExpressions = this._value._lengthExpressions.concat();
    this._value._lengthExpressions[index] = value;
    return this;
  }
  clearLengthExpressions() {
    this._value._lengthExpressions = [];
    return this;
  }
}
AreaSearchRectangle.Builder = AreaSearchRectangle_Builder;
class AreaSearchRectangle_WithParent {
  /**
   * @param {AreaSearchRectangle} value
   * @param {AreaSearchRectangle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AreaSearchRectangle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWidth() {
    if (this._cachedHasWidth === undefined) {
      if (this._value.hasWidth) {
        this._cachedHasWidth = true;
      } else {
        this._cachedHasWidth = this._parent ? this._parent.hasWidth : false;
      }
    }
    return this._cachedHasWidth;
  }
  get width() {
    if (this._cachedWidth === undefined) {
      if (this._value.hasWidth) {
        this._cachedWidth = this._value.width;
      } else {
        this._cachedWidth = this._parent ? this._parent.width : this._value.width;
      }
    }
    return this._cachedWidth;
  }
  get selfWidthExpressions() {
    if (!this._selfWidthExpressions) {
      this._selfWidthExpressions = [];
      for (let i of this._value.widthExpressions) {
        this._selfWidthExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfWidthExpressions;
  }
  get inherentWidthExpressions() {
    if (!this._inherentWidthExpressions) {
      this._inherentWidthExpressions = this._parent ? this._parent.widthExpressions : [];
    }
    return this._inherentWidthExpressions;
  }
  get widthExpressions() {
    if (!this._allWidthExpressions) {
      this._allWidthExpressions = this._parent ? this._parent.widthExpressions.concat(this.selfWidthExpressions) : this.selfWidthExpressions;
    }
    return this._allWidthExpressions;
  }
  get hasLength() {
    if (this._cachedHasLength === undefined) {
      if (this._value.hasLength) {
        this._cachedHasLength = true;
      } else {
        this._cachedHasLength = this._parent ? this._parent.hasLength : false;
      }
    }
    return this._cachedHasLength;
  }
  get length() {
    if (this._cachedLength === undefined) {
      if (this._value.hasLength) {
        this._cachedLength = this._value.length;
      } else {
        this._cachedLength = this._parent ? this._parent.length : this._value.length;
      }
    }
    return this._cachedLength;
  }
  get selfLengthExpressions() {
    if (!this._selfLengthExpressions) {
      this._selfLengthExpressions = [];
      for (let i of this._value.lengthExpressions) {
        this._selfLengthExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfLengthExpressions;
  }
  get inherentLengthExpressions() {
    if (!this._inherentLengthExpressions) {
      this._inherentLengthExpressions = this._parent ? this._parent.lengthExpressions : [];
    }
    return this._inherentLengthExpressions;
  }
  get lengthExpressions() {
    if (!this._allLengthExpressions) {
      this._allLengthExpressions = this._parent ? this._parent.lengthExpressions.concat(this.selfLengthExpressions) : this.selfLengthExpressions;
    }
    return this._allLengthExpressions;
  }
  update(current, parent) {
    const result = new AreaSearchRectangle_WithParent(current, parent);
    if (this._selfWidthExpressions) {
      if (this._value.widthExpressions === current.widthExpressions) {
        result._selfWidthExpressions = this._selfWidthExpressions;
      } else {
        result._selfWidthExpressions = [];
        for (let i = 0; i < current.widthExpressions.length; i++) {
          const oldValue = this._value.widthExpressions[i];
          if (oldValue) {
            const oldCache = this._selfWidthExpressions[i];
            if (oldValue === current.widthExpressions[i]) {
              result._selfWidthExpressions[i] = oldCache;
            } else {
              result._selfWidthExpressions[i] = oldCache.update(current.widthExpressions[i], null);
            }
          } else {
            result._selfWidthExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.widthExpressions[i], null);
          }
        }
      }
    }
    if (this._selfLengthExpressions) {
      if (this._value.lengthExpressions === current.lengthExpressions) {
        result._selfLengthExpressions = this._selfLengthExpressions;
      } else {
        result._selfLengthExpressions = [];
        for (let i = 0; i < current.lengthExpressions.length; i++) {
          const oldValue = this._value.lengthExpressions[i];
          if (oldValue) {
            const oldCache = this._selfLengthExpressions[i];
            if (oldValue === current.lengthExpressions[i]) {
              result._selfLengthExpressions[i] = oldCache;
            } else {
              result._selfLengthExpressions[i] = oldCache.update(current.lengthExpressions[i], null);
            }
          } else {
            result._selfLengthExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.lengthExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
AreaSearchRectangle_WithParent.default = new AreaSearchRectangle_WithParent(AreaSearchRectangle.default, null);
AreaSearchRectangle.WithParent = AreaSearchRectangle_WithParent;
class AreaSearchRectangle_Descriptor {
  get width() {
    if (!this._width) {
      this._width = {
        name: "width",
        Name: "Width",
        number: 1,
        protoType: 1,
        protoName: "width",
        type: JsonToDouble,
        options: {
          comments: "Sets the width of the rectangle to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._width;
  }
  get widthExpressions() {
    if (!this._widthExpressions) {
      this._widthExpressions = {
        name: "widthExpressions",
        Name: "WidthExpressions",
        number: 3,
        protoType: 11,
        protoName: "width_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **width** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._widthExpressions;
  }
  get length() {
    if (!this._length) {
      this._length = {
        name: "length",
        Name: "Length",
        number: 2,
        protoType: 1,
        protoName: "length",
        type: JsonToDouble,
        options: {
          comments: "Sets the length of the rectangle to search.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._length;
  }
  get lengthExpressions() {
    if (!this._lengthExpressions) {
      this._lengthExpressions = {
        name: "lengthExpressions",
        Name: "LengthExpressions",
        number: 4,
        protoType: 11,
        protoName: "length_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "Any expressions here will be evaluated and added to the **length** each time the search is executed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._lengthExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.width,
        this.widthExpressions,
        this.length,
        this.lengthExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWidth",
        Name: "DummyOneofForWidth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLength",
        Name: "DummyOneofForLength",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AreaSearchRectangle.descriptor = new AreaSearchRectangle_Descriptor();
export class AreaSearchChildrenUnits {
  get descriptor() {
    return AreaSearchChildrenUnits.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof AreaSearchChildrenUnits) {
      return value;
    }
    return AreaSearchChildrenUnits.fromJson(value);
  }
  static fromJson(json) {
    const result = new AreaSearchChildrenUnits();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {AreaSearchChildrenUnits} other
   * @returns {AreaSearchChildrenUnits}
   */
  merge(other) {
    const copy = new AreaSearchChildrenUnits(this);
    return copy;
  }
}
AreaSearchChildrenUnits.default = new AreaSearchChildrenUnits();
class AreaSearchChildrenUnits_Builder {
  constructor(value) {
    this._value = new AreaSearchChildrenUnits(value);
  }
  build() {
    return new AreaSearchChildrenUnits(this._value);
  }
}
AreaSearchChildrenUnits.Builder = AreaSearchChildrenUnits_Builder;
class AreaSearchChildrenUnits_WithParent {
  /**
   * @param {AreaSearchChildrenUnits} value
   * @param {AreaSearchChildrenUnits_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AreaSearchChildrenUnits.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new AreaSearchChildrenUnits_WithParent(current, parent);
    return result;
  }
}
AreaSearchChildrenUnits_WithParent.default = new AreaSearchChildrenUnits_WithParent(AreaSearchChildrenUnits.default, null);
AreaSearchChildrenUnits.WithParent = AreaSearchChildrenUnits_WithParent;
class AreaSearchChildrenUnits_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
AreaSearchChildrenUnits.descriptor = new AreaSearchChildrenUnits_Descriptor();
class SearchFilter_SearchFilterSort {
  get descriptor() {
    return SearchFilter_SearchFilterSort.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasOrder = false;
    this._order = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasOrder) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SearchFilter_SearchFilterSort) {
      return value;
    }
    return SearchFilter_SearchFilterSort.fromJson(value);
  }
  static fromJson(json) {
    const result = new SearchFilter_SearchFilterSort();
    if (json.key != null) {
      result._hasKey = true;
      result._key = SearchFilter_FilterSortMethod.fromJson(json.key);
    }
    if (json.order != null) {
      result._hasOrder = true;
      result._order = SearchFilter_FilterSortOrder.fromJson(json.order);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = SearchFilter_FilterSortMethod.toJson(this._key);
    }
    if (this._hasOrder) {
      result.order = SearchFilter_FilterSortOrder.toJson(this._order);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get key() {
    return this._hasKey ? this._key : SearchFilter_FilterSortMethod.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get order() {
    return this._hasOrder ? this._order : SearchFilter_FilterSortOrder.default;
  }
  get hasOrder() {
    return this._hasOrder;
  }
  setOrder(path, value) {
    return {type: 'SET', path: path.concat(['order']), value};
  }
  deleteOrder(path) {
    return {type: 'DELETE', path: path.concat(['order'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter_SearchFilterSort(this);
              copy._hasKey = true;
              copy._key = SearchFilter_FilterSortMethod.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new SearchFilter_SearchFilterSort(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "order": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter_SearchFilterSort(this);
              copy._hasOrder = true;
              copy._order = SearchFilter_FilterSortOrder.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOrder) {
                return this;
              }
              const copy = new SearchFilter_SearchFilterSort(this);
              copy._hasOrder = false;
              copy._order = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SearchFilter_SearchFilterSort} other
   * @returns {SearchFilter_SearchFilterSort}
   */
  merge(other) {
    const copy = new SearchFilter_SearchFilterSort(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasOrder) {
      copy._hasOrder = true;
      copy._order = other._order;
    }
    return copy;
  }
}
SearchFilter_SearchFilterSort.default = new SearchFilter_SearchFilterSort();
class SearchFilter_SearchFilterSort_Builder {
  constructor(value) {
    this._value = new SearchFilter_SearchFilterSort(value);
  }
  build() {
    return new SearchFilter_SearchFilterSort(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setOrder(value) {
    this._value._hasOrder = true;
    this._value._order = value;
    return this;
  }
  deleteOrder() {
    this._value._hasOrder = false;
    this._value._order = null;
    return this;
  }
}
SearchFilter_SearchFilterSort.Builder = SearchFilter_SearchFilterSort_Builder;
class SearchFilter_SearchFilterSort_WithParent {
  /**
   * @param {SearchFilter_SearchFilterSort} value
   * @param {SearchFilter_SearchFilterSort_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SearchFilter_SearchFilterSort.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasOrder() {
    if (this._cachedHasOrder === undefined) {
      if (this._value.hasOrder) {
        this._cachedHasOrder = true;
      } else {
        this._cachedHasOrder = this._parent ? this._parent.hasOrder : false;
      }
    }
    return this._cachedHasOrder;
  }
  get order() {
    if (this._cachedOrder === undefined) {
      if (this._value.hasOrder) {
        this._cachedOrder = this._value.order;
      } else {
        this._cachedOrder = this._parent ? this._parent.order : this._value.order;
      }
    }
    return this._cachedOrder;
  }
  update(current, parent) {
    const result = new SearchFilter_SearchFilterSort_WithParent(current, parent);
    return result;
  }
}
SearchFilter_SearchFilterSort_WithParent.default = new SearchFilter_SearchFilterSort_WithParent(SearchFilter_SearchFilterSort.default, null);
SearchFilter_SearchFilterSort.WithParent = SearchFilter_SearchFilterSort_WithParent;
class SearchFilter_SearchFilterSort_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 14,
        protoName: "key",
        type: SearchFilter_FilterSortMethod,
        options: {
          comments: "The method used to sort potential targets.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get order() {
    if (!this._order) {
      this._order = {
        name: "order",
        Name: "Order",
        number: 2,
        protoType: 14,
        protoName: "order",
        type: SearchFilter_FilterSortOrder,
        options: {
          comments: "The order in which potential targets are sorted for priority.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._order;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.order,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOrder",
        Name: "DummyOneofForOrder",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SearchFilter_SearchFilterSort.descriptor = new SearchFilter_SearchFilterSort_Descriptor();
class SearchFilter_Flag {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ALLOWED": return 0;
        case "REQUIRED": return 1;
        case "EXCLUDED": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SearchFilter_Flag.fromJson(value);
  }
  static fromReact(e) {
    return SearchFilter_Flag.fromJson(e);
  }
}
SearchFilter_Flag.ALLOWED = 0;
SearchFilter_Flag.REQUIRED = 1;
SearchFilter_Flag.EXCLUDED = 2;
SearchFilter_Flag.default = 0;
SearchFilter_Flag.values = {
  ALLOWED: 0,
  REQUIRED: 1,
  EXCLUDED: 2,
};
SearchFilter_Flag.names = {
  0: "ALLOWED",
  1: "REQUIRED",
  2: "EXCLUDED",
};
class SearchFilter_FilterSortMethod {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "TARGET_PRIORITY": return 1;
        case "REMAINING_PATH_DISTANCE": return 2;
        case "DISTANCE_TO_SEARCH_CENTER": return 3;
        case "HEALTH_VALUE": return 4;
        case "HEALTH_FRACTION": return 5;
        case "VITALS": return 6;
        case "VITALS_FRACTION": return 7;
        case "ENGAGED": return 8;
        case "UNIT_COST": return 9;
        case "DISTANCE_TO_EFFECT_SOURCE": return 10;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SearchFilter_FilterSortMethod.fromJson(value);
  }
  static fromReact(e) {
    return SearchFilter_FilterSortMethod.fromJson(e);
  }
}
SearchFilter_FilterSortMethod.NONE = 0;
SearchFilter_FilterSortMethod.TARGET_PRIORITY = 1;
SearchFilter_FilterSortMethod.REMAINING_PATH_DISTANCE = 2;
SearchFilter_FilterSortMethod.DISTANCE_TO_SEARCH_CENTER = 3;
SearchFilter_FilterSortMethod.HEALTH_VALUE = 4;
SearchFilter_FilterSortMethod.HEALTH_FRACTION = 5;
SearchFilter_FilterSortMethod.VITALS = 6;
SearchFilter_FilterSortMethod.VITALS_FRACTION = 7;
SearchFilter_FilterSortMethod.ENGAGED = 8;
SearchFilter_FilterSortMethod.UNIT_COST = 9;
SearchFilter_FilterSortMethod.DISTANCE_TO_EFFECT_SOURCE = 10;
SearchFilter_FilterSortMethod.default = 0;
SearchFilter_FilterSortMethod.values = {
  NONE: 0,
  TARGET_PRIORITY: 1,
  REMAINING_PATH_DISTANCE: 2,
  DISTANCE_TO_SEARCH_CENTER: 3,
  HEALTH_VALUE: 4,
  HEALTH_FRACTION: 5,
  VITALS: 6,
  VITALS_FRACTION: 7,
  ENGAGED: 8,
  UNIT_COST: 9,
  DISTANCE_TO_EFFECT_SOURCE: 10,
};
SearchFilter_FilterSortMethod.names = {
  0: "NONE",
  1: "TARGET_PRIORITY",
  2: "REMAINING_PATH_DISTANCE",
  3: "DISTANCE_TO_SEARCH_CENTER",
  4: "HEALTH_VALUE",
  5: "HEALTH_FRACTION",
  6: "VITALS",
  7: "VITALS_FRACTION",
  8: "ENGAGED",
  9: "UNIT_COST",
  10: "DISTANCE_TO_EFFECT_SOURCE",
};
class SearchFilter_FilterSortOrder {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LOWEST_FIRST": return 0;
        case "HIGHEST_FIRST": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SearchFilter_FilterSortOrder.fromJson(value);
  }
  static fromReact(e) {
    return SearchFilter_FilterSortOrder.fromJson(e);
  }
}
SearchFilter_FilterSortOrder.LOWEST_FIRST = 0;
SearchFilter_FilterSortOrder.HIGHEST_FIRST = 1;
SearchFilter_FilterSortOrder.default = 0;
SearchFilter_FilterSortOrder.values = {
  LOWEST_FIRST: 0,
  HIGHEST_FIRST: 1,
};
SearchFilter_FilterSortOrder.names = {
  0: "LOWEST_FIRST",
  1: "HIGHEST_FIRST",
};
export class SearchFilter {
  get descriptor() {
    return SearchFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrimarySortKeys = false;
    this._primarySortKeys = null;
    this._hasSecondarySortKeys = false;
    this._secondarySortKeys = null;
    this._hasPlayer = false;
    this._player = null;
    this._hasAlly = false;
    this._ally = null;
    this._hasEnemy = false;
    this._enemy = null;
    this._hasNeutral = false;
    this._neutral = null;
    this._hasUnit = false;
    this._unit = null;
    this._hasMissile = false;
    this._missile = null;
    this._hasStructure = false;
    this._structure = null;
    this._hasAir = false;
    this._air = null;
    this._hasGround = false;
    this._ground = null;
    this._hasStealth = false;
    this._stealth = null;
    this._hasInvulerable = false;
    this._invulerable = null;
    this._hasAlive = false;
    this._alive = null;
  }
  isEmpty() {
    if (this._hasPrimarySortKeys && !this._primarySortKeys.isEmpty()) return false;
    if (this._hasSecondarySortKeys && !this._secondarySortKeys.isEmpty()) return false;
    if (this._hasPlayer) return false;
    if (this._hasAlly) return false;
    if (this._hasEnemy) return false;
    if (this._hasNeutral) return false;
    if (this._hasUnit) return false;
    if (this._hasMissile) return false;
    if (this._hasStructure) return false;
    if (this._hasAir) return false;
    if (this._hasGround) return false;
    if (this._hasStealth) return false;
    if (this._hasInvulerable) return false;
    if (this._hasAlive) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SearchFilter) {
      return value;
    }
    return SearchFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new SearchFilter();
    if (json.primarySortKeys != null) {
      result._hasPrimarySortKeys = true;
      result._primarySortKeys = SearchFilter_SearchFilterSort.fromJson(json.primarySortKeys);
    }
    if (json.secondarySortKeys != null) {
      result._hasSecondarySortKeys = true;
      result._secondarySortKeys = SearchFilter_SearchFilterSort.fromJson(json.secondarySortKeys);
    }
    if (json.player != null) {
      result._hasPlayer = true;
      result._player = SearchFilter_Flag.fromJson(json.player);
    }
    if (json.ally != null) {
      result._hasAlly = true;
      result._ally = SearchFilter_Flag.fromJson(json.ally);
    }
    if (json.enemy != null) {
      result._hasEnemy = true;
      result._enemy = SearchFilter_Flag.fromJson(json.enemy);
    }
    if (json.neutral != null) {
      result._hasNeutral = true;
      result._neutral = SearchFilter_Flag.fromJson(json.neutral);
    }
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = SearchFilter_Flag.fromJson(json.unit);
    }
    if (json.missile != null) {
      result._hasMissile = true;
      result._missile = SearchFilter_Flag.fromJson(json.missile);
    }
    if (json.structure != null) {
      result._hasStructure = true;
      result._structure = SearchFilter_Flag.fromJson(json.structure);
    }
    if (json.air != null) {
      result._hasAir = true;
      result._air = SearchFilter_Flag.fromJson(json.air);
    }
    if (json.ground != null) {
      result._hasGround = true;
      result._ground = SearchFilter_Flag.fromJson(json.ground);
    }
    if (json.stealth != null) {
      result._hasStealth = true;
      result._stealth = SearchFilter_Flag.fromJson(json.stealth);
    }
    if (json.invulerable != null) {
      result._hasInvulerable = true;
      result._invulerable = SearchFilter_Flag.fromJson(json.invulerable);
    }
    if (json.alive != null) {
      result._hasAlive = true;
      result._alive = SearchFilter_Flag.fromJson(json.alive);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrimarySortKeys && !this._primarySortKeys.isEmpty()) {
      result.primarySortKeys = SearchFilter_SearchFilterSort.toJson(this._primarySortKeys);
    }
    if (this._hasSecondarySortKeys && !this._secondarySortKeys.isEmpty()) {
      result.secondarySortKeys = SearchFilter_SearchFilterSort.toJson(this._secondarySortKeys);
    }
    if (this._hasPlayer) {
      result.player = SearchFilter_Flag.toJson(this._player);
    }
    if (this._hasAlly) {
      result.ally = SearchFilter_Flag.toJson(this._ally);
    }
    if (this._hasEnemy) {
      result.enemy = SearchFilter_Flag.toJson(this._enemy);
    }
    if (this._hasNeutral) {
      result.neutral = SearchFilter_Flag.toJson(this._neutral);
    }
    if (this._hasUnit) {
      result.unit = SearchFilter_Flag.toJson(this._unit);
    }
    if (this._hasMissile) {
      result.missile = SearchFilter_Flag.toJson(this._missile);
    }
    if (this._hasStructure) {
      result.structure = SearchFilter_Flag.toJson(this._structure);
    }
    if (this._hasAir) {
      result.air = SearchFilter_Flag.toJson(this._air);
    }
    if (this._hasGround) {
      result.ground = SearchFilter_Flag.toJson(this._ground);
    }
    if (this._hasStealth) {
      result.stealth = SearchFilter_Flag.toJson(this._stealth);
    }
    if (this._hasInvulerable) {
      result.invulerable = SearchFilter_Flag.toJson(this._invulerable);
    }
    if (this._hasAlive) {
      result.alive = SearchFilter_Flag.toJson(this._alive);
    }
    return result;
  }
  /**
   * @returns {SearchFilter_SearchFilterSort}
   */
  get primarySortKeys() {
    return this._hasPrimarySortKeys ? this._primarySortKeys : SearchFilter_SearchFilterSort.default;
  }
  get hasPrimarySortKeys() {
    return this._hasPrimarySortKeys;
  }
  setPrimarySortKeys(path, value) {
    return {type: 'SET', path: path.concat(['primarySortKeys']), value: value.toJson()};
  }
  deletePrimarySortKeys(path) {
    return {type: 'DELETE', path: path.concat(['primarySortKeys'])};
  }
  /**
   * @returns {SearchFilter_SearchFilterSort}
   */
  get secondarySortKeys() {
    return this._hasSecondarySortKeys ? this._secondarySortKeys : SearchFilter_SearchFilterSort.default;
  }
  get hasSecondarySortKeys() {
    return this._hasSecondarySortKeys;
  }
  setSecondarySortKeys(path, value) {
    return {type: 'SET', path: path.concat(['secondarySortKeys']), value: value.toJson()};
  }
  deleteSecondarySortKeys(path) {
    return {type: 'DELETE', path: path.concat(['secondarySortKeys'])};
  }
  /**
   * @returns {number}
   */
  get player() {
    return this._hasPlayer ? this._player : SearchFilter_Flag.default;
  }
  get hasPlayer() {
    return this._hasPlayer;
  }
  setPlayer(path, value) {
    return {type: 'SET', path: path.concat(['player']), value};
  }
  deletePlayer(path) {
    return {type: 'DELETE', path: path.concat(['player'])};
  }
  /**
   * @returns {number}
   */
  get ally() {
    return this._hasAlly ? this._ally : SearchFilter_Flag.default;
  }
  get hasAlly() {
    return this._hasAlly;
  }
  setAlly(path, value) {
    return {type: 'SET', path: path.concat(['ally']), value};
  }
  deleteAlly(path) {
    return {type: 'DELETE', path: path.concat(['ally'])};
  }
  /**
   * @returns {number}
   */
  get enemy() {
    return this._hasEnemy ? this._enemy : SearchFilter_Flag.default;
  }
  get hasEnemy() {
    return this._hasEnemy;
  }
  setEnemy(path, value) {
    return {type: 'SET', path: path.concat(['enemy']), value};
  }
  deleteEnemy(path) {
    return {type: 'DELETE', path: path.concat(['enemy'])};
  }
  /**
   * @returns {number}
   */
  get neutral() {
    return this._hasNeutral ? this._neutral : SearchFilter_Flag.default;
  }
  get hasNeutral() {
    return this._hasNeutral;
  }
  setNeutral(path, value) {
    return {type: 'SET', path: path.concat(['neutral']), value};
  }
  deleteNeutral(path) {
    return {type: 'DELETE', path: path.concat(['neutral'])};
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : SearchFilter_Flag.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {number}
   */
  get missile() {
    return this._hasMissile ? this._missile : SearchFilter_Flag.default;
  }
  get hasMissile() {
    return this._hasMissile;
  }
  setMissile(path, value) {
    return {type: 'SET', path: path.concat(['missile']), value};
  }
  deleteMissile(path) {
    return {type: 'DELETE', path: path.concat(['missile'])};
  }
  /**
   * @returns {number}
   */
  get structure() {
    return this._hasStructure ? this._structure : SearchFilter_Flag.default;
  }
  get hasStructure() {
    return this._hasStructure;
  }
  setStructure(path, value) {
    return {type: 'SET', path: path.concat(['structure']), value};
  }
  deleteStructure(path) {
    return {type: 'DELETE', path: path.concat(['structure'])};
  }
  /**
   * @returns {number}
   */
  get air() {
    return this._hasAir ? this._air : SearchFilter_Flag.default;
  }
  get hasAir() {
    return this._hasAir;
  }
  setAir(path, value) {
    return {type: 'SET', path: path.concat(['air']), value};
  }
  deleteAir(path) {
    return {type: 'DELETE', path: path.concat(['air'])};
  }
  /**
   * @returns {number}
   */
  get ground() {
    return this._hasGround ? this._ground : SearchFilter_Flag.default;
  }
  get hasGround() {
    return this._hasGround;
  }
  setGround(path, value) {
    return {type: 'SET', path: path.concat(['ground']), value};
  }
  deleteGround(path) {
    return {type: 'DELETE', path: path.concat(['ground'])};
  }
  /**
   * @returns {number}
   */
  get stealth() {
    return this._hasStealth ? this._stealth : SearchFilter_Flag.default;
  }
  get hasStealth() {
    return this._hasStealth;
  }
  setStealth(path, value) {
    return {type: 'SET', path: path.concat(['stealth']), value};
  }
  deleteStealth(path) {
    return {type: 'DELETE', path: path.concat(['stealth'])};
  }
  /**
   * @returns {number}
   */
  get invulerable() {
    return this._hasInvulerable ? this._invulerable : SearchFilter_Flag.default;
  }
  get hasInvulerable() {
    return this._hasInvulerable;
  }
  setInvulerable(path, value) {
    return {type: 'SET', path: path.concat(['invulerable']), value};
  }
  deleteInvulerable(path) {
    return {type: 'DELETE', path: path.concat(['invulerable'])};
  }
  /**
   * @returns {number}
   */
  get alive() {
    return this._hasAlive ? this._alive : SearchFilter_Flag.default;
  }
  get hasAlive() {
    return this._hasAlive;
  }
  setAlive(path, value) {
    return {type: 'SET', path: path.concat(['alive']), value};
  }
  deleteAlive(path) {
    return {type: 'DELETE', path: path.concat(['alive'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "primarySortKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasPrimarySortKeys = true;
              copy._primarySortKeys = SearchFilter_SearchFilterSort.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrimarySortKeys) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasPrimarySortKeys = false;
              copy._primarySortKeys = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPrimarySortKeys) {
            const copy = new SearchFilter(this);
            copy._hasPrimarySortKeys = true;
            copy._primarySortKeys = SearchFilter_SearchFilterSort.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._primarySortKeys.apply(type, path.slice(1), value);
          if (newValue === this._primarySortKeys) {
            return this;
          }
          const copy = new SearchFilter(this);
          copy._primarySortKeys = copy._primarySortKeys.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "secondarySortKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasSecondarySortKeys = true;
              copy._secondarySortKeys = SearchFilter_SearchFilterSort.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondarySortKeys) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasSecondarySortKeys = false;
              copy._secondarySortKeys = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSecondarySortKeys) {
            const copy = new SearchFilter(this);
            copy._hasSecondarySortKeys = true;
            copy._secondarySortKeys = SearchFilter_SearchFilterSort.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._secondarySortKeys.apply(type, path.slice(1), value);
          if (newValue === this._secondarySortKeys) {
            return this;
          }
          const copy = new SearchFilter(this);
          copy._secondarySortKeys = copy._secondarySortKeys.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "player": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasPlayer = true;
              copy._player = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayer) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasPlayer = false;
              copy._player = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ally": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasAlly = true;
              copy._ally = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlly) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasAlly = false;
              copy._ally = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enemy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasEnemy = true;
              copy._enemy = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnemy) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasEnemy = false;
              copy._enemy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "neutral": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasNeutral = true;
              copy._neutral = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNeutral) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasNeutral = false;
              copy._neutral = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasUnit = true;
              copy._unit = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missile": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasMissile = true;
              copy._missile = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissile) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasMissile = false;
              copy._missile = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "structure": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasStructure = true;
              copy._structure = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStructure) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasStructure = false;
              copy._structure = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "air": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasAir = true;
              copy._air = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAir) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasAir = false;
              copy._air = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ground": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasGround = true;
              copy._ground = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGround) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasGround = false;
              copy._ground = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasStealth = true;
              copy._stealth = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStealth) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasStealth = false;
              copy._stealth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "invulerable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasInvulerable = true;
              copy._invulerable = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInvulerable) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasInvulerable = false;
              copy._invulerable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "alive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SearchFilter(this);
              copy._hasAlive = true;
              copy._alive = SearchFilter_Flag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlive) {
                return this;
              }
              const copy = new SearchFilter(this);
              copy._hasAlive = false;
              copy._alive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SearchFilter} other
   * @returns {SearchFilter}
   */
  merge(other) {
    const copy = new SearchFilter(this);
    if (other._hasPrimarySortKeys) {
      if (copy._hasPrimarySortKeys) {
        copy._primarySortKeys = copy.primarySortKeys.merge(other.primarySortKeys);
      } else {
        copy._primarySortKeys = other._primarySortKeys;
      }
      copy._hasPrimarySortKeys = true;
    }
    if (other._hasSecondarySortKeys) {
      if (copy._hasSecondarySortKeys) {
        copy._secondarySortKeys = copy.secondarySortKeys.merge(other.secondarySortKeys);
      } else {
        copy._secondarySortKeys = other._secondarySortKeys;
      }
      copy._hasSecondarySortKeys = true;
    }
    if (other._hasPlayer) {
      copy._hasPlayer = true;
      copy._player = other._player;
    }
    if (other._hasAlly) {
      copy._hasAlly = true;
      copy._ally = other._ally;
    }
    if (other._hasEnemy) {
      copy._hasEnemy = true;
      copy._enemy = other._enemy;
    }
    if (other._hasNeutral) {
      copy._hasNeutral = true;
      copy._neutral = other._neutral;
    }
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasMissile) {
      copy._hasMissile = true;
      copy._missile = other._missile;
    }
    if (other._hasStructure) {
      copy._hasStructure = true;
      copy._structure = other._structure;
    }
    if (other._hasAir) {
      copy._hasAir = true;
      copy._air = other._air;
    }
    if (other._hasGround) {
      copy._hasGround = true;
      copy._ground = other._ground;
    }
    if (other._hasStealth) {
      copy._hasStealth = true;
      copy._stealth = other._stealth;
    }
    if (other._hasInvulerable) {
      copy._hasInvulerable = true;
      copy._invulerable = other._invulerable;
    }
    if (other._hasAlive) {
      copy._hasAlive = true;
      copy._alive = other._alive;
    }
    return copy;
  }
}
SearchFilter.default = new SearchFilter();
SearchFilter.SearchFilterSort = SearchFilter_SearchFilterSort;
SearchFilter.Flag = SearchFilter_Flag;
SearchFilter.FilterSortMethod = SearchFilter_FilterSortMethod;
SearchFilter.FilterSortOrder = SearchFilter_FilterSortOrder;
class SearchFilter_Builder {
  constructor(value) {
    this._value = new SearchFilter(value);
  }
  build() {
    return new SearchFilter(this._value);
  }
  setPrimarySortKeys(value) {
    this._value._hasPrimarySortKeys = true;
    this._value._primarySortKeys = value;
    return this;
  }
  deletePrimarySortKeys() {
    this._value._hasPrimarySortKeys = false;
    this._value._primarySortKeys = null;
    return this;
  }
  setSecondarySortKeys(value) {
    this._value._hasSecondarySortKeys = true;
    this._value._secondarySortKeys = value;
    return this;
  }
  deleteSecondarySortKeys() {
    this._value._hasSecondarySortKeys = false;
    this._value._secondarySortKeys = null;
    return this;
  }
  setPlayer(value) {
    this._value._hasPlayer = true;
    this._value._player = value;
    return this;
  }
  deletePlayer() {
    this._value._hasPlayer = false;
    this._value._player = null;
    return this;
  }
  setAlly(value) {
    this._value._hasAlly = true;
    this._value._ally = value;
    return this;
  }
  deleteAlly() {
    this._value._hasAlly = false;
    this._value._ally = null;
    return this;
  }
  setEnemy(value) {
    this._value._hasEnemy = true;
    this._value._enemy = value;
    return this;
  }
  deleteEnemy() {
    this._value._hasEnemy = false;
    this._value._enemy = null;
    return this;
  }
  setNeutral(value) {
    this._value._hasNeutral = true;
    this._value._neutral = value;
    return this;
  }
  deleteNeutral() {
    this._value._hasNeutral = false;
    this._value._neutral = null;
    return this;
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setMissile(value) {
    this._value._hasMissile = true;
    this._value._missile = value;
    return this;
  }
  deleteMissile() {
    this._value._hasMissile = false;
    this._value._missile = null;
    return this;
  }
  setStructure(value) {
    this._value._hasStructure = true;
    this._value._structure = value;
    return this;
  }
  deleteStructure() {
    this._value._hasStructure = false;
    this._value._structure = null;
    return this;
  }
  setAir(value) {
    this._value._hasAir = true;
    this._value._air = value;
    return this;
  }
  deleteAir() {
    this._value._hasAir = false;
    this._value._air = null;
    return this;
  }
  setGround(value) {
    this._value._hasGround = true;
    this._value._ground = value;
    return this;
  }
  deleteGround() {
    this._value._hasGround = false;
    this._value._ground = null;
    return this;
  }
  setStealth(value) {
    this._value._hasStealth = true;
    this._value._stealth = value;
    return this;
  }
  deleteStealth() {
    this._value._hasStealth = false;
    this._value._stealth = null;
    return this;
  }
  setInvulerable(value) {
    this._value._hasInvulerable = true;
    this._value._invulerable = value;
    return this;
  }
  deleteInvulerable() {
    this._value._hasInvulerable = false;
    this._value._invulerable = null;
    return this;
  }
  setAlive(value) {
    this._value._hasAlive = true;
    this._value._alive = value;
    return this;
  }
  deleteAlive() {
    this._value._hasAlive = false;
    this._value._alive = null;
    return this;
  }
}
SearchFilter.Builder = SearchFilter_Builder;
class SearchFilter_WithParent {
  /**
   * @param {SearchFilter} value
   * @param {SearchFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SearchFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrimarySortKeys() {
    if (this._cachedHasPrimarySortKeys === undefined) {
      if (this._value.hasPrimarySortKeys) {
        this._cachedHasPrimarySortKeys = true;
      } else {
        this._cachedHasPrimarySortKeys = this._parent ? this._parent.hasPrimarySortKeys : false;
      }
    }
    return this._cachedHasPrimarySortKeys;
  }
  get primarySortKeys() {
    if (!this._cachedPrimarySortKeys) {
      if (this._value.hasPrimarySortKeys) {
        this._cachedPrimarySortKeys = new SearchFilter_SearchFilterSort.WithParent(this._value.primarySortKeys, this._parent && this._parent.hasPrimarySortKeys ? this._parent.primarySortKeys : null);
      } else {
        this._cachedPrimarySortKeys = this._parent ? new SearchFilter_SearchFilterSort.WithParent(SearchFilter_SearchFilterSort.default, this._parent.primarySortKeys) : SearchFilter_SearchFilterSort.WithParent.default;
      }
    }
    return this._cachedPrimarySortKeys;
  }
  get hasSecondarySortKeys() {
    if (this._cachedHasSecondarySortKeys === undefined) {
      if (this._value.hasSecondarySortKeys) {
        this._cachedHasSecondarySortKeys = true;
      } else {
        this._cachedHasSecondarySortKeys = this._parent ? this._parent.hasSecondarySortKeys : false;
      }
    }
    return this._cachedHasSecondarySortKeys;
  }
  get secondarySortKeys() {
    if (!this._cachedSecondarySortKeys) {
      if (this._value.hasSecondarySortKeys) {
        this._cachedSecondarySortKeys = new SearchFilter_SearchFilterSort.WithParent(this._value.secondarySortKeys, this._parent && this._parent.hasSecondarySortKeys ? this._parent.secondarySortKeys : null);
      } else {
        this._cachedSecondarySortKeys = this._parent ? new SearchFilter_SearchFilterSort.WithParent(SearchFilter_SearchFilterSort.default, this._parent.secondarySortKeys) : SearchFilter_SearchFilterSort.WithParent.default;
      }
    }
    return this._cachedSecondarySortKeys;
  }
  get hasPlayer() {
    if (this._cachedHasPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedHasPlayer = true;
      } else {
        this._cachedHasPlayer = this._parent ? this._parent.hasPlayer : false;
      }
    }
    return this._cachedHasPlayer;
  }
  get player() {
    if (this._cachedPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedPlayer = this._value.player;
      } else {
        this._cachedPlayer = this._parent ? this._parent.player : this._value.player;
      }
    }
    return this._cachedPlayer;
  }
  get hasAlly() {
    if (this._cachedHasAlly === undefined) {
      if (this._value.hasAlly) {
        this._cachedHasAlly = true;
      } else {
        this._cachedHasAlly = this._parent ? this._parent.hasAlly : false;
      }
    }
    return this._cachedHasAlly;
  }
  get ally() {
    if (this._cachedAlly === undefined) {
      if (this._value.hasAlly) {
        this._cachedAlly = this._value.ally;
      } else {
        this._cachedAlly = this._parent ? this._parent.ally : this._value.ally;
      }
    }
    return this._cachedAlly;
  }
  get hasEnemy() {
    if (this._cachedHasEnemy === undefined) {
      if (this._value.hasEnemy) {
        this._cachedHasEnemy = true;
      } else {
        this._cachedHasEnemy = this._parent ? this._parent.hasEnemy : false;
      }
    }
    return this._cachedHasEnemy;
  }
  get enemy() {
    if (this._cachedEnemy === undefined) {
      if (this._value.hasEnemy) {
        this._cachedEnemy = this._value.enemy;
      } else {
        this._cachedEnemy = this._parent ? this._parent.enemy : this._value.enemy;
      }
    }
    return this._cachedEnemy;
  }
  get hasNeutral() {
    if (this._cachedHasNeutral === undefined) {
      if (this._value.hasNeutral) {
        this._cachedHasNeutral = true;
      } else {
        this._cachedHasNeutral = this._parent ? this._parent.hasNeutral : false;
      }
    }
    return this._cachedHasNeutral;
  }
  get neutral() {
    if (this._cachedNeutral === undefined) {
      if (this._value.hasNeutral) {
        this._cachedNeutral = this._value.neutral;
      } else {
        this._cachedNeutral = this._parent ? this._parent.neutral : this._value.neutral;
      }
    }
    return this._cachedNeutral;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasMissile() {
    if (this._cachedHasMissile === undefined) {
      if (this._value.hasMissile) {
        this._cachedHasMissile = true;
      } else {
        this._cachedHasMissile = this._parent ? this._parent.hasMissile : false;
      }
    }
    return this._cachedHasMissile;
  }
  get missile() {
    if (this._cachedMissile === undefined) {
      if (this._value.hasMissile) {
        this._cachedMissile = this._value.missile;
      } else {
        this._cachedMissile = this._parent ? this._parent.missile : this._value.missile;
      }
    }
    return this._cachedMissile;
  }
  get hasStructure() {
    if (this._cachedHasStructure === undefined) {
      if (this._value.hasStructure) {
        this._cachedHasStructure = true;
      } else {
        this._cachedHasStructure = this._parent ? this._parent.hasStructure : false;
      }
    }
    return this._cachedHasStructure;
  }
  get structure() {
    if (this._cachedStructure === undefined) {
      if (this._value.hasStructure) {
        this._cachedStructure = this._value.structure;
      } else {
        this._cachedStructure = this._parent ? this._parent.structure : this._value.structure;
      }
    }
    return this._cachedStructure;
  }
  get hasAir() {
    if (this._cachedHasAir === undefined) {
      if (this._value.hasAir) {
        this._cachedHasAir = true;
      } else {
        this._cachedHasAir = this._parent ? this._parent.hasAir : false;
      }
    }
    return this._cachedHasAir;
  }
  get air() {
    if (this._cachedAir === undefined) {
      if (this._value.hasAir) {
        this._cachedAir = this._value.air;
      } else {
        this._cachedAir = this._parent ? this._parent.air : this._value.air;
      }
    }
    return this._cachedAir;
  }
  get hasGround() {
    if (this._cachedHasGround === undefined) {
      if (this._value.hasGround) {
        this._cachedHasGround = true;
      } else {
        this._cachedHasGround = this._parent ? this._parent.hasGround : false;
      }
    }
    return this._cachedHasGround;
  }
  get ground() {
    if (this._cachedGround === undefined) {
      if (this._value.hasGround) {
        this._cachedGround = this._value.ground;
      } else {
        this._cachedGround = this._parent ? this._parent.ground : this._value.ground;
      }
    }
    return this._cachedGround;
  }
  get hasStealth() {
    if (this._cachedHasStealth === undefined) {
      if (this._value.hasStealth) {
        this._cachedHasStealth = true;
      } else {
        this._cachedHasStealth = this._parent ? this._parent.hasStealth : false;
      }
    }
    return this._cachedHasStealth;
  }
  get stealth() {
    if (this._cachedStealth === undefined) {
      if (this._value.hasStealth) {
        this._cachedStealth = this._value.stealth;
      } else {
        this._cachedStealth = this._parent ? this._parent.stealth : this._value.stealth;
      }
    }
    return this._cachedStealth;
  }
  get hasInvulerable() {
    if (this._cachedHasInvulerable === undefined) {
      if (this._value.hasInvulerable) {
        this._cachedHasInvulerable = true;
      } else {
        this._cachedHasInvulerable = this._parent ? this._parent.hasInvulerable : false;
      }
    }
    return this._cachedHasInvulerable;
  }
  get invulerable() {
    if (this._cachedInvulerable === undefined) {
      if (this._value.hasInvulerable) {
        this._cachedInvulerable = this._value.invulerable;
      } else {
        this._cachedInvulerable = this._parent ? this._parent.invulerable : this._value.invulerable;
      }
    }
    return this._cachedInvulerable;
  }
  get hasAlive() {
    if (this._cachedHasAlive === undefined) {
      if (this._value.hasAlive) {
        this._cachedHasAlive = true;
      } else {
        this._cachedHasAlive = this._parent ? this._parent.hasAlive : false;
      }
    }
    return this._cachedHasAlive;
  }
  get alive() {
    if (this._cachedAlive === undefined) {
      if (this._value.hasAlive) {
        this._cachedAlive = this._value.alive;
      } else {
        this._cachedAlive = this._parent ? this._parent.alive : this._value.alive;
      }
    }
    return this._cachedAlive;
  }
  update(current, parent) {
    const result = new SearchFilter_WithParent(current, parent);
    if (this._cachedPrimarySortKeys && this._value.hasPrimarySortKeys && current.hasPrimarySortKeys) {
      if (this._value.primarySortKeys === current.primarySortKeys && this._parent === parent) {
        result._cachedPrimarySortKeys = this._cachedPrimarySortKeys;
      } else {
        result._cachedPrimarySortKeys = this._cachedPrimarySortKeys.update(current.primarySortKeys, parent && parent.hasPrimarySortKeys ? parent.primarySortKeys : null);
      }
    }
    if (this._cachedSecondarySortKeys && this._value.hasSecondarySortKeys && current.hasSecondarySortKeys) {
      if (this._value.secondarySortKeys === current.secondarySortKeys && this._parent === parent) {
        result._cachedSecondarySortKeys = this._cachedSecondarySortKeys;
      } else {
        result._cachedSecondarySortKeys = this._cachedSecondarySortKeys.update(current.secondarySortKeys, parent && parent.hasSecondarySortKeys ? parent.secondarySortKeys : null);
      }
    }
    return result;
  }
}
SearchFilter_WithParent.default = new SearchFilter_WithParent(SearchFilter.default, null);
SearchFilter.WithParent = SearchFilter_WithParent;
class SearchFilter_Descriptor {
  get primarySortKeys() {
    if (!this._primarySortKeys) {
      this._primarySortKeys = {
        name: "primarySortKeys",
        Name: "PrimarySortKeys",
        number: 1,
        protoType: 11,
        protoName: "primary_sort_keys",
        type: SearchFilter_SearchFilterSort,
        options: {
          comments: "Potential targets are sorted based on these parameters.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._primarySortKeys;
  }
  get secondarySortKeys() {
    if (!this._secondarySortKeys) {
      this._secondarySortKeys = {
        name: "secondarySortKeys",
        Name: "SecondarySortKeys",
        number: 2,
        protoType: 11,
        protoName: "secondary_sort_keys",
        type: SearchFilter_SearchFilterSort,
        options: {
          comments: "If a pair of targets have the same priority value due to Primary Sort Keys, this sort key is then used to determine which unit to target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._secondarySortKeys;
  }
  get player() {
    if (!this._player) {
      this._player = {
        name: "player",
        Name: "Player",
        number: 11,
        protoType: 14,
        protoName: "player",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets owned by the player that created the search will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._player;
  }
  get ally() {
    if (!this._ally) {
      this._ally = {
        name: "ally",
        Name: "Ally",
        number: 12,
        protoType: 14,
        protoName: "ally",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets owned by an ally of the player that created the search will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ally;
  }
  get enemy() {
    if (!this._enemy) {
      this._enemy = {
        name: "enemy",
        Name: "Enemy",
        number: 13,
        protoType: 14,
        protoName: "enemy",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets owned by an enemy of the player that created the search will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enemy;
  }
  get neutral() {
    if (!this._neutral) {
      this._neutral = {
        name: "neutral",
        Name: "Neutral",
        number: 14,
        protoType: 14,
        protoName: "neutral",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that are neutral to the player that created the search will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._neutral;
  }
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 22,
        protoType: 14,
        protoName: "unit",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that use the \"Unit\" category will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get missile() {
    if (!this._missile) {
      this._missile = {
        name: "missile",
        Name: "Missile",
        number: 23,
        protoType: 14,
        protoName: "missile",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that use the \"Missile\" category will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missile;
  }
  get structure() {
    if (!this._structure) {
      this._structure = {
        name: "structure",
        Name: "Structure",
        number: 24,
        protoType: 14,
        protoName: "structure",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that use the \"Structure\" category will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._structure;
  }
  get air() {
    if (!this._air) {
      this._air = {
        name: "air",
        Name: "Air",
        number: 32,
        protoType: 14,
        protoName: "air",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that use air unit collision will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._air;
  }
  get ground() {
    if (!this._ground) {
      this._ground = {
        name: "ground",
        Name: "Ground",
        number: 33,
        protoType: 14,
        protoName: "ground",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that use ground unit collision will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ground;
  }
  get stealth() {
    if (!this._stealth) {
      this._stealth = {
        name: "stealth",
        Name: "Stealth",
        number: 34,
        protoType: 14,
        protoName: "stealth",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets with a behavior that uses the stealth flag will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stealth;
  }
  get invulerable() {
    if (!this._invulerable) {
      this._invulerable = {
        name: "invulerable",
        Name: "Invulerable",
        number: 41,
        protoType: 14,
        protoName: "invulerable",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets with the invulnerable flag will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._invulerable;
  }
  get alive() {
    if (!this._alive) {
      this._alive = {
        name: "alive",
        Name: "Alive",
        number: 42,
        protoType: 14,
        protoName: "alive",
        type: SearchFilter_Flag,
        options: {
          comments: "Targets that are currently alive will match the filter.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._alive;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.primarySortKeys,
        this.secondarySortKeys,
        this.player,
        this.ally,
        this.enemy,
        this.neutral,
        this.unit,
        this.missile,
        this.structure,
        this.air,
        this.ground,
        this.stealth,
        this.invulerable,
        this.alive,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrimarySortKeys",
        Name: "DummyOneofForPrimarySortKeys",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondarySortKeys",
        Name: "DummyOneofForSecondarySortKeys",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayer",
        Name: "DummyOneofForPlayer",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlly",
        Name: "DummyOneofForAlly",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnemy",
        Name: "DummyOneofForEnemy",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNeutral",
        Name: "DummyOneofForNeutral",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissile",
        Name: "DummyOneofForMissile",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStructure",
        Name: "DummyOneofForStructure",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAir",
        Name: "DummyOneofForAir",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGround",
        Name: "DummyOneofForGround",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStealth",
        Name: "DummyOneofForStealth",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInvulerable",
        Name: "DummyOneofForInvulerable",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlive",
        Name: "DummyOneofForAlive",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
SearchFilter.descriptor = new SearchFilter_Descriptor();
export class OldSearchFilter {
  get descriptor() {
    return OldSearchFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSelf = false;
    this._self = null;
    this._hasPlayer = false;
    this._player = null;
    this._hasAlly = false;
    this._ally = null;
    this._hasEnemy = false;
    this._enemy = null;
    this._hasNeutral = false;
    this._neutral = null;
    this._hasUnit = false;
    this._unit = null;
    this._hasMissile = false;
    this._missile = null;
    this._hasStructure = false;
    this._structure = null;
    this._hasAir = false;
    this._air = null;
    this._hasGround = false;
    this._ground = null;
    this._hasInvulerable = false;
    this._invulerable = null;
  }
  isEmpty() {
    if (this._hasSelf) return false;
    if (this._hasPlayer) return false;
    if (this._hasAlly) return false;
    if (this._hasEnemy) return false;
    if (this._hasNeutral) return false;
    if (this._hasUnit) return false;
    if (this._hasMissile) return false;
    if (this._hasStructure) return false;
    if (this._hasAir) return false;
    if (this._hasGround) return false;
    if (this._hasInvulerable) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof OldSearchFilter) {
      return value;
    }
    return OldSearchFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new OldSearchFilter();
    if (json.self != null) {
      result._hasSelf = true;
      result._self = JsonToBoolean.fromJson(json.self);
    }
    if (json.player != null) {
      result._hasPlayer = true;
      result._player = JsonToBoolean.fromJson(json.player);
    }
    if (json.ally != null) {
      result._hasAlly = true;
      result._ally = JsonToBoolean.fromJson(json.ally);
    }
    if (json.enemy != null) {
      result._hasEnemy = true;
      result._enemy = JsonToBoolean.fromJson(json.enemy);
    }
    if (json.neutral != null) {
      result._hasNeutral = true;
      result._neutral = JsonToBoolean.fromJson(json.neutral);
    }
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = JsonToBoolean.fromJson(json.unit);
    }
    if (json.missile != null) {
      result._hasMissile = true;
      result._missile = JsonToBoolean.fromJson(json.missile);
    }
    if (json.structure != null) {
      result._hasStructure = true;
      result._structure = JsonToBoolean.fromJson(json.structure);
    }
    if (json.air != null) {
      result._hasAir = true;
      result._air = JsonToBoolean.fromJson(json.air);
    }
    if (json.ground != null) {
      result._hasGround = true;
      result._ground = JsonToBoolean.fromJson(json.ground);
    }
    if (json.invulerable != null) {
      result._hasInvulerable = true;
      result._invulerable = JsonToBoolean.fromJson(json.invulerable);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSelf) {
      result.self = JsonToBoolean.toJson(this._self);
    }
    if (this._hasPlayer) {
      result.player = JsonToBoolean.toJson(this._player);
    }
    if (this._hasAlly) {
      result.ally = JsonToBoolean.toJson(this._ally);
    }
    if (this._hasEnemy) {
      result.enemy = JsonToBoolean.toJson(this._enemy);
    }
    if (this._hasNeutral) {
      result.neutral = JsonToBoolean.toJson(this._neutral);
    }
    if (this._hasUnit) {
      result.unit = JsonToBoolean.toJson(this._unit);
    }
    if (this._hasMissile) {
      result.missile = JsonToBoolean.toJson(this._missile);
    }
    if (this._hasStructure) {
      result.structure = JsonToBoolean.toJson(this._structure);
    }
    if (this._hasAir) {
      result.air = JsonToBoolean.toJson(this._air);
    }
    if (this._hasGround) {
      result.ground = JsonToBoolean.toJson(this._ground);
    }
    if (this._hasInvulerable) {
      result.invulerable = JsonToBoolean.toJson(this._invulerable);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get self() {
    return this._hasSelf ? this._self : JsonToBoolean.default;
  }
  get hasSelf() {
    return this._hasSelf;
  }
  setSelf(path, value) {
    return {type: 'SET', path: path.concat(['self']), value};
  }
  deleteSelf(path) {
    return {type: 'DELETE', path: path.concat(['self'])};
  }
  /**
   * @returns {boolean}
   */
  get player() {
    return this._hasPlayer ? this._player : JsonToBoolean.default;
  }
  get hasPlayer() {
    return this._hasPlayer;
  }
  setPlayer(path, value) {
    return {type: 'SET', path: path.concat(['player']), value};
  }
  deletePlayer(path) {
    return {type: 'DELETE', path: path.concat(['player'])};
  }
  /**
   * @returns {boolean}
   */
  get ally() {
    return this._hasAlly ? this._ally : JsonToBoolean.default;
  }
  get hasAlly() {
    return this._hasAlly;
  }
  setAlly(path, value) {
    return {type: 'SET', path: path.concat(['ally']), value};
  }
  deleteAlly(path) {
    return {type: 'DELETE', path: path.concat(['ally'])};
  }
  /**
   * @returns {boolean}
   */
  get enemy() {
    return this._hasEnemy ? this._enemy : JsonToBoolean.default;
  }
  get hasEnemy() {
    return this._hasEnemy;
  }
  setEnemy(path, value) {
    return {type: 'SET', path: path.concat(['enemy']), value};
  }
  deleteEnemy(path) {
    return {type: 'DELETE', path: path.concat(['enemy'])};
  }
  /**
   * @returns {boolean}
   */
  get neutral() {
    return this._hasNeutral ? this._neutral : JsonToBoolean.default;
  }
  get hasNeutral() {
    return this._hasNeutral;
  }
  setNeutral(path, value) {
    return {type: 'SET', path: path.concat(['neutral']), value};
  }
  deleteNeutral(path) {
    return {type: 'DELETE', path: path.concat(['neutral'])};
  }
  /**
   * @returns {boolean}
   */
  get unit() {
    return this._hasUnit ? this._unit : JsonToBoolean.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {boolean}
   */
  get missile() {
    return this._hasMissile ? this._missile : JsonToBoolean.default;
  }
  get hasMissile() {
    return this._hasMissile;
  }
  setMissile(path, value) {
    return {type: 'SET', path: path.concat(['missile']), value};
  }
  deleteMissile(path) {
    return {type: 'DELETE', path: path.concat(['missile'])};
  }
  /**
   * @returns {boolean}
   */
  get structure() {
    return this._hasStructure ? this._structure : JsonToBoolean.default;
  }
  get hasStructure() {
    return this._hasStructure;
  }
  setStructure(path, value) {
    return {type: 'SET', path: path.concat(['structure']), value};
  }
  deleteStructure(path) {
    return {type: 'DELETE', path: path.concat(['structure'])};
  }
  /**
   * @returns {boolean}
   */
  get air() {
    return this._hasAir ? this._air : JsonToBoolean.default;
  }
  get hasAir() {
    return this._hasAir;
  }
  setAir(path, value) {
    return {type: 'SET', path: path.concat(['air']), value};
  }
  deleteAir(path) {
    return {type: 'DELETE', path: path.concat(['air'])};
  }
  /**
   * @returns {boolean}
   */
  get ground() {
    return this._hasGround ? this._ground : JsonToBoolean.default;
  }
  get hasGround() {
    return this._hasGround;
  }
  setGround(path, value) {
    return {type: 'SET', path: path.concat(['ground']), value};
  }
  deleteGround(path) {
    return {type: 'DELETE', path: path.concat(['ground'])};
  }
  /**
   * @returns {boolean}
   */
  get invulerable() {
    return this._hasInvulerable ? this._invulerable : JsonToBoolean.default;
  }
  get hasInvulerable() {
    return this._hasInvulerable;
  }
  setInvulerable(path, value) {
    return {type: 'SET', path: path.concat(['invulerable']), value};
  }
  deleteInvulerable(path) {
    return {type: 'DELETE', path: path.concat(['invulerable'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "self": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasSelf = true;
              copy._self = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelf) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasSelf = false;
              copy._self = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "player": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasPlayer = true;
              copy._player = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayer) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasPlayer = false;
              copy._player = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ally": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasAlly = true;
              copy._ally = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAlly) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasAlly = false;
              copy._ally = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enemy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasEnemy = true;
              copy._enemy = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnemy) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasEnemy = false;
              copy._enemy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "neutral": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasNeutral = true;
              copy._neutral = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNeutral) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasNeutral = false;
              copy._neutral = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasUnit = true;
              copy._unit = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missile": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasMissile = true;
              copy._missile = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissile) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasMissile = false;
              copy._missile = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "structure": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasStructure = true;
              copy._structure = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStructure) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasStructure = false;
              copy._structure = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "air": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasAir = true;
              copy._air = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAir) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasAir = false;
              copy._air = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ground": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasGround = true;
              copy._ground = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGround) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasGround = false;
              copy._ground = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "invulerable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OldSearchFilter(this);
              copy._hasInvulerable = true;
              copy._invulerable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInvulerable) {
                return this;
              }
              const copy = new OldSearchFilter(this);
              copy._hasInvulerable = false;
              copy._invulerable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {OldSearchFilter} other
   * @returns {OldSearchFilter}
   */
  merge(other) {
    const copy = new OldSearchFilter(this);
    if (other._hasSelf) {
      copy._hasSelf = true;
      copy._self = other._self;
    }
    if (other._hasPlayer) {
      copy._hasPlayer = true;
      copy._player = other._player;
    }
    if (other._hasAlly) {
      copy._hasAlly = true;
      copy._ally = other._ally;
    }
    if (other._hasEnemy) {
      copy._hasEnemy = true;
      copy._enemy = other._enemy;
    }
    if (other._hasNeutral) {
      copy._hasNeutral = true;
      copy._neutral = other._neutral;
    }
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasMissile) {
      copy._hasMissile = true;
      copy._missile = other._missile;
    }
    if (other._hasStructure) {
      copy._hasStructure = true;
      copy._structure = other._structure;
    }
    if (other._hasAir) {
      copy._hasAir = true;
      copy._air = other._air;
    }
    if (other._hasGround) {
      copy._hasGround = true;
      copy._ground = other._ground;
    }
    if (other._hasInvulerable) {
      copy._hasInvulerable = true;
      copy._invulerable = other._invulerable;
    }
    return copy;
  }
}
OldSearchFilter.default = new OldSearchFilter();
class OldSearchFilter_Builder {
  constructor(value) {
    this._value = new OldSearchFilter(value);
  }
  build() {
    return new OldSearchFilter(this._value);
  }
  setSelf(value) {
    this._value._hasSelf = true;
    this._value._self = value;
    return this;
  }
  deleteSelf() {
    this._value._hasSelf = false;
    this._value._self = null;
    return this;
  }
  setPlayer(value) {
    this._value._hasPlayer = true;
    this._value._player = value;
    return this;
  }
  deletePlayer() {
    this._value._hasPlayer = false;
    this._value._player = null;
    return this;
  }
  setAlly(value) {
    this._value._hasAlly = true;
    this._value._ally = value;
    return this;
  }
  deleteAlly() {
    this._value._hasAlly = false;
    this._value._ally = null;
    return this;
  }
  setEnemy(value) {
    this._value._hasEnemy = true;
    this._value._enemy = value;
    return this;
  }
  deleteEnemy() {
    this._value._hasEnemy = false;
    this._value._enemy = null;
    return this;
  }
  setNeutral(value) {
    this._value._hasNeutral = true;
    this._value._neutral = value;
    return this;
  }
  deleteNeutral() {
    this._value._hasNeutral = false;
    this._value._neutral = null;
    return this;
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setMissile(value) {
    this._value._hasMissile = true;
    this._value._missile = value;
    return this;
  }
  deleteMissile() {
    this._value._hasMissile = false;
    this._value._missile = null;
    return this;
  }
  setStructure(value) {
    this._value._hasStructure = true;
    this._value._structure = value;
    return this;
  }
  deleteStructure() {
    this._value._hasStructure = false;
    this._value._structure = null;
    return this;
  }
  setAir(value) {
    this._value._hasAir = true;
    this._value._air = value;
    return this;
  }
  deleteAir() {
    this._value._hasAir = false;
    this._value._air = null;
    return this;
  }
  setGround(value) {
    this._value._hasGround = true;
    this._value._ground = value;
    return this;
  }
  deleteGround() {
    this._value._hasGround = false;
    this._value._ground = null;
    return this;
  }
  setInvulerable(value) {
    this._value._hasInvulerable = true;
    this._value._invulerable = value;
    return this;
  }
  deleteInvulerable() {
    this._value._hasInvulerable = false;
    this._value._invulerable = null;
    return this;
  }
}
OldSearchFilter.Builder = OldSearchFilter_Builder;
class OldSearchFilter_WithParent {
  /**
   * @param {OldSearchFilter} value
   * @param {OldSearchFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return OldSearchFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSelf() {
    if (this._cachedHasSelf === undefined) {
      if (this._value.hasSelf) {
        this._cachedHasSelf = true;
      } else {
        this._cachedHasSelf = this._parent ? this._parent.hasSelf : false;
      }
    }
    return this._cachedHasSelf;
  }
  get self() {
    if (this._cachedSelf === undefined) {
      if (this._value.hasSelf) {
        this._cachedSelf = this._value.self;
      } else {
        this._cachedSelf = this._parent ? this._parent.self : this._value.self;
      }
    }
    return this._cachedSelf;
  }
  get hasPlayer() {
    if (this._cachedHasPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedHasPlayer = true;
      } else {
        this._cachedHasPlayer = this._parent ? this._parent.hasPlayer : false;
      }
    }
    return this._cachedHasPlayer;
  }
  get player() {
    if (this._cachedPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedPlayer = this._value.player;
      } else {
        this._cachedPlayer = this._parent ? this._parent.player : this._value.player;
      }
    }
    return this._cachedPlayer;
  }
  get hasAlly() {
    if (this._cachedHasAlly === undefined) {
      if (this._value.hasAlly) {
        this._cachedHasAlly = true;
      } else {
        this._cachedHasAlly = this._parent ? this._parent.hasAlly : false;
      }
    }
    return this._cachedHasAlly;
  }
  get ally() {
    if (this._cachedAlly === undefined) {
      if (this._value.hasAlly) {
        this._cachedAlly = this._value.ally;
      } else {
        this._cachedAlly = this._parent ? this._parent.ally : this._value.ally;
      }
    }
    return this._cachedAlly;
  }
  get hasEnemy() {
    if (this._cachedHasEnemy === undefined) {
      if (this._value.hasEnemy) {
        this._cachedHasEnemy = true;
      } else {
        this._cachedHasEnemy = this._parent ? this._parent.hasEnemy : false;
      }
    }
    return this._cachedHasEnemy;
  }
  get enemy() {
    if (this._cachedEnemy === undefined) {
      if (this._value.hasEnemy) {
        this._cachedEnemy = this._value.enemy;
      } else {
        this._cachedEnemy = this._parent ? this._parent.enemy : this._value.enemy;
      }
    }
    return this._cachedEnemy;
  }
  get hasNeutral() {
    if (this._cachedHasNeutral === undefined) {
      if (this._value.hasNeutral) {
        this._cachedHasNeutral = true;
      } else {
        this._cachedHasNeutral = this._parent ? this._parent.hasNeutral : false;
      }
    }
    return this._cachedHasNeutral;
  }
  get neutral() {
    if (this._cachedNeutral === undefined) {
      if (this._value.hasNeutral) {
        this._cachedNeutral = this._value.neutral;
      } else {
        this._cachedNeutral = this._parent ? this._parent.neutral : this._value.neutral;
      }
    }
    return this._cachedNeutral;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasMissile() {
    if (this._cachedHasMissile === undefined) {
      if (this._value.hasMissile) {
        this._cachedHasMissile = true;
      } else {
        this._cachedHasMissile = this._parent ? this._parent.hasMissile : false;
      }
    }
    return this._cachedHasMissile;
  }
  get missile() {
    if (this._cachedMissile === undefined) {
      if (this._value.hasMissile) {
        this._cachedMissile = this._value.missile;
      } else {
        this._cachedMissile = this._parent ? this._parent.missile : this._value.missile;
      }
    }
    return this._cachedMissile;
  }
  get hasStructure() {
    if (this._cachedHasStructure === undefined) {
      if (this._value.hasStructure) {
        this._cachedHasStructure = true;
      } else {
        this._cachedHasStructure = this._parent ? this._parent.hasStructure : false;
      }
    }
    return this._cachedHasStructure;
  }
  get structure() {
    if (this._cachedStructure === undefined) {
      if (this._value.hasStructure) {
        this._cachedStructure = this._value.structure;
      } else {
        this._cachedStructure = this._parent ? this._parent.structure : this._value.structure;
      }
    }
    return this._cachedStructure;
  }
  get hasAir() {
    if (this._cachedHasAir === undefined) {
      if (this._value.hasAir) {
        this._cachedHasAir = true;
      } else {
        this._cachedHasAir = this._parent ? this._parent.hasAir : false;
      }
    }
    return this._cachedHasAir;
  }
  get air() {
    if (this._cachedAir === undefined) {
      if (this._value.hasAir) {
        this._cachedAir = this._value.air;
      } else {
        this._cachedAir = this._parent ? this._parent.air : this._value.air;
      }
    }
    return this._cachedAir;
  }
  get hasGround() {
    if (this._cachedHasGround === undefined) {
      if (this._value.hasGround) {
        this._cachedHasGround = true;
      } else {
        this._cachedHasGround = this._parent ? this._parent.hasGround : false;
      }
    }
    return this._cachedHasGround;
  }
  get ground() {
    if (this._cachedGround === undefined) {
      if (this._value.hasGround) {
        this._cachedGround = this._value.ground;
      } else {
        this._cachedGround = this._parent ? this._parent.ground : this._value.ground;
      }
    }
    return this._cachedGround;
  }
  get hasInvulerable() {
    if (this._cachedHasInvulerable === undefined) {
      if (this._value.hasInvulerable) {
        this._cachedHasInvulerable = true;
      } else {
        this._cachedHasInvulerable = this._parent ? this._parent.hasInvulerable : false;
      }
    }
    return this._cachedHasInvulerable;
  }
  get invulerable() {
    if (this._cachedInvulerable === undefined) {
      if (this._value.hasInvulerable) {
        this._cachedInvulerable = this._value.invulerable;
      } else {
        this._cachedInvulerable = this._parent ? this._parent.invulerable : this._value.invulerable;
      }
    }
    return this._cachedInvulerable;
  }
  update(current, parent) {
    const result = new OldSearchFilter_WithParent(current, parent);
    return result;
  }
}
OldSearchFilter_WithParent.default = new OldSearchFilter_WithParent(OldSearchFilter.default, null);
OldSearchFilter.WithParent = OldSearchFilter_WithParent;
class OldSearchFilter_Descriptor {
  get self() {
    if (!this._self) {
      this._self = {
        name: "self",
        Name: "Self",
        number: 1,
        protoType: 8,
        protoName: "self",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._self;
  }
  get player() {
    if (!this._player) {
      this._player = {
        name: "player",
        Name: "Player",
        number: 2,
        protoType: 8,
        protoName: "player",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._player;
  }
  get ally() {
    if (!this._ally) {
      this._ally = {
        name: "ally",
        Name: "Ally",
        number: 3,
        protoType: 8,
        protoName: "ally",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ally;
  }
  get enemy() {
    if (!this._enemy) {
      this._enemy = {
        name: "enemy",
        Name: "Enemy",
        number: 4,
        protoType: 8,
        protoName: "enemy",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enemy;
  }
  get neutral() {
    if (!this._neutral) {
      this._neutral = {
        name: "neutral",
        Name: "Neutral",
        number: 5,
        protoType: 8,
        protoName: "neutral",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._neutral;
  }
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 11,
        protoType: 8,
        protoName: "unit",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get missile() {
    if (!this._missile) {
      this._missile = {
        name: "missile",
        Name: "Missile",
        number: 12,
        protoType: 8,
        protoName: "missile",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missile;
  }
  get structure() {
    if (!this._structure) {
      this._structure = {
        name: "structure",
        Name: "Structure",
        number: 13,
        protoType: 8,
        protoName: "structure",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._structure;
  }
  get air() {
    if (!this._air) {
      this._air = {
        name: "air",
        Name: "Air",
        number: 21,
        protoType: 8,
        protoName: "air",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._air;
  }
  get ground() {
    if (!this._ground) {
      this._ground = {
        name: "ground",
        Name: "Ground",
        number: 22,
        protoType: 8,
        protoName: "ground",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ground;
  }
  get invulerable() {
    if (!this._invulerable) {
      this._invulerable = {
        name: "invulerable",
        Name: "Invulerable",
        number: 31,
        protoType: 8,
        protoName: "invulerable",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._invulerable;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.self,
        this.player,
        this.ally,
        this.enemy,
        this.neutral,
        this.unit,
        this.missile,
        this.structure,
        this.air,
        this.ground,
        this.invulerable,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSelf",
        Name: "DummyOneofForSelf",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayer",
        Name: "DummyOneofForPlayer",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAlly",
        Name: "DummyOneofForAlly",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnemy",
        Name: "DummyOneofForEnemy",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNeutral",
        Name: "DummyOneofForNeutral",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissile",
        Name: "DummyOneofForMissile",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStructure",
        Name: "DummyOneofForStructure",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAir",
        Name: "DummyOneofForAir",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGround",
        Name: "DummyOneofForGround",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInvulerable",
        Name: "DummyOneofForInvulerable",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
OldSearchFilter.descriptor = new OldSearchFilter_Descriptor();
export class EffectOffset {
  get descriptor() {
    return EffectOffset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasForward = false;
    this._forward = null;
    this._hasRight = false;
    this._right = null;
    this._hasUp = false;
    this._up = null;
  }
  isEmpty() {
    if (this._hasForward) return false;
    if (this._hasRight) return false;
    if (this._hasUp) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectOffset) {
      return value;
    }
    return EffectOffset.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectOffset();
    if (json.forward != null) {
      result._hasForward = true;
      result._forward = JsonToDouble.fromJson(json.forward);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = JsonToDouble.fromJson(json.right);
    }
    if (json.up != null) {
      result._hasUp = true;
      result._up = JsonToDouble.fromJson(json.up);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasForward) {
      result.forward = JsonToDouble.toJson(this._forward);
    }
    if (this._hasRight) {
      result.right = JsonToDouble.toJson(this._right);
    }
    if (this._hasUp) {
      result.up = JsonToDouble.toJson(this._up);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get forward() {
    return this._hasForward ? this._forward : JsonToDouble.default;
  }
  get hasForward() {
    return this._hasForward;
  }
  setForward(path, value) {
    return {type: 'SET', path: path.concat(['forward']), value};
  }
  deleteForward(path) {
    return {type: 'DELETE', path: path.concat(['forward'])};
  }
  /**
   * @returns {number}
   */
  get right() {
    return this._hasRight ? this._right : JsonToDouble.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  /**
   * @returns {number}
   */
  get up() {
    return this._hasUp ? this._up : JsonToDouble.default;
  }
  get hasUp() {
    return this._hasUp;
  }
  setUp(path, value) {
    return {type: 'SET', path: path.concat(['up']), value};
  }
  deleteUp(path) {
    return {type: 'DELETE', path: path.concat(['up'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "forward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectOffset(this);
              copy._hasForward = true;
              copy._forward = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForward) {
                return this;
              }
              const copy = new EffectOffset(this);
              copy._hasForward = false;
              copy._forward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectOffset(this);
              copy._hasRight = true;
              copy._right = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new EffectOffset(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "up": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectOffset(this);
              copy._hasUp = true;
              copy._up = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUp) {
                return this;
              }
              const copy = new EffectOffset(this);
              copy._hasUp = false;
              copy._up = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectOffset} other
   * @returns {EffectOffset}
   */
  merge(other) {
    const copy = new EffectOffset(this);
    if (other._hasForward) {
      copy._hasForward = true;
      copy._forward = other._forward;
    }
    if (other._hasRight) {
      copy._hasRight = true;
      copy._right = other._right;
    }
    if (other._hasUp) {
      copy._hasUp = true;
      copy._up = other._up;
    }
    return copy;
  }
}
EffectOffset.default = new EffectOffset();
class EffectOffset_Builder {
  constructor(value) {
    this._value = new EffectOffset(value);
  }
  build() {
    return new EffectOffset(this._value);
  }
  setForward(value) {
    this._value._hasForward = true;
    this._value._forward = value;
    return this;
  }
  deleteForward() {
    this._value._hasForward = false;
    this._value._forward = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
  setUp(value) {
    this._value._hasUp = true;
    this._value._up = value;
    return this;
  }
  deleteUp() {
    this._value._hasUp = false;
    this._value._up = null;
    return this;
  }
}
EffectOffset.Builder = EffectOffset_Builder;
class EffectOffset_WithParent {
  /**
   * @param {EffectOffset} value
   * @param {EffectOffset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectOffset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasForward() {
    if (this._cachedHasForward === undefined) {
      if (this._value.hasForward) {
        this._cachedHasForward = true;
      } else {
        this._cachedHasForward = this._parent ? this._parent.hasForward : false;
      }
    }
    return this._cachedHasForward;
  }
  get forward() {
    if (this._cachedForward === undefined) {
      if (this._value.hasForward) {
        this._cachedForward = this._value.forward;
      } else {
        this._cachedForward = this._parent ? this._parent.forward : this._value.forward;
      }
    }
    return this._cachedForward;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (this._cachedRight === undefined) {
      if (this._value.hasRight) {
        this._cachedRight = this._value.right;
      } else {
        this._cachedRight = this._parent ? this._parent.right : this._value.right;
      }
    }
    return this._cachedRight;
  }
  get hasUp() {
    if (this._cachedHasUp === undefined) {
      if (this._value.hasUp) {
        this._cachedHasUp = true;
      } else {
        this._cachedHasUp = this._parent ? this._parent.hasUp : false;
      }
    }
    return this._cachedHasUp;
  }
  get up() {
    if (this._cachedUp === undefined) {
      if (this._value.hasUp) {
        this._cachedUp = this._value.up;
      } else {
        this._cachedUp = this._parent ? this._parent.up : this._value.up;
      }
    }
    return this._cachedUp;
  }
  update(current, parent) {
    const result = new EffectOffset_WithParent(current, parent);
    return result;
  }
}
EffectOffset_WithParent.default = new EffectOffset_WithParent(EffectOffset.default, null);
EffectOffset.WithParent = EffectOffset_WithParent;
class EffectOffset_Descriptor {
  get forward() {
    if (!this._forward) {
      this._forward = {
        name: "forward",
        Name: "Forward",
        number: 1,
        protoType: 1,
        protoName: "forward",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forward;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 1,
        protoName: "right",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get up() {
    if (!this._up) {
      this._up = {
        name: "up",
        Name: "Up",
        number: 3,
        protoType: 1,
        protoName: "up",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._up;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.forward,
        this.right,
        this.up,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForForward",
        Name: "DummyOneofForForward",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUp",
        Name: "DummyOneofForUp",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectOffset.descriptor = new EffectOffset_Descriptor();
class EffectPersistent_SelectMode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "SEQUENCE": return 0;
        case "RANDOM": return 1;
        case "RANDOM_NO_REPEAT": return 2;
        case "RANDOM_SHUFFLE": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectPersistent_SelectMode.fromJson(value);
  }
  static fromReact(e) {
    return EffectPersistent_SelectMode.fromJson(e);
  }
}
EffectPersistent_SelectMode.SEQUENCE = 0;
EffectPersistent_SelectMode.RANDOM = 1;
EffectPersistent_SelectMode.RANDOM_NO_REPEAT = 2;
EffectPersistent_SelectMode.RANDOM_SHUFFLE = 3;
EffectPersistent_SelectMode.default = 0;
EffectPersistent_SelectMode.values = {
  SEQUENCE: 0,
  RANDOM: 1,
  RANDOM_NO_REPEAT: 2,
  RANDOM_SHUFFLE: 3,
};
EffectPersistent_SelectMode.names = {
  0: "SEQUENCE",
  1: "RANDOM",
  2: "RANDOM_NO_REPEAT",
  3: "RANDOM_SHUFFLE",
};
export class EffectPersistent {
  get descriptor() {
    return EffectPersistent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedTargetType = false;
    this._targetType = null;
    this._hasDeprecatedDuration = false;
    this._duration = null;
    this._hasPeriodicCount = false;
    this._periodicCount = null;
    this._hasDeprecatedPeriodicInterval = false;
    this._periodicInterval = null;
    this._hasDeprecatedPeriodicEffect = false;
    this._periodicEffect = null;
    this._hasStartEffect = false;
    this._startEffect = null;
    this._hasFinalEffect = false;
    this._finalEffect = null;
    this._hasLocation = false;
    this._location = null;
    this._hasOffsetStart = false;
    this._offsetStart = null;
    this._hasOffsetEnd = false;
    this._offsetEnd = null;
    this._hasStartEffectOffset = false;
    this._startEffectOffset = null;
    this._hasFinalEffectOffset = false;
    this._finalEffectOffset = null;
    this._hasWorldFacing = false;
    this._worldFacing = null;
    this._hasPeriodicDurationSelectMode = false;
    this._periodicDurationSelectMode = null;
    this._periodicDurations = [];
    this._hasPeriodicEffectSelectMode = false;
    this._periodicEffectSelectMode = null;
    this._periodicEffects = [];
    this._hasPeriodicOffsetSelectMode = false;
    this._periodicOffsetSelectMode = null;
    this._periodicEffectOffsets = [];
    this._periodicValidators = [];
    this._hasTerminateOnPeriodicEffectSuccess = false;
    this._terminateOnPeriodicEffectSuccess = null;
    this._hasTerminateOnPeriodicEffectFailure = false;
    this._terminateOnPeriodicEffectFailure = null;
  }
  isEmpty() {
    if (this._hasDeprecatedTargetType) return false;
    if (this._hasDeprecatedDuration) return false;
    if (this._hasPeriodicCount) return false;
    if (this._hasDeprecatedPeriodicInterval) return false;
    if (this._hasDeprecatedPeriodicEffect) return false;
    if (this._hasStartEffect) return false;
    if (this._hasFinalEffect) return false;
    if (this._hasLocation) return false;
    if (this._hasOffsetStart) return false;
    if (this._hasOffsetEnd) return false;
    if (this._hasStartEffectOffset && !this._startEffectOffset.isEmpty()) return false;
    if (this._hasFinalEffectOffset && !this._finalEffectOffset.isEmpty()) return false;
    if (this._hasWorldFacing) return false;
    if (this._hasPeriodicDurationSelectMode) return false;
    if (this._periodicDurations.length > 0) return false;
    if (this._hasPeriodicEffectSelectMode) return false;
    if (this._periodicEffects.length > 0) return false;
    if (this._hasPeriodicOffsetSelectMode) return false;
    if (this._periodicEffectOffsets.length > 0) return false;
    if (this._periodicValidators.length > 0) return false;
    if (this._hasTerminateOnPeriodicEffectSuccess) return false;
    if (this._hasTerminateOnPeriodicEffectFailure) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectPersistent) {
      return value;
    }
    return EffectPersistent.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectPersistent();
    if (json.targetType != null) {
      result._hasDeprecatedTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    if (json.duration != null) {
      result._hasDeprecatedDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.periodicCount != null) {
      result._hasPeriodicCount = true;
      result._periodicCount = JsonToInt32.fromJson(json.periodicCount);
    }
    if (json.periodicInterval != null) {
      result._hasDeprecatedPeriodicInterval = true;
      result._periodicInterval = JsonToDouble.fromJson(json.periodicInterval);
    }
    if (json.periodicEffect != null) {
      result._hasDeprecatedPeriodicEffect = true;
      result._periodicEffect = JsonToString.fromJson(json.periodicEffect);
    }
    if (json.startEffect != null) {
      result._hasStartEffect = true;
      result._startEffect = JsonToString.fromJson(json.startEffect);
    }
    if (json.finalEffect != null) {
      result._hasFinalEffect = true;
      result._finalEffect = JsonToString.fromJson(json.finalEffect);
    }
    if (json.location != null) {
      result._hasLocation = true;
      result._location = EffectTarget_Type.fromJson(json.location);
    }
    if (json.offsetStart != null) {
      result._hasOffsetStart = true;
      result._offsetStart = EffectTarget_Type.fromJson(json.offsetStart);
    }
    if (json.offsetEnd != null) {
      result._hasOffsetEnd = true;
      result._offsetEnd = EffectTarget_Type.fromJson(json.offsetEnd);
    }
    if (json.startEffectOffset != null) {
      result._hasStartEffectOffset = true;
      result._startEffectOffset = EffectOffset.fromJson(json.startEffectOffset);
    }
    if (json.finalEffectOffset != null) {
      result._hasFinalEffectOffset = true;
      result._finalEffectOffset = EffectOffset.fromJson(json.finalEffectOffset);
    }
    if (json.worldFacing != null) {
      result._hasWorldFacing = true;
      result._worldFacing = JsonToBoolean.fromJson(json.worldFacing);
    }
    if (json.periodicDurationSelectMode != null) {
      result._hasPeriodicDurationSelectMode = true;
      result._periodicDurationSelectMode = EffectPersistent_SelectMode.fromJson(json.periodicDurationSelectMode);
    }
    result._periodicDurations = JsonToList(json.periodicDurations, JsonToDouble);
    if (json.periodicEffectSelectMode != null) {
      result._hasPeriodicEffectSelectMode = true;
      result._periodicEffectSelectMode = EffectPersistent_SelectMode.fromJson(json.periodicEffectSelectMode);
    }
    result._periodicEffects = JsonToList(json.periodicEffects, JsonToString);
    if (json.periodicOffsetSelectMode != null) {
      result._hasPeriodicOffsetSelectMode = true;
      result._periodicOffsetSelectMode = EffectPersistent_SelectMode.fromJson(json.periodicOffsetSelectMode);
    }
    result._periodicEffectOffsets = JsonToList(json.periodicEffectOffsets, EffectOffset);
    result._periodicValidators = JsonToList(json.periodicValidators, JsonToString);
    if (json.terminateOnPeriodicEffectSuccess != null) {
      result._hasTerminateOnPeriodicEffectSuccess = true;
      result._terminateOnPeriodicEffectSuccess = JsonToBoolean.fromJson(json.terminateOnPeriodicEffectSuccess);
    }
    if (json.terminateOnPeriodicEffectFailure != null) {
      result._hasTerminateOnPeriodicEffectFailure = true;
      result._terminateOnPeriodicEffectFailure = JsonToBoolean.fromJson(json.terminateOnPeriodicEffectFailure);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._hasDeprecatedDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasPeriodicCount) {
      result.periodicCount = JsonToInt32.toJson(this._periodicCount);
    }
    if (this._hasDeprecatedPeriodicInterval) {
      result.periodicInterval = JsonToDouble.toJson(this._periodicInterval);
    }
    if (this._hasDeprecatedPeriodicEffect) {
      result.periodicEffect = JsonToString.toJson(this._periodicEffect);
    }
    if (this._hasStartEffect) {
      result.startEffect = JsonToString.toJson(this._startEffect);
    }
    if (this._hasFinalEffect) {
      result.finalEffect = JsonToString.toJson(this._finalEffect);
    }
    if (this._hasLocation) {
      result.location = EffectTarget_Type.toJson(this._location);
    }
    if (this._hasOffsetStart) {
      result.offsetStart = EffectTarget_Type.toJson(this._offsetStart);
    }
    if (this._hasOffsetEnd) {
      result.offsetEnd = EffectTarget_Type.toJson(this._offsetEnd);
    }
    if (this._hasStartEffectOffset && !this._startEffectOffset.isEmpty()) {
      result.startEffectOffset = EffectOffset.toJson(this._startEffectOffset);
    }
    if (this._hasFinalEffectOffset && !this._finalEffectOffset.isEmpty()) {
      result.finalEffectOffset = EffectOffset.toJson(this._finalEffectOffset);
    }
    if (this._hasWorldFacing) {
      result.worldFacing = JsonToBoolean.toJson(this._worldFacing);
    }
    if (this._hasPeriodicDurationSelectMode) {
      result.periodicDurationSelectMode = EffectPersistent_SelectMode.toJson(this._periodicDurationSelectMode);
    }
    if (this._periodicDurations.length > 0) {
      result.periodicDurations = ArrayToJson(this._periodicDurations, JsonToDouble);
    }
    if (this._hasPeriodicEffectSelectMode) {
      result.periodicEffectSelectMode = EffectPersistent_SelectMode.toJson(this._periodicEffectSelectMode);
    }
    if (this._periodicEffects.length > 0) {
      result.periodicEffects = ArrayToJson(this._periodicEffects, JsonToString);
    }
    if (this._hasPeriodicOffsetSelectMode) {
      result.periodicOffsetSelectMode = EffectPersistent_SelectMode.toJson(this._periodicOffsetSelectMode);
    }
    if (this._periodicEffectOffsets.length > 0) {
      result.periodicEffectOffsets = ArrayToJson(this._periodicEffectOffsets, EffectOffset);
    }
    if (this._periodicValidators.length > 0) {
      result.periodicValidators = ArrayToJson(this._periodicValidators, JsonToString);
    }
    if (this._hasTerminateOnPeriodicEffectSuccess) {
      result.terminateOnPeriodicEffectSuccess = JsonToBoolean.toJson(this._terminateOnPeriodicEffectSuccess);
    }
    if (this._hasTerminateOnPeriodicEffectFailure) {
      result.terminateOnPeriodicEffectFailure = JsonToBoolean.toJson(this._terminateOnPeriodicEffectFailure);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasDeprecatedTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasDeprecatedTargetType() {
    return this._hasDeprecatedTargetType;
  }
  setDeprecatedTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteDeprecatedTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDeprecatedDuration ? this._duration : JsonToDouble.default;
  }
  get hasDeprecatedDuration() {
    return this._hasDeprecatedDuration;
  }
  setDeprecatedDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDeprecatedDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {number}
   */
  get periodicCount() {
    return this._hasPeriodicCount ? this._periodicCount : JsonToInt32.default;
  }
  get hasPeriodicCount() {
    return this._hasPeriodicCount;
  }
  setPeriodicCount(path, value) {
    return {type: 'SET', path: path.concat(['periodicCount']), value};
  }
  deletePeriodicCount(path) {
    return {type: 'DELETE', path: path.concat(['periodicCount'])};
  }
  /**
   * @returns {number}
   */
  get periodicInterval() {
    return this._hasDeprecatedPeriodicInterval ? this._periodicInterval : JsonToDouble.default;
  }
  get hasDeprecatedPeriodicInterval() {
    return this._hasDeprecatedPeriodicInterval;
  }
  setDeprecatedPeriodicInterval(path, value) {
    return {type: 'SET', path: path.concat(['periodicInterval']), value};
  }
  deleteDeprecatedPeriodicInterval(path) {
    return {type: 'DELETE', path: path.concat(['periodicInterval'])};
  }
  /**
   * @returns {string}
   */
  get periodicEffect() {
    return this._hasDeprecatedPeriodicEffect ? this._periodicEffect : JsonToString.default;
  }
  get hasDeprecatedPeriodicEffect() {
    return this._hasDeprecatedPeriodicEffect;
  }
  setDeprecatedPeriodicEffect(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffect']), value};
  }
  deleteDeprecatedPeriodicEffect(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffect'])};
  }
  /**
   * @returns {string}
   */
  get startEffect() {
    return this._hasStartEffect ? this._startEffect : JsonToString.default;
  }
  get hasStartEffect() {
    return this._hasStartEffect;
  }
  setStartEffect(path, value) {
    return {type: 'SET', path: path.concat(['startEffect']), value};
  }
  deleteStartEffect(path) {
    return {type: 'DELETE', path: path.concat(['startEffect'])};
  }
  /**
   * @returns {string}
   */
  get finalEffect() {
    return this._hasFinalEffect ? this._finalEffect : JsonToString.default;
  }
  get hasFinalEffect() {
    return this._hasFinalEffect;
  }
  setFinalEffect(path, value) {
    return {type: 'SET', path: path.concat(['finalEffect']), value};
  }
  deleteFinalEffect(path) {
    return {type: 'DELETE', path: path.concat(['finalEffect'])};
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : EffectTarget_Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  /**
   * @returns {number}
   */
  get offsetStart() {
    return this._hasOffsetStart ? this._offsetStart : EffectTarget_Type.default;
  }
  get hasOffsetStart() {
    return this._hasOffsetStart;
  }
  setOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['offsetStart']), value};
  }
  deleteOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['offsetStart'])};
  }
  /**
   * @returns {number}
   */
  get offsetEnd() {
    return this._hasOffsetEnd ? this._offsetEnd : EffectTarget_Type.default;
  }
  get hasOffsetEnd() {
    return this._hasOffsetEnd;
  }
  setOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['offsetEnd']), value};
  }
  deleteOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['offsetEnd'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get startEffectOffset() {
    return this._hasStartEffectOffset ? this._startEffectOffset : EffectOffset.default;
  }
  get hasStartEffectOffset() {
    return this._hasStartEffectOffset;
  }
  setStartEffectOffset(path, value) {
    return {type: 'SET', path: path.concat(['startEffectOffset']), value: value.toJson()};
  }
  deleteStartEffectOffset(path) {
    return {type: 'DELETE', path: path.concat(['startEffectOffset'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get finalEffectOffset() {
    return this._hasFinalEffectOffset ? this._finalEffectOffset : EffectOffset.default;
  }
  get hasFinalEffectOffset() {
    return this._hasFinalEffectOffset;
  }
  setFinalEffectOffset(path, value) {
    return {type: 'SET', path: path.concat(['finalEffectOffset']), value: value.toJson()};
  }
  deleteFinalEffectOffset(path) {
    return {type: 'DELETE', path: path.concat(['finalEffectOffset'])};
  }
  /**
   * @returns {boolean}
   */
  get worldFacing() {
    return this._hasWorldFacing ? this._worldFacing : JsonToBoolean.default;
  }
  get hasWorldFacing() {
    return this._hasWorldFacing;
  }
  setWorldFacing(path, value) {
    return {type: 'SET', path: path.concat(['worldFacing']), value};
  }
  deleteWorldFacing(path) {
    return {type: 'DELETE', path: path.concat(['worldFacing'])};
  }
  /**
   * @returns {number}
   */
  get periodicDurationSelectMode() {
    return this._hasPeriodicDurationSelectMode ? this._periodicDurationSelectMode : EffectPersistent_SelectMode.default;
  }
  get hasPeriodicDurationSelectMode() {
    return this._hasPeriodicDurationSelectMode;
  }
  setPeriodicDurationSelectMode(path, value) {
    return {type: 'SET', path: path.concat(['periodicDurationSelectMode']), value};
  }
  deletePeriodicDurationSelectMode(path) {
    return {type: 'DELETE', path: path.concat(['periodicDurationSelectMode'])};
  }
  /**
   * @returns {number[]}
   */
  get periodicDurations() {
    return this._periodicDurations;
  }
  addPeriodicDurations(path, value) {
    return {type: 'ADD', path: path.concat(['periodicDurations']), value};
  }
  setPeriodicDurations(path, value) {
    return {type: 'SET', path: path.concat(['periodicDurations']), value: ArrayToJson(value, JsonToDouble)};
  }
  setPeriodicDurationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['periodicDurations', key]), value};
  }
  deletePeriodicDurations(path) {
    return {type: 'DELETE', path: path.concat(['periodicDurations'])};
  }
  deletePeriodicDurationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['periodicDurations', key])};
  }
  /**
   * @returns {number}
   */
  get periodicEffectSelectMode() {
    return this._hasPeriodicEffectSelectMode ? this._periodicEffectSelectMode : EffectPersistent_SelectMode.default;
  }
  get hasPeriodicEffectSelectMode() {
    return this._hasPeriodicEffectSelectMode;
  }
  setPeriodicEffectSelectMode(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffectSelectMode']), value};
  }
  deletePeriodicEffectSelectMode(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffectSelectMode'])};
  }
  /**
   * @returns {string[]}
   */
  get periodicEffects() {
    return this._periodicEffects;
  }
  addPeriodicEffects(path, value) {
    return {type: 'ADD', path: path.concat(['periodicEffects']), value};
  }
  setPeriodicEffects(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffects']), value: ArrayToJson(value, JsonToString)};
  }
  setPeriodicEffectsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['periodicEffects', key]), value};
  }
  deletePeriodicEffects(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffects'])};
  }
  deletePeriodicEffectsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['periodicEffects', key])};
  }
  /**
   * @returns {number}
   */
  get periodicOffsetSelectMode() {
    return this._hasPeriodicOffsetSelectMode ? this._periodicOffsetSelectMode : EffectPersistent_SelectMode.default;
  }
  get hasPeriodicOffsetSelectMode() {
    return this._hasPeriodicOffsetSelectMode;
  }
  setPeriodicOffsetSelectMode(path, value) {
    return {type: 'SET', path: path.concat(['periodicOffsetSelectMode']), value};
  }
  deletePeriodicOffsetSelectMode(path) {
    return {type: 'DELETE', path: path.concat(['periodicOffsetSelectMode'])};
  }
  /**
   * @returns {EffectOffset[]}
   */
  get periodicEffectOffsets() {
    return this._periodicEffectOffsets;
  }
  addPeriodicEffectOffsets(path, value) {
    return {type: 'ADD', path: path.concat(['periodicEffectOffsets']), value: value.toJson()};
  }
  setPeriodicEffectOffsets(path, value) {
    return {type: 'SET', path: path.concat(['periodicEffectOffsets']), value: ArrayToJson(value, EffectOffset)};
  }
  setPeriodicEffectOffsetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['periodicEffectOffsets', key]), value: value.toJson()};
  }
  deletePeriodicEffectOffsets(path) {
    return {type: 'DELETE', path: path.concat(['periodicEffectOffsets'])};
  }
  deletePeriodicEffectOffsetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['periodicEffectOffsets', key])};
  }
  /**
   * @returns {string[]}
   */
  get periodicValidators() {
    return this._periodicValidators;
  }
  addPeriodicValidators(path, value) {
    return {type: 'ADD', path: path.concat(['periodicValidators']), value};
  }
  setPeriodicValidators(path, value) {
    return {type: 'SET', path: path.concat(['periodicValidators']), value: ArrayToJson(value, JsonToString)};
  }
  setPeriodicValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['periodicValidators', key]), value};
  }
  deletePeriodicValidators(path) {
    return {type: 'DELETE', path: path.concat(['periodicValidators'])};
  }
  deletePeriodicValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['periodicValidators', key])};
  }
  /**
   * @returns {boolean}
   */
  get terminateOnPeriodicEffectSuccess() {
    return this._hasTerminateOnPeriodicEffectSuccess ? this._terminateOnPeriodicEffectSuccess : JsonToBoolean.default;
  }
  get hasTerminateOnPeriodicEffectSuccess() {
    return this._hasTerminateOnPeriodicEffectSuccess;
  }
  setTerminateOnPeriodicEffectSuccess(path, value) {
    return {type: 'SET', path: path.concat(['terminateOnPeriodicEffectSuccess']), value};
  }
  deleteTerminateOnPeriodicEffectSuccess(path) {
    return {type: 'DELETE', path: path.concat(['terminateOnPeriodicEffectSuccess'])};
  }
  /**
   * @returns {boolean}
   */
  get terminateOnPeriodicEffectFailure() {
    return this._hasTerminateOnPeriodicEffectFailure ? this._terminateOnPeriodicEffectFailure : JsonToBoolean.default;
  }
  get hasTerminateOnPeriodicEffectFailure() {
    return this._hasTerminateOnPeriodicEffectFailure;
  }
  setTerminateOnPeriodicEffectFailure(path, value) {
    return {type: 'SET', path: path.concat(['terminateOnPeriodicEffectFailure']), value};
  }
  deleteTerminateOnPeriodicEffectFailure(path) {
    return {type: 'DELETE', path: path.concat(['terminateOnPeriodicEffectFailure'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedTargetType) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedDuration) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasPeriodicCount = true;
              copy._periodicCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicCount) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasPeriodicCount = false;
              copy._periodicCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicInterval": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedPeriodicInterval = true;
              copy._periodicInterval = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedPeriodicInterval) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedPeriodicInterval = false;
              copy._periodicInterval = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedPeriodicEffect = true;
              copy._periodicEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedPeriodicEffect) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasDeprecatedPeriodicEffect = false;
              copy._periodicEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasStartEffect = true;
              copy._startEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartEffect) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasStartEffect = false;
              copy._startEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "finalEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasFinalEffect = true;
              copy._finalEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinalEffect) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasFinalEffect = false;
              copy._finalEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasLocation = true;
              copy._location = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasOffsetStart = true;
              copy._offsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetStart) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasOffsetStart = false;
              copy._offsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasOffsetEnd = true;
              copy._offsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetEnd) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasOffsetEnd = false;
              copy._offsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startEffectOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasStartEffectOffset = true;
              copy._startEffectOffset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartEffectOffset) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasStartEffectOffset = false;
              copy._startEffectOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStartEffectOffset) {
            const copy = new EffectPersistent(this);
            copy._hasStartEffectOffset = true;
            copy._startEffectOffset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._startEffectOffset.apply(type, path.slice(1), value);
          if (newValue === this._startEffectOffset) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._startEffectOffset = copy._startEffectOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "finalEffectOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasFinalEffectOffset = true;
              copy._finalEffectOffset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinalEffectOffset) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasFinalEffectOffset = false;
              copy._finalEffectOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFinalEffectOffset) {
            const copy = new EffectPersistent(this);
            copy._hasFinalEffectOffset = true;
            copy._finalEffectOffset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._finalEffectOffset.apply(type, path.slice(1), value);
          if (newValue === this._finalEffectOffset) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._finalEffectOffset = copy._finalEffectOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "worldFacing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasWorldFacing = true;
              copy._worldFacing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWorldFacing) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasWorldFacing = false;
              copy._worldFacing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicDurationSelectMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasPeriodicDurationSelectMode = true;
              copy._periodicDurationSelectMode = EffectPersistent_SelectMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicDurationSelectMode) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasPeriodicDurationSelectMode = false;
              copy._periodicDurationSelectMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicDurations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicDurations = [];        for (let i of value) {
                copy._periodicDurations.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectPersistent(this);
              copy._periodicDurations = copy._periodicDurations.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._periodicDurations.length === 0) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._periodicDurations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._periodicDurations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicDurations = copy._periodicDurations.slice();
              copy._periodicDurations[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectPersistent(this);
              copy._periodicDurations = copy._periodicDurations.slice(0, path[1]).concat(copy._periodicDurations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._periodicDurations.length) {
            return this;
          }
          const oldValue = this._periodicDurations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._periodicDurations = copy._periodicDurations.slice();
          copy._periodicDurations[key] = newValue;
          return copy;
        }
      }
      case "periodicEffectSelectMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasPeriodicEffectSelectMode = true;
              copy._periodicEffectSelectMode = EffectPersistent_SelectMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicEffectSelectMode) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasPeriodicEffectSelectMode = false;
              copy._periodicEffectSelectMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicEffects": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicEffects = [];        for (let i of value) {
                copy._periodicEffects.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectPersistent(this);
              copy._periodicEffects = copy._periodicEffects.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._periodicEffects.length === 0) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._periodicEffects = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._periodicEffects.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicEffects = copy._periodicEffects.slice();
              copy._periodicEffects[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectPersistent(this);
              copy._periodicEffects = copy._periodicEffects.slice(0, path[1]).concat(copy._periodicEffects.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._periodicEffects.length) {
            return this;
          }
          const oldValue = this._periodicEffects[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._periodicEffects = copy._periodicEffects.slice();
          copy._periodicEffects[key] = newValue;
          return copy;
        }
      }
      case "periodicOffsetSelectMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasPeriodicOffsetSelectMode = true;
              copy._periodicOffsetSelectMode = EffectPersistent_SelectMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriodicOffsetSelectMode) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasPeriodicOffsetSelectMode = false;
              copy._periodicOffsetSelectMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "periodicEffectOffsets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicEffectOffsets = [];        for (let i of value) {
                copy._periodicEffectOffsets.push(EffectOffset.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectPersistent(this);
              copy._periodicEffectOffsets = copy._periodicEffectOffsets.concat([EffectOffset.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._periodicEffectOffsets.length === 0) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._periodicEffectOffsets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._periodicEffectOffsets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicEffectOffsets = copy._periodicEffectOffsets.slice();
              copy._periodicEffectOffsets[path[1]] = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectPersistent(this);
              copy._periodicEffectOffsets = copy._periodicEffectOffsets.slice(0, path[1]).concat(copy._periodicEffectOffsets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._periodicEffectOffsets.length) {
            return this;
          }
          const oldValue = this._periodicEffectOffsets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._periodicEffectOffsets = copy._periodicEffectOffsets.slice();
          copy._periodicEffectOffsets[key] = newValue;
          return copy;
        }
      }
      case "periodicValidators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicValidators = [];        for (let i of value) {
                copy._periodicValidators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectPersistent(this);
              copy._periodicValidators = copy._periodicValidators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._periodicValidators.length === 0) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._periodicValidators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._periodicValidators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._periodicValidators = copy._periodicValidators.slice();
              copy._periodicValidators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectPersistent(this);
              copy._periodicValidators = copy._periodicValidators.slice(0, path[1]).concat(copy._periodicValidators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._periodicValidators.length) {
            return this;
          }
          const oldValue = this._periodicValidators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectPersistent(this);
          copy._periodicValidators = copy._periodicValidators.slice();
          copy._periodicValidators[key] = newValue;
          return copy;
        }
      }
      case "terminateOnPeriodicEffectSuccess": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasTerminateOnPeriodicEffectSuccess = true;
              copy._terminateOnPeriodicEffectSuccess = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerminateOnPeriodicEffectSuccess) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasTerminateOnPeriodicEffectSuccess = false;
              copy._terminateOnPeriodicEffectSuccess = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "terminateOnPeriodicEffectFailure": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectPersistent(this);
              copy._hasTerminateOnPeriodicEffectFailure = true;
              copy._terminateOnPeriodicEffectFailure = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerminateOnPeriodicEffectFailure) {
                return this;
              }
              const copy = new EffectPersistent(this);
              copy._hasTerminateOnPeriodicEffectFailure = false;
              copy._terminateOnPeriodicEffectFailure = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectPersistent} other
   * @returns {EffectPersistent}
   */
  merge(other) {
    const copy = new EffectPersistent(this);
    if (other._hasDeprecatedTargetType) {
      copy._hasDeprecatedTargetType = true;
      copy._targetType = other._targetType;
    }
    if (other._hasDeprecatedDuration) {
      copy._hasDeprecatedDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasPeriodicCount) {
      copy._hasPeriodicCount = true;
      copy._periodicCount = other._periodicCount;
    }
    if (other._hasDeprecatedPeriodicInterval) {
      copy._hasDeprecatedPeriodicInterval = true;
      copy._periodicInterval = other._periodicInterval;
    }
    if (other._hasDeprecatedPeriodicEffect) {
      copy._hasDeprecatedPeriodicEffect = true;
      copy._periodicEffect = other._periodicEffect;
    }
    if (other._hasStartEffect) {
      copy._hasStartEffect = true;
      copy._startEffect = other._startEffect;
    }
    if (other._hasFinalEffect) {
      copy._hasFinalEffect = true;
      copy._finalEffect = other._finalEffect;
    }
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    if (other._hasOffsetStart) {
      copy._hasOffsetStart = true;
      copy._offsetStart = other._offsetStart;
    }
    if (other._hasOffsetEnd) {
      copy._hasOffsetEnd = true;
      copy._offsetEnd = other._offsetEnd;
    }
    if (other._hasStartEffectOffset) {
      if (copy._hasStartEffectOffset) {
        copy._startEffectOffset = copy.startEffectOffset.merge(other.startEffectOffset);
      } else {
        copy._startEffectOffset = other._startEffectOffset;
      }
      copy._hasStartEffectOffset = true;
    }
    if (other._hasFinalEffectOffset) {
      if (copy._hasFinalEffectOffset) {
        copy._finalEffectOffset = copy.finalEffectOffset.merge(other.finalEffectOffset);
      } else {
        copy._finalEffectOffset = other._finalEffectOffset;
      }
      copy._hasFinalEffectOffset = true;
    }
    if (other._hasWorldFacing) {
      copy._hasWorldFacing = true;
      copy._worldFacing = other._worldFacing;
    }
    if (other._hasPeriodicDurationSelectMode) {
      copy._hasPeriodicDurationSelectMode = true;
      copy._periodicDurationSelectMode = other._periodicDurationSelectMode;
    }
    copy._periodicDurations = this._periodicDurations.concat(other._periodicDurations);
    if (other._hasPeriodicEffectSelectMode) {
      copy._hasPeriodicEffectSelectMode = true;
      copy._periodicEffectSelectMode = other._periodicEffectSelectMode;
    }
    copy._periodicEffects = this._periodicEffects.concat(other._periodicEffects);
    if (other._hasPeriodicOffsetSelectMode) {
      copy._hasPeriodicOffsetSelectMode = true;
      copy._periodicOffsetSelectMode = other._periodicOffsetSelectMode;
    }
    copy._periodicEffectOffsets = this._periodicEffectOffsets.concat(other._periodicEffectOffsets);
    copy._periodicValidators = this._periodicValidators.concat(other._periodicValidators);
    if (other._hasTerminateOnPeriodicEffectSuccess) {
      copy._hasTerminateOnPeriodicEffectSuccess = true;
      copy._terminateOnPeriodicEffectSuccess = other._terminateOnPeriodicEffectSuccess;
    }
    if (other._hasTerminateOnPeriodicEffectFailure) {
      copy._hasTerminateOnPeriodicEffectFailure = true;
      copy._terminateOnPeriodicEffectFailure = other._terminateOnPeriodicEffectFailure;
    }
    return copy;
  }
}
EffectPersistent.default = new EffectPersistent();
EffectPersistent.SelectMode = EffectPersistent_SelectMode;
class EffectPersistent_Builder {
  constructor(value) {
    this._value = new EffectPersistent(value);
  }
  build() {
    return new EffectPersistent(this._value);
  }
  setDeprecatedTargetType(value) {
    this._value._hasDeprecatedTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteDeprecatedTargetType() {
    this._value._hasDeprecatedTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setDeprecatedDuration(value) {
    this._value._hasDeprecatedDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDeprecatedDuration() {
    this._value._hasDeprecatedDuration = false;
    this._value._duration = null;
    return this;
  }
  setPeriodicCount(value) {
    this._value._hasPeriodicCount = true;
    this._value._periodicCount = value;
    return this;
  }
  deletePeriodicCount() {
    this._value._hasPeriodicCount = false;
    this._value._periodicCount = null;
    return this;
  }
  setDeprecatedPeriodicInterval(value) {
    this._value._hasDeprecatedPeriodicInterval = true;
    this._value._periodicInterval = value;
    return this;
  }
  deleteDeprecatedPeriodicInterval() {
    this._value._hasDeprecatedPeriodicInterval = false;
    this._value._periodicInterval = null;
    return this;
  }
  setDeprecatedPeriodicEffect(value) {
    this._value._hasDeprecatedPeriodicEffect = true;
    this._value._periodicEffect = value;
    return this;
  }
  deleteDeprecatedPeriodicEffect() {
    this._value._hasDeprecatedPeriodicEffect = false;
    this._value._periodicEffect = null;
    return this;
  }
  setStartEffect(value) {
    this._value._hasStartEffect = true;
    this._value._startEffect = value;
    return this;
  }
  deleteStartEffect() {
    this._value._hasStartEffect = false;
    this._value._startEffect = null;
    return this;
  }
  setFinalEffect(value) {
    this._value._hasFinalEffect = true;
    this._value._finalEffect = value;
    return this;
  }
  deleteFinalEffect() {
    this._value._hasFinalEffect = false;
    this._value._finalEffect = null;
    return this;
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
  setOffsetStart(value) {
    this._value._hasOffsetStart = true;
    this._value._offsetStart = value;
    return this;
  }
  deleteOffsetStart() {
    this._value._hasOffsetStart = false;
    this._value._offsetStart = null;
    return this;
  }
  setOffsetEnd(value) {
    this._value._hasOffsetEnd = true;
    this._value._offsetEnd = value;
    return this;
  }
  deleteOffsetEnd() {
    this._value._hasOffsetEnd = false;
    this._value._offsetEnd = null;
    return this;
  }
  setStartEffectOffset(value) {
    this._value._hasStartEffectOffset = true;
    this._value._startEffectOffset = value;
    return this;
  }
  deleteStartEffectOffset() {
    this._value._hasStartEffectOffset = false;
    this._value._startEffectOffset = null;
    return this;
  }
  setFinalEffectOffset(value) {
    this._value._hasFinalEffectOffset = true;
    this._value._finalEffectOffset = value;
    return this;
  }
  deleteFinalEffectOffset() {
    this._value._hasFinalEffectOffset = false;
    this._value._finalEffectOffset = null;
    return this;
  }
  setWorldFacing(value) {
    this._value._hasWorldFacing = true;
    this._value._worldFacing = value;
    return this;
  }
  deleteWorldFacing() {
    this._value._hasWorldFacing = false;
    this._value._worldFacing = null;
    return this;
  }
  setPeriodicDurationSelectMode(value) {
    this._value._hasPeriodicDurationSelectMode = true;
    this._value._periodicDurationSelectMode = value;
    return this;
  }
  deletePeriodicDurationSelectMode() {
    this._value._hasPeriodicDurationSelectMode = false;
    this._value._periodicDurationSelectMode = null;
    return this;
  }
  addAllPeriodicDurations(values) {
    this._value._periodicDurations = this._value._periodicDurations.concat(values);
    return this;
  }
  addPeriodicDurations(value) {
    this._value._periodicDurations = this._value._periodicDurations.concat([value]);
    return this;
  }
  setPeriodicDurations(index, value) {
    this._value._periodicDurations = this._value._periodicDurations.concat();
    this._value._periodicDurations[index] = value;
    return this;
  }
  clearPeriodicDurations() {
    this._value._periodicDurations = [];
    return this;
  }
  setPeriodicEffectSelectMode(value) {
    this._value._hasPeriodicEffectSelectMode = true;
    this._value._periodicEffectSelectMode = value;
    return this;
  }
  deletePeriodicEffectSelectMode() {
    this._value._hasPeriodicEffectSelectMode = false;
    this._value._periodicEffectSelectMode = null;
    return this;
  }
  addAllPeriodicEffects(values) {
    this._value._periodicEffects = this._value._periodicEffects.concat(values);
    return this;
  }
  addPeriodicEffects(value) {
    this._value._periodicEffects = this._value._periodicEffects.concat([value]);
    return this;
  }
  setPeriodicEffects(index, value) {
    this._value._periodicEffects = this._value._periodicEffects.concat();
    this._value._periodicEffects[index] = value;
    return this;
  }
  clearPeriodicEffects() {
    this._value._periodicEffects = [];
    return this;
  }
  setPeriodicOffsetSelectMode(value) {
    this._value._hasPeriodicOffsetSelectMode = true;
    this._value._periodicOffsetSelectMode = value;
    return this;
  }
  deletePeriodicOffsetSelectMode() {
    this._value._hasPeriodicOffsetSelectMode = false;
    this._value._periodicOffsetSelectMode = null;
    return this;
  }
  addAllPeriodicEffectOffsets(values) {
    this._value._periodicEffectOffsets = this._value._periodicEffectOffsets.concat(values);
    return this;
  }
  addPeriodicEffectOffsets(value) {
    this._value._periodicEffectOffsets = this._value._periodicEffectOffsets.concat([value]);
    return this;
  }
  setPeriodicEffectOffsets(index, value) {
    this._value._periodicEffectOffsets = this._value._periodicEffectOffsets.concat();
    this._value._periodicEffectOffsets[index] = value;
    return this;
  }
  clearPeriodicEffectOffsets() {
    this._value._periodicEffectOffsets = [];
    return this;
  }
  addAllPeriodicValidators(values) {
    this._value._periodicValidators = this._value._periodicValidators.concat(values);
    return this;
  }
  addPeriodicValidators(value) {
    this._value._periodicValidators = this._value._periodicValidators.concat([value]);
    return this;
  }
  setPeriodicValidators(index, value) {
    this._value._periodicValidators = this._value._periodicValidators.concat();
    this._value._periodicValidators[index] = value;
    return this;
  }
  clearPeriodicValidators() {
    this._value._periodicValidators = [];
    return this;
  }
  setTerminateOnPeriodicEffectSuccess(value) {
    this._value._hasTerminateOnPeriodicEffectSuccess = true;
    this._value._terminateOnPeriodicEffectSuccess = value;
    return this;
  }
  deleteTerminateOnPeriodicEffectSuccess() {
    this._value._hasTerminateOnPeriodicEffectSuccess = false;
    this._value._terminateOnPeriodicEffectSuccess = null;
    return this;
  }
  setTerminateOnPeriodicEffectFailure(value) {
    this._value._hasTerminateOnPeriodicEffectFailure = true;
    this._value._terminateOnPeriodicEffectFailure = value;
    return this;
  }
  deleteTerminateOnPeriodicEffectFailure() {
    this._value._hasTerminateOnPeriodicEffectFailure = false;
    this._value._terminateOnPeriodicEffectFailure = null;
    return this;
  }
}
EffectPersistent.Builder = EffectPersistent_Builder;
class EffectPersistent_WithParent {
  /**
   * @param {EffectPersistent} value
   * @param {EffectPersistent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectPersistent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedTargetType() {
    if (this._cachedHasDeprecatedTargetType === undefined) {
      if (this._value.hasDeprecatedTargetType) {
        this._cachedHasDeprecatedTargetType = true;
      } else {
        this._cachedHasDeprecatedTargetType = this._parent ? this._parent.hasDeprecatedTargetType : false;
      }
    }
    return this._cachedHasDeprecatedTargetType;
  }
  get targetType() {
    if (this._cachedDeprecatedTargetType === undefined) {
      if (this._value.hasDeprecatedTargetType) {
        this._cachedDeprecatedTargetType = this._value.targetType;
      } else {
        this._cachedDeprecatedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedDeprecatedTargetType;
  }
  get hasDeprecatedDuration() {
    if (this._cachedHasDeprecatedDuration === undefined) {
      if (this._value.hasDeprecatedDuration) {
        this._cachedHasDeprecatedDuration = true;
      } else {
        this._cachedHasDeprecatedDuration = this._parent ? this._parent.hasDeprecatedDuration : false;
      }
    }
    return this._cachedHasDeprecatedDuration;
  }
  get duration() {
    if (this._cachedDeprecatedDuration === undefined) {
      if (this._value.hasDeprecatedDuration) {
        this._cachedDeprecatedDuration = this._value.duration;
      } else {
        this._cachedDeprecatedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDeprecatedDuration;
  }
  get hasPeriodicCount() {
    if (this._cachedHasPeriodicCount === undefined) {
      if (this._value.hasPeriodicCount) {
        this._cachedHasPeriodicCount = true;
      } else {
        this._cachedHasPeriodicCount = this._parent ? this._parent.hasPeriodicCount : false;
      }
    }
    return this._cachedHasPeriodicCount;
  }
  get periodicCount() {
    if (this._cachedPeriodicCount === undefined) {
      if (this._value.hasPeriodicCount) {
        this._cachedPeriodicCount = this._value.periodicCount;
      } else {
        this._cachedPeriodicCount = this._parent ? this._parent.periodicCount : this._value.periodicCount;
      }
    }
    return this._cachedPeriodicCount;
  }
  get hasDeprecatedPeriodicInterval() {
    if (this._cachedHasDeprecatedPeriodicInterval === undefined) {
      if (this._value.hasDeprecatedPeriodicInterval) {
        this._cachedHasDeprecatedPeriodicInterval = true;
      } else {
        this._cachedHasDeprecatedPeriodicInterval = this._parent ? this._parent.hasDeprecatedPeriodicInterval : false;
      }
    }
    return this._cachedHasDeprecatedPeriodicInterval;
  }
  get periodicInterval() {
    if (this._cachedDeprecatedPeriodicInterval === undefined) {
      if (this._value.hasDeprecatedPeriodicInterval) {
        this._cachedDeprecatedPeriodicInterval = this._value.periodicInterval;
      } else {
        this._cachedDeprecatedPeriodicInterval = this._parent ? this._parent.periodicInterval : this._value.periodicInterval;
      }
    }
    return this._cachedDeprecatedPeriodicInterval;
  }
  get hasDeprecatedPeriodicEffect() {
    if (this._cachedHasDeprecatedPeriodicEffect === undefined) {
      if (this._value.hasDeprecatedPeriodicEffect) {
        this._cachedHasDeprecatedPeriodicEffect = true;
      } else {
        this._cachedHasDeprecatedPeriodicEffect = this._parent ? this._parent.hasDeprecatedPeriodicEffect : false;
      }
    }
    return this._cachedHasDeprecatedPeriodicEffect;
  }
  get periodicEffect() {
    if (this._cachedDeprecatedPeriodicEffect === undefined) {
      if (this._value.hasDeprecatedPeriodicEffect) {
        this._cachedDeprecatedPeriodicEffect = this._value.periodicEffect;
      } else {
        this._cachedDeprecatedPeriodicEffect = this._parent ? this._parent.periodicEffect : this._value.periodicEffect;
      }
    }
    return this._cachedDeprecatedPeriodicEffect;
  }
  get hasStartEffect() {
    if (this._cachedHasStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedHasStartEffect = true;
      } else {
        this._cachedHasStartEffect = this._parent ? this._parent.hasStartEffect : false;
      }
    }
    return this._cachedHasStartEffect;
  }
  get startEffect() {
    if (this._cachedStartEffect === undefined) {
      if (this._value.hasStartEffect) {
        this._cachedStartEffect = this._value.startEffect;
      } else {
        this._cachedStartEffect = this._parent ? this._parent.startEffect : this._value.startEffect;
      }
    }
    return this._cachedStartEffect;
  }
  get hasFinalEffect() {
    if (this._cachedHasFinalEffect === undefined) {
      if (this._value.hasFinalEffect) {
        this._cachedHasFinalEffect = true;
      } else {
        this._cachedHasFinalEffect = this._parent ? this._parent.hasFinalEffect : false;
      }
    }
    return this._cachedHasFinalEffect;
  }
  get finalEffect() {
    if (this._cachedFinalEffect === undefined) {
      if (this._value.hasFinalEffect) {
        this._cachedFinalEffect = this._value.finalEffect;
      } else {
        this._cachedFinalEffect = this._parent ? this._parent.finalEffect : this._value.finalEffect;
      }
    }
    return this._cachedFinalEffect;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  get hasOffsetStart() {
    if (this._cachedHasOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedHasOffsetStart = true;
      } else {
        this._cachedHasOffsetStart = this._parent ? this._parent.hasOffsetStart : false;
      }
    }
    return this._cachedHasOffsetStart;
  }
  get offsetStart() {
    if (this._cachedOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedOffsetStart = this._value.offsetStart;
      } else {
        this._cachedOffsetStart = this._parent ? this._parent.offsetStart : this._value.offsetStart;
      }
    }
    return this._cachedOffsetStart;
  }
  get hasOffsetEnd() {
    if (this._cachedHasOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedHasOffsetEnd = true;
      } else {
        this._cachedHasOffsetEnd = this._parent ? this._parent.hasOffsetEnd : false;
      }
    }
    return this._cachedHasOffsetEnd;
  }
  get offsetEnd() {
    if (this._cachedOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedOffsetEnd = this._value.offsetEnd;
      } else {
        this._cachedOffsetEnd = this._parent ? this._parent.offsetEnd : this._value.offsetEnd;
      }
    }
    return this._cachedOffsetEnd;
  }
  get hasStartEffectOffset() {
    if (this._cachedHasStartEffectOffset === undefined) {
      if (this._value.hasStartEffectOffset) {
        this._cachedHasStartEffectOffset = true;
      } else {
        this._cachedHasStartEffectOffset = this._parent ? this._parent.hasStartEffectOffset : false;
      }
    }
    return this._cachedHasStartEffectOffset;
  }
  get startEffectOffset() {
    if (!this._cachedStartEffectOffset) {
      if (this._value.hasStartEffectOffset) {
        this._cachedStartEffectOffset = new EffectOffset.WithParent(this._value.startEffectOffset, this._parent && this._parent.hasStartEffectOffset ? this._parent.startEffectOffset : null);
      } else {
        this._cachedStartEffectOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.startEffectOffset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedStartEffectOffset;
  }
  get hasFinalEffectOffset() {
    if (this._cachedHasFinalEffectOffset === undefined) {
      if (this._value.hasFinalEffectOffset) {
        this._cachedHasFinalEffectOffset = true;
      } else {
        this._cachedHasFinalEffectOffset = this._parent ? this._parent.hasFinalEffectOffset : false;
      }
    }
    return this._cachedHasFinalEffectOffset;
  }
  get finalEffectOffset() {
    if (!this._cachedFinalEffectOffset) {
      if (this._value.hasFinalEffectOffset) {
        this._cachedFinalEffectOffset = new EffectOffset.WithParent(this._value.finalEffectOffset, this._parent && this._parent.hasFinalEffectOffset ? this._parent.finalEffectOffset : null);
      } else {
        this._cachedFinalEffectOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.finalEffectOffset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedFinalEffectOffset;
  }
  get hasWorldFacing() {
    if (this._cachedHasWorldFacing === undefined) {
      if (this._value.hasWorldFacing) {
        this._cachedHasWorldFacing = true;
      } else {
        this._cachedHasWorldFacing = this._parent ? this._parent.hasWorldFacing : false;
      }
    }
    return this._cachedHasWorldFacing;
  }
  get worldFacing() {
    if (this._cachedWorldFacing === undefined) {
      if (this._value.hasWorldFacing) {
        this._cachedWorldFacing = this._value.worldFacing;
      } else {
        this._cachedWorldFacing = this._parent ? this._parent.worldFacing : this._value.worldFacing;
      }
    }
    return this._cachedWorldFacing;
  }
  get hasPeriodicDurationSelectMode() {
    if (this._cachedHasPeriodicDurationSelectMode === undefined) {
      if (this._value.hasPeriodicDurationSelectMode) {
        this._cachedHasPeriodicDurationSelectMode = true;
      } else {
        this._cachedHasPeriodicDurationSelectMode = this._parent ? this._parent.hasPeriodicDurationSelectMode : false;
      }
    }
    return this._cachedHasPeriodicDurationSelectMode;
  }
  get periodicDurationSelectMode() {
    if (this._cachedPeriodicDurationSelectMode === undefined) {
      if (this._value.hasPeriodicDurationSelectMode) {
        this._cachedPeriodicDurationSelectMode = this._value.periodicDurationSelectMode;
      } else {
        this._cachedPeriodicDurationSelectMode = this._parent ? this._parent.periodicDurationSelectMode : this._value.periodicDurationSelectMode;
      }
    }
    return this._cachedPeriodicDurationSelectMode;
  }
  get selfPeriodicDurations() {
    return this._value.periodicDurations;
  }
  get inherentPeriodicDurations() {
    if (!this._inherentPeriodicDurations) {
      this._inherentPeriodicDurations = this._parent ? this._parent.periodicDurations : [];
    }
    return this._inherentPeriodicDurations;
  }
  get periodicDurations() {
    if (!this._allPeriodicDurations) {
      this._allPeriodicDurations = this._parent ? this._parent.periodicDurations.concat(this.selfPeriodicDurations) : this.selfPeriodicDurations;
    }
    return this._allPeriodicDurations;
  }
  get hasPeriodicEffectSelectMode() {
    if (this._cachedHasPeriodicEffectSelectMode === undefined) {
      if (this._value.hasPeriodicEffectSelectMode) {
        this._cachedHasPeriodicEffectSelectMode = true;
      } else {
        this._cachedHasPeriodicEffectSelectMode = this._parent ? this._parent.hasPeriodicEffectSelectMode : false;
      }
    }
    return this._cachedHasPeriodicEffectSelectMode;
  }
  get periodicEffectSelectMode() {
    if (this._cachedPeriodicEffectSelectMode === undefined) {
      if (this._value.hasPeriodicEffectSelectMode) {
        this._cachedPeriodicEffectSelectMode = this._value.periodicEffectSelectMode;
      } else {
        this._cachedPeriodicEffectSelectMode = this._parent ? this._parent.periodicEffectSelectMode : this._value.periodicEffectSelectMode;
      }
    }
    return this._cachedPeriodicEffectSelectMode;
  }
  get selfPeriodicEffects() {
    return this._value.periodicEffects;
  }
  get inherentPeriodicEffects() {
    if (!this._inherentPeriodicEffects) {
      this._inherentPeriodicEffects = this._parent ? this._parent.periodicEffects : [];
    }
    return this._inherentPeriodicEffects;
  }
  get periodicEffects() {
    if (!this._allPeriodicEffects) {
      this._allPeriodicEffects = this._parent ? this._parent.periodicEffects.concat(this.selfPeriodicEffects) : this.selfPeriodicEffects;
    }
    return this._allPeriodicEffects;
  }
  get hasPeriodicOffsetSelectMode() {
    if (this._cachedHasPeriodicOffsetSelectMode === undefined) {
      if (this._value.hasPeriodicOffsetSelectMode) {
        this._cachedHasPeriodicOffsetSelectMode = true;
      } else {
        this._cachedHasPeriodicOffsetSelectMode = this._parent ? this._parent.hasPeriodicOffsetSelectMode : false;
      }
    }
    return this._cachedHasPeriodicOffsetSelectMode;
  }
  get periodicOffsetSelectMode() {
    if (this._cachedPeriodicOffsetSelectMode === undefined) {
      if (this._value.hasPeriodicOffsetSelectMode) {
        this._cachedPeriodicOffsetSelectMode = this._value.periodicOffsetSelectMode;
      } else {
        this._cachedPeriodicOffsetSelectMode = this._parent ? this._parent.periodicOffsetSelectMode : this._value.periodicOffsetSelectMode;
      }
    }
    return this._cachedPeriodicOffsetSelectMode;
  }
  get selfPeriodicEffectOffsets() {
    if (!this._selfPeriodicEffectOffsets) {
      this._selfPeriodicEffectOffsets = [];
      for (let i of this._value.periodicEffectOffsets) {
        this._selfPeriodicEffectOffsets.push(new EffectOffset.WithParent(i, null));
      }
    }
    return this._selfPeriodicEffectOffsets;
  }
  get inherentPeriodicEffectOffsets() {
    if (!this._inherentPeriodicEffectOffsets) {
      this._inherentPeriodicEffectOffsets = this._parent ? this._parent.periodicEffectOffsets : [];
    }
    return this._inherentPeriodicEffectOffsets;
  }
  get periodicEffectOffsets() {
    if (!this._allPeriodicEffectOffsets) {
      this._allPeriodicEffectOffsets = this._parent ? this._parent.periodicEffectOffsets.concat(this.selfPeriodicEffectOffsets) : this.selfPeriodicEffectOffsets;
    }
    return this._allPeriodicEffectOffsets;
  }
  get selfPeriodicValidators() {
    return this._value.periodicValidators;
  }
  get inherentPeriodicValidators() {
    if (!this._inherentPeriodicValidators) {
      this._inherentPeriodicValidators = this._parent ? this._parent.periodicValidators : [];
    }
    return this._inherentPeriodicValidators;
  }
  get periodicValidators() {
    if (!this._allPeriodicValidators) {
      this._allPeriodicValidators = this._parent ? this._parent.periodicValidators.concat(this.selfPeriodicValidators) : this.selfPeriodicValidators;
    }
    return this._allPeriodicValidators;
  }
  get hasTerminateOnPeriodicEffectSuccess() {
    if (this._cachedHasTerminateOnPeriodicEffectSuccess === undefined) {
      if (this._value.hasTerminateOnPeriodicEffectSuccess) {
        this._cachedHasTerminateOnPeriodicEffectSuccess = true;
      } else {
        this._cachedHasTerminateOnPeriodicEffectSuccess = this._parent ? this._parent.hasTerminateOnPeriodicEffectSuccess : false;
      }
    }
    return this._cachedHasTerminateOnPeriodicEffectSuccess;
  }
  get terminateOnPeriodicEffectSuccess() {
    if (this._cachedTerminateOnPeriodicEffectSuccess === undefined) {
      if (this._value.hasTerminateOnPeriodicEffectSuccess) {
        this._cachedTerminateOnPeriodicEffectSuccess = this._value.terminateOnPeriodicEffectSuccess;
      } else {
        this._cachedTerminateOnPeriodicEffectSuccess = this._parent ? this._parent.terminateOnPeriodicEffectSuccess : this._value.terminateOnPeriodicEffectSuccess;
      }
    }
    return this._cachedTerminateOnPeriodicEffectSuccess;
  }
  get hasTerminateOnPeriodicEffectFailure() {
    if (this._cachedHasTerminateOnPeriodicEffectFailure === undefined) {
      if (this._value.hasTerminateOnPeriodicEffectFailure) {
        this._cachedHasTerminateOnPeriodicEffectFailure = true;
      } else {
        this._cachedHasTerminateOnPeriodicEffectFailure = this._parent ? this._parent.hasTerminateOnPeriodicEffectFailure : false;
      }
    }
    return this._cachedHasTerminateOnPeriodicEffectFailure;
  }
  get terminateOnPeriodicEffectFailure() {
    if (this._cachedTerminateOnPeriodicEffectFailure === undefined) {
      if (this._value.hasTerminateOnPeriodicEffectFailure) {
        this._cachedTerminateOnPeriodicEffectFailure = this._value.terminateOnPeriodicEffectFailure;
      } else {
        this._cachedTerminateOnPeriodicEffectFailure = this._parent ? this._parent.terminateOnPeriodicEffectFailure : this._value.terminateOnPeriodicEffectFailure;
      }
    }
    return this._cachedTerminateOnPeriodicEffectFailure;
  }
  update(current, parent) {
    const result = new EffectPersistent_WithParent(current, parent);
    if (this._cachedStartEffectOffset && this._value.hasStartEffectOffset && current.hasStartEffectOffset) {
      if (this._value.startEffectOffset === current.startEffectOffset && this._parent === parent) {
        result._cachedStartEffectOffset = this._cachedStartEffectOffset;
      } else {
        result._cachedStartEffectOffset = this._cachedStartEffectOffset.update(current.startEffectOffset, parent && parent.hasStartEffectOffset ? parent.startEffectOffset : null);
      }
    }
    if (this._cachedFinalEffectOffset && this._value.hasFinalEffectOffset && current.hasFinalEffectOffset) {
      if (this._value.finalEffectOffset === current.finalEffectOffset && this._parent === parent) {
        result._cachedFinalEffectOffset = this._cachedFinalEffectOffset;
      } else {
        result._cachedFinalEffectOffset = this._cachedFinalEffectOffset.update(current.finalEffectOffset, parent && parent.hasFinalEffectOffset ? parent.finalEffectOffset : null);
      }
    }
    if (this._selfPeriodicEffectOffsets) {
      if (this._value.periodicEffectOffsets === current.periodicEffectOffsets) {
        result._selfPeriodicEffectOffsets = this._selfPeriodicEffectOffsets;
      } else {
        result._selfPeriodicEffectOffsets = [];
        for (let i = 0; i < current.periodicEffectOffsets.length; i++) {
          const oldValue = this._value.periodicEffectOffsets[i];
          if (oldValue) {
            const oldCache = this._selfPeriodicEffectOffsets[i];
            if (oldValue === current.periodicEffectOffsets[i]) {
              result._selfPeriodicEffectOffsets[i] = oldCache;
            } else {
              result._selfPeriodicEffectOffsets[i] = oldCache.update(current.periodicEffectOffsets[i], null);
            }
          } else {
            result._selfPeriodicEffectOffsets[i] = new EffectOffset.WithParent(current.periodicEffectOffsets[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectPersistent_WithParent.default = new EffectPersistent_WithParent(EffectPersistent.default, null);
EffectPersistent.WithParent = EffectPersistent_WithParent;
class EffectPersistent_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "DeprecatedTargetType",
        number: 1,
        protoType: 14,
        protoName: "deprecated_target_type",
        type: EffectTargetType_Type,
        options: {
          comments: "Target to be selected when this effect is associated with an ability and the ability is being casted manually.\nIf set to none, treated as UnitOrLocation",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "DeprecatedDuration",
        number: 1001,
        protoType: 1,
        protoName: "deprecated_duration",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get periodicCount() {
    if (!this._periodicCount) {
      this._periodicCount = {
        name: "periodicCount",
        Name: "PeriodicCount",
        number: 2,
        protoType: 5,
        protoName: "periodic_count",
        type: JsonToInt32,
        options: {
          comments: "The number of periodic effects to create.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicCount;
  }
  get periodicInterval() {
    if (!this._periodicInterval) {
      this._periodicInterval = {
        name: "periodicInterval",
        Name: "DeprecatedPeriodicInterval",
        number: 1002,
        protoType: 1,
        protoName: "deprecated_periodic_interval",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicInterval;
  }
  get periodicEffect() {
    if (!this._periodicEffect) {
      this._periodicEffect = {
        name: "periodicEffect",
        Name: "DeprecatedPeriodicEffect",
        number: 1003,
        protoType: 9,
        protoName: "deprecated_periodic_effect",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffect;
  }
  get startEffect() {
    if (!this._startEffect) {
      this._startEffect = {
        name: "startEffect",
        Name: "StartEffect",
        number: 4,
        protoType: 9,
        protoName: "start_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the persistent is created, before the periodic effects.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startEffect;
  }
  get finalEffect() {
    if (!this._finalEffect) {
      this._finalEffect = {
        name: "finalEffect",
        Name: "FinalEffect",
        number: 5,
        protoType: 9,
        protoName: "final_effect",
        type: JsonToString,
        options: {
          comments: "The effect created when the persistent ends, after the periodic effects.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finalEffect;
  }
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 6,
        protoType: 14,
        protoName: "location",
        type: EffectTarget_Type,
        options: {
          comments: "Determines where the persistent effect is created. - If unit, the persistent effect will move along with the unit and effects created by the persistent will use the unit as the source. If the associated unit is removed, the persistent effect will stay at its last position. - If location, the persistent effect will be created at that location and effects created will use the location as their source. - If unit or location, unit will be selected first if available and if not location will be used.\n",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get offsetStart() {
    if (!this._offsetStart) {
      this._offsetStart = {
        name: "offsetStart",
        Name: "OffsetStart",
        number: 11,
        protoType: 14,
        protoName: "offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset End to determine the facing of this effect. If start & end is at the same point, facing of the source unit is used as a fallback and if source is not an unit, facing of the caster unit is used.\n",
          default: "SOURCE_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetStart;
  }
  get offsetEnd() {
    if (!this._offsetEnd) {
      this._offsetEnd = {
        name: "offsetEnd",
        Name: "OffsetEnd",
        number: 12,
        protoType: 14,
        protoName: "offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If start & end is at the same point, facing of the source unit is used as a fallback and if source is not an unit, facing of the caster unit is used.",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetEnd;
  }
  get startEffectOffset() {
    if (!this._startEffectOffset) {
      this._startEffectOffset = {
        name: "startEffectOffset",
        Name: "StartEffectOffset",
        number: 13,
        protoType: 11,
        protoName: "start_effect_offset",
        type: EffectOffset,
        options: {
          comments: "Offset coordinates for the start effect. Offsets are relative to the effect\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startEffectOffset;
  }
  get finalEffectOffset() {
    if (!this._finalEffectOffset) {
      this._finalEffectOffset = {
        name: "finalEffectOffset",
        Name: "FinalEffectOffset",
        number: 14,
        protoType: 11,
        protoName: "final_effect_offset",
        type: EffectOffset,
        options: {
          comments: "Offset coordinates for the final effect. Offsets are relative to the effect\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finalEffectOffset;
  }
  get worldFacing() {
    if (!this._worldFacing) {
      this._worldFacing = {
        name: "worldFacing",
        Name: "WorldFacing",
        number: 15,
        protoType: 8,
        protoName: "world_facing",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the persistent will ignore Offset Start/End and instead use world grid facing. This is useful for certain game types such as an arcade shooter where projectiles always travel up.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._worldFacing;
  }
  get periodicDurationSelectMode() {
    if (!this._periodicDurationSelectMode) {
      this._periodicDurationSelectMode = {
        name: "periodicDurationSelectMode",
        Name: "PeriodicDurationSelectMode",
        number: 21,
        protoType: 14,
        protoName: "periodic_duration_select_mode",
        type: EffectPersistent_SelectMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicDurationSelectMode;
  }
  get periodicDurations() {
    if (!this._periodicDurations) {
      this._periodicDurations = {
        name: "periodicDurations",
        Name: "PeriodicDurations",
        number: 22,
        protoType: 1,
        protoName: "periodic_durations",
        type: JsonToDouble,
        isRepeated: true,
        options: {
          comments: "The duration of each period.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicDurations;
  }
  get periodicEffectSelectMode() {
    if (!this._periodicEffectSelectMode) {
      this._periodicEffectSelectMode = {
        name: "periodicEffectSelectMode",
        Name: "PeriodicEffectSelectMode",
        number: 23,
        protoType: 14,
        protoName: "periodic_effect_select_mode",
        type: EffectPersistent_SelectMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffectSelectMode;
  }
  get periodicEffects() {
    if (!this._periodicEffects) {
      this._periodicEffects = {
        name: "periodicEffects",
        Name: "PeriodicEffects",
        number: 24,
        protoType: 9,
        protoName: "periodic_effects",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The effects to run at the end of each period.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffects;
  }
  get periodicOffsetSelectMode() {
    if (!this._periodicOffsetSelectMode) {
      this._periodicOffsetSelectMode = {
        name: "periodicOffsetSelectMode",
        Name: "PeriodicOffsetSelectMode",
        number: 25,
        protoType: 14,
        protoName: "periodic_offset_select_mode",
        type: EffectPersistent_SelectMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicOffsetSelectMode;
  }
  get periodicEffectOffsets() {
    if (!this._periodicEffectOffsets) {
      this._periodicEffectOffsets = {
        name: "periodicEffectOffsets",
        Name: "PeriodicEffectOffsets",
        number: 26,
        protoType: 11,
        protoName: "periodic_effect_offsets",
        type: EffectOffset,
        isRepeated: true,
        options: {
          comments: "The offset used to create the periodic effects. Uses the effect\'s facing to determine offset facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicEffectOffsets;
  }
  get periodicValidators() {
    if (!this._periodicValidators) {
      this._periodicValidators = {
        name: "periodicValidators",
        Name: "PeriodicValidators",
        number: 27,
        protoType: 9,
        protoName: "periodic_validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "All validators listed are checked each period and the periodic effect is only executed if all validators succeed.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._periodicValidators;
  }
  get terminateOnPeriodicEffectSuccess() {
    if (!this._terminateOnPeriodicEffectSuccess) {
      this._terminateOnPeriodicEffectSuccess = {
        name: "terminateOnPeriodicEffectSuccess",
        Name: "TerminateOnPeriodicEffectSuccess",
        number: 28,
        protoType: 8,
        protoName: "terminate_on_periodic_effect_success",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the persistent effect will be destroyed the first time the periodic validators succeed. The final effect will be executed when the persistent is terminated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._terminateOnPeriodicEffectSuccess;
  }
  get terminateOnPeriodicEffectFailure() {
    if (!this._terminateOnPeriodicEffectFailure) {
      this._terminateOnPeriodicEffectFailure = {
        name: "terminateOnPeriodicEffectFailure",
        Name: "TerminateOnPeriodicEffectFailure",
        number: 29,
        protoType: 8,
        protoName: "terminate_on_periodic_effect_failure",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the persistent effect will be destroyed the first time the periodic validators fail. The final effect will be executed when the persistent is terminated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._terminateOnPeriodicEffectFailure;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.duration,
        this.periodicCount,
        this.periodicInterval,
        this.periodicEffect,
        this.startEffect,
        this.finalEffect,
        this.location,
        this.offsetStart,
        this.offsetEnd,
        this.startEffectOffset,
        this.finalEffectOffset,
        this.worldFacing,
        this.periodicDurationSelectMode,
        this.periodicDurations,
        this.periodicEffectSelectMode,
        this.periodicEffects,
        this.periodicOffsetSelectMode,
        this.periodicEffectOffsets,
        this.periodicValidators,
        this.terminateOnPeriodicEffectSuccess,
        this.terminateOnPeriodicEffectFailure,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedTargetType",
        Name: "DummyOneofForDeprecatedTargetType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedDuration",
        Name: "DummyOneofForDeprecatedDuration",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicCount",
        Name: "DummyOneofForPeriodicCount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedPeriodicInterval",
        Name: "DummyOneofForDeprecatedPeriodicInterval",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedPeriodicEffect",
        Name: "DummyOneofForDeprecatedPeriodicEffect",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartEffect",
        Name: "DummyOneofForStartEffect",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinalEffect",
        Name: "DummyOneofForFinalEffect",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetStart",
        Name: "DummyOneofForOffsetStart",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetEnd",
        Name: "DummyOneofForOffsetEnd",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartEffectOffset",
        Name: "DummyOneofForStartEffectOffset",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinalEffectOffset",
        Name: "DummyOneofForFinalEffectOffset",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWorldFacing",
        Name: "DummyOneofForWorldFacing",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicDurationSelectMode",
        Name: "DummyOneofForPeriodicDurationSelectMode",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicEffectSelectMode",
        Name: "DummyOneofForPeriodicEffectSelectMode",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeriodicOffsetSelectMode",
        Name: "DummyOneofForPeriodicOffsetSelectMode",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerminateOnPeriodicEffectSuccess",
        Name: "DummyOneofForTerminateOnPeriodicEffectSuccess",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerminateOnPeriodicEffectFailure",
        Name: "DummyOneofForTerminateOnPeriodicEffectFailure",
        fields: [
          this.fields[21],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectPersistent.descriptor = new EffectPersistent_Descriptor();
export class Modifier {
  get descriptor() {
    return Modifier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasScaled = false;
    this._scaled = null;
    this._hasFraction = false;
    this._fraction = null;
    this._hasUnifiedFactor = false;
    this._unifiedFactor = null;
    this._hasUnscaled = false;
    this._unscaled = null;
  }
  isEmpty() {
    if (this._hasScaled) return false;
    if (this._hasFraction) return false;
    if (this._hasUnifiedFactor) return false;
    if (this._hasUnscaled) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Modifier) {
      return value;
    }
    return Modifier.fromJson(value);
  }
  static fromJson(json) {
    const result = new Modifier();
    if (json.scaled != null) {
      result._hasScaled = true;
      result._scaled = JsonToDouble.fromJson(json.scaled);
    }
    if (json.fraction != null) {
      result._hasFraction = true;
      result._fraction = JsonToDouble.fromJson(json.fraction);
    }
    if (json.unifiedFactor != null) {
      result._hasUnifiedFactor = true;
      result._unifiedFactor = JsonToDouble.fromJson(json.unifiedFactor);
    }
    if (json.unscaled != null) {
      result._hasUnscaled = true;
      result._unscaled = JsonToDouble.fromJson(json.unscaled);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasScaled) {
      result.scaled = JsonToDouble.toJson(this._scaled);
    }
    if (this._hasFraction) {
      result.fraction = JsonToDouble.toJson(this._fraction);
    }
    if (this._hasUnifiedFactor) {
      result.unifiedFactor = JsonToDouble.toJson(this._unifiedFactor);
    }
    if (this._hasUnscaled) {
      result.unscaled = JsonToDouble.toJson(this._unscaled);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get scaled() {
    return this._hasScaled ? this._scaled : JsonToDouble.default;
  }
  get hasScaled() {
    return this._hasScaled;
  }
  setScaled(path, value) {
    return {type: 'SET', path: path.concat(['scaled']), value};
  }
  deleteScaled(path) {
    return {type: 'DELETE', path: path.concat(['scaled'])};
  }
  /**
   * @returns {number}
   */
  get fraction() {
    return this._hasFraction ? this._fraction : JsonToDouble.default;
  }
  get hasFraction() {
    return this._hasFraction;
  }
  setFraction(path, value) {
    return {type: 'SET', path: path.concat(['fraction']), value};
  }
  deleteFraction(path) {
    return {type: 'DELETE', path: path.concat(['fraction'])};
  }
  /**
   * @returns {number}
   */
  get unifiedFactor() {
    return this._hasUnifiedFactor ? this._unifiedFactor : JsonToDouble.default;
  }
  get hasUnifiedFactor() {
    return this._hasUnifiedFactor;
  }
  setUnifiedFactor(path, value) {
    return {type: 'SET', path: path.concat(['unifiedFactor']), value};
  }
  deleteUnifiedFactor(path) {
    return {type: 'DELETE', path: path.concat(['unifiedFactor'])};
  }
  /**
   * @returns {number}
   */
  get unscaled() {
    return this._hasUnscaled ? this._unscaled : JsonToDouble.default;
  }
  get hasUnscaled() {
    return this._hasUnscaled;
  }
  setUnscaled(path, value) {
    return {type: 'SET', path: path.concat(['unscaled']), value};
  }
  deleteUnscaled(path) {
    return {type: 'DELETE', path: path.concat(['unscaled'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "scaled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modifier(this);
              copy._hasScaled = true;
              copy._scaled = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScaled) {
                return this;
              }
              const copy = new Modifier(this);
              copy._hasScaled = false;
              copy._scaled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fraction": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modifier(this);
              copy._hasFraction = true;
              copy._fraction = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFraction) {
                return this;
              }
              const copy = new Modifier(this);
              copy._hasFraction = false;
              copy._fraction = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unifiedFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modifier(this);
              copy._hasUnifiedFactor = true;
              copy._unifiedFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnifiedFactor) {
                return this;
              }
              const copy = new Modifier(this);
              copy._hasUnifiedFactor = false;
              copy._unifiedFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unscaled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modifier(this);
              copy._hasUnscaled = true;
              copy._unscaled = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnscaled) {
                return this;
              }
              const copy = new Modifier(this);
              copy._hasUnscaled = false;
              copy._unscaled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Modifier} other
   * @returns {Modifier}
   */
  merge(other) {
    const copy = new Modifier(this);
    if (other._hasScaled) {
      copy._hasScaled = true;
      copy._scaled = other._scaled;
    }
    if (other._hasFraction) {
      copy._hasFraction = true;
      copy._fraction = other._fraction;
    }
    if (other._hasUnifiedFactor) {
      copy._hasUnifiedFactor = true;
      copy._unifiedFactor = other._unifiedFactor;
    }
    if (other._hasUnscaled) {
      copy._hasUnscaled = true;
      copy._unscaled = other._unscaled;
    }
    return copy;
  }
}
Modifier.default = new Modifier();
class Modifier_Builder {
  constructor(value) {
    this._value = new Modifier(value);
  }
  build() {
    return new Modifier(this._value);
  }
  setScaled(value) {
    this._value._hasScaled = true;
    this._value._scaled = value;
    return this;
  }
  deleteScaled() {
    this._value._hasScaled = false;
    this._value._scaled = null;
    return this;
  }
  setFraction(value) {
    this._value._hasFraction = true;
    this._value._fraction = value;
    return this;
  }
  deleteFraction() {
    this._value._hasFraction = false;
    this._value._fraction = null;
    return this;
  }
  setUnifiedFactor(value) {
    this._value._hasUnifiedFactor = true;
    this._value._unifiedFactor = value;
    return this;
  }
  deleteUnifiedFactor() {
    this._value._hasUnifiedFactor = false;
    this._value._unifiedFactor = null;
    return this;
  }
  setUnscaled(value) {
    this._value._hasUnscaled = true;
    this._value._unscaled = value;
    return this;
  }
  deleteUnscaled() {
    this._value._hasUnscaled = false;
    this._value._unscaled = null;
    return this;
  }
}
Modifier.Builder = Modifier_Builder;
class Modifier_WithParent {
  /**
   * @param {Modifier} value
   * @param {Modifier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Modifier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasScaled() {
    if (this._cachedHasScaled === undefined) {
      if (this._value.hasScaled) {
        this._cachedHasScaled = true;
      } else {
        this._cachedHasScaled = this._parent ? this._parent.hasScaled : false;
      }
    }
    return this._cachedHasScaled;
  }
  get scaled() {
    if (this._cachedScaled === undefined) {
      if (this._value.hasScaled) {
        this._cachedScaled = this._value.scaled;
      } else {
        this._cachedScaled = this._parent ? this._parent.scaled : this._value.scaled;
      }
    }
    return this._cachedScaled;
  }
  get hasFraction() {
    if (this._cachedHasFraction === undefined) {
      if (this._value.hasFraction) {
        this._cachedHasFraction = true;
      } else {
        this._cachedHasFraction = this._parent ? this._parent.hasFraction : false;
      }
    }
    return this._cachedHasFraction;
  }
  get fraction() {
    if (this._cachedFraction === undefined) {
      if (this._value.hasFraction) {
        this._cachedFraction = this._value.fraction;
      } else {
        this._cachedFraction = this._parent ? this._parent.fraction : this._value.fraction;
      }
    }
    return this._cachedFraction;
  }
  get hasUnifiedFactor() {
    if (this._cachedHasUnifiedFactor === undefined) {
      if (this._value.hasUnifiedFactor) {
        this._cachedHasUnifiedFactor = true;
      } else {
        this._cachedHasUnifiedFactor = this._parent ? this._parent.hasUnifiedFactor : false;
      }
    }
    return this._cachedHasUnifiedFactor;
  }
  get unifiedFactor() {
    if (this._cachedUnifiedFactor === undefined) {
      if (this._value.hasUnifiedFactor) {
        this._cachedUnifiedFactor = this._value.unifiedFactor;
      } else {
        this._cachedUnifiedFactor = this._parent ? this._parent.unifiedFactor : this._value.unifiedFactor;
      }
    }
    return this._cachedUnifiedFactor;
  }
  get hasUnscaled() {
    if (this._cachedHasUnscaled === undefined) {
      if (this._value.hasUnscaled) {
        this._cachedHasUnscaled = true;
      } else {
        this._cachedHasUnscaled = this._parent ? this._parent.hasUnscaled : false;
      }
    }
    return this._cachedHasUnscaled;
  }
  get unscaled() {
    if (this._cachedUnscaled === undefined) {
      if (this._value.hasUnscaled) {
        this._cachedUnscaled = this._value.unscaled;
      } else {
        this._cachedUnscaled = this._parent ? this._parent.unscaled : this._value.unscaled;
      }
    }
    return this._cachedUnscaled;
  }
  update(current, parent) {
    const result = new Modifier_WithParent(current, parent);
    return result;
  }
}
Modifier_WithParent.default = new Modifier_WithParent(Modifier.default, null);
Modifier.WithParent = Modifier_WithParent;
class Modifier_Descriptor {
  get scaled() {
    if (!this._scaled) {
      this._scaled = {
        name: "scaled",
        Name: "Scaled",
        number: 1,
        protoType: 1,
        protoName: "scaled",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scaled;
  }
  get fraction() {
    if (!this._fraction) {
      this._fraction = {
        name: "fraction",
        Name: "Fraction",
        number: 2,
        protoType: 1,
        protoName: "fraction",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fraction;
  }
  get unifiedFactor() {
    if (!this._unifiedFactor) {
      this._unifiedFactor = {
        name: "unifiedFactor",
        Name: "UnifiedFactor",
        number: 3,
        protoType: 1,
        protoName: "unified_factor",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unifiedFactor;
  }
  get unscaled() {
    if (!this._unscaled) {
      this._unscaled = {
        name: "unscaled",
        Name: "Unscaled",
        number: 4,
        protoType: 1,
        protoName: "unscaled",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unscaled;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.scaled,
        this.fraction,
        this.unifiedFactor,
        this.unscaled,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForScaled",
        Name: "DummyOneofForScaled",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFraction",
        Name: "DummyOneofForFraction",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnifiedFactor",
        Name: "DummyOneofForUnifiedFactor",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnscaled",
        Name: "DummyOneofForUnscaled",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
Modifier.descriptor = new Modifier_Descriptor();
export class PassiveModifications {
  get descriptor() {
    return PassiveModifications.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHealthModifier = false;
    this._healthModifier = null;
    this._hasManaModifier = false;
    this._manaModifier = null;
    this._hasSpeedModifier = false;
    this._speedModifier = null;
    this._hasDamageModifier = false;
    this._damageModifier = null;
    this._hasDamageTakenModifier = false;
    this._damageTakenModifier = null;
  }
  isEmpty() {
    if (this._hasHealthModifier && !this._healthModifier.isEmpty()) return false;
    if (this._hasManaModifier && !this._manaModifier.isEmpty()) return false;
    if (this._hasSpeedModifier && !this._speedModifier.isEmpty()) return false;
    if (this._hasDamageModifier && !this._damageModifier.isEmpty()) return false;
    if (this._hasDamageTakenModifier && !this._damageTakenModifier.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PassiveModifications) {
      return value;
    }
    return PassiveModifications.fromJson(value);
  }
  static fromJson(json) {
    const result = new PassiveModifications();
    if (json.healthModifier != null) {
      result._hasHealthModifier = true;
      result._healthModifier = Modifier.fromJson(json.healthModifier);
    }
    if (json.manaModifier != null) {
      result._hasManaModifier = true;
      result._manaModifier = Modifier.fromJson(json.manaModifier);
    }
    if (json.speedModifier != null) {
      result._hasSpeedModifier = true;
      result._speedModifier = Modifier.fromJson(json.speedModifier);
    }
    if (json.damageModifier != null) {
      result._hasDamageModifier = true;
      result._damageModifier = Modifier.fromJson(json.damageModifier);
    }
    if (json.damageTakenModifier != null) {
      result._hasDamageTakenModifier = true;
      result._damageTakenModifier = Modifier.fromJson(json.damageTakenModifier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHealthModifier && !this._healthModifier.isEmpty()) {
      result.healthModifier = Modifier.toJson(this._healthModifier);
    }
    if (this._hasManaModifier && !this._manaModifier.isEmpty()) {
      result.manaModifier = Modifier.toJson(this._manaModifier);
    }
    if (this._hasSpeedModifier && !this._speedModifier.isEmpty()) {
      result.speedModifier = Modifier.toJson(this._speedModifier);
    }
    if (this._hasDamageModifier && !this._damageModifier.isEmpty()) {
      result.damageModifier = Modifier.toJson(this._damageModifier);
    }
    if (this._hasDamageTakenModifier && !this._damageTakenModifier.isEmpty()) {
      result.damageTakenModifier = Modifier.toJson(this._damageTakenModifier);
    }
    return result;
  }
  /**
   * @returns {Modifier}
   */
  get healthModifier() {
    return this._hasHealthModifier ? this._healthModifier : Modifier.default;
  }
  get hasHealthModifier() {
    return this._hasHealthModifier;
  }
  setHealthModifier(path, value) {
    return {type: 'SET', path: path.concat(['healthModifier']), value: value.toJson()};
  }
  deleteHealthModifier(path) {
    return {type: 'DELETE', path: path.concat(['healthModifier'])};
  }
  /**
   * @returns {Modifier}
   */
  get manaModifier() {
    return this._hasManaModifier ? this._manaModifier : Modifier.default;
  }
  get hasManaModifier() {
    return this._hasManaModifier;
  }
  setManaModifier(path, value) {
    return {type: 'SET', path: path.concat(['manaModifier']), value: value.toJson()};
  }
  deleteManaModifier(path) {
    return {type: 'DELETE', path: path.concat(['manaModifier'])};
  }
  /**
   * @returns {Modifier}
   */
  get speedModifier() {
    return this._hasSpeedModifier ? this._speedModifier : Modifier.default;
  }
  get hasSpeedModifier() {
    return this._hasSpeedModifier;
  }
  setSpeedModifier(path, value) {
    return {type: 'SET', path: path.concat(['speedModifier']), value: value.toJson()};
  }
  deleteSpeedModifier(path) {
    return {type: 'DELETE', path: path.concat(['speedModifier'])};
  }
  /**
   * @returns {Modifier}
   */
  get damageModifier() {
    return this._hasDamageModifier ? this._damageModifier : Modifier.default;
  }
  get hasDamageModifier() {
    return this._hasDamageModifier;
  }
  setDamageModifier(path, value) {
    return {type: 'SET', path: path.concat(['damageModifier']), value: value.toJson()};
  }
  deleteDamageModifier(path) {
    return {type: 'DELETE', path: path.concat(['damageModifier'])};
  }
  /**
   * @returns {Modifier}
   */
  get damageTakenModifier() {
    return this._hasDamageTakenModifier ? this._damageTakenModifier : Modifier.default;
  }
  get hasDamageTakenModifier() {
    return this._hasDamageTakenModifier;
  }
  setDamageTakenModifier(path, value) {
    return {type: 'SET', path: path.concat(['damageTakenModifier']), value: value.toJson()};
  }
  deleteDamageTakenModifier(path) {
    return {type: 'DELETE', path: path.concat(['damageTakenModifier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "healthModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PassiveModifications(this);
              copy._hasHealthModifier = true;
              copy._healthModifier = Modifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealthModifier) {
                return this;
              }
              const copy = new PassiveModifications(this);
              copy._hasHealthModifier = false;
              copy._healthModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealthModifier) {
            const copy = new PassiveModifications(this);
            copy._hasHealthModifier = true;
            copy._healthModifier = Modifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healthModifier.apply(type, path.slice(1), value);
          if (newValue === this._healthModifier) {
            return this;
          }
          const copy = new PassiveModifications(this);
          copy._healthModifier = copy._healthModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "manaModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PassiveModifications(this);
              copy._hasManaModifier = true;
              copy._manaModifier = Modifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasManaModifier) {
                return this;
              }
              const copy = new PassiveModifications(this);
              copy._hasManaModifier = false;
              copy._manaModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasManaModifier) {
            const copy = new PassiveModifications(this);
            copy._hasManaModifier = true;
            copy._manaModifier = Modifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._manaModifier.apply(type, path.slice(1), value);
          if (newValue === this._manaModifier) {
            return this;
          }
          const copy = new PassiveModifications(this);
          copy._manaModifier = copy._manaModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "speedModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PassiveModifications(this);
              copy._hasSpeedModifier = true;
              copy._speedModifier = Modifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeedModifier) {
                return this;
              }
              const copy = new PassiveModifications(this);
              copy._hasSpeedModifier = false;
              copy._speedModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSpeedModifier) {
            const copy = new PassiveModifications(this);
            copy._hasSpeedModifier = true;
            copy._speedModifier = Modifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._speedModifier.apply(type, path.slice(1), value);
          if (newValue === this._speedModifier) {
            return this;
          }
          const copy = new PassiveModifications(this);
          copy._speedModifier = copy._speedModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "damageModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PassiveModifications(this);
              copy._hasDamageModifier = true;
              copy._damageModifier = Modifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageModifier) {
                return this;
              }
              const copy = new PassiveModifications(this);
              copy._hasDamageModifier = false;
              copy._damageModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDamageModifier) {
            const copy = new PassiveModifications(this);
            copy._hasDamageModifier = true;
            copy._damageModifier = Modifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._damageModifier.apply(type, path.slice(1), value);
          if (newValue === this._damageModifier) {
            return this;
          }
          const copy = new PassiveModifications(this);
          copy._damageModifier = copy._damageModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "damageTakenModifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PassiveModifications(this);
              copy._hasDamageTakenModifier = true;
              copy._damageTakenModifier = Modifier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamageTakenModifier) {
                return this;
              }
              const copy = new PassiveModifications(this);
              copy._hasDamageTakenModifier = false;
              copy._damageTakenModifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDamageTakenModifier) {
            const copy = new PassiveModifications(this);
            copy._hasDamageTakenModifier = true;
            copy._damageTakenModifier = Modifier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._damageTakenModifier.apply(type, path.slice(1), value);
          if (newValue === this._damageTakenModifier) {
            return this;
          }
          const copy = new PassiveModifications(this);
          copy._damageTakenModifier = copy._damageTakenModifier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PassiveModifications} other
   * @returns {PassiveModifications}
   */
  merge(other) {
    const copy = new PassiveModifications(this);
    if (other._hasHealthModifier) {
      if (copy._hasHealthModifier) {
        copy._healthModifier = copy.healthModifier.merge(other.healthModifier);
      } else {
        copy._healthModifier = other._healthModifier;
      }
      copy._hasHealthModifier = true;
    }
    if (other._hasManaModifier) {
      if (copy._hasManaModifier) {
        copy._manaModifier = copy.manaModifier.merge(other.manaModifier);
      } else {
        copy._manaModifier = other._manaModifier;
      }
      copy._hasManaModifier = true;
    }
    if (other._hasSpeedModifier) {
      if (copy._hasSpeedModifier) {
        copy._speedModifier = copy.speedModifier.merge(other.speedModifier);
      } else {
        copy._speedModifier = other._speedModifier;
      }
      copy._hasSpeedModifier = true;
    }
    if (other._hasDamageModifier) {
      if (copy._hasDamageModifier) {
        copy._damageModifier = copy.damageModifier.merge(other.damageModifier);
      } else {
        copy._damageModifier = other._damageModifier;
      }
      copy._hasDamageModifier = true;
    }
    if (other._hasDamageTakenModifier) {
      if (copy._hasDamageTakenModifier) {
        copy._damageTakenModifier = copy.damageTakenModifier.merge(other.damageTakenModifier);
      } else {
        copy._damageTakenModifier = other._damageTakenModifier;
      }
      copy._hasDamageTakenModifier = true;
    }
    return copy;
  }
}
PassiveModifications.default = new PassiveModifications();
class PassiveModifications_Builder {
  constructor(value) {
    this._value = new PassiveModifications(value);
  }
  build() {
    return new PassiveModifications(this._value);
  }
  setHealthModifier(value) {
    this._value._hasHealthModifier = true;
    this._value._healthModifier = value;
    return this;
  }
  deleteHealthModifier() {
    this._value._hasHealthModifier = false;
    this._value._healthModifier = null;
    return this;
  }
  setManaModifier(value) {
    this._value._hasManaModifier = true;
    this._value._manaModifier = value;
    return this;
  }
  deleteManaModifier() {
    this._value._hasManaModifier = false;
    this._value._manaModifier = null;
    return this;
  }
  setSpeedModifier(value) {
    this._value._hasSpeedModifier = true;
    this._value._speedModifier = value;
    return this;
  }
  deleteSpeedModifier() {
    this._value._hasSpeedModifier = false;
    this._value._speedModifier = null;
    return this;
  }
  setDamageModifier(value) {
    this._value._hasDamageModifier = true;
    this._value._damageModifier = value;
    return this;
  }
  deleteDamageModifier() {
    this._value._hasDamageModifier = false;
    this._value._damageModifier = null;
    return this;
  }
  setDamageTakenModifier(value) {
    this._value._hasDamageTakenModifier = true;
    this._value._damageTakenModifier = value;
    return this;
  }
  deleteDamageTakenModifier() {
    this._value._hasDamageTakenModifier = false;
    this._value._damageTakenModifier = null;
    return this;
  }
}
PassiveModifications.Builder = PassiveModifications_Builder;
class PassiveModifications_WithParent {
  /**
   * @param {PassiveModifications} value
   * @param {PassiveModifications_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PassiveModifications.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHealthModifier() {
    if (this._cachedHasHealthModifier === undefined) {
      if (this._value.hasHealthModifier) {
        this._cachedHasHealthModifier = true;
      } else {
        this._cachedHasHealthModifier = this._parent ? this._parent.hasHealthModifier : false;
      }
    }
    return this._cachedHasHealthModifier;
  }
  get healthModifier() {
    if (!this._cachedHealthModifier) {
      if (this._value.hasHealthModifier) {
        this._cachedHealthModifier = new Modifier.WithParent(this._value.healthModifier, this._parent && this._parent.hasHealthModifier ? this._parent.healthModifier : null);
      } else {
        this._cachedHealthModifier = this._parent ? new Modifier.WithParent(Modifier.default, this._parent.healthModifier) : Modifier.WithParent.default;
      }
    }
    return this._cachedHealthModifier;
  }
  get hasManaModifier() {
    if (this._cachedHasManaModifier === undefined) {
      if (this._value.hasManaModifier) {
        this._cachedHasManaModifier = true;
      } else {
        this._cachedHasManaModifier = this._parent ? this._parent.hasManaModifier : false;
      }
    }
    return this._cachedHasManaModifier;
  }
  get manaModifier() {
    if (!this._cachedManaModifier) {
      if (this._value.hasManaModifier) {
        this._cachedManaModifier = new Modifier.WithParent(this._value.manaModifier, this._parent && this._parent.hasManaModifier ? this._parent.manaModifier : null);
      } else {
        this._cachedManaModifier = this._parent ? new Modifier.WithParent(Modifier.default, this._parent.manaModifier) : Modifier.WithParent.default;
      }
    }
    return this._cachedManaModifier;
  }
  get hasSpeedModifier() {
    if (this._cachedHasSpeedModifier === undefined) {
      if (this._value.hasSpeedModifier) {
        this._cachedHasSpeedModifier = true;
      } else {
        this._cachedHasSpeedModifier = this._parent ? this._parent.hasSpeedModifier : false;
      }
    }
    return this._cachedHasSpeedModifier;
  }
  get speedModifier() {
    if (!this._cachedSpeedModifier) {
      if (this._value.hasSpeedModifier) {
        this._cachedSpeedModifier = new Modifier.WithParent(this._value.speedModifier, this._parent && this._parent.hasSpeedModifier ? this._parent.speedModifier : null);
      } else {
        this._cachedSpeedModifier = this._parent ? new Modifier.WithParent(Modifier.default, this._parent.speedModifier) : Modifier.WithParent.default;
      }
    }
    return this._cachedSpeedModifier;
  }
  get hasDamageModifier() {
    if (this._cachedHasDamageModifier === undefined) {
      if (this._value.hasDamageModifier) {
        this._cachedHasDamageModifier = true;
      } else {
        this._cachedHasDamageModifier = this._parent ? this._parent.hasDamageModifier : false;
      }
    }
    return this._cachedHasDamageModifier;
  }
  get damageModifier() {
    if (!this._cachedDamageModifier) {
      if (this._value.hasDamageModifier) {
        this._cachedDamageModifier = new Modifier.WithParent(this._value.damageModifier, this._parent && this._parent.hasDamageModifier ? this._parent.damageModifier : null);
      } else {
        this._cachedDamageModifier = this._parent ? new Modifier.WithParent(Modifier.default, this._parent.damageModifier) : Modifier.WithParent.default;
      }
    }
    return this._cachedDamageModifier;
  }
  get hasDamageTakenModifier() {
    if (this._cachedHasDamageTakenModifier === undefined) {
      if (this._value.hasDamageTakenModifier) {
        this._cachedHasDamageTakenModifier = true;
      } else {
        this._cachedHasDamageTakenModifier = this._parent ? this._parent.hasDamageTakenModifier : false;
      }
    }
    return this._cachedHasDamageTakenModifier;
  }
  get damageTakenModifier() {
    if (!this._cachedDamageTakenModifier) {
      if (this._value.hasDamageTakenModifier) {
        this._cachedDamageTakenModifier = new Modifier.WithParent(this._value.damageTakenModifier, this._parent && this._parent.hasDamageTakenModifier ? this._parent.damageTakenModifier : null);
      } else {
        this._cachedDamageTakenModifier = this._parent ? new Modifier.WithParent(Modifier.default, this._parent.damageTakenModifier) : Modifier.WithParent.default;
      }
    }
    return this._cachedDamageTakenModifier;
  }
  update(current, parent) {
    const result = new PassiveModifications_WithParent(current, parent);
    if (this._cachedHealthModifier && this._value.hasHealthModifier && current.hasHealthModifier) {
      if (this._value.healthModifier === current.healthModifier && this._parent === parent) {
        result._cachedHealthModifier = this._cachedHealthModifier;
      } else {
        result._cachedHealthModifier = this._cachedHealthModifier.update(current.healthModifier, parent && parent.hasHealthModifier ? parent.healthModifier : null);
      }
    }
    if (this._cachedManaModifier && this._value.hasManaModifier && current.hasManaModifier) {
      if (this._value.manaModifier === current.manaModifier && this._parent === parent) {
        result._cachedManaModifier = this._cachedManaModifier;
      } else {
        result._cachedManaModifier = this._cachedManaModifier.update(current.manaModifier, parent && parent.hasManaModifier ? parent.manaModifier : null);
      }
    }
    if (this._cachedSpeedModifier && this._value.hasSpeedModifier && current.hasSpeedModifier) {
      if (this._value.speedModifier === current.speedModifier && this._parent === parent) {
        result._cachedSpeedModifier = this._cachedSpeedModifier;
      } else {
        result._cachedSpeedModifier = this._cachedSpeedModifier.update(current.speedModifier, parent && parent.hasSpeedModifier ? parent.speedModifier : null);
      }
    }
    if (this._cachedDamageModifier && this._value.hasDamageModifier && current.hasDamageModifier) {
      if (this._value.damageModifier === current.damageModifier && this._parent === parent) {
        result._cachedDamageModifier = this._cachedDamageModifier;
      } else {
        result._cachedDamageModifier = this._cachedDamageModifier.update(current.damageModifier, parent && parent.hasDamageModifier ? parent.damageModifier : null);
      }
    }
    if (this._cachedDamageTakenModifier && this._value.hasDamageTakenModifier && current.hasDamageTakenModifier) {
      if (this._value.damageTakenModifier === current.damageTakenModifier && this._parent === parent) {
        result._cachedDamageTakenModifier = this._cachedDamageTakenModifier;
      } else {
        result._cachedDamageTakenModifier = this._cachedDamageTakenModifier.update(current.damageTakenModifier, parent && parent.hasDamageTakenModifier ? parent.damageTakenModifier : null);
      }
    }
    return result;
  }
}
PassiveModifications_WithParent.default = new PassiveModifications_WithParent(PassiveModifications.default, null);
PassiveModifications.WithParent = PassiveModifications_WithParent;
class PassiveModifications_Descriptor {
  get healthModifier() {
    if (!this._healthModifier) {
      this._healthModifier = {
        name: "healthModifier",
        Name: "HealthModifier",
        number: 1,
        protoType: 11,
        protoName: "health_modifier",
        type: Modifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthModifier;
  }
  get manaModifier() {
    if (!this._manaModifier) {
      this._manaModifier = {
        name: "manaModifier",
        Name: "ManaModifier",
        number: 2,
        protoType: 11,
        protoName: "mana_modifier",
        type: Modifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._manaModifier;
  }
  get speedModifier() {
    if (!this._speedModifier) {
      this._speedModifier = {
        name: "speedModifier",
        Name: "SpeedModifier",
        number: 3,
        protoType: 11,
        protoName: "speed_modifier",
        type: Modifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedModifier;
  }
  get damageModifier() {
    if (!this._damageModifier) {
      this._damageModifier = {
        name: "damageModifier",
        Name: "DamageModifier",
        number: 4,
        protoType: 11,
        protoName: "damage_modifier",
        type: Modifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageModifier;
  }
  get damageTakenModifier() {
    if (!this._damageTakenModifier) {
      this._damageTakenModifier = {
        name: "damageTakenModifier",
        Name: "DamageTakenModifier",
        number: 5,
        protoType: 11,
        protoName: "damage_taken_modifier",
        type: Modifier,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageTakenModifier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.healthModifier,
        this.manaModifier,
        this.speedModifier,
        this.damageModifier,
        this.damageTakenModifier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHealthModifier",
        Name: "DummyOneofForHealthModifier",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForManaModifier",
        Name: "DummyOneofForManaModifier",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeedModifier",
        Name: "DummyOneofForSpeedModifier",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageModifier",
        Name: "DummyOneofForDamageModifier",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamageTakenModifier",
        Name: "DummyOneofForDamageTakenModifier",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
PassiveModifications.descriptor = new PassiveModifications_Descriptor();
export class EffectKill {
  get descriptor() {
    return EffectKill.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectKill) {
      return value;
    }
    return EffectKill.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectKill();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {EffectKill} other
   * @returns {EffectKill}
   */
  merge(other) {
    const copy = new EffectKill(this);
    return copy;
  }
}
EffectKill.default = new EffectKill();
class EffectKill_Builder {
  constructor(value) {
    this._value = new EffectKill(value);
  }
  build() {
    return new EffectKill(this._value);
  }
}
EffectKill.Builder = EffectKill_Builder;
class EffectKill_WithParent {
  /**
   * @param {EffectKill} value
   * @param {EffectKill_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectKill.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new EffectKill_WithParent(current, parent);
    return result;
  }
}
EffectKill_WithParent.default = new EffectKill_WithParent(EffectKill.default, null);
EffectKill.WithParent = EffectKill_WithParent;
class EffectKill_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectKill.descriptor = new EffectKill_Descriptor();
export class EffectSpawn {
  get descriptor() {
    return EffectSpawn.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasCount = false;
    this._count = null;
    this._hasOwner = false;
    this._owner = null;
    this._hasOwnerId = false;
    this._ownerPlayId = null;
    this._hasLocation = false;
    this._location = null;
    this._hasOffsetStart = false;
    this._offsetStart = null;
    this._hasOffsetEnd = false;
    this._offsetEnd = null;
    this._hasOffset = false;
    this._offset = null;
    this._hasEffect = false;
    this._effect = null;
    this._hasSpawnOnNavmesh = false;
    this._spawnOnNavmesh = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasCount) return false;
    if (this._hasOwner) return false;
    if (this._hasOwnerId) return false;
    if (this._hasLocation) return false;
    if (this._hasOffsetStart) return false;
    if (this._hasOffsetEnd) return false;
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    if (this._hasEffect) return false;
    if (this._hasSpawnOnNavmesh) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSpawn) {
      return value;
    }
    return EffectSpawn.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSpawn();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = JsonToString.fromJson(json.unit);
    }
    if (json.count != null) {
      result._hasCount = true;
      result._count = JsonToInt32.fromJson(json.count);
    }
    if (json.owner != null) {
      result._hasOwner = true;
      result._owner = EffectUnitTarget_Type.fromJson(json.owner);
    }
    if (json.ownerPlayId != null) {
      result._hasOwnerId = true;
      result._ownerPlayId = JsonToInt32.fromJson(json.ownerPlayId);
    }
    if (json.location != null) {
      result._hasLocation = true;
      result._location = EffectTarget_Type.fromJson(json.location);
    }
    if (json.offsetStart != null) {
      result._hasOffsetStart = true;
      result._offsetStart = EffectTarget_Type.fromJson(json.offsetStart);
    }
    if (json.offsetEnd != null) {
      result._hasOffsetEnd = true;
      result._offsetEnd = EffectTarget_Type.fromJson(json.offsetEnd);
    }
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = EffectOffset.fromJson(json.offset);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.spawnOnNavmesh != null) {
      result._hasSpawnOnNavmesh = true;
      result._spawnOnNavmesh = JsonToBoolean.fromJson(json.spawnOnNavmesh);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = JsonToString.toJson(this._unit);
    }
    if (this._hasCount) {
      result.count = JsonToInt32.toJson(this._count);
    }
    if (this._hasOwner) {
      result.owner = EffectUnitTarget_Type.toJson(this._owner);
    }
    if (this._hasOwnerId) {
      result.ownerPlayId = JsonToInt32.toJson(this._ownerPlayId);
    }
    if (this._hasLocation) {
      result.location = EffectTarget_Type.toJson(this._location);
    }
    if (this._hasOffsetStart) {
      result.offsetStart = EffectTarget_Type.toJson(this._offsetStart);
    }
    if (this._hasOffsetEnd) {
      result.offsetEnd = EffectTarget_Type.toJson(this._offsetEnd);
    }
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = EffectOffset.toJson(this._offset);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasSpawnOnNavmesh) {
      result.spawnOnNavmesh = JsonToBoolean.toJson(this._spawnOnNavmesh);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unit() {
    return this._hasUnit ? this._unit : JsonToString.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {number}
   */
  get count() {
    return this._hasCount ? this._count : JsonToInt32.default;
  }
  get hasCount() {
    return this._hasCount;
  }
  setCount(path, value) {
    return {type: 'SET', path: path.concat(['count']), value};
  }
  deleteCount(path) {
    return {type: 'DELETE', path: path.concat(['count'])};
  }
  /**
   * @returns {number}
   */
  get owner() {
    return this._hasOwner ? this._owner : EffectUnitTarget_Type.default;
  }
  get hasOwner() {
    return this._hasOwner;
  }
  setOwner(path, value) {
    return {type: 'SET', path: path.concat(['owner']), value};
  }
  deleteOwner(path) {
    return {type: 'DELETE', path: path.concat(['owner'])};
  }
  /**
   * @returns {number}
   */
  get ownerPlayId() {
    return this._hasOwnerId ? this._ownerPlayId : JsonToInt32.default;
  }
  get hasOwnerId() {
    return this._hasOwnerId;
  }
  setOwnerId(path, value) {
    return {type: 'SET', path: path.concat(['ownerPlayId']), value};
  }
  deleteOwnerId(path) {
    return {type: 'DELETE', path: path.concat(['ownerPlayId'])};
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : EffectTarget_Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  /**
   * @returns {number}
   */
  get offsetStart() {
    return this._hasOffsetStart ? this._offsetStart : EffectTarget_Type.default;
  }
  get hasOffsetStart() {
    return this._hasOffsetStart;
  }
  setOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['offsetStart']), value};
  }
  deleteOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['offsetStart'])};
  }
  /**
   * @returns {number}
   */
  get offsetEnd() {
    return this._hasOffsetEnd ? this._offsetEnd : EffectTarget_Type.default;
  }
  get hasOffsetEnd() {
    return this._hasOffsetEnd;
  }
  setOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['offsetEnd']), value};
  }
  deleteOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['offsetEnd'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get offset() {
    return this._hasOffset ? this._offset : EffectOffset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {boolean}
   */
  get spawnOnNavmesh() {
    return this._hasSpawnOnNavmesh ? this._spawnOnNavmesh : JsonToBoolean.default;
  }
  get hasSpawnOnNavmesh() {
    return this._hasSpawnOnNavmesh;
  }
  setSpawnOnNavmesh(path, value) {
    return {type: 'SET', path: path.concat(['spawnOnNavmesh']), value};
  }
  deleteSpawnOnNavmesh(path) {
    return {type: 'DELETE', path: path.concat(['spawnOnNavmesh'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasUnit = true;
              copy._unit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "count": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasCount = true;
              copy._count = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCount) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasCount = false;
              copy._count = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "owner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasOwner = true;
              copy._owner = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOwner) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasOwner = false;
              copy._owner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ownerPlayId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasOwnerId = true;
              copy._ownerPlayId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOwnerId) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasOwnerId = false;
              copy._ownerPlayId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasLocation = true;
              copy._location = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasOffsetStart = true;
              copy._offsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetStart) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasOffsetStart = false;
              copy._offsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasOffsetEnd = true;
              copy._offsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetEnd) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasOffsetEnd = false;
              copy._offsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasOffset = true;
              copy._offset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new EffectSpawn(this);
            copy._hasOffset = true;
            copy._offset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new EffectSpawn(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spawnOnNavmesh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawn(this);
              copy._hasSpawnOnNavmesh = true;
              copy._spawnOnNavmesh = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpawnOnNavmesh) {
                return this;
              }
              const copy = new EffectSpawn(this);
              copy._hasSpawnOnNavmesh = false;
              copy._spawnOnNavmesh = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSpawn} other
   * @returns {EffectSpawn}
   */
  merge(other) {
    const copy = new EffectSpawn(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasCount) {
      copy._hasCount = true;
      copy._count = other._count;
    }
    if (other._hasOwner) {
      copy._hasOwner = true;
      copy._owner = other._owner;
    }
    if (other._hasOwnerId) {
      copy._hasOwnerId = true;
      copy._ownerPlayId = other._ownerPlayId;
    }
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    if (other._hasOffsetStart) {
      copy._hasOffsetStart = true;
      copy._offsetStart = other._offsetStart;
    }
    if (other._hasOffsetEnd) {
      copy._hasOffsetEnd = true;
      copy._offsetEnd = other._offsetEnd;
    }
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasSpawnOnNavmesh) {
      copy._hasSpawnOnNavmesh = true;
      copy._spawnOnNavmesh = other._spawnOnNavmesh;
    }
    return copy;
  }
}
EffectSpawn.default = new EffectSpawn();
class EffectSpawn_Builder {
  constructor(value) {
    this._value = new EffectSpawn(value);
  }
  build() {
    return new EffectSpawn(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setCount(value) {
    this._value._hasCount = true;
    this._value._count = value;
    return this;
  }
  deleteCount() {
    this._value._hasCount = false;
    this._value._count = null;
    return this;
  }
  setOwner(value) {
    this._value._hasOwner = true;
    this._value._owner = value;
    return this;
  }
  deleteOwner() {
    this._value._hasOwner = false;
    this._value._owner = null;
    return this;
  }
  setOwnerId(value) {
    this._value._hasOwnerId = true;
    this._value._ownerPlayId = value;
    return this;
  }
  deleteOwnerId() {
    this._value._hasOwnerId = false;
    this._value._ownerPlayId = null;
    return this;
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
  setOffsetStart(value) {
    this._value._hasOffsetStart = true;
    this._value._offsetStart = value;
    return this;
  }
  deleteOffsetStart() {
    this._value._hasOffsetStart = false;
    this._value._offsetStart = null;
    return this;
  }
  setOffsetEnd(value) {
    this._value._hasOffsetEnd = true;
    this._value._offsetEnd = value;
    return this;
  }
  deleteOffsetEnd() {
    this._value._hasOffsetEnd = false;
    this._value._offsetEnd = null;
    return this;
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setSpawnOnNavmesh(value) {
    this._value._hasSpawnOnNavmesh = true;
    this._value._spawnOnNavmesh = value;
    return this;
  }
  deleteSpawnOnNavmesh() {
    this._value._hasSpawnOnNavmesh = false;
    this._value._spawnOnNavmesh = null;
    return this;
  }
}
EffectSpawn.Builder = EffectSpawn_Builder;
class EffectSpawn_WithParent {
  /**
   * @param {EffectSpawn} value
   * @param {EffectSpawn_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSpawn.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasCount() {
    if (this._cachedHasCount === undefined) {
      if (this._value.hasCount) {
        this._cachedHasCount = true;
      } else {
        this._cachedHasCount = this._parent ? this._parent.hasCount : false;
      }
    }
    return this._cachedHasCount;
  }
  get count() {
    if (this._cachedCount === undefined) {
      if (this._value.hasCount) {
        this._cachedCount = this._value.count;
      } else {
        this._cachedCount = this._parent ? this._parent.count : this._value.count;
      }
    }
    return this._cachedCount;
  }
  get hasOwner() {
    if (this._cachedHasOwner === undefined) {
      if (this._value.hasOwner) {
        this._cachedHasOwner = true;
      } else {
        this._cachedHasOwner = this._parent ? this._parent.hasOwner : false;
      }
    }
    return this._cachedHasOwner;
  }
  get owner() {
    if (this._cachedOwner === undefined) {
      if (this._value.hasOwner) {
        this._cachedOwner = this._value.owner;
      } else {
        this._cachedOwner = this._parent ? this._parent.owner : this._value.owner;
      }
    }
    return this._cachedOwner;
  }
  get hasOwnerId() {
    if (this._cachedHasOwnerId === undefined) {
      if (this._value.hasOwnerId) {
        this._cachedHasOwnerId = true;
      } else {
        this._cachedHasOwnerId = this._parent ? this._parent.hasOwnerId : false;
      }
    }
    return this._cachedHasOwnerId;
  }
  get ownerPlayId() {
    if (this._cachedOwnerId === undefined) {
      if (this._value.hasOwnerId) {
        this._cachedOwnerId = this._value.ownerPlayId;
      } else {
        this._cachedOwnerId = this._parent ? this._parent.ownerPlayId : this._value.ownerPlayId;
      }
    }
    return this._cachedOwnerId;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  get hasOffsetStart() {
    if (this._cachedHasOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedHasOffsetStart = true;
      } else {
        this._cachedHasOffsetStart = this._parent ? this._parent.hasOffsetStart : false;
      }
    }
    return this._cachedHasOffsetStart;
  }
  get offsetStart() {
    if (this._cachedOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedOffsetStart = this._value.offsetStart;
      } else {
        this._cachedOffsetStart = this._parent ? this._parent.offsetStart : this._value.offsetStart;
      }
    }
    return this._cachedOffsetStart;
  }
  get hasOffsetEnd() {
    if (this._cachedHasOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedHasOffsetEnd = true;
      } else {
        this._cachedHasOffsetEnd = this._parent ? this._parent.hasOffsetEnd : false;
      }
    }
    return this._cachedHasOffsetEnd;
  }
  get offsetEnd() {
    if (this._cachedOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedOffsetEnd = this._value.offsetEnd;
      } else {
        this._cachedOffsetEnd = this._parent ? this._parent.offsetEnd : this._value.offsetEnd;
      }
    }
    return this._cachedOffsetEnd;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new EffectOffset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.offset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasSpawnOnNavmesh() {
    if (this._cachedHasSpawnOnNavmesh === undefined) {
      if (this._value.hasSpawnOnNavmesh) {
        this._cachedHasSpawnOnNavmesh = true;
      } else {
        this._cachedHasSpawnOnNavmesh = this._parent ? this._parent.hasSpawnOnNavmesh : false;
      }
    }
    return this._cachedHasSpawnOnNavmesh;
  }
  get spawnOnNavmesh() {
    if (this._cachedSpawnOnNavmesh === undefined) {
      if (this._value.hasSpawnOnNavmesh) {
        this._cachedSpawnOnNavmesh = this._value.spawnOnNavmesh;
      } else {
        this._cachedSpawnOnNavmesh = this._parent ? this._parent.spawnOnNavmesh : this._value.spawnOnNavmesh;
      }
    }
    return this._cachedSpawnOnNavmesh;
  }
  update(current, parent) {
    const result = new EffectSpawn_WithParent(current, parent);
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
EffectSpawn_WithParent.default = new EffectSpawn_WithParent(EffectSpawn.default, null);
EffectSpawn.WithParent = EffectSpawn_WithParent;
class EffectSpawn_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 9,
        protoName: "unit",
        type: JsonToString,
        options: {
          comments: "The type of unit to create.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get count() {
    if (!this._count) {
      this._count = {
        name: "count",
        Name: "Count",
        number: 2,
        protoType: 5,
        protoName: "count",
        type: JsonToInt32,
        options: {
          comments: "The number of units to create.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._count;
  }
  get owner() {
    if (!this._owner) {
      this._owner = {
        name: "owner",
        Name: "Owner",
        number: 3,
        protoType: 14,
        protoName: "owner",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit\'s owner will be the owner for the spawned units.",
          default: "CASTER_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._owner;
  }
  get ownerPlayId() {
    if (!this._ownerPlayId) {
      this._ownerPlayId = {
        name: "ownerPlayId",
        Name: "OwnerId",
        number: 8,
        protoType: 5,
        protoName: "owner_id",
        type: JsonToInt32,
        options: {
          comments: "If specified (i.e., non-zero), this field will be used instead of the \"owner\" field.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ownerPlayId;
  }
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 4,
        protoType: 14,
        protoName: "location",
        type: EffectTarget_Type,
        options: {
          comments: "Determines the position and facing of the spawned unit. If the specified location is not an unit, spawned units use the default facing (0).\n",
          default: "TARGET_UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get offsetStart() {
    if (!this._offsetStart) {
      this._offsetStart = {
        name: "offsetStart",
        Name: "OffsetStart",
        number: 5,
        protoType: 14,
        protoName: "offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Offset start & end together determines the \"facing\" of this effect. This facing will be used to interpret offsets and also will be used as the initial facing of the created missile unit.\nIf offset start & end are both set to non-none values and the specified locations don\'t overlap, the effect will face from start to end.\nIf offset start & end are both specified but are overlapping, and the offset start is an unit (e.g., caster unit), the facing of that unit will be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetStart;
  }
  get offsetEnd() {
    if (!this._offsetEnd) {
      this._offsetEnd = {
        name: "offsetEnd",
        Name: "OffsetEnd",
        number: 6,
        protoType: 14,
        protoName: "offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetEnd;
  }
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 7,
        protoType: 11,
        protoName: "offset",
        type: EffectOffset,
        options: {
          comments: "Offset relative to the facing of the created unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 11,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "Effect applied to the spawned unit after they are spawned.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get spawnOnNavmesh() {
    if (!this._spawnOnNavmesh) {
      this._spawnOnNavmesh = {
        name: "spawnOnNavmesh",
        Name: "SpawnOnNavmesh",
        number: 12,
        protoType: 8,
        protoName: "spawn_on_navmesh",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the unit will be spawned at the nearest pathable location if the target location isn\'t pathable.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnOnNavmesh;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.count,
        this.owner,
        this.ownerPlayId,
        this.location,
        this.offsetStart,
        this.offsetEnd,
        this.offset,
        this.effect,
        this.spawnOnNavmesh,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCount",
        Name: "DummyOneofForCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOwner",
        Name: "DummyOneofForOwner",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOwnerId",
        Name: "DummyOneofForOwnerId",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetStart",
        Name: "DummyOneofForOffsetStart",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetEnd",
        Name: "DummyOneofForOffsetEnd",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffset",
        Name: "DummyOneofForOffset",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpawnOnNavmesh",
        Name: "DummyOneofForSpawnOnNavmesh",
        fields: [
          this.fields[9],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSpawn.descriptor = new EffectSpawn_Descriptor();
export class MorphParameters {
  get descriptor() {
    return MorphParameters.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasResetHealthPercentage = false;
    this._resetHealthPercentage = null;
    this._hasResetManaPercentage = false;
    this._resetManaPercentage = null;
  }
  isEmpty() {
    if (this._hasResetHealthPercentage) return false;
    if (this._hasResetManaPercentage) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MorphParameters) {
      return value;
    }
    return MorphParameters.fromJson(value);
  }
  static fromJson(json) {
    const result = new MorphParameters();
    if (json.resetHealthPercentage != null) {
      result._hasResetHealthPercentage = true;
      result._resetHealthPercentage = JsonToBoolean.fromJson(json.resetHealthPercentage);
    }
    if (json.resetManaPercentage != null) {
      result._hasResetManaPercentage = true;
      result._resetManaPercentage = JsonToBoolean.fromJson(json.resetManaPercentage);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasResetHealthPercentage) {
      result.resetHealthPercentage = JsonToBoolean.toJson(this._resetHealthPercentage);
    }
    if (this._hasResetManaPercentage) {
      result.resetManaPercentage = JsonToBoolean.toJson(this._resetManaPercentage);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get resetHealthPercentage() {
    return this._hasResetHealthPercentage ? this._resetHealthPercentage : JsonToBoolean.default;
  }
  get hasResetHealthPercentage() {
    return this._hasResetHealthPercentage;
  }
  setResetHealthPercentage(path, value) {
    return {type: 'SET', path: path.concat(['resetHealthPercentage']), value};
  }
  deleteResetHealthPercentage(path) {
    return {type: 'DELETE', path: path.concat(['resetHealthPercentage'])};
  }
  /**
   * @returns {boolean}
   */
  get resetManaPercentage() {
    return this._hasResetManaPercentage ? this._resetManaPercentage : JsonToBoolean.default;
  }
  get hasResetManaPercentage() {
    return this._hasResetManaPercentage;
  }
  setResetManaPercentage(path, value) {
    return {type: 'SET', path: path.concat(['resetManaPercentage']), value};
  }
  deleteResetManaPercentage(path) {
    return {type: 'DELETE', path: path.concat(['resetManaPercentage'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "resetHealthPercentage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MorphParameters(this);
              copy._hasResetHealthPercentage = true;
              copy._resetHealthPercentage = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetHealthPercentage) {
                return this;
              }
              const copy = new MorphParameters(this);
              copy._hasResetHealthPercentage = false;
              copy._resetHealthPercentage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resetManaPercentage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MorphParameters(this);
              copy._hasResetManaPercentage = true;
              copy._resetManaPercentage = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetManaPercentage) {
                return this;
              }
              const copy = new MorphParameters(this);
              copy._hasResetManaPercentage = false;
              copy._resetManaPercentage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MorphParameters} other
   * @returns {MorphParameters}
   */
  merge(other) {
    const copy = new MorphParameters(this);
    if (other._hasResetHealthPercentage) {
      copy._hasResetHealthPercentage = true;
      copy._resetHealthPercentage = other._resetHealthPercentage;
    }
    if (other._hasResetManaPercentage) {
      copy._hasResetManaPercentage = true;
      copy._resetManaPercentage = other._resetManaPercentage;
    }
    return copy;
  }
}
MorphParameters.default = new MorphParameters();
class MorphParameters_Builder {
  constructor(value) {
    this._value = new MorphParameters(value);
  }
  build() {
    return new MorphParameters(this._value);
  }
  setResetHealthPercentage(value) {
    this._value._hasResetHealthPercentage = true;
    this._value._resetHealthPercentage = value;
    return this;
  }
  deleteResetHealthPercentage() {
    this._value._hasResetHealthPercentage = false;
    this._value._resetHealthPercentage = null;
    return this;
  }
  setResetManaPercentage(value) {
    this._value._hasResetManaPercentage = true;
    this._value._resetManaPercentage = value;
    return this;
  }
  deleteResetManaPercentage() {
    this._value._hasResetManaPercentage = false;
    this._value._resetManaPercentage = null;
    return this;
  }
}
MorphParameters.Builder = MorphParameters_Builder;
class MorphParameters_WithParent {
  /**
   * @param {MorphParameters} value
   * @param {MorphParameters_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MorphParameters.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasResetHealthPercentage() {
    if (this._cachedHasResetHealthPercentage === undefined) {
      if (this._value.hasResetHealthPercentage) {
        this._cachedHasResetHealthPercentage = true;
      } else {
        this._cachedHasResetHealthPercentage = this._parent ? this._parent.hasResetHealthPercentage : false;
      }
    }
    return this._cachedHasResetHealthPercentage;
  }
  get resetHealthPercentage() {
    if (this._cachedResetHealthPercentage === undefined) {
      if (this._value.hasResetHealthPercentage) {
        this._cachedResetHealthPercentage = this._value.resetHealthPercentage;
      } else {
        this._cachedResetHealthPercentage = this._parent ? this._parent.resetHealthPercentage : this._value.resetHealthPercentage;
      }
    }
    return this._cachedResetHealthPercentage;
  }
  get hasResetManaPercentage() {
    if (this._cachedHasResetManaPercentage === undefined) {
      if (this._value.hasResetManaPercentage) {
        this._cachedHasResetManaPercentage = true;
      } else {
        this._cachedHasResetManaPercentage = this._parent ? this._parent.hasResetManaPercentage : false;
      }
    }
    return this._cachedHasResetManaPercentage;
  }
  get resetManaPercentage() {
    if (this._cachedResetManaPercentage === undefined) {
      if (this._value.hasResetManaPercentage) {
        this._cachedResetManaPercentage = this._value.resetManaPercentage;
      } else {
        this._cachedResetManaPercentage = this._parent ? this._parent.resetManaPercentage : this._value.resetManaPercentage;
      }
    }
    return this._cachedResetManaPercentage;
  }
  update(current, parent) {
    const result = new MorphParameters_WithParent(current, parent);
    return result;
  }
}
MorphParameters_WithParent.default = new MorphParameters_WithParent(MorphParameters.default, null);
MorphParameters.WithParent = MorphParameters_WithParent;
class MorphParameters_Descriptor {
  get resetHealthPercentage() {
    if (!this._resetHealthPercentage) {
      this._resetHealthPercentage = {
        name: "resetHealthPercentage",
        Name: "ResetHealthPercentage",
        number: 1,
        protoType: 8,
        protoName: "reset_health_percentage",
        type: JsonToBoolean,
        options: {
          comments: "If unchecked, new unit will retain the same health percentage as before the morph.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetHealthPercentage;
  }
  get resetManaPercentage() {
    if (!this._resetManaPercentage) {
      this._resetManaPercentage = {
        name: "resetManaPercentage",
        Name: "ResetManaPercentage",
        number: 2,
        protoType: 8,
        protoName: "reset_mana_percentage",
        type: JsonToBoolean,
        options: {
          comments: "If unchecked, new unit will retain the same mana percentage as before the morph.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetManaPercentage;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.resetHealthPercentage,
        this.resetManaPercentage,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForResetHealthPercentage",
        Name: "DummyOneofForResetHealthPercentage",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetManaPercentage",
        Name: "DummyOneofForResetManaPercentage",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MorphParameters.descriptor = new MorphParameters_Descriptor();
export class EffectSell {
  get descriptor() {
    return EffectSell.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValueType = false;
    this._valueType = null;
    this._hasRefund = false;
    this._refund = null;
    this._hasUnitCostOnly = false;
    this._unitCostOnly = null;
  }
  isEmpty() {
    if (this._hasValueType) return false;
    if (this._hasRefund) return false;
    if (this._hasUnitCostOnly) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSell) {
      return value;
    }
    return EffectSell.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSell();
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = ValueType.fromJson(json.valueType);
    }
    if (json.refund != null) {
      result._hasRefund = true;
      result._refund = JsonToDouble.fromJson(json.refund);
    }
    if (json.unitCostOnly != null) {
      result._hasUnitCostOnly = true;
      result._unitCostOnly = JsonToBoolean.fromJson(json.unitCostOnly);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValueType) {
      result.valueType = ValueType.toJson(this._valueType);
    }
    if (this._hasRefund) {
      result.refund = JsonToDouble.toJson(this._refund);
    }
    if (this._hasUnitCostOnly) {
      result.unitCostOnly = JsonToBoolean.toJson(this._unitCostOnly);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get refund() {
    return this._hasRefund ? this._refund : JsonToDouble.default;
  }
  get hasRefund() {
    return this._hasRefund;
  }
  setRefund(path, value) {
    return {type: 'SET', path: path.concat(['refund']), value};
  }
  deleteRefund(path) {
    return {type: 'DELETE', path: path.concat(['refund'])};
  }
  /**
   * @returns {boolean}
   */
  get unitCostOnly() {
    return this._hasUnitCostOnly ? this._unitCostOnly : JsonToBoolean.default;
  }
  get hasUnitCostOnly() {
    return this._hasUnitCostOnly;
  }
  setUnitCostOnly(path, value) {
    return {type: 'SET', path: path.concat(['unitCostOnly']), value};
  }
  deleteUnitCostOnly(path) {
    return {type: 'DELETE', path: path.concat(['unitCostOnly'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSell(this);
              copy._hasValueType = true;
              copy._valueType = ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new EffectSell(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "refund": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSell(this);
              copy._hasRefund = true;
              copy._refund = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRefund) {
                return this;
              }
              const copy = new EffectSell(this);
              copy._hasRefund = false;
              copy._refund = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitCostOnly": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSell(this);
              copy._hasUnitCostOnly = true;
              copy._unitCostOnly = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitCostOnly) {
                return this;
              }
              const copy = new EffectSell(this);
              copy._hasUnitCostOnly = false;
              copy._unitCostOnly = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSell} other
   * @returns {EffectSell}
   */
  merge(other) {
    const copy = new EffectSell(this);
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasRefund) {
      copy._hasRefund = true;
      copy._refund = other._refund;
    }
    if (other._hasUnitCostOnly) {
      copy._hasUnitCostOnly = true;
      copy._unitCostOnly = other._unitCostOnly;
    }
    return copy;
  }
}
EffectSell.default = new EffectSell();
class EffectSell_Builder {
  constructor(value) {
    this._value = new EffectSell(value);
  }
  build() {
    return new EffectSell(this._value);
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setRefund(value) {
    this._value._hasRefund = true;
    this._value._refund = value;
    return this;
  }
  deleteRefund() {
    this._value._hasRefund = false;
    this._value._refund = null;
    return this;
  }
  setUnitCostOnly(value) {
    this._value._hasUnitCostOnly = true;
    this._value._unitCostOnly = value;
    return this;
  }
  deleteUnitCostOnly() {
    this._value._hasUnitCostOnly = false;
    this._value._unitCostOnly = null;
    return this;
  }
}
EffectSell.Builder = EffectSell_Builder;
class EffectSell_WithParent {
  /**
   * @param {EffectSell} value
   * @param {EffectSell_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSell.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasRefund() {
    if (this._cachedHasRefund === undefined) {
      if (this._value.hasRefund) {
        this._cachedHasRefund = true;
      } else {
        this._cachedHasRefund = this._parent ? this._parent.hasRefund : false;
      }
    }
    return this._cachedHasRefund;
  }
  get refund() {
    if (this._cachedRefund === undefined) {
      if (this._value.hasRefund) {
        this._cachedRefund = this._value.refund;
      } else {
        this._cachedRefund = this._parent ? this._parent.refund : this._value.refund;
      }
    }
    return this._cachedRefund;
  }
  get hasUnitCostOnly() {
    if (this._cachedHasUnitCostOnly === undefined) {
      if (this._value.hasUnitCostOnly) {
        this._cachedHasUnitCostOnly = true;
      } else {
        this._cachedHasUnitCostOnly = this._parent ? this._parent.hasUnitCostOnly : false;
      }
    }
    return this._cachedHasUnitCostOnly;
  }
  get unitCostOnly() {
    if (this._cachedUnitCostOnly === undefined) {
      if (this._value.hasUnitCostOnly) {
        this._cachedUnitCostOnly = this._value.unitCostOnly;
      } else {
        this._cachedUnitCostOnly = this._parent ? this._parent.unitCostOnly : this._value.unitCostOnly;
      }
    }
    return this._cachedUnitCostOnly;
  }
  update(current, parent) {
    const result = new EffectSell_WithParent(current, parent);
    return result;
  }
}
EffectSell_WithParent.default = new EffectSell_WithParent(EffectSell.default, null);
EffectSell.WithParent = EffectSell_WithParent;
class EffectSell_Descriptor {
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 1,
        protoType: 14,
        protoName: "value_type",
        type: ValueType,
        options: {
          comments: "Whether to refund a percentage of the target\'s cost or an explicit amount.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get refund() {
    if (!this._refund) {
      this._refund = {
        name: "refund",
        Name: "Refund",
        number: 2,
        protoType: 1,
        protoName: "refund",
        type: JsonToDouble,
        options: {
          comments: "The amount of gold to refund. If using percentage, 0.5 means 50%.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._refund;
  }
  get unitCostOnly() {
    if (!this._unitCostOnly) {
      this._unitCostOnly = {
        name: "unitCostOnly",
        Name: "UnitCostOnly",
        number: 3,
        protoType: 8,
        protoName: "unit_cost_only",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitCostOnly;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.valueType,
        this.refund,
        this.unitCostOnly,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRefund",
        Name: "DummyOneofForRefund",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitCostOnly",
        Name: "DummyOneofForUnitCostOnly",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSell.descriptor = new EffectSell_Descriptor();
export class EffectMorph {
  get descriptor() {
    return EffectMorph.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetUnit = false;
    this._targetUnit = null;
    this._hasParameters = false;
    this._parameters = null;
  }
  isEmpty() {
    if (this._hasTargetUnit) return false;
    if (this._hasParameters && !this._parameters.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectMorph) {
      return value;
    }
    return EffectMorph.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectMorph();
    if (json.targetUnit != null) {
      result._hasTargetUnit = true;
      result._targetUnit = JsonToString.fromJson(json.targetUnit);
    }
    if (json.parameters != null) {
      result._hasParameters = true;
      result._parameters = MorphParameters.fromJson(json.parameters);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetUnit) {
      result.targetUnit = JsonToString.toJson(this._targetUnit);
    }
    if (this._hasParameters && !this._parameters.isEmpty()) {
      result.parameters = MorphParameters.toJson(this._parameters);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get targetUnit() {
    return this._hasTargetUnit ? this._targetUnit : JsonToString.default;
  }
  get hasTargetUnit() {
    return this._hasTargetUnit;
  }
  setTargetUnit(path, value) {
    return {type: 'SET', path: path.concat(['targetUnit']), value};
  }
  deleteTargetUnit(path) {
    return {type: 'DELETE', path: path.concat(['targetUnit'])};
  }
  /**
   * @returns {MorphParameters}
   */
  get parameters() {
    return this._hasParameters ? this._parameters : MorphParameters.default;
  }
  get hasParameters() {
    return this._hasParameters;
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectMorph(this);
              copy._hasTargetUnit = true;
              copy._targetUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetUnit) {
                return this;
              }
              const copy = new EffectMorph(this);
              copy._hasTargetUnit = false;
              copy._targetUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectMorph(this);
              copy._hasParameters = true;
              copy._parameters = MorphParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParameters) {
                return this;
              }
              const copy = new EffectMorph(this);
              copy._hasParameters = false;
              copy._parameters = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasParameters) {
            const copy = new EffectMorph(this);
            copy._hasParameters = true;
            copy._parameters = MorphParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._parameters.apply(type, path.slice(1), value);
          if (newValue === this._parameters) {
            return this;
          }
          const copy = new EffectMorph(this);
          copy._parameters = copy._parameters.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectMorph} other
   * @returns {EffectMorph}
   */
  merge(other) {
    const copy = new EffectMorph(this);
    if (other._hasTargetUnit) {
      copy._hasTargetUnit = true;
      copy._targetUnit = other._targetUnit;
    }
    if (other._hasParameters) {
      if (copy._hasParameters) {
        copy._parameters = copy.parameters.merge(other.parameters);
      } else {
        copy._parameters = other._parameters;
      }
      copy._hasParameters = true;
    }
    return copy;
  }
}
EffectMorph.default = new EffectMorph();
class EffectMorph_Builder {
  constructor(value) {
    this._value = new EffectMorph(value);
  }
  build() {
    return new EffectMorph(this._value);
  }
  setTargetUnit(value) {
    this._value._hasTargetUnit = true;
    this._value._targetUnit = value;
    return this;
  }
  deleteTargetUnit() {
    this._value._hasTargetUnit = false;
    this._value._targetUnit = null;
    return this;
  }
  setParameters(value) {
    this._value._hasParameters = true;
    this._value._parameters = value;
    return this;
  }
  deleteParameters() {
    this._value._hasParameters = false;
    this._value._parameters = null;
    return this;
  }
}
EffectMorph.Builder = EffectMorph_Builder;
class EffectMorph_WithParent {
  /**
   * @param {EffectMorph} value
   * @param {EffectMorph_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectMorph.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetUnit() {
    if (this._cachedHasTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedHasTargetUnit = true;
      } else {
        this._cachedHasTargetUnit = this._parent ? this._parent.hasTargetUnit : false;
      }
    }
    return this._cachedHasTargetUnit;
  }
  get targetUnit() {
    if (this._cachedTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedTargetUnit = this._value.targetUnit;
      } else {
        this._cachedTargetUnit = this._parent ? this._parent.targetUnit : this._value.targetUnit;
      }
    }
    return this._cachedTargetUnit;
  }
  get hasParameters() {
    if (this._cachedHasParameters === undefined) {
      if (this._value.hasParameters) {
        this._cachedHasParameters = true;
      } else {
        this._cachedHasParameters = this._parent ? this._parent.hasParameters : false;
      }
    }
    return this._cachedHasParameters;
  }
  get parameters() {
    if (!this._cachedParameters) {
      if (this._value.hasParameters) {
        this._cachedParameters = new MorphParameters.WithParent(this._value.parameters, this._parent && this._parent.hasParameters ? this._parent.parameters : null);
      } else {
        this._cachedParameters = this._parent ? new MorphParameters.WithParent(MorphParameters.default, this._parent.parameters) : MorphParameters.WithParent.default;
      }
    }
    return this._cachedParameters;
  }
  update(current, parent) {
    const result = new EffectMorph_WithParent(current, parent);
    if (this._cachedParameters && this._value.hasParameters && current.hasParameters) {
      if (this._value.parameters === current.parameters && this._parent === parent) {
        result._cachedParameters = this._cachedParameters;
      } else {
        result._cachedParameters = this._cachedParameters.update(current.parameters, parent && parent.hasParameters ? parent.parameters : null);
      }
    }
    return result;
  }
}
EffectMorph_WithParent.default = new EffectMorph_WithParent(EffectMorph.default, null);
EffectMorph.WithParent = EffectMorph_WithParent;
class EffectMorph_Descriptor {
  get targetUnit() {
    if (!this._targetUnit) {
      this._targetUnit = {
        name: "targetUnit",
        Name: "TargetUnit",
        number: 1,
        protoType: 9,
        protoName: "target_unit",
        type: JsonToString,
        options: {
          comments: "The type of unit to morph into.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetUnit;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: MorphParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetUnit,
        this.parameters,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetUnit",
        Name: "DummyOneofForTargetUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParameters",
        Name: "DummyOneofForParameters",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectMorph.descriptor = new EffectMorph_Descriptor();
class EffectSpawnTroop_Offset {
  get descriptor() {
    return EffectSpawnTroop_Offset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSpawnTroop_Offset) {
      return value;
    }
    return EffectSpawnTroop_Offset.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSpawnTroop_Offset();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new EffectSpawnTroop_Offset(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSpawnTroop_Offset} other
   * @returns {EffectSpawnTroop_Offset}
   */
  merge(other) {
    const copy = new EffectSpawnTroop_Offset(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    return copy;
  }
}
EffectSpawnTroop_Offset.default = new EffectSpawnTroop_Offset();
class EffectSpawnTroop_Offset_Builder {
  constructor(value) {
    this._value = new EffectSpawnTroop_Offset(value);
  }
  build() {
    return new EffectSpawnTroop_Offset(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
}
EffectSpawnTroop_Offset.Builder = EffectSpawnTroop_Offset_Builder;
class EffectSpawnTroop_Offset_WithParent {
  /**
   * @param {EffectSpawnTroop_Offset} value
   * @param {EffectSpawnTroop_Offset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSpawnTroop_Offset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  update(current, parent) {
    const result = new EffectSpawnTroop_Offset_WithParent(current, parent);
    return result;
  }
}
EffectSpawnTroop_Offset_WithParent.default = new EffectSpawnTroop_Offset_WithParent(EffectSpawnTroop_Offset.default, null);
EffectSpawnTroop_Offset.WithParent = EffectSpawnTroop_Offset_WithParent;
class EffectSpawnTroop_Offset_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSpawnTroop_Offset.descriptor = new EffectSpawnTroop_Offset_Descriptor();
export class EffectSpawnTroop {
  get descriptor() {
    return EffectSpawnTroop.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasSpawnCount = false;
    this._spawnCount = null;
    this._hasMaxCount = false;
    this._maxCount = null;
    this._hasOffset = false;
    this._offset = null;
    this._hasSpawnAtRallyPoint = false;
    this._spawnAtRallyPoint = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasSpawnCount) return false;
    if (this._hasMaxCount) return false;
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    if (this._hasSpawnAtRallyPoint) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSpawnTroop) {
      return value;
    }
    return EffectSpawnTroop.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSpawnTroop();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = JsonToString.fromJson(json.unit);
    }
    if (json.spawnCount != null) {
      result._hasSpawnCount = true;
      result._spawnCount = JsonToInt32.fromJson(json.spawnCount);
    }
    if (json.maxCount != null) {
      result._hasMaxCount = true;
      result._maxCount = JsonToInt32.fromJson(json.maxCount);
    }
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = EffectSpawnTroop_Offset.fromJson(json.offset);
    }
    if (json.spawnAtRallyPoint != null) {
      result._hasSpawnAtRallyPoint = true;
      result._spawnAtRallyPoint = JsonToBoolean.fromJson(json.spawnAtRallyPoint);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = JsonToString.toJson(this._unit);
    }
    if (this._hasSpawnCount) {
      result.spawnCount = JsonToInt32.toJson(this._spawnCount);
    }
    if (this._hasMaxCount) {
      result.maxCount = JsonToInt32.toJson(this._maxCount);
    }
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = EffectSpawnTroop_Offset.toJson(this._offset);
    }
    if (this._hasSpawnAtRallyPoint) {
      result.spawnAtRallyPoint = JsonToBoolean.toJson(this._spawnAtRallyPoint);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unit() {
    return this._hasUnit ? this._unit : JsonToString.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {number}
   */
  get spawnCount() {
    return this._hasSpawnCount ? this._spawnCount : JsonToInt32.default;
  }
  get hasSpawnCount() {
    return this._hasSpawnCount;
  }
  setSpawnCount(path, value) {
    return {type: 'SET', path: path.concat(['spawnCount']), value};
  }
  deleteSpawnCount(path) {
    return {type: 'DELETE', path: path.concat(['spawnCount'])};
  }
  /**
   * @returns {number}
   */
  get maxCount() {
    return this._hasMaxCount ? this._maxCount : JsonToInt32.default;
  }
  get hasMaxCount() {
    return this._hasMaxCount;
  }
  setMaxCount(path, value) {
    return {type: 'SET', path: path.concat(['maxCount']), value};
  }
  deleteMaxCount(path) {
    return {type: 'DELETE', path: path.concat(['maxCount'])};
  }
  /**
   * @returns {EffectSpawnTroop_Offset}
   */
  get offset() {
    return this._hasOffset ? this._offset : EffectSpawnTroop_Offset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  /**
   * @returns {boolean}
   */
  get spawnAtRallyPoint() {
    return this._hasSpawnAtRallyPoint ? this._spawnAtRallyPoint : JsonToBoolean.default;
  }
  get hasSpawnAtRallyPoint() {
    return this._hasSpawnAtRallyPoint;
  }
  setSpawnAtRallyPoint(path, value) {
    return {type: 'SET', path: path.concat(['spawnAtRallyPoint']), value};
  }
  deleteSpawnAtRallyPoint(path) {
    return {type: 'DELETE', path: path.concat(['spawnAtRallyPoint'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop(this);
              copy._hasUnit = true;
              copy._unit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new EffectSpawnTroop(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spawnCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop(this);
              copy._hasSpawnCount = true;
              copy._spawnCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpawnCount) {
                return this;
              }
              const copy = new EffectSpawnTroop(this);
              copy._hasSpawnCount = false;
              copy._spawnCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop(this);
              copy._hasMaxCount = true;
              copy._maxCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxCount) {
                return this;
              }
              const copy = new EffectSpawnTroop(this);
              copy._hasMaxCount = false;
              copy._maxCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop(this);
              copy._hasOffset = true;
              copy._offset = EffectSpawnTroop_Offset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new EffectSpawnTroop(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new EffectSpawnTroop(this);
            copy._hasOffset = true;
            copy._offset = EffectSpawnTroop_Offset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new EffectSpawnTroop(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "spawnAtRallyPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSpawnTroop(this);
              copy._hasSpawnAtRallyPoint = true;
              copy._spawnAtRallyPoint = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpawnAtRallyPoint) {
                return this;
              }
              const copy = new EffectSpawnTroop(this);
              copy._hasSpawnAtRallyPoint = false;
              copy._spawnAtRallyPoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSpawnTroop} other
   * @returns {EffectSpawnTroop}
   */
  merge(other) {
    const copy = new EffectSpawnTroop(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasSpawnCount) {
      copy._hasSpawnCount = true;
      copy._spawnCount = other._spawnCount;
    }
    if (other._hasMaxCount) {
      copy._hasMaxCount = true;
      copy._maxCount = other._maxCount;
    }
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    if (other._hasSpawnAtRallyPoint) {
      copy._hasSpawnAtRallyPoint = true;
      copy._spawnAtRallyPoint = other._spawnAtRallyPoint;
    }
    return copy;
  }
}
EffectSpawnTroop.default = new EffectSpawnTroop();
EffectSpawnTroop.Offset = EffectSpawnTroop_Offset;
class EffectSpawnTroop_Builder {
  constructor(value) {
    this._value = new EffectSpawnTroop(value);
  }
  build() {
    return new EffectSpawnTroop(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setSpawnCount(value) {
    this._value._hasSpawnCount = true;
    this._value._spawnCount = value;
    return this;
  }
  deleteSpawnCount() {
    this._value._hasSpawnCount = false;
    this._value._spawnCount = null;
    return this;
  }
  setMaxCount(value) {
    this._value._hasMaxCount = true;
    this._value._maxCount = value;
    return this;
  }
  deleteMaxCount() {
    this._value._hasMaxCount = false;
    this._value._maxCount = null;
    return this;
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
  setSpawnAtRallyPoint(value) {
    this._value._hasSpawnAtRallyPoint = true;
    this._value._spawnAtRallyPoint = value;
    return this;
  }
  deleteSpawnAtRallyPoint() {
    this._value._hasSpawnAtRallyPoint = false;
    this._value._spawnAtRallyPoint = null;
    return this;
  }
}
EffectSpawnTroop.Builder = EffectSpawnTroop_Builder;
class EffectSpawnTroop_WithParent {
  /**
   * @param {EffectSpawnTroop} value
   * @param {EffectSpawnTroop_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSpawnTroop.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasSpawnCount() {
    if (this._cachedHasSpawnCount === undefined) {
      if (this._value.hasSpawnCount) {
        this._cachedHasSpawnCount = true;
      } else {
        this._cachedHasSpawnCount = this._parent ? this._parent.hasSpawnCount : false;
      }
    }
    return this._cachedHasSpawnCount;
  }
  get spawnCount() {
    if (this._cachedSpawnCount === undefined) {
      if (this._value.hasSpawnCount) {
        this._cachedSpawnCount = this._value.spawnCount;
      } else {
        this._cachedSpawnCount = this._parent ? this._parent.spawnCount : this._value.spawnCount;
      }
    }
    return this._cachedSpawnCount;
  }
  get hasMaxCount() {
    if (this._cachedHasMaxCount === undefined) {
      if (this._value.hasMaxCount) {
        this._cachedHasMaxCount = true;
      } else {
        this._cachedHasMaxCount = this._parent ? this._parent.hasMaxCount : false;
      }
    }
    return this._cachedHasMaxCount;
  }
  get maxCount() {
    if (this._cachedMaxCount === undefined) {
      if (this._value.hasMaxCount) {
        this._cachedMaxCount = this._value.maxCount;
      } else {
        this._cachedMaxCount = this._parent ? this._parent.maxCount : this._value.maxCount;
      }
    }
    return this._cachedMaxCount;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new EffectSpawnTroop_Offset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new EffectSpawnTroop_Offset.WithParent(EffectSpawnTroop_Offset.default, this._parent.offset) : EffectSpawnTroop_Offset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  get hasSpawnAtRallyPoint() {
    if (this._cachedHasSpawnAtRallyPoint === undefined) {
      if (this._value.hasSpawnAtRallyPoint) {
        this._cachedHasSpawnAtRallyPoint = true;
      } else {
        this._cachedHasSpawnAtRallyPoint = this._parent ? this._parent.hasSpawnAtRallyPoint : false;
      }
    }
    return this._cachedHasSpawnAtRallyPoint;
  }
  get spawnAtRallyPoint() {
    if (this._cachedSpawnAtRallyPoint === undefined) {
      if (this._value.hasSpawnAtRallyPoint) {
        this._cachedSpawnAtRallyPoint = this._value.spawnAtRallyPoint;
      } else {
        this._cachedSpawnAtRallyPoint = this._parent ? this._parent.spawnAtRallyPoint : this._value.spawnAtRallyPoint;
      }
    }
    return this._cachedSpawnAtRallyPoint;
  }
  update(current, parent) {
    const result = new EffectSpawnTroop_WithParent(current, parent);
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
EffectSpawnTroop_WithParent.default = new EffectSpawnTroop_WithParent(EffectSpawnTroop.default, null);
EffectSpawnTroop.WithParent = EffectSpawnTroop_WithParent;
class EffectSpawnTroop_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 9,
        protoName: "unit",
        type: JsonToString,
        options: {
          comments: "The type of unit to create.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get spawnCount() {
    if (!this._spawnCount) {
      this._spawnCount = {
        name: "spawnCount",
        Name: "SpawnCount",
        number: 2,
        protoType: 5,
        protoName: "spawn_count",
        type: JsonToInt32,
        options: {
          comments: "The number of units to create.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnCount;
  }
  get maxCount() {
    if (!this._maxCount) {
      this._maxCount = {
        name: "maxCount",
        Name: "MaxCount",
        number: 3,
        protoType: 5,
        protoName: "max_count",
        type: JsonToInt32,
        options: {
          comments: "If set, only up to this number of units will be created.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxCount;
  }
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 4,
        protoType: 11,
        protoName: "offset",
        type: EffectSpawnTroop_Offset,
        options: {
          comments: "The offset for where the unit is created.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get spawnAtRallyPoint() {
    if (!this._spawnAtRallyPoint) {
      this._spawnAtRallyPoint = {
        name: "spawnAtRallyPoint",
        Name: "SpawnAtRallyPoint",
        number: 5,
        protoType: 8,
        protoName: "spawn_at_rally_point",
        type: JsonToBoolean,
        options: {
          comments: "If checked, will create the units at the parent\'s rally point rather than the parent\'s location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnAtRallyPoint;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.spawnCount,
        this.maxCount,
        this.offset,
        this.spawnAtRallyPoint,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpawnCount",
        Name: "DummyOneofForSpawnCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxCount",
        Name: "DummyOneofForMaxCount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffset",
        Name: "DummyOneofForOffset",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpawnAtRallyPoint",
        Name: "DummyOneofForSpawnAtRallyPoint",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSpawnTroop.descriptor = new EffectSpawnTroop_Descriptor();
export class EffectMorphTroop {
  get descriptor() {
    return EffectMorphTroop.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetUnit = false;
    this._targetUnit = null;
    this._hasParameters = false;
    this._parameters = null;
  }
  isEmpty() {
    if (this._hasTargetUnit) return false;
    if (this._hasParameters && !this._parameters.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectMorphTroop) {
      return value;
    }
    return EffectMorphTroop.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectMorphTroop();
    if (json.targetUnit != null) {
      result._hasTargetUnit = true;
      result._targetUnit = JsonToString.fromJson(json.targetUnit);
    }
    if (json.parameters != null) {
      result._hasParameters = true;
      result._parameters = MorphParameters.fromJson(json.parameters);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetUnit) {
      result.targetUnit = JsonToString.toJson(this._targetUnit);
    }
    if (this._hasParameters && !this._parameters.isEmpty()) {
      result.parameters = MorphParameters.toJson(this._parameters);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get targetUnit() {
    return this._hasTargetUnit ? this._targetUnit : JsonToString.default;
  }
  get hasTargetUnit() {
    return this._hasTargetUnit;
  }
  setTargetUnit(path, value) {
    return {type: 'SET', path: path.concat(['targetUnit']), value};
  }
  deleteTargetUnit(path) {
    return {type: 'DELETE', path: path.concat(['targetUnit'])};
  }
  /**
   * @returns {MorphParameters}
   */
  get parameters() {
    return this._hasParameters ? this._parameters : MorphParameters.default;
  }
  get hasParameters() {
    return this._hasParameters;
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectMorphTroop(this);
              copy._hasTargetUnit = true;
              copy._targetUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetUnit) {
                return this;
              }
              const copy = new EffectMorphTroop(this);
              copy._hasTargetUnit = false;
              copy._targetUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectMorphTroop(this);
              copy._hasParameters = true;
              copy._parameters = MorphParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParameters) {
                return this;
              }
              const copy = new EffectMorphTroop(this);
              copy._hasParameters = false;
              copy._parameters = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasParameters) {
            const copy = new EffectMorphTroop(this);
            copy._hasParameters = true;
            copy._parameters = MorphParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._parameters.apply(type, path.slice(1), value);
          if (newValue === this._parameters) {
            return this;
          }
          const copy = new EffectMorphTroop(this);
          copy._parameters = copy._parameters.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectMorphTroop} other
   * @returns {EffectMorphTroop}
   */
  merge(other) {
    const copy = new EffectMorphTroop(this);
    if (other._hasTargetUnit) {
      copy._hasTargetUnit = true;
      copy._targetUnit = other._targetUnit;
    }
    if (other._hasParameters) {
      if (copy._hasParameters) {
        copy._parameters = copy.parameters.merge(other.parameters);
      } else {
        copy._parameters = other._parameters;
      }
      copy._hasParameters = true;
    }
    return copy;
  }
}
EffectMorphTroop.default = new EffectMorphTroop();
class EffectMorphTroop_Builder {
  constructor(value) {
    this._value = new EffectMorphTroop(value);
  }
  build() {
    return new EffectMorphTroop(this._value);
  }
  setTargetUnit(value) {
    this._value._hasTargetUnit = true;
    this._value._targetUnit = value;
    return this;
  }
  deleteTargetUnit() {
    this._value._hasTargetUnit = false;
    this._value._targetUnit = null;
    return this;
  }
  setParameters(value) {
    this._value._hasParameters = true;
    this._value._parameters = value;
    return this;
  }
  deleteParameters() {
    this._value._hasParameters = false;
    this._value._parameters = null;
    return this;
  }
}
EffectMorphTroop.Builder = EffectMorphTroop_Builder;
class EffectMorphTroop_WithParent {
  /**
   * @param {EffectMorphTroop} value
   * @param {EffectMorphTroop_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectMorphTroop.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetUnit() {
    if (this._cachedHasTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedHasTargetUnit = true;
      } else {
        this._cachedHasTargetUnit = this._parent ? this._parent.hasTargetUnit : false;
      }
    }
    return this._cachedHasTargetUnit;
  }
  get targetUnit() {
    if (this._cachedTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedTargetUnit = this._value.targetUnit;
      } else {
        this._cachedTargetUnit = this._parent ? this._parent.targetUnit : this._value.targetUnit;
      }
    }
    return this._cachedTargetUnit;
  }
  get hasParameters() {
    if (this._cachedHasParameters === undefined) {
      if (this._value.hasParameters) {
        this._cachedHasParameters = true;
      } else {
        this._cachedHasParameters = this._parent ? this._parent.hasParameters : false;
      }
    }
    return this._cachedHasParameters;
  }
  get parameters() {
    if (!this._cachedParameters) {
      if (this._value.hasParameters) {
        this._cachedParameters = new MorphParameters.WithParent(this._value.parameters, this._parent && this._parent.hasParameters ? this._parent.parameters : null);
      } else {
        this._cachedParameters = this._parent ? new MorphParameters.WithParent(MorphParameters.default, this._parent.parameters) : MorphParameters.WithParent.default;
      }
    }
    return this._cachedParameters;
  }
  update(current, parent) {
    const result = new EffectMorphTroop_WithParent(current, parent);
    if (this._cachedParameters && this._value.hasParameters && current.hasParameters) {
      if (this._value.parameters === current.parameters && this._parent === parent) {
        result._cachedParameters = this._cachedParameters;
      } else {
        result._cachedParameters = this._cachedParameters.update(current.parameters, parent && parent.hasParameters ? parent.parameters : null);
      }
    }
    return result;
  }
}
EffectMorphTroop_WithParent.default = new EffectMorphTroop_WithParent(EffectMorphTroop.default, null);
EffectMorphTroop.WithParent = EffectMorphTroop_WithParent;
class EffectMorphTroop_Descriptor {
  get targetUnit() {
    if (!this._targetUnit) {
      this._targetUnit = {
        name: "targetUnit",
        Name: "TargetUnit",
        number: 1,
        protoType: 9,
        protoName: "target_unit",
        type: JsonToString,
        options: {
          comments: "The type of unit to morph into.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetUnit;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: MorphParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetUnit,
        this.parameters,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetUnit",
        Name: "DummyOneofForTargetUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParameters",
        Name: "DummyOneofForParameters",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectMorphTroop.descriptor = new EffectMorphTroop_Descriptor();
export class EffectApplyBehavior {
  get descriptor() {
    return EffectApplyBehavior.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehavior = false;
    this._behavior = null;
    this._hasTarget = false;
    this._target = null;
    this._hasStackCount = false;
    this._stackCount = null;
    this._stackCountExpressions = [];
    this._hasDuration = false;
    this._duration = null;
    this._hasExtendDuration = false;
    this._extendDuration = null;
    this._expressions = [];
    this._hasRetainCaster = false;
    this._retainCaster = null;
  }
  isEmpty() {
    if (this._hasBehavior) return false;
    if (this._hasTarget) return false;
    if (this._hasStackCount) return false;
    if (this._stackCountExpressions.length > 0) return false;
    if (this._hasDuration) return false;
    if (this._hasExtendDuration) return false;
    if (this._expressions.length > 0) return false;
    if (this._hasRetainCaster) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectApplyBehavior) {
      return value;
    }
    return EffectApplyBehavior.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectApplyBehavior();
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectUnitTarget_Type.fromJson(json.target);
    }
    if (json.stackCount != null) {
      result._hasStackCount = true;
      result._stackCount = JsonToInt32.fromJson(json.stackCount);
    }
    result._stackCountExpressions = JsonToList(json.stackCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.extendDuration != null) {
      result._hasExtendDuration = true;
      result._extendDuration = JsonToBoolean.fromJson(json.extendDuration);
    }
    result._expressions = JsonToList(json.expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.retainCaster != null) {
      result._hasRetainCaster = true;
      result._retainCaster = JsonToBoolean.fromJson(json.retainCaster);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    if (this._hasTarget) {
      result.target = EffectUnitTarget_Type.toJson(this._target);
    }
    if (this._hasStackCount) {
      result.stackCount = JsonToInt32.toJson(this._stackCount);
    }
    if (this._stackCountExpressions.length > 0) {
      result.stackCountExpressions = ArrayToJson(this._stackCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasExtendDuration) {
      result.extendDuration = JsonToBoolean.toJson(this._extendDuration);
    }
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasRetainCaster) {
      result.retainCaster = JsonToBoolean.toJson(this._retainCaster);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectUnitTarget_Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {number}
   */
  get stackCount() {
    return this._hasStackCount ? this._stackCount : JsonToInt32.default;
  }
  get hasStackCount() {
    return this._hasStackCount;
  }
  setStackCount(path, value) {
    return {type: 'SET', path: path.concat(['stackCount']), value};
  }
  deleteStackCount(path) {
    return {type: 'DELETE', path: path.concat(['stackCount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get stackCountExpressions() {
    return this._stackCountExpressions;
  }
  addStackCountExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['stackCountExpressions']), value: value.toJson()};
  }
  setStackCountExpressions(path, value) {
    return {type: 'SET', path: path.concat(['stackCountExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setStackCountExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['stackCountExpressions', key]), value: value.toJson()};
  }
  deleteStackCountExpressions(path) {
    return {type: 'DELETE', path: path.concat(['stackCountExpressions'])};
  }
  deleteStackCountExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['stackCountExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {boolean}
   */
  get extendDuration() {
    return this._hasExtendDuration ? this._extendDuration : JsonToBoolean.default;
  }
  get hasExtendDuration() {
    return this._hasExtendDuration;
  }
  setExtendDuration(path, value) {
    return {type: 'SET', path: path.concat(['extendDuration']), value};
  }
  deleteExtendDuration(path) {
    return {type: 'DELETE', path: path.concat(['extendDuration'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  /**
   * @returns {boolean}
   */
  get retainCaster() {
    return this._hasRetainCaster ? this._retainCaster : JsonToBoolean.default;
  }
  get hasRetainCaster() {
    return this._hasRetainCaster;
  }
  setRetainCaster(path, value) {
    return {type: 'SET', path: path.concat(['retainCaster']), value};
  }
  deleteRetainCaster(path) {
    return {type: 'DELETE', path: path.concat(['retainCaster'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasTarget = true;
              copy._target = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasStackCount = true;
              copy._stackCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStackCount) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasStackCount = false;
              copy._stackCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stackCountExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._stackCountExpressions = [];        for (let i of value) {
                copy._stackCountExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectApplyBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._stackCountExpressions.length === 0) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._stackCountExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._stackCountExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.slice();
              copy._stackCountExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectApplyBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.slice(0, path[1]).concat(copy._stackCountExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._stackCountExpressions.length) {
            return this;
          }
          const oldValue = this._stackCountExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectApplyBehavior(this);
          copy._stackCountExpressions = copy._stackCountExpressions.slice();
          copy._stackCountExpressions[key] = newValue;
          return copy;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "extendDuration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasExtendDuration = true;
              copy._extendDuration = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExtendDuration) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasExtendDuration = false;
              copy._extendDuration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectApplyBehavior(this);
              copy._expressions = copy._expressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectApplyBehavior(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectApplyBehavior(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      case "retainCaster": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyBehavior(this);
              copy._hasRetainCaster = true;
              copy._retainCaster = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRetainCaster) {
                return this;
              }
              const copy = new EffectApplyBehavior(this);
              copy._hasRetainCaster = false;
              copy._retainCaster = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectApplyBehavior} other
   * @returns {EffectApplyBehavior}
   */
  merge(other) {
    const copy = new EffectApplyBehavior(this);
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasStackCount) {
      copy._hasStackCount = true;
      copy._stackCount = other._stackCount;
    }
    copy._stackCountExpressions = this._stackCountExpressions.concat(other._stackCountExpressions);
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasExtendDuration) {
      copy._hasExtendDuration = true;
      copy._extendDuration = other._extendDuration;
    }
    copy._expressions = this._expressions.concat(other._expressions);
    if (other._hasRetainCaster) {
      copy._hasRetainCaster = true;
      copy._retainCaster = other._retainCaster;
    }
    return copy;
  }
}
EffectApplyBehavior.default = new EffectApplyBehavior();
class EffectApplyBehavior_Builder {
  constructor(value) {
    this._value = new EffectApplyBehavior(value);
  }
  build() {
    return new EffectApplyBehavior(this._value);
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setStackCount(value) {
    this._value._hasStackCount = true;
    this._value._stackCount = value;
    return this;
  }
  deleteStackCount() {
    this._value._hasStackCount = false;
    this._value._stackCount = null;
    return this;
  }
  addAllStackCountExpressions(values) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat(values);
    return this;
  }
  addStackCountExpressions(value) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat([value]);
    return this;
  }
  setStackCountExpressions(index, value) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat();
    this._value._stackCountExpressions[index] = value;
    return this;
  }
  clearStackCountExpressions() {
    this._value._stackCountExpressions = [];
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setExtendDuration(value) {
    this._value._hasExtendDuration = true;
    this._value._extendDuration = value;
    return this;
  }
  deleteExtendDuration() {
    this._value._hasExtendDuration = false;
    this._value._extendDuration = null;
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
  setRetainCaster(value) {
    this._value._hasRetainCaster = true;
    this._value._retainCaster = value;
    return this;
  }
  deleteRetainCaster() {
    this._value._hasRetainCaster = false;
    this._value._retainCaster = null;
    return this;
  }
}
EffectApplyBehavior.Builder = EffectApplyBehavior_Builder;
class EffectApplyBehavior_WithParent {
  /**
   * @param {EffectApplyBehavior} value
   * @param {EffectApplyBehavior_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectApplyBehavior.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasStackCount() {
    if (this._cachedHasStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedHasStackCount = true;
      } else {
        this._cachedHasStackCount = this._parent ? this._parent.hasStackCount : false;
      }
    }
    return this._cachedHasStackCount;
  }
  get stackCount() {
    if (this._cachedStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedStackCount = this._value.stackCount;
      } else {
        this._cachedStackCount = this._parent ? this._parent.stackCount : this._value.stackCount;
      }
    }
    return this._cachedStackCount;
  }
  get selfStackCountExpressions() {
    if (!this._selfStackCountExpressions) {
      this._selfStackCountExpressions = [];
      for (let i of this._value.stackCountExpressions) {
        this._selfStackCountExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfStackCountExpressions;
  }
  get inherentStackCountExpressions() {
    if (!this._inherentStackCountExpressions) {
      this._inherentStackCountExpressions = this._parent ? this._parent.stackCountExpressions : [];
    }
    return this._inherentStackCountExpressions;
  }
  get stackCountExpressions() {
    if (!this._allStackCountExpressions) {
      this._allStackCountExpressions = this._parent ? this._parent.stackCountExpressions.concat(this.selfStackCountExpressions) : this.selfStackCountExpressions;
    }
    return this._allStackCountExpressions;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasExtendDuration() {
    if (this._cachedHasExtendDuration === undefined) {
      if (this._value.hasExtendDuration) {
        this._cachedHasExtendDuration = true;
      } else {
        this._cachedHasExtendDuration = this._parent ? this._parent.hasExtendDuration : false;
      }
    }
    return this._cachedHasExtendDuration;
  }
  get extendDuration() {
    if (this._cachedExtendDuration === undefined) {
      if (this._value.hasExtendDuration) {
        this._cachedExtendDuration = this._value.extendDuration;
      } else {
        this._cachedExtendDuration = this._parent ? this._parent.extendDuration : this._value.extendDuration;
      }
    }
    return this._cachedExtendDuration;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  get hasRetainCaster() {
    if (this._cachedHasRetainCaster === undefined) {
      if (this._value.hasRetainCaster) {
        this._cachedHasRetainCaster = true;
      } else {
        this._cachedHasRetainCaster = this._parent ? this._parent.hasRetainCaster : false;
      }
    }
    return this._cachedHasRetainCaster;
  }
  get retainCaster() {
    if (this._cachedRetainCaster === undefined) {
      if (this._value.hasRetainCaster) {
        this._cachedRetainCaster = this._value.retainCaster;
      } else {
        this._cachedRetainCaster = this._parent ? this._parent.retainCaster : this._value.retainCaster;
      }
    }
    return this._cachedRetainCaster;
  }
  update(current, parent) {
    const result = new EffectApplyBehavior_WithParent(current, parent);
    if (this._selfStackCountExpressions) {
      if (this._value.stackCountExpressions === current.stackCountExpressions) {
        result._selfStackCountExpressions = this._selfStackCountExpressions;
      } else {
        result._selfStackCountExpressions = [];
        for (let i = 0; i < current.stackCountExpressions.length; i++) {
          const oldValue = this._value.stackCountExpressions[i];
          if (oldValue) {
            const oldCache = this._selfStackCountExpressions[i];
            if (oldValue === current.stackCountExpressions[i]) {
              result._selfStackCountExpressions[i] = oldCache;
            } else {
              result._selfStackCountExpressions[i] = oldCache.update(current.stackCountExpressions[i], null);
            }
          } else {
            result._selfStackCountExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.stackCountExpressions[i], null);
          }
        }
      }
    }
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectApplyBehavior_WithParent.default = new EffectApplyBehavior_WithParent(EffectApplyBehavior.default, null);
EffectApplyBehavior.WithParent = EffectApplyBehavior_WithParent;
class EffectApplyBehavior_Descriptor {
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 1,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "The behavior to apply.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 2,
        protoType: 14,
        protoName: "target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to apply the behavior to. Using NONE defaults to TARGET_UNIT. NONE is TARGET_UNIT",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get stackCount() {
    if (!this._stackCount) {
      this._stackCount = {
        name: "stackCount",
        Name: "StackCount",
        number: 3,
        protoType: 5,
        protoName: "stack_count",
        type: JsonToInt32,
        options: {
          comments: "The number of behavior stacks to apply. If set to 0, 1 stack count will be added.",
          default: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stackCount;
  }
  get stackCountExpressions() {
    if (!this._stackCountExpressions) {
      this._stackCountExpressions = {
        name: "stackCountExpressions",
        Name: "StackCountExpressions",
        number: 8,
        protoType: 11,
        protoName: "stack_count_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stackCountExpressions;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 4,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "If set, this will be used instead of the behavior\'s duration.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get extendDuration() {
    if (!this._extendDuration) {
      this._extendDuration = {
        name: "extendDuration",
        Name: "ExtendDuration",
        number: 5,
        protoType: 8,
        protoName: "extend_duration",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the duration will be added to the existing behavior on the target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._extendDuration;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 6,
        protoType: 11,
        protoName: "expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get retainCaster() {
    if (!this._retainCaster) {
      this._retainCaster = {
        name: "retainCaster",
        Name: "RetainCaster",
        number: 7,
        protoType: 8,
        protoName: "retain_caster",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the effects created by the applied behavior will use the caster of this effect as the caster reference. By default, behaviors will use their target unit as the caster reference. This is useful for making colliding projectiles that deal damage using a damage expression that references behaviors or tags on the caster.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._retainCaster;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behavior,
        this.target,
        this.stackCount,
        this.stackCountExpressions,
        this.duration,
        this.extendDuration,
        this.expressions,
        this.retainCaster,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStackCount",
        Name: "DummyOneofForStackCount",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExtendDuration",
        Name: "DummyOneofForExtendDuration",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRetainCaster",
        Name: "DummyOneofForRetainCaster",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectApplyBehavior.descriptor = new EffectApplyBehavior_Descriptor();
export class EffectRemoveBehavior {
  get descriptor() {
    return EffectRemoveBehavior.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehavior = false;
    this._behavior = null;
    this._hasTarget = false;
    this._target = null;
    this._hasStackCount = false;
    this._stackCount = null;
    this._stackCountExpressions = [];
  }
  isEmpty() {
    if (this._hasBehavior) return false;
    if (this._hasTarget) return false;
    if (this._hasStackCount) return false;
    if (this._stackCountExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectRemoveBehavior) {
      return value;
    }
    return EffectRemoveBehavior.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectRemoveBehavior();
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectUnitTarget_Type.fromJson(json.target);
    }
    if (json.stackCount != null) {
      result._hasStackCount = true;
      result._stackCount = JsonToInt32.fromJson(json.stackCount);
    }
    result._stackCountExpressions = JsonToList(json.stackCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    if (this._hasTarget) {
      result.target = EffectUnitTarget_Type.toJson(this._target);
    }
    if (this._hasStackCount) {
      result.stackCount = JsonToInt32.toJson(this._stackCount);
    }
    if (this._stackCountExpressions.length > 0) {
      result.stackCountExpressions = ArrayToJson(this._stackCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectUnitTarget_Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {number}
   */
  get stackCount() {
    return this._hasStackCount ? this._stackCount : JsonToInt32.default;
  }
  get hasStackCount() {
    return this._hasStackCount;
  }
  setStackCount(path, value) {
    return {type: 'SET', path: path.concat(['stackCount']), value};
  }
  deleteStackCount(path) {
    return {type: 'DELETE', path: path.concat(['stackCount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get stackCountExpressions() {
    return this._stackCountExpressions;
  }
  addStackCountExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['stackCountExpressions']), value: value.toJson()};
  }
  setStackCountExpressions(path, value) {
    return {type: 'SET', path: path.concat(['stackCountExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setStackCountExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['stackCountExpressions', key]), value: value.toJson()};
  }
  deleteStackCountExpressions(path) {
    return {type: 'DELETE', path: path.concat(['stackCountExpressions'])};
  }
  deleteStackCountExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['stackCountExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveBehavior(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new EffectRemoveBehavior(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveBehavior(this);
              copy._hasTarget = true;
              copy._target = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectRemoveBehavior(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveBehavior(this);
              copy._hasStackCount = true;
              copy._stackCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStackCount) {
                return this;
              }
              const copy = new EffectRemoveBehavior(this);
              copy._hasStackCount = false;
              copy._stackCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stackCountExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveBehavior(this);
              copy._stackCountExpressions = [];        for (let i of value) {
                copy._stackCountExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectRemoveBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._stackCountExpressions.length === 0) {
                return this;
              }
              const copy = new EffectRemoveBehavior(this);
              copy._stackCountExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._stackCountExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.slice();
              copy._stackCountExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectRemoveBehavior(this);
              copy._stackCountExpressions = copy._stackCountExpressions.slice(0, path[1]).concat(copy._stackCountExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._stackCountExpressions.length) {
            return this;
          }
          const oldValue = this._stackCountExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectRemoveBehavior(this);
          copy._stackCountExpressions = copy._stackCountExpressions.slice();
          copy._stackCountExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectRemoveBehavior} other
   * @returns {EffectRemoveBehavior}
   */
  merge(other) {
    const copy = new EffectRemoveBehavior(this);
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasStackCount) {
      copy._hasStackCount = true;
      copy._stackCount = other._stackCount;
    }
    copy._stackCountExpressions = this._stackCountExpressions.concat(other._stackCountExpressions);
    return copy;
  }
}
EffectRemoveBehavior.default = new EffectRemoveBehavior();
class EffectRemoveBehavior_Builder {
  constructor(value) {
    this._value = new EffectRemoveBehavior(value);
  }
  build() {
    return new EffectRemoveBehavior(this._value);
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setStackCount(value) {
    this._value._hasStackCount = true;
    this._value._stackCount = value;
    return this;
  }
  deleteStackCount() {
    this._value._hasStackCount = false;
    this._value._stackCount = null;
    return this;
  }
  addAllStackCountExpressions(values) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat(values);
    return this;
  }
  addStackCountExpressions(value) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat([value]);
    return this;
  }
  setStackCountExpressions(index, value) {
    this._value._stackCountExpressions = this._value._stackCountExpressions.concat();
    this._value._stackCountExpressions[index] = value;
    return this;
  }
  clearStackCountExpressions() {
    this._value._stackCountExpressions = [];
    return this;
  }
}
EffectRemoveBehavior.Builder = EffectRemoveBehavior_Builder;
class EffectRemoveBehavior_WithParent {
  /**
   * @param {EffectRemoveBehavior} value
   * @param {EffectRemoveBehavior_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectRemoveBehavior.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasStackCount() {
    if (this._cachedHasStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedHasStackCount = true;
      } else {
        this._cachedHasStackCount = this._parent ? this._parent.hasStackCount : false;
      }
    }
    return this._cachedHasStackCount;
  }
  get stackCount() {
    if (this._cachedStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedStackCount = this._value.stackCount;
      } else {
        this._cachedStackCount = this._parent ? this._parent.stackCount : this._value.stackCount;
      }
    }
    return this._cachedStackCount;
  }
  get selfStackCountExpressions() {
    if (!this._selfStackCountExpressions) {
      this._selfStackCountExpressions = [];
      for (let i of this._value.stackCountExpressions) {
        this._selfStackCountExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfStackCountExpressions;
  }
  get inherentStackCountExpressions() {
    if (!this._inherentStackCountExpressions) {
      this._inherentStackCountExpressions = this._parent ? this._parent.stackCountExpressions : [];
    }
    return this._inherentStackCountExpressions;
  }
  get stackCountExpressions() {
    if (!this._allStackCountExpressions) {
      this._allStackCountExpressions = this._parent ? this._parent.stackCountExpressions.concat(this.selfStackCountExpressions) : this.selfStackCountExpressions;
    }
    return this._allStackCountExpressions;
  }
  update(current, parent) {
    const result = new EffectRemoveBehavior_WithParent(current, parent);
    if (this._selfStackCountExpressions) {
      if (this._value.stackCountExpressions === current.stackCountExpressions) {
        result._selfStackCountExpressions = this._selfStackCountExpressions;
      } else {
        result._selfStackCountExpressions = [];
        for (let i = 0; i < current.stackCountExpressions.length; i++) {
          const oldValue = this._value.stackCountExpressions[i];
          if (oldValue) {
            const oldCache = this._selfStackCountExpressions[i];
            if (oldValue === current.stackCountExpressions[i]) {
              result._selfStackCountExpressions[i] = oldCache;
            } else {
              result._selfStackCountExpressions[i] = oldCache.update(current.stackCountExpressions[i], null);
            }
          } else {
            result._selfStackCountExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.stackCountExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectRemoveBehavior_WithParent.default = new EffectRemoveBehavior_WithParent(EffectRemoveBehavior.default, null);
EffectRemoveBehavior.WithParent = EffectRemoveBehavior_WithParent;
class EffectRemoveBehavior_Descriptor {
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 1,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "The behavior to remove.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 2,
        protoType: 14,
        protoName: "target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to remove the behavior from. Using NONE defaults to TARGET_UNIT. NONE is TARGET_UNIT",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get stackCount() {
    if (!this._stackCount) {
      this._stackCount = {
        name: "stackCount",
        Name: "StackCount",
        number: 3,
        protoType: 5,
        protoName: "stack_count",
        type: JsonToInt32,
        options: {
          comments: "How many stacks to remove. If set to 0, the behavior will be removed regardless of the existing stack count.",
          default: "All",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stackCount;
  }
  get stackCountExpressions() {
    if (!this._stackCountExpressions) {
      this._stackCountExpressions = {
        name: "stackCountExpressions",
        Name: "StackCountExpressions",
        number: 4,
        protoType: 11,
        protoName: "stack_count_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stackCountExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behavior,
        this.target,
        this.stackCount,
        this.stackCountExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStackCount",
        Name: "DummyOneofForStackCount",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectRemoveBehavior.descriptor = new EffectRemoveBehavior_Descriptor();
export class EffectApplyTag {
  get descriptor() {
    return EffectApplyTag.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedTag = false;
    this._tag = null;
    this._hasTagName = false;
    this._tagName = null;
    this._hasDuration = false;
    this._duration = null;
    this._hasStackCount = false;
    this._stackCount = null;
  }
  isEmpty() {
    if (this._hasDeprecatedTag) return false;
    if (this._hasTagName) return false;
    if (this._hasDuration) return false;
    if (this._hasStackCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectApplyTag) {
      return value;
    }
    return EffectApplyTag.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectApplyTag();
    if (json.tag != null) {
      result._hasDeprecatedTag = true;
      result._tag = JsonToInt32.fromJson(json.tag);
    }
    if (json.tagName != null) {
      result._hasTagName = true;
      result._tagName = JsonToString.fromJson(json.tagName);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.stackCount != null) {
      result._hasStackCount = true;
      result._stackCount = JsonToInt32.fromJson(json.stackCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedTag) {
      result.tag = JsonToInt32.toJson(this._tag);
    }
    if (this._hasTagName) {
      result.tagName = JsonToString.toJson(this._tagName);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasStackCount) {
      result.stackCount = JsonToInt32.toJson(this._stackCount);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get tag() {
    return this._hasDeprecatedTag ? this._tag : JsonToInt32.default;
  }
  get hasDeprecatedTag() {
    return this._hasDeprecatedTag;
  }
  setDeprecatedTag(path, value) {
    return {type: 'SET', path: path.concat(['tag']), value};
  }
  deleteDeprecatedTag(path) {
    return {type: 'DELETE', path: path.concat(['tag'])};
  }
  /**
   * @returns {string}
   */
  get tagName() {
    return this._hasTagName ? this._tagName : JsonToString.default;
  }
  get hasTagName() {
    return this._hasTagName;
  }
  setTagName(path, value) {
    return {type: 'SET', path: path.concat(['tagName']), value};
  }
  deleteTagName(path) {
    return {type: 'DELETE', path: path.concat(['tagName'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {number}
   */
  get stackCount() {
    return this._hasStackCount ? this._stackCount : JsonToInt32.default;
  }
  get hasStackCount() {
    return this._hasStackCount;
  }
  setStackCount(path, value) {
    return {type: 'SET', path: path.concat(['stackCount']), value};
  }
  deleteStackCount(path) {
    return {type: 'DELETE', path: path.concat(['stackCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyTag(this);
              copy._hasDeprecatedTag = true;
              copy._tag = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedTag) {
                return this;
              }
              const copy = new EffectApplyTag(this);
              copy._hasDeprecatedTag = false;
              copy._tag = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyTag(this);
              copy._hasTagName = true;
              copy._tagName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagName) {
                return this;
              }
              const copy = new EffectApplyTag(this);
              copy._hasTagName = false;
              copy._tagName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyTag(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new EffectApplyTag(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectApplyTag(this);
              copy._hasStackCount = true;
              copy._stackCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStackCount) {
                return this;
              }
              const copy = new EffectApplyTag(this);
              copy._hasStackCount = false;
              copy._stackCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectApplyTag} other
   * @returns {EffectApplyTag}
   */
  merge(other) {
    const copy = new EffectApplyTag(this);
    if (other._hasDeprecatedTag) {
      copy._hasDeprecatedTag = true;
      copy._tag = other._tag;
    }
    if (other._hasTagName) {
      copy._hasTagName = true;
      copy._tagName = other._tagName;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasStackCount) {
      copy._hasStackCount = true;
      copy._stackCount = other._stackCount;
    }
    return copy;
  }
}
EffectApplyTag.default = new EffectApplyTag();
class EffectApplyTag_Builder {
  constructor(value) {
    this._value = new EffectApplyTag(value);
  }
  build() {
    return new EffectApplyTag(this._value);
  }
  setDeprecatedTag(value) {
    this._value._hasDeprecatedTag = true;
    this._value._tag = value;
    return this;
  }
  deleteDeprecatedTag() {
    this._value._hasDeprecatedTag = false;
    this._value._tag = null;
    return this;
  }
  setTagName(value) {
    this._value._hasTagName = true;
    this._value._tagName = value;
    return this;
  }
  deleteTagName() {
    this._value._hasTagName = false;
    this._value._tagName = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setStackCount(value) {
    this._value._hasStackCount = true;
    this._value._stackCount = value;
    return this;
  }
  deleteStackCount() {
    this._value._hasStackCount = false;
    this._value._stackCount = null;
    return this;
  }
}
EffectApplyTag.Builder = EffectApplyTag_Builder;
class EffectApplyTag_WithParent {
  /**
   * @param {EffectApplyTag} value
   * @param {EffectApplyTag_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectApplyTag.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedTag() {
    if (this._cachedHasDeprecatedTag === undefined) {
      if (this._value.hasDeprecatedTag) {
        this._cachedHasDeprecatedTag = true;
      } else {
        this._cachedHasDeprecatedTag = this._parent ? this._parent.hasDeprecatedTag : false;
      }
    }
    return this._cachedHasDeprecatedTag;
  }
  get tag() {
    if (this._cachedDeprecatedTag === undefined) {
      if (this._value.hasDeprecatedTag) {
        this._cachedDeprecatedTag = this._value.tag;
      } else {
        this._cachedDeprecatedTag = this._parent ? this._parent.tag : this._value.tag;
      }
    }
    return this._cachedDeprecatedTag;
  }
  get hasTagName() {
    if (this._cachedHasTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedHasTagName = true;
      } else {
        this._cachedHasTagName = this._parent ? this._parent.hasTagName : false;
      }
    }
    return this._cachedHasTagName;
  }
  get tagName() {
    if (this._cachedTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedTagName = this._value.tagName;
      } else {
        this._cachedTagName = this._parent ? this._parent.tagName : this._value.tagName;
      }
    }
    return this._cachedTagName;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasStackCount() {
    if (this._cachedHasStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedHasStackCount = true;
      } else {
        this._cachedHasStackCount = this._parent ? this._parent.hasStackCount : false;
      }
    }
    return this._cachedHasStackCount;
  }
  get stackCount() {
    if (this._cachedStackCount === undefined) {
      if (this._value.hasStackCount) {
        this._cachedStackCount = this._value.stackCount;
      } else {
        this._cachedStackCount = this._parent ? this._parent.stackCount : this._value.stackCount;
      }
    }
    return this._cachedStackCount;
  }
  update(current, parent) {
    const result = new EffectApplyTag_WithParent(current, parent);
    return result;
  }
}
EffectApplyTag_WithParent.default = new EffectApplyTag_WithParent(EffectApplyTag.default, null);
EffectApplyTag.WithParent = EffectApplyTag_WithParent;
class EffectApplyTag_Descriptor {
  get tag() {
    if (!this._tag) {
      this._tag = {
        name: "tag",
        Name: "DeprecatedTag",
        number: 1,
        protoType: 5,
        protoName: "deprecated_tag",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tag;
  }
  get tagName() {
    if (!this._tagName) {
      this._tagName = {
        name: "tagName",
        Name: "TagName",
        number: 2,
        protoType: 9,
        protoName: "tag_name",
        type: JsonToString,
        options: {
          comments: "The tag reference.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagName;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 3,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "The duration of the tag. Use -1 to make the duration infinite.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get stackCount() {
    if (!this._stackCount) {
      this._stackCount = {
        name: "stackCount",
        Name: "StackCount",
        number: 4,
        protoType: 5,
        protoName: "stack_count",
        type: JsonToInt32,
        options: {
          comments: "The number of stacks of the tag to apply.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stackCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tag,
        this.tagName,
        this.duration,
        this.stackCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedTag",
        Name: "DummyOneofForDeprecatedTag",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTagName",
        Name: "DummyOneofForTagName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStackCount",
        Name: "DummyOneofForStackCount",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectApplyTag.descriptor = new EffectApplyTag_Descriptor();
export class EffectRemoveTag {
  get descriptor() {
    return EffectRemoveTag.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTagName = false;
    this._tagName = null;
  }
  isEmpty() {
    if (this._hasTagName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectRemoveTag) {
      return value;
    }
    return EffectRemoveTag.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectRemoveTag();
    if (json.tagName != null) {
      result._hasTagName = true;
      result._tagName = JsonToString.fromJson(json.tagName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTagName) {
      result.tagName = JsonToString.toJson(this._tagName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get tagName() {
    return this._hasTagName ? this._tagName : JsonToString.default;
  }
  get hasTagName() {
    return this._hasTagName;
  }
  setTagName(path, value) {
    return {type: 'SET', path: path.concat(['tagName']), value};
  }
  deleteTagName(path) {
    return {type: 'DELETE', path: path.concat(['tagName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tagName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemoveTag(this);
              copy._hasTagName = true;
              copy._tagName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagName) {
                return this;
              }
              const copy = new EffectRemoveTag(this);
              copy._hasTagName = false;
              copy._tagName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectRemoveTag} other
   * @returns {EffectRemoveTag}
   */
  merge(other) {
    const copy = new EffectRemoveTag(this);
    if (other._hasTagName) {
      copy._hasTagName = true;
      copy._tagName = other._tagName;
    }
    return copy;
  }
}
EffectRemoveTag.default = new EffectRemoveTag();
class EffectRemoveTag_Builder {
  constructor(value) {
    this._value = new EffectRemoveTag(value);
  }
  build() {
    return new EffectRemoveTag(this._value);
  }
  setTagName(value) {
    this._value._hasTagName = true;
    this._value._tagName = value;
    return this;
  }
  deleteTagName() {
    this._value._hasTagName = false;
    this._value._tagName = null;
    return this;
  }
}
EffectRemoveTag.Builder = EffectRemoveTag_Builder;
class EffectRemoveTag_WithParent {
  /**
   * @param {EffectRemoveTag} value
   * @param {EffectRemoveTag_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectRemoveTag.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTagName() {
    if (this._cachedHasTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedHasTagName = true;
      } else {
        this._cachedHasTagName = this._parent ? this._parent.hasTagName : false;
      }
    }
    return this._cachedHasTagName;
  }
  get tagName() {
    if (this._cachedTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedTagName = this._value.tagName;
      } else {
        this._cachedTagName = this._parent ? this._parent.tagName : this._value.tagName;
      }
    }
    return this._cachedTagName;
  }
  update(current, parent) {
    const result = new EffectRemoveTag_WithParent(current, parent);
    return result;
  }
}
EffectRemoveTag_WithParent.default = new EffectRemoveTag_WithParent(EffectRemoveTag.default, null);
EffectRemoveTag.WithParent = EffectRemoveTag_WithParent;
class EffectRemoveTag_Descriptor {
  get tagName() {
    if (!this._tagName) {
      this._tagName = {
        name: "tagName",
        Name: "TagName",
        number: 1,
        protoType: 9,
        protoName: "tag_name",
        type: JsonToString,
        options: {
          comments: "The tag reference to remove.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tagName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTagName",
        Name: "DummyOneofForTagName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectRemoveTag.descriptor = new EffectRemoveTag_Descriptor();
class EffectSwitch_EffectCase {
  get descriptor() {
    return EffectSwitch_EffectCase.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEffect = false;
    this._effect = null;
    this._hasValidator = false;
    this._validator = null;
    this._hasFallThrough = false;
    this._fallThrough = null;
  }
  isEmpty() {
    if (this._hasEffect) return false;
    if (this._hasValidator) return false;
    if (this._hasFallThrough) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSwitch_EffectCase) {
      return value;
    }
    return EffectSwitch_EffectCase.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSwitch_EffectCase();
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.validator != null) {
      result._hasValidator = true;
      result._validator = JsonToString.fromJson(json.validator);
    }
    if (json.fallThrough != null) {
      result._hasFallThrough = true;
      result._fallThrough = JsonToBoolean.fromJson(json.fallThrough);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasValidator) {
      result.validator = JsonToString.toJson(this._validator);
    }
    if (this._hasFallThrough) {
      result.fallThrough = JsonToBoolean.toJson(this._fallThrough);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {string}
   */
  get validator() {
    return this._hasValidator ? this._validator : JsonToString.default;
  }
  get hasValidator() {
    return this._hasValidator;
  }
  setValidator(path, value) {
    return {type: 'SET', path: path.concat(['validator']), value};
  }
  deleteValidator(path) {
    return {type: 'DELETE', path: path.concat(['validator'])};
  }
  /**
   * @returns {boolean}
   */
  get fallThrough() {
    return this._hasFallThrough ? this._fallThrough : JsonToBoolean.default;
  }
  get hasFallThrough() {
    return this._hasFallThrough;
  }
  setFallThrough(path, value) {
    return {type: 'SET', path: path.concat(['fallThrough']), value};
  }
  deleteFallThrough(path) {
    return {type: 'DELETE', path: path.concat(['fallThrough'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "validator": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasValidator = true;
              copy._validator = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValidator) {
                return this;
              }
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasValidator = false;
              copy._validator = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fallThrough": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasFallThrough = true;
              copy._fallThrough = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFallThrough) {
                return this;
              }
              const copy = new EffectSwitch_EffectCase(this);
              copy._hasFallThrough = false;
              copy._fallThrough = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSwitch_EffectCase} other
   * @returns {EffectSwitch_EffectCase}
   */
  merge(other) {
    const copy = new EffectSwitch_EffectCase(this);
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasValidator) {
      copy._hasValidator = true;
      copy._validator = other._validator;
    }
    if (other._hasFallThrough) {
      copy._hasFallThrough = true;
      copy._fallThrough = other._fallThrough;
    }
    return copy;
  }
}
EffectSwitch_EffectCase.default = new EffectSwitch_EffectCase();
class EffectSwitch_EffectCase_Builder {
  constructor(value) {
    this._value = new EffectSwitch_EffectCase(value);
  }
  build() {
    return new EffectSwitch_EffectCase(this._value);
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setValidator(value) {
    this._value._hasValidator = true;
    this._value._validator = value;
    return this;
  }
  deleteValidator() {
    this._value._hasValidator = false;
    this._value._validator = null;
    return this;
  }
  setFallThrough(value) {
    this._value._hasFallThrough = true;
    this._value._fallThrough = value;
    return this;
  }
  deleteFallThrough() {
    this._value._hasFallThrough = false;
    this._value._fallThrough = null;
    return this;
  }
}
EffectSwitch_EffectCase.Builder = EffectSwitch_EffectCase_Builder;
class EffectSwitch_EffectCase_WithParent {
  /**
   * @param {EffectSwitch_EffectCase} value
   * @param {EffectSwitch_EffectCase_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSwitch_EffectCase.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasValidator() {
    if (this._cachedHasValidator === undefined) {
      if (this._value.hasValidator) {
        this._cachedHasValidator = true;
      } else {
        this._cachedHasValidator = this._parent ? this._parent.hasValidator : false;
      }
    }
    return this._cachedHasValidator;
  }
  get validator() {
    if (this._cachedValidator === undefined) {
      if (this._value.hasValidator) {
        this._cachedValidator = this._value.validator;
      } else {
        this._cachedValidator = this._parent ? this._parent.validator : this._value.validator;
      }
    }
    return this._cachedValidator;
  }
  get hasFallThrough() {
    if (this._cachedHasFallThrough === undefined) {
      if (this._value.hasFallThrough) {
        this._cachedHasFallThrough = true;
      } else {
        this._cachedHasFallThrough = this._parent ? this._parent.hasFallThrough : false;
      }
    }
    return this._cachedHasFallThrough;
  }
  get fallThrough() {
    if (this._cachedFallThrough === undefined) {
      if (this._value.hasFallThrough) {
        this._cachedFallThrough = this._value.fallThrough;
      } else {
        this._cachedFallThrough = this._parent ? this._parent.fallThrough : this._value.fallThrough;
      }
    }
    return this._cachedFallThrough;
  }
  update(current, parent) {
    const result = new EffectSwitch_EffectCase_WithParent(current, parent);
    return result;
  }
}
EffectSwitch_EffectCase_WithParent.default = new EffectSwitch_EffectCase_WithParent(EffectSwitch_EffectCase.default, null);
EffectSwitch_EffectCase.WithParent = EffectSwitch_EffectCase_WithParent;
class EffectSwitch_EffectCase_Descriptor {
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 1,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect to run if the validator passes.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get validator() {
    if (!this._validator) {
      this._validator = {
        name: "validator",
        Name: "Validator",
        number: 2,
        protoType: 9,
        protoName: "validator",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedValidatorNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validator;
  }
  get fallThrough() {
    if (!this._fallThrough) {
      this._fallThrough = {
        name: "fallThrough",
        Name: "FallThrough",
        number: 3,
        protoType: 8,
        protoName: "fall_through",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the next case will be evaluated even if this case passes.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fallThrough;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.effect,
        this.validator,
        this.fallThrough,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValidator",
        Name: "DummyOneofForValidator",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFallThrough",
        Name: "DummyOneofForFallThrough",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSwitch_EffectCase.descriptor = new EffectSwitch_EffectCase_Descriptor();
export class EffectSwitch {
  get descriptor() {
    return EffectSwitch.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._cases = [];
  }
  isEmpty() {
    if (this._hasTargetType) return false;
    if (this._cases.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSwitch) {
      return value;
    }
    return EffectSwitch.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSwitch();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    result._cases = JsonToList(json.cases, EffectSwitch_EffectCase);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._cases.length > 0) {
      result.cases = ArrayToJson(this._cases, EffectSwitch_EffectCase);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {EffectSwitch_EffectCase[]}
   */
  get cases() {
    return this._cases;
  }
  addCases(path, value) {
    return {type: 'ADD', path: path.concat(['cases']), value: value.toJson()};
  }
  setCases(path, value) {
    return {type: 'SET', path: path.concat(['cases']), value: ArrayToJson(value, EffectSwitch_EffectCase)};
  }
  setCasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cases', key]), value: value.toJson()};
  }
  deleteCases(path) {
    return {type: 'DELETE', path: path.concat(['cases'])};
  }
  deleteCasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cases', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch(this);
              copy._hasTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new EffectSwitch(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch(this);
              copy._cases = [];        for (let i of value) {
                copy._cases.push(EffectSwitch_EffectCase.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectSwitch(this);
              copy._cases = copy._cases.concat([EffectSwitch_EffectCase.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cases.length === 0) {
                return this;
              }
              const copy = new EffectSwitch(this);
              copy._cases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectSwitch(this);
              copy._cases = copy._cases.slice();
              copy._cases[path[1]] = EffectSwitch_EffectCase.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectSwitch(this);
              copy._cases = copy._cases.slice(0, path[1]).concat(copy._cases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cases.length) {
            return this;
          }
          const oldValue = this._cases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectSwitch(this);
          copy._cases = copy._cases.slice();
          copy._cases[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSwitch} other
   * @returns {EffectSwitch}
   */
  merge(other) {
    const copy = new EffectSwitch(this);
    if (other._hasTargetType) {
      copy._hasTargetType = true;
      copy._targetType = other._targetType;
    }
    copy._cases = this._cases.concat(other._cases);
    return copy;
  }
}
EffectSwitch.default = new EffectSwitch();
EffectSwitch.EffectCase = EffectSwitch_EffectCase;
class EffectSwitch_Builder {
  constructor(value) {
    this._value = new EffectSwitch(value);
  }
  build() {
    return new EffectSwitch(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  addAllCases(values) {
    this._value._cases = this._value._cases.concat(values);
    return this;
  }
  addCases(value) {
    this._value._cases = this._value._cases.concat([value]);
    return this;
  }
  setCases(index, value) {
    this._value._cases = this._value._cases.concat();
    this._value._cases[index] = value;
    return this;
  }
  clearCases() {
    this._value._cases = [];
    return this;
  }
}
EffectSwitch.Builder = EffectSwitch_Builder;
class EffectSwitch_WithParent {
  /**
   * @param {EffectSwitch} value
   * @param {EffectSwitch_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSwitch.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (this._cachedTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = this._value.targetType;
      } else {
        this._cachedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedTargetType;
  }
  get selfCases() {
    if (!this._selfCases) {
      this._selfCases = [];
      for (let i of this._value.cases) {
        this._selfCases.push(new EffectSwitch_EffectCase.WithParent(i, null));
      }
    }
    return this._selfCases;
  }
  get inherentCases() {
    if (!this._inherentCases) {
      this._inherentCases = this._parent ? this._parent.cases : [];
    }
    return this._inherentCases;
  }
  get cases() {
    if (!this._allCases) {
      this._allCases = this._parent ? this._parent.cases.concat(this.selfCases) : this.selfCases;
    }
    return this._allCases;
  }
  update(current, parent) {
    const result = new EffectSwitch_WithParent(current, parent);
    if (this._selfCases) {
      if (this._value.cases === current.cases) {
        result._selfCases = this._selfCases;
      } else {
        result._selfCases = [];
        for (let i = 0; i < current.cases.length; i++) {
          const oldValue = this._value.cases[i];
          if (oldValue) {
            const oldCache = this._selfCases[i];
            if (oldValue === current.cases[i]) {
              result._selfCases[i] = oldCache;
            } else {
              result._selfCases[i] = oldCache.update(current.cases[i], null);
            }
          } else {
            result._selfCases[i] = new EffectSwitch_EffectCase.WithParent(current.cases[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectSwitch_WithParent.default = new EffectSwitch_WithParent(EffectSwitch.default, null);
EffectSwitch.WithParent = EffectSwitch_WithParent;
class EffectSwitch_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 1,
        protoType: 14,
        protoName: "target_type",
        type: EffectTargetType_Type,
        options: {
          comments: "Used to determine the ability target type if this effect is the first effect of an ability.",
          default: "UNIT_OR_LOCATION",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get cases() {
    if (!this._cases) {
      this._cases = {
        name: "cases",
        Name: "Cases",
        number: 2,
        protoType: 11,
        protoName: "cases",
        type: EffectSwitch_EffectCase,
        isRepeated: true,
        options: {
          comments: "For each case (from top to bottom), check the Validator and execute the effect if the Validator succeeds. By default the switch ends when the first Validator passes.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cases;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.cases,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSwitch.descriptor = new EffectSwitch_Descriptor();
class EffectSetWaypoints_Waypoints_NearestWaypoint {
  get descriptor() {
    return EffectSetWaypoints_Waypoints_NearestWaypoint.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._allowedRoutes = [];
  }
  isEmpty() {
    if (this._allowedRoutes.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSetWaypoints_Waypoints_NearestWaypoint) {
      return value;
    }
    return EffectSetWaypoints_Waypoints_NearestWaypoint.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSetWaypoints_Waypoints_NearestWaypoint();
    result._allowedRoutes = JsonToList(json.allowedRoutes, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._allowedRoutes.length > 0) {
      result.allowedRoutes = ArrayToJson(this._allowedRoutes, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get allowedRoutes() {
    return this._allowedRoutes;
  }
  addAllowedRoutes(path, value) {
    return {type: 'ADD', path: path.concat(['allowedRoutes']), value};
  }
  setAllowedRoutes(path, value) {
    return {type: 'SET', path: path.concat(['allowedRoutes']), value: ArrayToJson(value, JsonToString)};
  }
  setAllowedRoutesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['allowedRoutes', key]), value};
  }
  deleteAllowedRoutes(path) {
    return {type: 'DELETE', path: path.concat(['allowedRoutes'])};
  }
  deleteAllowedRoutesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['allowedRoutes', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "allowedRoutes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
              copy._allowedRoutes = [];        for (let i of value) {
                copy._allowedRoutes.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
              copy._allowedRoutes = copy._allowedRoutes.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._allowedRoutes.length === 0) {
                return this;
              }
              const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
              copy._allowedRoutes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._allowedRoutes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
              copy._allowedRoutes = copy._allowedRoutes.slice();
              copy._allowedRoutes[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
              copy._allowedRoutes = copy._allowedRoutes.slice(0, path[1]).concat(copy._allowedRoutes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._allowedRoutes.length) {
            return this;
          }
          const oldValue = this._allowedRoutes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
          copy._allowedRoutes = copy._allowedRoutes.slice();
          copy._allowedRoutes[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSetWaypoints_Waypoints_NearestWaypoint} other
   * @returns {EffectSetWaypoints_Waypoints_NearestWaypoint}
   */
  merge(other) {
    const copy = new EffectSetWaypoints_Waypoints_NearestWaypoint(this);
    copy._allowedRoutes = this._allowedRoutes.concat(other._allowedRoutes);
    return copy;
  }
}
EffectSetWaypoints_Waypoints_NearestWaypoint.default = new EffectSetWaypoints_Waypoints_NearestWaypoint();
class EffectSetWaypoints_Waypoints_NearestWaypoint_Builder {
  constructor(value) {
    this._value = new EffectSetWaypoints_Waypoints_NearestWaypoint(value);
  }
  build() {
    return new EffectSetWaypoints_Waypoints_NearestWaypoint(this._value);
  }
  addAllAllowedRoutes(values) {
    this._value._allowedRoutes = this._value._allowedRoutes.concat(values);
    return this;
  }
  addAllowedRoutes(value) {
    this._value._allowedRoutes = this._value._allowedRoutes.concat([value]);
    return this;
  }
  setAllowedRoutes(index, value) {
    this._value._allowedRoutes = this._value._allowedRoutes.concat();
    this._value._allowedRoutes[index] = value;
    return this;
  }
  clearAllowedRoutes() {
    this._value._allowedRoutes = [];
    return this;
  }
}
EffectSetWaypoints_Waypoints_NearestWaypoint.Builder = EffectSetWaypoints_Waypoints_NearestWaypoint_Builder;
class EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent {
  /**
   * @param {EffectSetWaypoints_Waypoints_NearestWaypoint} value
   * @param {EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSetWaypoints_Waypoints_NearestWaypoint.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfAllowedRoutes() {
    return this._value.allowedRoutes;
  }
  get inherentAllowedRoutes() {
    if (!this._inherentAllowedRoutes) {
      this._inherentAllowedRoutes = this._parent ? this._parent.allowedRoutes : [];
    }
    return this._inherentAllowedRoutes;
  }
  get allowedRoutes() {
    if (!this._allAllowedRoutes) {
      this._allAllowedRoutes = this._parent ? this._parent.allowedRoutes.concat(this.selfAllowedRoutes) : this.selfAllowedRoutes;
    }
    return this._allAllowedRoutes;
  }
  update(current, parent) {
    const result = new EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent(current, parent);
    return result;
  }
}
EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent.default = new EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent(EffectSetWaypoints_Waypoints_NearestWaypoint.default, null);
EffectSetWaypoints_Waypoints_NearestWaypoint.WithParent = EffectSetWaypoints_Waypoints_NearestWaypoint_WithParent;
class EffectSetWaypoints_Waypoints_NearestWaypoint_Descriptor {
  get allowedRoutes() {
    if (!this._allowedRoutes) {
      this._allowedRoutes = {
        name: "allowedRoutes",
        Name: "AllowedRoutes",
        number: 1,
        protoType: 9,
        protoName: "allowed_routes",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Which routes will be searched, when set to NONE, all routes will be searched.",
          valueDropdown: "SupportedWaypointNameList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allowedRoutes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.allowedRoutes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectSetWaypoints_Waypoints_NearestWaypoint.descriptor = new EffectSetWaypoints_Waypoints_NearestWaypoint_Descriptor();
class EffectSetWaypoints_Waypoints {
  get descriptor() {
    return EffectSetWaypoints_Waypoints.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofWaypointsTypeCase = 0;
    this._oneofWaypointsTypeValue = null;
  }
  isEmpty() {
    if (this._oneofWaypointsTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSetWaypoints_Waypoints) {
      return value;
    }
    return EffectSetWaypoints_Waypoints.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSetWaypoints_Waypoints();
    if (json.waypointsName != null) {
      result._oneofWaypointsTypeCase = 11;
      result._oneofWaypointsTypeValue = JsonToString.fromJson(json.waypointsName);
    }
    if (json.fromUnit != null) {
      result._oneofWaypointsTypeCase = 12;
      result._oneofWaypointsTypeValue = EffectUnitTarget_Type.fromJson(json.fromUnit);
    }
    if (json.nearestWaypoint != null) {
      result._oneofWaypointsTypeCase = 13;
      result._oneofWaypointsTypeValue = EffectSetWaypoints_Waypoints_NearestWaypoint.fromJson(json.nearestWaypoint);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofWaypointsTypeCase) {
      case 11:
        result.waypointsName = JsonToString.toJson(this._oneofWaypointsTypeValue);
        break;
      case 12:
        result.fromUnit = EffectUnitTarget_Type.toJson(this._oneofWaypointsTypeValue);
        break;
      case 13:
        result.nearestWaypoint = EffectSetWaypoints_Waypoints_NearestWaypoint.toJson(this._oneofWaypointsTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofWaypointsTypeCase() {
    return this._oneofWaypointsTypeCase;
  }
  deleteOneofWaypointsType(path) {
    switch (this._oneofWaypointsTypeCase) {
      default:
      case 11: {
        return {type: 'DELETE', path: path.concat(['waypointsName'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['fromUnit'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['nearestWaypoint'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get waypointsName() {
    return this._oneofWaypointsTypeCase === 11 ? this._oneofWaypointsTypeValue : JsonToString.default;
  }
  setWaypointsName(path, value) {
    return {type: 'SET', path: path.concat(['waypointsName']), value};
  }
  deleteWaypointsName(path) {
    return {type: 'DELETE', path: path.concat(['waypointsName'])};
  }
  /**
   * @returns {number}
   */
  get fromUnit() {
    return this._oneofWaypointsTypeCase === 12 ? this._oneofWaypointsTypeValue : EffectUnitTarget_Type.default;
  }
  setFromUnit(path, value) {
    return {type: 'SET', path: path.concat(['fromUnit']), value};
  }
  deleteFromUnit(path) {
    return {type: 'DELETE', path: path.concat(['fromUnit'])};
  }
  /**
   * @returns {EffectSetWaypoints_Waypoints_NearestWaypoint}
   */
  get nearestWaypoint() {
    return this._oneofWaypointsTypeCase === 13 ? this._oneofWaypointsTypeValue : EffectSetWaypoints_Waypoints_NearestWaypoint.default;
  }
  setNearestWaypoint(path, value) {
    return {type: 'SET', path: path.concat(['nearestWaypoint']), value: value.toJson()};
  }
  deleteNearestWaypoint(path) {
    return {type: 'DELETE', path: path.concat(['nearestWaypoint'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "waypointsName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 11;
              copy._oneofWaypointsTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofWaypointsTypeCase !== 11) {
                return this;
              }
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 0;
              copy._oneofWaypointsTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fromUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 12;
              copy._oneofWaypointsTypeValue = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofWaypointsTypeCase !== 12) {
                return this;
              }
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 0;
              copy._oneofWaypointsTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nearestWaypoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 13;
              copy._oneofWaypointsTypeValue = EffectSetWaypoints_Waypoints_NearestWaypoint.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofWaypointsTypeCase !== 13) {
                return this;
              }
              const copy = new EffectSetWaypoints_Waypoints(this);
              copy._oneofWaypointsTypeCase = 0;
              copy._oneofWaypointsTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofWaypointsTypeCase !== 13) {
            const copy = new EffectSetWaypoints_Waypoints(this);
            copy._oneofWaypointsTypeCase = 13;
            copy._oneofWaypointsTypeValue = EffectSetWaypoints_Waypoints_NearestWaypoint.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.nearestWaypoint.apply(type, path.slice(1), value);
          if (newValue === this.nearestWaypoint) {
            return this;
          }
          const copy = new EffectSetWaypoints_Waypoints(this);
          copy._oneofWaypointsTypeCase = 13;
          copy._oneofWaypointsTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSetWaypoints_Waypoints} other
   * @returns {EffectSetWaypoints_Waypoints}
   */
  merge(other) {
    const copy = new EffectSetWaypoints_Waypoints(this);
    if (other._oneofWaypointsTypeCase === 11) {
      copy._oneofWaypointsTypeCase = 11;
      copy._oneofWaypointsTypeValue = other._oneofWaypointsTypeValue;
    }
    if (other._oneofWaypointsTypeCase === 11) {
      copy._oneofWaypointsTypeCase = 11;
      copy._oneofWaypointsTypeValue = other._oneofWaypointsTypeValue;
    }
    if (other._oneofWaypointsTypeCase === 11) {
      if (this._oneofWaypointsTypeCase === 11) {
        copy._oneofWaypointsTypeValue = copy._oneofWaypointsTypeValue.merge(other._oneofWaypointsTypeValue);
      } else {
        copy._oneofWaypointsTypeValue = other._oneofWaypointsTypeValue;
      }
      copy._oneofWaypointsTypeCase = 11;
    }
    return copy;
  }
}
EffectSetWaypoints_Waypoints.default = new EffectSetWaypoints_Waypoints();
EffectSetWaypoints_Waypoints.NearestWaypoint = EffectSetWaypoints_Waypoints_NearestWaypoint;
class EffectSetWaypoints_Waypoints_Builder {
  constructor(value) {
    this._value = new EffectSetWaypoints_Waypoints(value);
  }
  build() {
    return new EffectSetWaypoints_Waypoints(this._value);
  }
  clearoneofWaypointsType() {
    this._value._oneofWaypointsTypeCase = 0;
    this._value._oneofWaypointsTypeValue = null;
    return this;
  }
  setWaypointsName(value) {
    this._value._oneofWaypointsTypeCase = 11;
    this._value._oneofWaypointsTypeValue = value;
    return this;
  }
  setFromUnit(value) {
    this._value._oneofWaypointsTypeCase = 12;
    this._value._oneofWaypointsTypeValue = value;
    return this;
  }
  setNearestWaypoint(value) {
    this._value._oneofWaypointsTypeCase = 13;
    this._value._oneofWaypointsTypeValue = value;
    return this;
  }
}
EffectSetWaypoints_Waypoints.Builder = EffectSetWaypoints_Waypoints_Builder;
class EffectSetWaypoints_Waypoints_WithParent {
  /**
   * @param {EffectSetWaypoints_Waypoints} value
   * @param {EffectSetWaypoints_Waypoints_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSetWaypoints_Waypoints.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofWaypointsTypeCase() {
    if (this._cachedoneofWaypointsTypeCase === undefined) {
      if (this._value._oneofWaypointsTypeCase === 0) {
        this._cachedoneofWaypointsTypeCase = this._parent ? this._parent.oneofWaypointsTypeCase : 0;
      } else {
        this._cachedoneofWaypointsTypeCase = this._value._oneofWaypointsTypeCase;
      }
    }
    return this._cachedoneofWaypointsTypeCase;
  }
  get waypointsName() {
    if (!this._cachedWaypointsName) {
      if (this._value._oneofWaypointsTypeCase === 0) {
        this._cachedWaypointsName = this._parent ? this._parent.waypointsName : this._value.waypointsName;
      } else {
        this._cachedWaypointsName = this._value.waypointsName;
      }
    }
    return this._cachedWaypointsName;
  }
  get fromUnit() {
    if (!this._cachedFromUnit) {
      if (this._value._oneofWaypointsTypeCase === 0) {
        this._cachedFromUnit = this._parent ? this._parent.fromUnit : this._value.fromUnit;
      } else {
        this._cachedFromUnit = this._value.fromUnit;
      }
    }
    return this._cachedFromUnit;
  }
  get nearestWaypoint() {
    if (!this._cachedNearestWaypoint) {
      if (this._value._oneofWaypointsTypeCase === 0) {
        this._cachedNearestWaypoint = this._parent ? new EffectSetWaypoints_Waypoints_NearestWaypoint.WithParent(EffectSetWaypoints_Waypoints_NearestWaypoint.default, this._parent.nearestWaypoint) : this._value.nearestWaypoint;
      } else if (this._value._oneofWaypointsTypeCase === 13) {
        this._cachedNearestWaypoint = new EffectSetWaypoints_Waypoints_NearestWaypoint.WithParent(this._value.nearestWaypoint, this._parent && this._parent.oneofWaypointsTypeCase === 13 ? this._parent.nearestWaypoint : null);
      } else {
        this._cachedNearestWaypoint = EffectSetWaypoints_Waypoints_NearestWaypoint.WithParent.default;
      }
    }
    return this._cachedNearestWaypoint;
  }
  update(current, parent) {
    const result = new EffectSetWaypoints_Waypoints_WithParent(current, parent);
    if (this._cachedNearestWaypoint && this._value._oneofWaypointsTypeCase === 13 && current._oneofWaypointsTypeCase === 13) {
      if (this._value.nearestWaypoint === current.nearestWaypoint && this._parent === parent) {
        result._cachedNearestWaypoint = this._cachedNearestWaypoint;
      } else {
        result._cachedNearestWaypoint = this._cachedNearestWaypoint.update(current.nearestWaypoint, parent && parent.oneofWaypointsTypeCase === 13 ? parent.nearestWaypoint : null);
      }
    }
    return result;
  }
}
EffectSetWaypoints_Waypoints_WithParent.default = new EffectSetWaypoints_Waypoints_WithParent(EffectSetWaypoints_Waypoints.default, null);
EffectSetWaypoints_Waypoints.WithParent = EffectSetWaypoints_Waypoints_WithParent;
class EffectSetWaypoints_Waypoints_Descriptor {
  get waypointsName() {
    if (!this._waypointsName) {
      this._waypointsName = {
        name: "waypointsName",
        Name: "WaypointsName",
        number: 11,
        protoType: 9,
        protoName: "waypoints_name",
        oneofIndex: 0,
        type: JsonToString,
        options: {
          valueDropdown: "SupportedWaypointNameList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waypointsName;
  }
  get fromUnit() {
    if (!this._fromUnit) {
      this._fromUnit = {
        name: "fromUnit",
        Name: "FromUnit",
        number: 12,
        protoType: 14,
        protoName: "from_unit",
        oneofIndex: 0,
        type: EffectUnitTarget_Type,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fromUnit;
  }
  get nearestWaypoint() {
    if (!this._nearestWaypoint) {
      this._nearestWaypoint = {
        name: "nearestWaypoint",
        Name: "NearestWaypoint",
        number: 13,
        protoType: 11,
        protoName: "nearest_waypoint",
        oneofIndex: 0,
        type: EffectSetWaypoints_Waypoints_NearestWaypoint,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nearestWaypoint;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.waypointsName,
        this.fromUnit,
        this.nearestWaypoint,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofWaypointsType",
        Name: "OneofWaypointsType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSetWaypoints_Waypoints.descriptor = new EffectSetWaypoints_Waypoints_Descriptor();
export class EffectSetWaypoints {
  get descriptor() {
    return EffectSetWaypoints.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTarget = false;
    this._target = null;
    this._hasWaypoints = false;
    this._waypoints = null;
    this._hasDispersalOffset = false;
    this._dispersalOffset = null;
    this._hasDispersalOffsetRange = false;
    this._dispersalOffsetRange = null;
    this._hasUseNaturalDispersal = false;
    this._useNaturalDispersal = null;
    this._hasIgnoreRallyDisabledLanes = false;
    this._ignoreRallyDisabledLanes = null;
  }
  isEmpty() {
    if (this._hasTarget) return false;
    if (this._hasWaypoints && !this._waypoints.isEmpty()) return false;
    if (this._hasDispersalOffset) return false;
    if (this._hasDispersalOffsetRange) return false;
    if (this._hasUseNaturalDispersal) return false;
    if (this._hasIgnoreRallyDisabledLanes) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSetWaypoints) {
      return value;
    }
    return EffectSetWaypoints.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSetWaypoints();
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectUnitTarget_Type.fromJson(json.target);
    }
    if (json.waypoints != null) {
      result._hasWaypoints = true;
      result._waypoints = EffectSetWaypoints_Waypoints.fromJson(json.waypoints);
    }
    if (json.dispersalOffset != null) {
      result._hasDispersalOffset = true;
      result._dispersalOffset = JsonToDouble.fromJson(json.dispersalOffset);
    }
    if (json.dispersalOffsetRange != null) {
      result._hasDispersalOffsetRange = true;
      result._dispersalOffsetRange = JsonToDouble.fromJson(json.dispersalOffsetRange);
    }
    if (json.useNaturalDispersal != null) {
      result._hasUseNaturalDispersal = true;
      result._useNaturalDispersal = JsonToBoolean.fromJson(json.useNaturalDispersal);
    }
    if (json.ignoreRallyDisabledLanes != null) {
      result._hasIgnoreRallyDisabledLanes = true;
      result._ignoreRallyDisabledLanes = JsonToBoolean.fromJson(json.ignoreRallyDisabledLanes);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTarget) {
      result.target = EffectUnitTarget_Type.toJson(this._target);
    }
    if (this._hasWaypoints && !this._waypoints.isEmpty()) {
      result.waypoints = EffectSetWaypoints_Waypoints.toJson(this._waypoints);
    }
    if (this._hasDispersalOffset) {
      result.dispersalOffset = JsonToDouble.toJson(this._dispersalOffset);
    }
    if (this._hasDispersalOffsetRange) {
      result.dispersalOffsetRange = JsonToDouble.toJson(this._dispersalOffsetRange);
    }
    if (this._hasUseNaturalDispersal) {
      result.useNaturalDispersal = JsonToBoolean.toJson(this._useNaturalDispersal);
    }
    if (this._hasIgnoreRallyDisabledLanes) {
      result.ignoreRallyDisabledLanes = JsonToBoolean.toJson(this._ignoreRallyDisabledLanes);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectUnitTarget_Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {EffectSetWaypoints_Waypoints}
   */
  get waypoints() {
    return this._hasWaypoints ? this._waypoints : EffectSetWaypoints_Waypoints.default;
  }
  get hasWaypoints() {
    return this._hasWaypoints;
  }
  setWaypoints(path, value) {
    return {type: 'SET', path: path.concat(['waypoints']), value: value.toJson()};
  }
  deleteWaypoints(path) {
    return {type: 'DELETE', path: path.concat(['waypoints'])};
  }
  /**
   * @returns {number}
   */
  get dispersalOffset() {
    return this._hasDispersalOffset ? this._dispersalOffset : JsonToDouble.default;
  }
  get hasDispersalOffset() {
    return this._hasDispersalOffset;
  }
  setDispersalOffset(path, value) {
    return {type: 'SET', path: path.concat(['dispersalOffset']), value};
  }
  deleteDispersalOffset(path) {
    return {type: 'DELETE', path: path.concat(['dispersalOffset'])};
  }
  /**
   * @returns {number}
   */
  get dispersalOffsetRange() {
    return this._hasDispersalOffsetRange ? this._dispersalOffsetRange : JsonToDouble.default;
  }
  get hasDispersalOffsetRange() {
    return this._hasDispersalOffsetRange;
  }
  setDispersalOffsetRange(path, value) {
    return {type: 'SET', path: path.concat(['dispersalOffsetRange']), value};
  }
  deleteDispersalOffsetRange(path) {
    return {type: 'DELETE', path: path.concat(['dispersalOffsetRange'])};
  }
  /**
   * @returns {boolean}
   */
  get useNaturalDispersal() {
    return this._hasUseNaturalDispersal ? this._useNaturalDispersal : JsonToBoolean.default;
  }
  get hasUseNaturalDispersal() {
    return this._hasUseNaturalDispersal;
  }
  setUseNaturalDispersal(path, value) {
    return {type: 'SET', path: path.concat(['useNaturalDispersal']), value};
  }
  deleteUseNaturalDispersal(path) {
    return {type: 'DELETE', path: path.concat(['useNaturalDispersal'])};
  }
  /**
   * @returns {boolean}
   */
  get ignoreRallyDisabledLanes() {
    return this._hasIgnoreRallyDisabledLanes ? this._ignoreRallyDisabledLanes : JsonToBoolean.default;
  }
  get hasIgnoreRallyDisabledLanes() {
    return this._hasIgnoreRallyDisabledLanes;
  }
  setIgnoreRallyDisabledLanes(path, value) {
    return {type: 'SET', path: path.concat(['ignoreRallyDisabledLanes']), value};
  }
  deleteIgnoreRallyDisabledLanes(path) {
    return {type: 'DELETE', path: path.concat(['ignoreRallyDisabledLanes'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasTarget = true;
              copy._target = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "waypoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasWaypoints = true;
              copy._waypoints = EffectSetWaypoints_Waypoints.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaypoints) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasWaypoints = false;
              copy._waypoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaypoints) {
            const copy = new EffectSetWaypoints(this);
            copy._hasWaypoints = true;
            copy._waypoints = EffectSetWaypoints_Waypoints.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._waypoints.apply(type, path.slice(1), value);
          if (newValue === this._waypoints) {
            return this;
          }
          const copy = new EffectSetWaypoints(this);
          copy._waypoints = copy._waypoints.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "dispersalOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasDispersalOffset = true;
              copy._dispersalOffset = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDispersalOffset) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasDispersalOffset = false;
              copy._dispersalOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dispersalOffsetRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasDispersalOffsetRange = true;
              copy._dispersalOffsetRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDispersalOffsetRange) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasDispersalOffsetRange = false;
              copy._dispersalOffsetRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useNaturalDispersal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasUseNaturalDispersal = true;
              copy._useNaturalDispersal = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseNaturalDispersal) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasUseNaturalDispersal = false;
              copy._useNaturalDispersal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignoreRallyDisabledLanes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetWaypoints(this);
              copy._hasIgnoreRallyDisabledLanes = true;
              copy._ignoreRallyDisabledLanes = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnoreRallyDisabledLanes) {
                return this;
              }
              const copy = new EffectSetWaypoints(this);
              copy._hasIgnoreRallyDisabledLanes = false;
              copy._ignoreRallyDisabledLanes = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSetWaypoints} other
   * @returns {EffectSetWaypoints}
   */
  merge(other) {
    const copy = new EffectSetWaypoints(this);
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasWaypoints) {
      if (copy._hasWaypoints) {
        copy._waypoints = copy.waypoints.merge(other.waypoints);
      } else {
        copy._waypoints = other._waypoints;
      }
      copy._hasWaypoints = true;
    }
    if (other._hasDispersalOffset) {
      copy._hasDispersalOffset = true;
      copy._dispersalOffset = other._dispersalOffset;
    }
    if (other._hasDispersalOffsetRange) {
      copy._hasDispersalOffsetRange = true;
      copy._dispersalOffsetRange = other._dispersalOffsetRange;
    }
    if (other._hasUseNaturalDispersal) {
      copy._hasUseNaturalDispersal = true;
      copy._useNaturalDispersal = other._useNaturalDispersal;
    }
    if (other._hasIgnoreRallyDisabledLanes) {
      copy._hasIgnoreRallyDisabledLanes = true;
      copy._ignoreRallyDisabledLanes = other._ignoreRallyDisabledLanes;
    }
    return copy;
  }
}
EffectSetWaypoints.default = new EffectSetWaypoints();
EffectSetWaypoints.Waypoints = EffectSetWaypoints_Waypoints;
class EffectSetWaypoints_Builder {
  constructor(value) {
    this._value = new EffectSetWaypoints(value);
  }
  build() {
    return new EffectSetWaypoints(this._value);
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setWaypoints(value) {
    this._value._hasWaypoints = true;
    this._value._waypoints = value;
    return this;
  }
  deleteWaypoints() {
    this._value._hasWaypoints = false;
    this._value._waypoints = null;
    return this;
  }
  setDispersalOffset(value) {
    this._value._hasDispersalOffset = true;
    this._value._dispersalOffset = value;
    return this;
  }
  deleteDispersalOffset() {
    this._value._hasDispersalOffset = false;
    this._value._dispersalOffset = null;
    return this;
  }
  setDispersalOffsetRange(value) {
    this._value._hasDispersalOffsetRange = true;
    this._value._dispersalOffsetRange = value;
    return this;
  }
  deleteDispersalOffsetRange() {
    this._value._hasDispersalOffsetRange = false;
    this._value._dispersalOffsetRange = null;
    return this;
  }
  setUseNaturalDispersal(value) {
    this._value._hasUseNaturalDispersal = true;
    this._value._useNaturalDispersal = value;
    return this;
  }
  deleteUseNaturalDispersal() {
    this._value._hasUseNaturalDispersal = false;
    this._value._useNaturalDispersal = null;
    return this;
  }
  setIgnoreRallyDisabledLanes(value) {
    this._value._hasIgnoreRallyDisabledLanes = true;
    this._value._ignoreRallyDisabledLanes = value;
    return this;
  }
  deleteIgnoreRallyDisabledLanes() {
    this._value._hasIgnoreRallyDisabledLanes = false;
    this._value._ignoreRallyDisabledLanes = null;
    return this;
  }
}
EffectSetWaypoints.Builder = EffectSetWaypoints_Builder;
class EffectSetWaypoints_WithParent {
  /**
   * @param {EffectSetWaypoints} value
   * @param {EffectSetWaypoints_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSetWaypoints.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasWaypoints() {
    if (this._cachedHasWaypoints === undefined) {
      if (this._value.hasWaypoints) {
        this._cachedHasWaypoints = true;
      } else {
        this._cachedHasWaypoints = this._parent ? this._parent.hasWaypoints : false;
      }
    }
    return this._cachedHasWaypoints;
  }
  get waypoints() {
    if (!this._cachedWaypoints) {
      if (this._value.hasWaypoints) {
        this._cachedWaypoints = new EffectSetWaypoints_Waypoints.WithParent(this._value.waypoints, this._parent && this._parent.hasWaypoints ? this._parent.waypoints : null);
      } else {
        this._cachedWaypoints = this._parent ? new EffectSetWaypoints_Waypoints.WithParent(EffectSetWaypoints_Waypoints.default, this._parent.waypoints) : EffectSetWaypoints_Waypoints.WithParent.default;
      }
    }
    return this._cachedWaypoints;
  }
  get hasDispersalOffset() {
    if (this._cachedHasDispersalOffset === undefined) {
      if (this._value.hasDispersalOffset) {
        this._cachedHasDispersalOffset = true;
      } else {
        this._cachedHasDispersalOffset = this._parent ? this._parent.hasDispersalOffset : false;
      }
    }
    return this._cachedHasDispersalOffset;
  }
  get dispersalOffset() {
    if (this._cachedDispersalOffset === undefined) {
      if (this._value.hasDispersalOffset) {
        this._cachedDispersalOffset = this._value.dispersalOffset;
      } else {
        this._cachedDispersalOffset = this._parent ? this._parent.dispersalOffset : this._value.dispersalOffset;
      }
    }
    return this._cachedDispersalOffset;
  }
  get hasDispersalOffsetRange() {
    if (this._cachedHasDispersalOffsetRange === undefined) {
      if (this._value.hasDispersalOffsetRange) {
        this._cachedHasDispersalOffsetRange = true;
      } else {
        this._cachedHasDispersalOffsetRange = this._parent ? this._parent.hasDispersalOffsetRange : false;
      }
    }
    return this._cachedHasDispersalOffsetRange;
  }
  get dispersalOffsetRange() {
    if (this._cachedDispersalOffsetRange === undefined) {
      if (this._value.hasDispersalOffsetRange) {
        this._cachedDispersalOffsetRange = this._value.dispersalOffsetRange;
      } else {
        this._cachedDispersalOffsetRange = this._parent ? this._parent.dispersalOffsetRange : this._value.dispersalOffsetRange;
      }
    }
    return this._cachedDispersalOffsetRange;
  }
  get hasUseNaturalDispersal() {
    if (this._cachedHasUseNaturalDispersal === undefined) {
      if (this._value.hasUseNaturalDispersal) {
        this._cachedHasUseNaturalDispersal = true;
      } else {
        this._cachedHasUseNaturalDispersal = this._parent ? this._parent.hasUseNaturalDispersal : false;
      }
    }
    return this._cachedHasUseNaturalDispersal;
  }
  get useNaturalDispersal() {
    if (this._cachedUseNaturalDispersal === undefined) {
      if (this._value.hasUseNaturalDispersal) {
        this._cachedUseNaturalDispersal = this._value.useNaturalDispersal;
      } else {
        this._cachedUseNaturalDispersal = this._parent ? this._parent.useNaturalDispersal : this._value.useNaturalDispersal;
      }
    }
    return this._cachedUseNaturalDispersal;
  }
  get hasIgnoreRallyDisabledLanes() {
    if (this._cachedHasIgnoreRallyDisabledLanes === undefined) {
      if (this._value.hasIgnoreRallyDisabledLanes) {
        this._cachedHasIgnoreRallyDisabledLanes = true;
      } else {
        this._cachedHasIgnoreRallyDisabledLanes = this._parent ? this._parent.hasIgnoreRallyDisabledLanes : false;
      }
    }
    return this._cachedHasIgnoreRallyDisabledLanes;
  }
  get ignoreRallyDisabledLanes() {
    if (this._cachedIgnoreRallyDisabledLanes === undefined) {
      if (this._value.hasIgnoreRallyDisabledLanes) {
        this._cachedIgnoreRallyDisabledLanes = this._value.ignoreRallyDisabledLanes;
      } else {
        this._cachedIgnoreRallyDisabledLanes = this._parent ? this._parent.ignoreRallyDisabledLanes : this._value.ignoreRallyDisabledLanes;
      }
    }
    return this._cachedIgnoreRallyDisabledLanes;
  }
  update(current, parent) {
    const result = new EffectSetWaypoints_WithParent(current, parent);
    if (this._cachedWaypoints && this._value.hasWaypoints && current.hasWaypoints) {
      if (this._value.waypoints === current.waypoints && this._parent === parent) {
        result._cachedWaypoints = this._cachedWaypoints;
      } else {
        result._cachedWaypoints = this._cachedWaypoints.update(current.waypoints, parent && parent.hasWaypoints ? parent.waypoints : null);
      }
    }
    return result;
  }
}
EffectSetWaypoints_WithParent.default = new EffectSetWaypoints_WithParent(EffectSetWaypoints.default, null);
EffectSetWaypoints.WithParent = EffectSetWaypoints_WithParent;
class EffectSetWaypoints_Descriptor {
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 1,
        protoType: 14,
        protoName: "target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to set waypoints for.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get waypoints() {
    if (!this._waypoints) {
      this._waypoints = {
        name: "waypoints",
        Name: "Waypoints",
        number: 2,
        protoType: 11,
        protoName: "waypoints",
        type: EffectSetWaypoints_Waypoints,
        options: {
          comments: "Which method is used for setting waypoints.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waypoints;
  }
  get dispersalOffset() {
    if (!this._dispersalOffset) {
      this._dispersalOffset = {
        name: "dispersalOffset",
        Name: "DispersalOffset",
        number: 3,
        protoType: 1,
        protoName: "dispersal_offset",
        type: JsonToDouble,
        options: {
          comments: "Sets the waypoints offset across the lane width (0 = left edge, 1 = right edge).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dispersalOffset;
  }
  get dispersalOffsetRange() {
    if (!this._dispersalOffsetRange) {
      this._dispersalOffsetRange = {
        name: "dispersalOffsetRange",
        Name: "DispersalOffsetRange",
        number: 4,
        protoType: 1,
        protoName: "dispersal_offset_range",
        type: JsonToDouble,
        options: {
          comments: "A random number between this and 0 will be added to the dispersal offset.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dispersalOffsetRange;
  }
  get useNaturalDispersal() {
    if (!this._useNaturalDispersal) {
      this._useNaturalDispersal = {
        name: "useNaturalDispersal",
        Name: "UseNaturalDispersal",
        number: 5,
        protoType: 8,
        protoName: "use_natural_dispersal",
        type: JsonToBoolean,
        options: {
          comments: "If checked, determine dispersal automatically from unit\'s current position.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useNaturalDispersal;
  }
  get ignoreRallyDisabledLanes() {
    if (!this._ignoreRallyDisabledLanes) {
      this._ignoreRallyDisabledLanes = {
        name: "ignoreRallyDisabledLanes",
        Name: "IgnoreRallyDisabledLanes",
        number: 6,
        protoType: 8,
        protoName: "ignore_rally_disabled_lanes",
        type: JsonToBoolean,
        options: {
          comments: "When checked, lanes marked as \"Disable Rally\" as valid waypoints.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignoreRallyDisabledLanes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.target,
        this.waypoints,
        this.dispersalOffset,
        this.dispersalOffsetRange,
        this.useNaturalDispersal,
        this.ignoreRallyDisabledLanes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaypoints",
        Name: "DummyOneofForWaypoints",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDispersalOffset",
        Name: "DummyOneofForDispersalOffset",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDispersalOffsetRange",
        Name: "DummyOneofForDispersalOffsetRange",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseNaturalDispersal",
        Name: "DummyOneofForUseNaturalDispersal",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnoreRallyDisabledLanes",
        Name: "DummyOneofForIgnoreRallyDisabledLanes",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSetWaypoints.descriptor = new EffectSetWaypoints_Descriptor();
export class EffectDisengage {
  get descriptor() {
    return EffectDisengage.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLocation = false;
    this._location = null;
  }
  isEmpty() {
    if (this._hasLocation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectDisengage) {
      return value;
    }
    return EffectDisengage.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectDisengage();
    if (json.location != null) {
      result._hasLocation = true;
      result._location = EffectUnitTarget_Type.fromJson(json.location);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLocation) {
      result.location = EffectUnitTarget_Type.toJson(this._location);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : EffectUnitTarget_Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectDisengage(this);
              copy._hasLocation = true;
              copy._location = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new EffectDisengage(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectDisengage} other
   * @returns {EffectDisengage}
   */
  merge(other) {
    const copy = new EffectDisengage(this);
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    return copy;
  }
}
EffectDisengage.default = new EffectDisengage();
class EffectDisengage_Builder {
  constructor(value) {
    this._value = new EffectDisengage(value);
  }
  build() {
    return new EffectDisengage(this._value);
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
}
EffectDisengage.Builder = EffectDisengage_Builder;
class EffectDisengage_WithParent {
  /**
   * @param {EffectDisengage} value
   * @param {EffectDisengage_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectDisengage.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  update(current, parent) {
    const result = new EffectDisengage_WithParent(current, parent);
    return result;
  }
}
EffectDisengage_WithParent.default = new EffectDisengage_WithParent(EffectDisengage.default, null);
EffectDisengage.WithParent = EffectDisengage_WithParent;
class EffectDisengage_Descriptor {
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 1,
        protoType: 14,
        protoName: "location",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to disengage. If set to none, target unit will be used.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.location,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectDisengage.descriptor = new EffectDisengage_Descriptor();
export class EffectAddGold {
  get descriptor() {
    return EffectAddGold.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAmount = false;
    this._amount = null;
    this._hasTarget = false;
    this._target = null;
    this._hasDisplayInUi = false;
    this._displayInUi = null;
  }
  isEmpty() {
    if (this._hasAmount) return false;
    if (this._hasTarget) return false;
    if (this._hasDisplayInUi) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectAddGold) {
      return value;
    }
    return EffectAddGold.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectAddGold();
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectUnitTarget_Type.fromJson(json.target);
    }
    if (json.displayInUi != null) {
      result._hasDisplayInUi = true;
      result._displayInUi = JsonToBoolean.fromJson(json.displayInUi);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasTarget) {
      result.target = EffectUnitTarget_Type.toJson(this._target);
    }
    if (this._hasDisplayInUi) {
      result.displayInUi = JsonToBoolean.toJson(this._displayInUi);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectUnitTarget_Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  /**
   * @returns {boolean}
   */
  get displayInUi() {
    return this._hasDisplayInUi ? this._displayInUi : JsonToBoolean.default;
  }
  get hasDisplayInUi() {
    return this._hasDisplayInUi;
  }
  setDisplayInUi(path, value) {
    return {type: 'SET', path: path.concat(['displayInUi']), value};
  }
  deleteDisplayInUi(path) {
    return {type: 'DELETE', path: path.concat(['displayInUi'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAddGold(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectAddGold(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAddGold(this);
              copy._hasTarget = true;
              copy._target = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectAddGold(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayInUi": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectAddGold(this);
              copy._hasDisplayInUi = true;
              copy._displayInUi = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayInUi) {
                return this;
              }
              const copy = new EffectAddGold(this);
              copy._hasDisplayInUi = false;
              copy._displayInUi = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectAddGold} other
   * @returns {EffectAddGold}
   */
  merge(other) {
    const copy = new EffectAddGold(this);
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    if (other._hasDisplayInUi) {
      copy._hasDisplayInUi = true;
      copy._displayInUi = other._displayInUi;
    }
    return copy;
  }
}
EffectAddGold.default = new EffectAddGold();
class EffectAddGold_Builder {
  constructor(value) {
    this._value = new EffectAddGold(value);
  }
  build() {
    return new EffectAddGold(this._value);
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
  setDisplayInUi(value) {
    this._value._hasDisplayInUi = true;
    this._value._displayInUi = value;
    return this;
  }
  deleteDisplayInUi() {
    this._value._hasDisplayInUi = false;
    this._value._displayInUi = null;
    return this;
  }
}
EffectAddGold.Builder = EffectAddGold_Builder;
class EffectAddGold_WithParent {
  /**
   * @param {EffectAddGold} value
   * @param {EffectAddGold_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectAddGold.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  get hasDisplayInUi() {
    if (this._cachedHasDisplayInUi === undefined) {
      if (this._value.hasDisplayInUi) {
        this._cachedHasDisplayInUi = true;
      } else {
        this._cachedHasDisplayInUi = this._parent ? this._parent.hasDisplayInUi : false;
      }
    }
    return this._cachedHasDisplayInUi;
  }
  get displayInUi() {
    if (this._cachedDisplayInUi === undefined) {
      if (this._value.hasDisplayInUi) {
        this._cachedDisplayInUi = this._value.displayInUi;
      } else {
        this._cachedDisplayInUi = this._parent ? this._parent.displayInUi : this._value.displayInUi;
      }
    }
    return this._cachedDisplayInUi;
  }
  update(current, parent) {
    const result = new EffectAddGold_WithParent(current, parent);
    return result;
  }
}
EffectAddGold_WithParent.default = new EffectAddGold_WithParent(EffectAddGold.default, null);
EffectAddGold.WithParent = EffectAddGold_WithParent;
class EffectAddGold_Descriptor {
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 1,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          comments: "The amount of gold to add.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 2,
        protoType: 14,
        protoName: "target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit\'s owner to give gold to. Using NONE defaults to TARGET_UNIT. NONE is TARGET_UNIT",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get displayInUi() {
    if (!this._displayInUi) {
      this._displayInUi = {
        name: "displayInUi",
        Name: "DisplayInUi",
        number: 3,
        protoType: 8,
        protoName: "display_in_ui",
        type: JsonToBoolean,
        options: {
          comments: "If checked, will create UI ingame when the effect is created.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayInUi;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.amount,
        this.target,
        this.displayInUi,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayInUi",
        Name: "DummyOneofForDisplayInUi",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectAddGold.descriptor = new EffectAddGold_Descriptor();
export class EffectConsumeMana {
  get descriptor() {
    return EffectConsumeMana.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAmount = false;
    this._amount = null;
    this._hasTarget = false;
    this._target = null;
  }
  isEmpty() {
    if (this._hasAmount) return false;
    if (this._hasTarget) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectConsumeMana) {
      return value;
    }
    return EffectConsumeMana.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectConsumeMana();
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.target != null) {
      result._hasTarget = true;
      result._target = EffectUnitTarget_Type.fromJson(json.target);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasTarget) {
      result.target = EffectUnitTarget_Type.toJson(this._target);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {number}
   */
  get target() {
    return this._hasTarget ? this._target : EffectUnitTarget_Type.default;
  }
  get hasTarget() {
    return this._hasTarget;
  }
  setTarget(path, value) {
    return {type: 'SET', path: path.concat(['target']), value};
  }
  deleteTarget(path) {
    return {type: 'DELETE', path: path.concat(['target'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectConsumeMana(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectConsumeMana(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "target": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectConsumeMana(this);
              copy._hasTarget = true;
              copy._target = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTarget) {
                return this;
              }
              const copy = new EffectConsumeMana(this);
              copy._hasTarget = false;
              copy._target = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectConsumeMana} other
   * @returns {EffectConsumeMana}
   */
  merge(other) {
    const copy = new EffectConsumeMana(this);
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasTarget) {
      copy._hasTarget = true;
      copy._target = other._target;
    }
    return copy;
  }
}
EffectConsumeMana.default = new EffectConsumeMana();
class EffectConsumeMana_Builder {
  constructor(value) {
    this._value = new EffectConsumeMana(value);
  }
  build() {
    return new EffectConsumeMana(this._value);
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setTarget(value) {
    this._value._hasTarget = true;
    this._value._target = value;
    return this;
  }
  deleteTarget() {
    this._value._hasTarget = false;
    this._value._target = null;
    return this;
  }
}
EffectConsumeMana.Builder = EffectConsumeMana_Builder;
class EffectConsumeMana_WithParent {
  /**
   * @param {EffectConsumeMana} value
   * @param {EffectConsumeMana_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectConsumeMana.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasTarget() {
    if (this._cachedHasTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedHasTarget = true;
      } else {
        this._cachedHasTarget = this._parent ? this._parent.hasTarget : false;
      }
    }
    return this._cachedHasTarget;
  }
  get target() {
    if (this._cachedTarget === undefined) {
      if (this._value.hasTarget) {
        this._cachedTarget = this._value.target;
      } else {
        this._cachedTarget = this._parent ? this._parent.target : this._value.target;
      }
    }
    return this._cachedTarget;
  }
  update(current, parent) {
    const result = new EffectConsumeMana_WithParent(current, parent);
    return result;
  }
}
EffectConsumeMana_WithParent.default = new EffectConsumeMana_WithParent(EffectConsumeMana.default, null);
EffectConsumeMana.WithParent = EffectConsumeMana_WithParent;
class EffectConsumeMana_Descriptor {
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 1,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          comments: "The amount of mana to consume.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get target() {
    if (!this._target) {
      this._target = {
        name: "target",
        Name: "Target",
        number: 2,
        protoType: 14,
        protoName: "target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to consume mana from. Using NONE defaults to TARGET_UNIT. NONE is TARGET_UNIT",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._target;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.amount,
        this.target,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTarget",
        Name: "DummyOneofForTarget",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectConsumeMana.descriptor = new EffectConsumeMana_Descriptor();
export class EffectTeleport {
  get descriptor() {
    return EffectTeleport.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasTo = false;
    this._to = null;
    this._hasOffsetStart = false;
    this._offsetStart = null;
    this._hasOffsetEnd = false;
    this._offsetEnd = null;
    this._hasOffset = false;
    this._offset = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasTo) return false;
    if (this._hasOffsetStart) return false;
    if (this._hasOffsetEnd) return false;
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectTeleport) {
      return value;
    }
    return EffectTeleport.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectTeleport();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.to != null) {
      result._hasTo = true;
      result._to = EffectTarget_Type.fromJson(json.to);
    }
    if (json.offsetStart != null) {
      result._hasOffsetStart = true;
      result._offsetStart = EffectTarget_Type.fromJson(json.offsetStart);
    }
    if (json.offsetEnd != null) {
      result._hasOffsetEnd = true;
      result._offsetEnd = EffectTarget_Type.fromJson(json.offsetEnd);
    }
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = EffectOffset.fromJson(json.offset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasTo) {
      result.to = EffectTarget_Type.toJson(this._to);
    }
    if (this._hasOffsetStart) {
      result.offsetStart = EffectTarget_Type.toJson(this._offsetStart);
    }
    if (this._hasOffsetEnd) {
      result.offsetEnd = EffectTarget_Type.toJson(this._offsetEnd);
    }
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = EffectOffset.toJson(this._offset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get to() {
    return this._hasTo ? this._to : EffectTarget_Type.default;
  }
  get hasTo() {
    return this._hasTo;
  }
  setTo(path, value) {
    return {type: 'SET', path: path.concat(['to']), value};
  }
  deleteTo(path) {
    return {type: 'DELETE', path: path.concat(['to'])};
  }
  /**
   * @returns {number}
   */
  get offsetStart() {
    return this._hasOffsetStart ? this._offsetStart : EffectTarget_Type.default;
  }
  get hasOffsetStart() {
    return this._hasOffsetStart;
  }
  setOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['offsetStart']), value};
  }
  deleteOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['offsetStart'])};
  }
  /**
   * @returns {number}
   */
  get offsetEnd() {
    return this._hasOffsetEnd ? this._offsetEnd : EffectTarget_Type.default;
  }
  get hasOffsetEnd() {
    return this._hasOffsetEnd;
  }
  setOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['offsetEnd']), value};
  }
  deleteOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['offsetEnd'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get offset() {
    return this._hasOffset ? this._offset : EffectOffset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleport(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectTeleport(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "to": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleport(this);
              copy._hasTo = true;
              copy._to = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTo) {
                return this;
              }
              const copy = new EffectTeleport(this);
              copy._hasTo = false;
              copy._to = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleport(this);
              copy._hasOffsetStart = true;
              copy._offsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetStart) {
                return this;
              }
              const copy = new EffectTeleport(this);
              copy._hasOffsetStart = false;
              copy._offsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleport(this);
              copy._hasOffsetEnd = true;
              copy._offsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffsetEnd) {
                return this;
              }
              const copy = new EffectTeleport(this);
              copy._hasOffsetEnd = false;
              copy._offsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleport(this);
              copy._hasOffset = true;
              copy._offset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new EffectTeleport(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new EffectTeleport(this);
            copy._hasOffset = true;
            copy._offset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new EffectTeleport(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectTeleport} other
   * @returns {EffectTeleport}
   */
  merge(other) {
    const copy = new EffectTeleport(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasTo) {
      copy._hasTo = true;
      copy._to = other._to;
    }
    if (other._hasOffsetStart) {
      copy._hasOffsetStart = true;
      copy._offsetStart = other._offsetStart;
    }
    if (other._hasOffsetEnd) {
      copy._hasOffsetEnd = true;
      copy._offsetEnd = other._offsetEnd;
    }
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    return copy;
  }
}
EffectTeleport.default = new EffectTeleport();
class EffectTeleport_Builder {
  constructor(value) {
    this._value = new EffectTeleport(value);
  }
  build() {
    return new EffectTeleport(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setTo(value) {
    this._value._hasTo = true;
    this._value._to = value;
    return this;
  }
  deleteTo() {
    this._value._hasTo = false;
    this._value._to = null;
    return this;
  }
  setOffsetStart(value) {
    this._value._hasOffsetStart = true;
    this._value._offsetStart = value;
    return this;
  }
  deleteOffsetStart() {
    this._value._hasOffsetStart = false;
    this._value._offsetStart = null;
    return this;
  }
  setOffsetEnd(value) {
    this._value._hasOffsetEnd = true;
    this._value._offsetEnd = value;
    return this;
  }
  deleteOffsetEnd() {
    this._value._hasOffsetEnd = false;
    this._value._offsetEnd = null;
    return this;
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
}
EffectTeleport.Builder = EffectTeleport_Builder;
class EffectTeleport_WithParent {
  /**
   * @param {EffectTeleport} value
   * @param {EffectTeleport_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectTeleport.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasTo() {
    if (this._cachedHasTo === undefined) {
      if (this._value.hasTo) {
        this._cachedHasTo = true;
      } else {
        this._cachedHasTo = this._parent ? this._parent.hasTo : false;
      }
    }
    return this._cachedHasTo;
  }
  get to() {
    if (this._cachedTo === undefined) {
      if (this._value.hasTo) {
        this._cachedTo = this._value.to;
      } else {
        this._cachedTo = this._parent ? this._parent.to : this._value.to;
      }
    }
    return this._cachedTo;
  }
  get hasOffsetStart() {
    if (this._cachedHasOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedHasOffsetStart = true;
      } else {
        this._cachedHasOffsetStart = this._parent ? this._parent.hasOffsetStart : false;
      }
    }
    return this._cachedHasOffsetStart;
  }
  get offsetStart() {
    if (this._cachedOffsetStart === undefined) {
      if (this._value.hasOffsetStart) {
        this._cachedOffsetStart = this._value.offsetStart;
      } else {
        this._cachedOffsetStart = this._parent ? this._parent.offsetStart : this._value.offsetStart;
      }
    }
    return this._cachedOffsetStart;
  }
  get hasOffsetEnd() {
    if (this._cachedHasOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedHasOffsetEnd = true;
      } else {
        this._cachedHasOffsetEnd = this._parent ? this._parent.hasOffsetEnd : false;
      }
    }
    return this._cachedHasOffsetEnd;
  }
  get offsetEnd() {
    if (this._cachedOffsetEnd === undefined) {
      if (this._value.hasOffsetEnd) {
        this._cachedOffsetEnd = this._value.offsetEnd;
      } else {
        this._cachedOffsetEnd = this._parent ? this._parent.offsetEnd : this._value.offsetEnd;
      }
    }
    return this._cachedOffsetEnd;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new EffectOffset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.offset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  update(current, parent) {
    const result = new EffectTeleport_WithParent(current, parent);
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
EffectTeleport_WithParent.default = new EffectTeleport_WithParent(EffectTeleport.default, null);
EffectTeleport.WithParent = EffectTeleport_WithParent;
class EffectTeleport_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to teleport.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get to() {
    if (!this._to) {
      this._to = {
        name: "to",
        Name: "To",
        number: 2,
        protoType: 14,
        protoName: "to",
        type: EffectTarget_Type,
        options: {
          comments: "Where to teleport the unit to.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._to;
  }
  get offsetStart() {
    if (!this._offsetStart) {
      this._offsetStart = {
        name: "offsetStart",
        Name: "OffsetStart",
        number: 3,
        protoType: 14,
        protoName: "offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Offset start & end together determines the offset forward, right and up directions.\nIf start & end are same unit, forward direction will be that unit\'s orientation. If start & end are using target unit but effect is casted on target location, offset will be ignored. If start & end are different units, forward direction will be start--->end",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetStart;
  }
  get offsetEnd() {
    if (!this._offsetEnd) {
      this._offsetEnd = {
        name: "offsetEnd",
        Name: "OffsetEnd",
        number: 4,
        protoType: 14,
        protoName: "offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offsetEnd;
  }
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 5,
        protoType: 11,
        protoName: "offset",
        type: EffectOffset,
        options: {
          comments: "Offset for the teleport destination.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.to,
        this.offsetStart,
        this.offsetEnd,
        this.offset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTo",
        Name: "DummyOneofForTo",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetStart",
        Name: "DummyOneofForOffsetStart",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffsetEnd",
        Name: "DummyOneofForOffsetEnd",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffset",
        Name: "DummyOneofForOffset",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectTeleport.descriptor = new EffectTeleport_Descriptor();
export class EffectTeleportAlongWaypoint {
  get descriptor() {
    return EffectTeleportAlongWaypoint.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasDistance = false;
    this._distance = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasDistance) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectTeleportAlongWaypoint) {
      return value;
    }
    return EffectTeleportAlongWaypoint.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectTeleportAlongWaypoint();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.distance != null) {
      result._hasDistance = true;
      result._distance = JsonToDouble.fromJson(json.distance);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasDistance) {
      result.distance = JsonToDouble.toJson(this._distance);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get distance() {
    return this._hasDistance ? this._distance : JsonToDouble.default;
  }
  get hasDistance() {
    return this._hasDistance;
  }
  setDistance(path, value) {
    return {type: 'SET', path: path.concat(['distance']), value};
  }
  deleteDistance(path) {
    return {type: 'DELETE', path: path.concat(['distance'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleportAlongWaypoint(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectTeleportAlongWaypoint(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectTeleportAlongWaypoint(this);
              copy._hasDistance = true;
              copy._distance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistance) {
                return this;
              }
              const copy = new EffectTeleportAlongWaypoint(this);
              copy._hasDistance = false;
              copy._distance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectTeleportAlongWaypoint} other
   * @returns {EffectTeleportAlongWaypoint}
   */
  merge(other) {
    const copy = new EffectTeleportAlongWaypoint(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasDistance) {
      copy._hasDistance = true;
      copy._distance = other._distance;
    }
    return copy;
  }
}
EffectTeleportAlongWaypoint.default = new EffectTeleportAlongWaypoint();
class EffectTeleportAlongWaypoint_Builder {
  constructor(value) {
    this._value = new EffectTeleportAlongWaypoint(value);
  }
  build() {
    return new EffectTeleportAlongWaypoint(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setDistance(value) {
    this._value._hasDistance = true;
    this._value._distance = value;
    return this;
  }
  deleteDistance() {
    this._value._hasDistance = false;
    this._value._distance = null;
    return this;
  }
}
EffectTeleportAlongWaypoint.Builder = EffectTeleportAlongWaypoint_Builder;
class EffectTeleportAlongWaypoint_WithParent {
  /**
   * @param {EffectTeleportAlongWaypoint} value
   * @param {EffectTeleportAlongWaypoint_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectTeleportAlongWaypoint.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasDistance() {
    if (this._cachedHasDistance === undefined) {
      if (this._value.hasDistance) {
        this._cachedHasDistance = true;
      } else {
        this._cachedHasDistance = this._parent ? this._parent.hasDistance : false;
      }
    }
    return this._cachedHasDistance;
  }
  get distance() {
    if (this._cachedDistance === undefined) {
      if (this._value.hasDistance) {
        this._cachedDistance = this._value.distance;
      } else {
        this._cachedDistance = this._parent ? this._parent.distance : this._value.distance;
      }
    }
    return this._cachedDistance;
  }
  update(current, parent) {
    const result = new EffectTeleportAlongWaypoint_WithParent(current, parent);
    return result;
  }
}
EffectTeleportAlongWaypoint_WithParent.default = new EffectTeleportAlongWaypoint_WithParent(EffectTeleportAlongWaypoint.default, null);
EffectTeleportAlongWaypoint.WithParent = EffectTeleportAlongWaypoint_WithParent;
class EffectTeleportAlongWaypoint_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to teleport.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get distance() {
    if (!this._distance) {
      this._distance = {
        name: "distance",
        Name: "Distance",
        number: 2,
        protoType: 1,
        protoName: "distance",
        type: JsonToDouble,
        options: {
          comments: "Distance along waypoints to teleport a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distance;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.distance,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistance",
        Name: "DummyOneofForDistance",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectTeleportAlongWaypoint.descriptor = new EffectTeleportAlongWaypoint_Descriptor();
export class EffectSetRallyPoint {
  get descriptor() {
    return EffectSetRallyPoint.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasLocation = false;
    this._location = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasLocation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSetRallyPoint) {
      return value;
    }
    return EffectSetRallyPoint.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSetRallyPoint();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.location != null) {
      result._hasLocation = true;
      result._location = EffectTarget_Type.fromJson(json.location);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasLocation) {
      result.location = EffectTarget_Type.toJson(this._location);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get location() {
    return this._hasLocation ? this._location : EffectTarget_Type.default;
  }
  get hasLocation() {
    return this._hasLocation;
  }
  setLocation(path, value) {
    return {type: 'SET', path: path.concat(['location']), value};
  }
  deleteLocation(path) {
    return {type: 'DELETE', path: path.concat(['location'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetRallyPoint(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectSetRallyPoint(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "location": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetRallyPoint(this);
              copy._hasLocation = true;
              copy._location = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocation) {
                return this;
              }
              const copy = new EffectSetRallyPoint(this);
              copy._hasLocation = false;
              copy._location = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSetRallyPoint} other
   * @returns {EffectSetRallyPoint}
   */
  merge(other) {
    const copy = new EffectSetRallyPoint(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasLocation) {
      copy._hasLocation = true;
      copy._location = other._location;
    }
    return copy;
  }
}
EffectSetRallyPoint.default = new EffectSetRallyPoint();
class EffectSetRallyPoint_Builder {
  constructor(value) {
    this._value = new EffectSetRallyPoint(value);
  }
  build() {
    return new EffectSetRallyPoint(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setLocation(value) {
    this._value._hasLocation = true;
    this._value._location = value;
    return this;
  }
  deleteLocation() {
    this._value._hasLocation = false;
    this._value._location = null;
    return this;
  }
}
EffectSetRallyPoint.Builder = EffectSetRallyPoint_Builder;
class EffectSetRallyPoint_WithParent {
  /**
   * @param {EffectSetRallyPoint} value
   * @param {EffectSetRallyPoint_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSetRallyPoint.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasLocation() {
    if (this._cachedHasLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedHasLocation = true;
      } else {
        this._cachedHasLocation = this._parent ? this._parent.hasLocation : false;
      }
    }
    return this._cachedHasLocation;
  }
  get location() {
    if (this._cachedLocation === undefined) {
      if (this._value.hasLocation) {
        this._cachedLocation = this._value.location;
      } else {
        this._cachedLocation = this._parent ? this._parent.location : this._value.location;
      }
    }
    return this._cachedLocation;
  }
  update(current, parent) {
    const result = new EffectSetRallyPoint_WithParent(current, parent);
    return result;
  }
}
EffectSetRallyPoint_WithParent.default = new EffectSetRallyPoint_WithParent(EffectSetRallyPoint.default, null);
EffectSetRallyPoint.WithParent = EffectSetRallyPoint_WithParent;
class EffectSetRallyPoint_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to set rally point. For barracks tower, this should be the tower.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get location() {
    if (!this._location) {
      this._location = {
        name: "location",
        Name: "Location",
        number: 2,
        protoType: 14,
        protoName: "location",
        type: EffectTarget_Type,
        options: {
          comments: "The location of the new rally point on the ground to set to.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._location;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.location,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocation",
        Name: "DummyOneofForLocation",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSetRallyPoint.descriptor = new EffectSetRallyPoint_Descriptor();
class EffectEnumerateUnitList_LocationModeStatic {
  get descriptor() {
    return EffectEnumerateUnitList_LocationModeStatic.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectEnumerateUnitList_LocationModeStatic) {
      return value;
    }
    return EffectEnumerateUnitList_LocationModeStatic.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectEnumerateUnitList_LocationModeStatic();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {EffectEnumerateUnitList_LocationModeStatic} other
   * @returns {EffectEnumerateUnitList_LocationModeStatic}
   */
  merge(other) {
    const copy = new EffectEnumerateUnitList_LocationModeStatic(this);
    return copy;
  }
}
EffectEnumerateUnitList_LocationModeStatic.default = new EffectEnumerateUnitList_LocationModeStatic();
class EffectEnumerateUnitList_LocationModeStatic_Builder {
  constructor(value) {
    this._value = new EffectEnumerateUnitList_LocationModeStatic(value);
  }
  build() {
    return new EffectEnumerateUnitList_LocationModeStatic(this._value);
  }
}
EffectEnumerateUnitList_LocationModeStatic.Builder = EffectEnumerateUnitList_LocationModeStatic_Builder;
class EffectEnumerateUnitList_LocationModeStatic_WithParent {
  /**
   * @param {EffectEnumerateUnitList_LocationModeStatic} value
   * @param {EffectEnumerateUnitList_LocationModeStatic_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectEnumerateUnitList_LocationModeStatic.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new EffectEnumerateUnitList_LocationModeStatic_WithParent(current, parent);
    return result;
  }
}
EffectEnumerateUnitList_LocationModeStatic_WithParent.default = new EffectEnumerateUnitList_LocationModeStatic_WithParent(EffectEnumerateUnitList_LocationModeStatic.default, null);
EffectEnumerateUnitList_LocationModeStatic.WithParent = EffectEnumerateUnitList_LocationModeStatic_WithParent;
class EffectEnumerateUnitList_LocationModeStatic_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EffectEnumerateUnitList_LocationModeStatic.descriptor = new EffectEnumerateUnitList_LocationModeStatic_Descriptor();
class EffectEnumerateUnitList_LocationModeDynamic {
  get descriptor() {
    return EffectEnumerateUnitList_LocationModeDynamic.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStepDelay = false;
    this._stepDelay = null;
  }
  isEmpty() {
    if (this._hasStepDelay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectEnumerateUnitList_LocationModeDynamic) {
      return value;
    }
    return EffectEnumerateUnitList_LocationModeDynamic.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectEnumerateUnitList_LocationModeDynamic();
    if (json.stepDelay != null) {
      result._hasStepDelay = true;
      result._stepDelay = JsonToDouble.fromJson(json.stepDelay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStepDelay) {
      result.stepDelay = JsonToDouble.toJson(this._stepDelay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get stepDelay() {
    return this._hasStepDelay ? this._stepDelay : JsonToDouble.default;
  }
  get hasStepDelay() {
    return this._hasStepDelay;
  }
  setStepDelay(path, value) {
    return {type: 'SET', path: path.concat(['stepDelay']), value};
  }
  deleteStepDelay(path) {
    return {type: 'DELETE', path: path.concat(['stepDelay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "stepDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList_LocationModeDynamic(this);
              copy._hasStepDelay = true;
              copy._stepDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStepDelay) {
                return this;
              }
              const copy = new EffectEnumerateUnitList_LocationModeDynamic(this);
              copy._hasStepDelay = false;
              copy._stepDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectEnumerateUnitList_LocationModeDynamic} other
   * @returns {EffectEnumerateUnitList_LocationModeDynamic}
   */
  merge(other) {
    const copy = new EffectEnumerateUnitList_LocationModeDynamic(this);
    if (other._hasStepDelay) {
      copy._hasStepDelay = true;
      copy._stepDelay = other._stepDelay;
    }
    return copy;
  }
}
EffectEnumerateUnitList_LocationModeDynamic.default = new EffectEnumerateUnitList_LocationModeDynamic();
class EffectEnumerateUnitList_LocationModeDynamic_Builder {
  constructor(value) {
    this._value = new EffectEnumerateUnitList_LocationModeDynamic(value);
  }
  build() {
    return new EffectEnumerateUnitList_LocationModeDynamic(this._value);
  }
  setStepDelay(value) {
    this._value._hasStepDelay = true;
    this._value._stepDelay = value;
    return this;
  }
  deleteStepDelay() {
    this._value._hasStepDelay = false;
    this._value._stepDelay = null;
    return this;
  }
}
EffectEnumerateUnitList_LocationModeDynamic.Builder = EffectEnumerateUnitList_LocationModeDynamic_Builder;
class EffectEnumerateUnitList_LocationModeDynamic_WithParent {
  /**
   * @param {EffectEnumerateUnitList_LocationModeDynamic} value
   * @param {EffectEnumerateUnitList_LocationModeDynamic_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectEnumerateUnitList_LocationModeDynamic.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStepDelay() {
    if (this._cachedHasStepDelay === undefined) {
      if (this._value.hasStepDelay) {
        this._cachedHasStepDelay = true;
      } else {
        this._cachedHasStepDelay = this._parent ? this._parent.hasStepDelay : false;
      }
    }
    return this._cachedHasStepDelay;
  }
  get stepDelay() {
    if (this._cachedStepDelay === undefined) {
      if (this._value.hasStepDelay) {
        this._cachedStepDelay = this._value.stepDelay;
      } else {
        this._cachedStepDelay = this._parent ? this._parent.stepDelay : this._value.stepDelay;
      }
    }
    return this._cachedStepDelay;
  }
  update(current, parent) {
    const result = new EffectEnumerateUnitList_LocationModeDynamic_WithParent(current, parent);
    return result;
  }
}
EffectEnumerateUnitList_LocationModeDynamic_WithParent.default = new EffectEnumerateUnitList_LocationModeDynamic_WithParent(EffectEnumerateUnitList_LocationModeDynamic.default, null);
EffectEnumerateUnitList_LocationModeDynamic.WithParent = EffectEnumerateUnitList_LocationModeDynamic_WithParent;
class EffectEnumerateUnitList_LocationModeDynamic_Descriptor {
  get stepDelay() {
    if (!this._stepDelay) {
      this._stepDelay = {
        name: "stepDelay",
        Name: "StepDelay",
        number: 1,
        protoType: 1,
        protoName: "step_delay",
        type: JsonToDouble,
        options: {
          comments: "Creates a delay between each search.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stepDelay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.stepDelay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStepDelay",
        Name: "DummyOneofForStepDelay",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectEnumerateUnitList_LocationModeDynamic.descriptor = new EffectEnumerateUnitList_LocationModeDynamic_Descriptor();
class EffectEnumerateUnitList_IterationModes {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "REPEAT": return 0;
        case "FALL_THROUGH": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectEnumerateUnitList_IterationModes.fromJson(value);
  }
  static fromReact(e) {
    return EffectEnumerateUnitList_IterationModes.fromJson(e);
  }
}
EffectEnumerateUnitList_IterationModes.REPEAT = 0;
EffectEnumerateUnitList_IterationModes.FALL_THROUGH = 1;
EffectEnumerateUnitList_IterationModes.default = 0;
EffectEnumerateUnitList_IterationModes.values = {
  REPEAT: 0,
  FALL_THROUGH: 1,
};
EffectEnumerateUnitList_IterationModes.names = {
  0: "REPEAT",
  1: "FALL_THROUGH",
};
export class EffectEnumerateUnitList {
  get descriptor() {
    return EffectEnumerateUnitList.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTargetType = false;
    this._targetType = null;
    this._hasIterationMode = false;
    this._iterationMode = null;
    this._hasRepeatList = false;
    this._repeatList = null;
    this._oneofLocationModeCase = 0;
    this._oneofLocationModeValue = null;
    this._hasStepCount = false;
    this._stepCount = null;
    this._stepCountExpressions = [];
    this._hasValidator = false;
    this._validator = null;
    this._hasSearchEffect = false;
    this._searchEffect = null;
    this._hasDeprecatedImpactEffet = false;
    this._impactEffet = null;
    this._hasDeprecatedUpdateSourceToPreiousTarget = false;
    this._updateSourceToPreiousTarget = null;
    this._hasMissingEffect = false;
    this._missingEffect = null;
    this._hasImpactEffect = false;
    this._impactEffect = null;
    this._hasUpdateSourceToPreviousTarget = false;
    this._updateSourceToPreviousTarget = null;
  }
  isEmpty() {
    if (this._hasTargetType) return false;
    if (this._hasIterationMode) return false;
    if (this._hasRepeatList) return false;
    if (this._oneofLocationModeCase !== 0) return false;
    if (this._hasStepCount) return false;
    if (this._stepCountExpressions.length > 0) return false;
    if (this._hasValidator) return false;
    if (this._hasSearchEffect) return false;
    if (this._hasDeprecatedImpactEffet) return false;
    if (this._hasDeprecatedUpdateSourceToPreiousTarget) return false;
    if (this._hasMissingEffect) return false;
    if (this._hasImpactEffect) return false;
    if (this._hasUpdateSourceToPreviousTarget) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectEnumerateUnitList) {
      return value;
    }
    return EffectEnumerateUnitList.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectEnumerateUnitList();
    if (json.targetType != null) {
      result._hasTargetType = true;
      result._targetType = EffectTargetType_Type.fromJson(json.targetType);
    }
    if (json.iterationMode != null) {
      result._hasIterationMode = true;
      result._iterationMode = EffectEnumerateUnitList_IterationModes.fromJson(json.iterationMode);
    }
    if (json.repeatList != null) {
      result._hasRepeatList = true;
      result._repeatList = JsonToBoolean.fromJson(json.repeatList);
    }
    if (json.useSearchLocation != null) {
      result._oneofLocationModeCase = 4;
      result._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeStatic.fromJson(json.useSearchLocation);
    }
    if (json.useTargetLocation != null) {
      result._oneofLocationModeCase = 5;
      result._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeDynamic.fromJson(json.useTargetLocation);
    }
    if (json.stepCount != null) {
      result._hasStepCount = true;
      result._stepCount = JsonToInt32.fromJson(json.stepCount);
    }
    result._stepCountExpressions = JsonToList(json.stepCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.validator != null) {
      result._hasValidator = true;
      result._validator = JsonToString.fromJson(json.validator);
    }
    if (json.searchEffect != null) {
      result._hasSearchEffect = true;
      result._searchEffect = JsonToString.fromJson(json.searchEffect);
    }
    if (json.impactEffet != null) {
      result._hasDeprecatedImpactEffet = true;
      result._impactEffet = JsonToString.fromJson(json.impactEffet);
    }
    if (json.updateSourceToPreiousTarget != null) {
      result._hasDeprecatedUpdateSourceToPreiousTarget = true;
      result._updateSourceToPreiousTarget = JsonToBoolean.fromJson(json.updateSourceToPreiousTarget);
    }
    if (json.missingEffect != null) {
      result._hasMissingEffect = true;
      result._missingEffect = JsonToString.fromJson(json.missingEffect);
    }
    if (json.impactEffect != null) {
      result._hasImpactEffect = true;
      result._impactEffect = JsonToString.fromJson(json.impactEffect);
    }
    if (json.updateSourceToPreviousTarget != null) {
      result._hasUpdateSourceToPreviousTarget = true;
      result._updateSourceToPreviousTarget = JsonToBoolean.fromJson(json.updateSourceToPreviousTarget);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTargetType) {
      result.targetType = EffectTargetType_Type.toJson(this._targetType);
    }
    if (this._hasIterationMode) {
      result.iterationMode = EffectEnumerateUnitList_IterationModes.toJson(this._iterationMode);
    }
    if (this._hasRepeatList) {
      result.repeatList = JsonToBoolean.toJson(this._repeatList);
    }
    switch (this._oneofLocationModeCase) {
      case 4:
        result.useSearchLocation = EffectEnumerateUnitList_LocationModeStatic.toJson(this._oneofLocationModeValue);
        break;
      case 5:
        result.useTargetLocation = EffectEnumerateUnitList_LocationModeDynamic.toJson(this._oneofLocationModeValue);
        break;
      default:
        break;
    }
    if (this._hasStepCount) {
      result.stepCount = JsonToInt32.toJson(this._stepCount);
    }
    if (this._stepCountExpressions.length > 0) {
      result.stepCountExpressions = ArrayToJson(this._stepCountExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasValidator) {
      result.validator = JsonToString.toJson(this._validator);
    }
    if (this._hasSearchEffect) {
      result.searchEffect = JsonToString.toJson(this._searchEffect);
    }
    if (this._hasDeprecatedImpactEffet) {
      result.impactEffet = JsonToString.toJson(this._impactEffet);
    }
    if (this._hasDeprecatedUpdateSourceToPreiousTarget) {
      result.updateSourceToPreiousTarget = JsonToBoolean.toJson(this._updateSourceToPreiousTarget);
    }
    if (this._hasMissingEffect) {
      result.missingEffect = JsonToString.toJson(this._missingEffect);
    }
    if (this._hasImpactEffect) {
      result.impactEffect = JsonToString.toJson(this._impactEffect);
    }
    if (this._hasUpdateSourceToPreviousTarget) {
      result.updateSourceToPreviousTarget = JsonToBoolean.toJson(this._updateSourceToPreviousTarget);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get targetType() {
    return this._hasTargetType ? this._targetType : EffectTargetType_Type.default;
  }
  get hasTargetType() {
    return this._hasTargetType;
  }
  setTargetType(path, value) {
    return {type: 'SET', path: path.concat(['targetType']), value};
  }
  deleteTargetType(path) {
    return {type: 'DELETE', path: path.concat(['targetType'])};
  }
  /**
   * @returns {number}
   */
  get iterationMode() {
    return this._hasIterationMode ? this._iterationMode : EffectEnumerateUnitList_IterationModes.default;
  }
  get hasIterationMode() {
    return this._hasIterationMode;
  }
  setIterationMode(path, value) {
    return {type: 'SET', path: path.concat(['iterationMode']), value};
  }
  deleteIterationMode(path) {
    return {type: 'DELETE', path: path.concat(['iterationMode'])};
  }
  /**
   * @returns {boolean}
   */
  get repeatList() {
    return this._hasRepeatList ? this._repeatList : JsonToBoolean.default;
  }
  get hasRepeatList() {
    return this._hasRepeatList;
  }
  setRepeatList(path, value) {
    return {type: 'SET', path: path.concat(['repeatList']), value};
  }
  deleteRepeatList(path) {
    return {type: 'DELETE', path: path.concat(['repeatList'])};
  }
  get oneofLocationModeCase() {
    return this._oneofLocationModeCase;
  }
  deleteOneofLocationMode(path) {
    switch (this._oneofLocationModeCase) {
      default:
      case 4: {
        return {type: 'DELETE', path: path.concat(['useSearchLocation'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['useTargetLocation'])};
      }
    }
  }
  /**
   * @returns {EffectEnumerateUnitList_LocationModeStatic}
   */
  get useSearchLocation() {
    return this._oneofLocationModeCase === 4 ? this._oneofLocationModeValue : EffectEnumerateUnitList_LocationModeStatic.default;
  }
  setUseSearchLocation(path, value) {
    return {type: 'SET', path: path.concat(['useSearchLocation']), value: value.toJson()};
  }
  deleteUseSearchLocation(path) {
    return {type: 'DELETE', path: path.concat(['useSearchLocation'])};
  }
  /**
   * @returns {EffectEnumerateUnitList_LocationModeDynamic}
   */
  get useTargetLocation() {
    return this._oneofLocationModeCase === 5 ? this._oneofLocationModeValue : EffectEnumerateUnitList_LocationModeDynamic.default;
  }
  setUseTargetLocation(path, value) {
    return {type: 'SET', path: path.concat(['useTargetLocation']), value: value.toJson()};
  }
  deleteUseTargetLocation(path) {
    return {type: 'DELETE', path: path.concat(['useTargetLocation'])};
  }
  /**
   * @returns {number}
   */
  get stepCount() {
    return this._hasStepCount ? this._stepCount : JsonToInt32.default;
  }
  get hasStepCount() {
    return this._hasStepCount;
  }
  setStepCount(path, value) {
    return {type: 'SET', path: path.concat(['stepCount']), value};
  }
  deleteStepCount(path) {
    return {type: 'DELETE', path: path.concat(['stepCount'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get stepCountExpressions() {
    return this._stepCountExpressions;
  }
  addStepCountExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['stepCountExpressions']), value: value.toJson()};
  }
  setStepCountExpressions(path, value) {
    return {type: 'SET', path: path.concat(['stepCountExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setStepCountExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['stepCountExpressions', key]), value: value.toJson()};
  }
  deleteStepCountExpressions(path) {
    return {type: 'DELETE', path: path.concat(['stepCountExpressions'])};
  }
  deleteStepCountExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['stepCountExpressions', key])};
  }
  /**
   * @returns {string}
   */
  get validator() {
    return this._hasValidator ? this._validator : JsonToString.default;
  }
  get hasValidator() {
    return this._hasValidator;
  }
  setValidator(path, value) {
    return {type: 'SET', path: path.concat(['validator']), value};
  }
  deleteValidator(path) {
    return {type: 'DELETE', path: path.concat(['validator'])};
  }
  /**
   * @returns {string}
   */
  get searchEffect() {
    return this._hasSearchEffect ? this._searchEffect : JsonToString.default;
  }
  get hasSearchEffect() {
    return this._hasSearchEffect;
  }
  setSearchEffect(path, value) {
    return {type: 'SET', path: path.concat(['searchEffect']), value};
  }
  deleteSearchEffect(path) {
    return {type: 'DELETE', path: path.concat(['searchEffect'])};
  }
  /**
   * @returns {string}
   */
  get impactEffet() {
    return this._hasDeprecatedImpactEffet ? this._impactEffet : JsonToString.default;
  }
  get hasDeprecatedImpactEffet() {
    return this._hasDeprecatedImpactEffet;
  }
  setDeprecatedImpactEffet(path, value) {
    return {type: 'SET', path: path.concat(['impactEffet']), value};
  }
  deleteDeprecatedImpactEffet(path) {
    return {type: 'DELETE', path: path.concat(['impactEffet'])};
  }
  /**
   * @returns {boolean}
   */
  get updateSourceToPreiousTarget() {
    return this._hasDeprecatedUpdateSourceToPreiousTarget ? this._updateSourceToPreiousTarget : JsonToBoolean.default;
  }
  get hasDeprecatedUpdateSourceToPreiousTarget() {
    return this._hasDeprecatedUpdateSourceToPreiousTarget;
  }
  setDeprecatedUpdateSourceToPreiousTarget(path, value) {
    return {type: 'SET', path: path.concat(['updateSourceToPreiousTarget']), value};
  }
  deleteDeprecatedUpdateSourceToPreiousTarget(path) {
    return {type: 'DELETE', path: path.concat(['updateSourceToPreiousTarget'])};
  }
  /**
   * @returns {string}
   */
  get missingEffect() {
    return this._hasMissingEffect ? this._missingEffect : JsonToString.default;
  }
  get hasMissingEffect() {
    return this._hasMissingEffect;
  }
  setMissingEffect(path, value) {
    return {type: 'SET', path: path.concat(['missingEffect']), value};
  }
  deleteMissingEffect(path) {
    return {type: 'DELETE', path: path.concat(['missingEffect'])};
  }
  /**
   * @returns {string}
   */
  get impactEffect() {
    return this._hasImpactEffect ? this._impactEffect : JsonToString.default;
  }
  get hasImpactEffect() {
    return this._hasImpactEffect;
  }
  setImpactEffect(path, value) {
    return {type: 'SET', path: path.concat(['impactEffect']), value};
  }
  deleteImpactEffect(path) {
    return {type: 'DELETE', path: path.concat(['impactEffect'])};
  }
  /**
   * @returns {boolean}
   */
  get updateSourceToPreviousTarget() {
    return this._hasUpdateSourceToPreviousTarget ? this._updateSourceToPreviousTarget : JsonToBoolean.default;
  }
  get hasUpdateSourceToPreviousTarget() {
    return this._hasUpdateSourceToPreviousTarget;
  }
  setUpdateSourceToPreviousTarget(path, value) {
    return {type: 'SET', path: path.concat(['updateSourceToPreviousTarget']), value};
  }
  deleteUpdateSourceToPreviousTarget(path) {
    return {type: 'DELETE', path: path.concat(['updateSourceToPreviousTarget'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "targetType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasTargetType = true;
              copy._targetType = EffectTargetType_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetType) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasTargetType = false;
              copy._targetType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "iterationMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasIterationMode = true;
              copy._iterationMode = EffectEnumerateUnitList_IterationModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIterationMode) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasIterationMode = false;
              copy._iterationMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "repeatList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasRepeatList = true;
              copy._repeatList = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRepeatList) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasRepeatList = false;
              copy._repeatList = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useSearchLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._oneofLocationModeCase = 4;
              copy._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeStatic.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofLocationModeCase !== 4) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._oneofLocationModeCase = 0;
              copy._oneofLocationModeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofLocationModeCase !== 4) {
            const copy = new EffectEnumerateUnitList(this);
            copy._oneofLocationModeCase = 4;
            copy._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeStatic.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.useSearchLocation.apply(type, path.slice(1), value);
          if (newValue === this.useSearchLocation) {
            return this;
          }
          const copy = new EffectEnumerateUnitList(this);
          copy._oneofLocationModeCase = 4;
          copy._oneofLocationModeValue = newValue;
          return copy;
        }
      }
      case "useTargetLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._oneofLocationModeCase = 5;
              copy._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeDynamic.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofLocationModeCase !== 5) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._oneofLocationModeCase = 0;
              copy._oneofLocationModeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofLocationModeCase !== 5) {
            const copy = new EffectEnumerateUnitList(this);
            copy._oneofLocationModeCase = 5;
            copy._oneofLocationModeValue = EffectEnumerateUnitList_LocationModeDynamic.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.useTargetLocation.apply(type, path.slice(1), value);
          if (newValue === this.useTargetLocation) {
            return this;
          }
          const copy = new EffectEnumerateUnitList(this);
          copy._oneofLocationModeCase = 5;
          copy._oneofLocationModeValue = newValue;
          return copy;
        }
      }
      case "stepCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasStepCount = true;
              copy._stepCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStepCount) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasStepCount = false;
              copy._stepCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stepCountExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._stepCountExpressions = [];        for (let i of value) {
                copy._stepCountExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EffectEnumerateUnitList(this);
              copy._stepCountExpressions = copy._stepCountExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._stepCountExpressions.length === 0) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._stepCountExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._stepCountExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._stepCountExpressions = copy._stepCountExpressions.slice();
              copy._stepCountExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EffectEnumerateUnitList(this);
              copy._stepCountExpressions = copy._stepCountExpressions.slice(0, path[1]).concat(copy._stepCountExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._stepCountExpressions.length) {
            return this;
          }
          const oldValue = this._stepCountExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EffectEnumerateUnitList(this);
          copy._stepCountExpressions = copy._stepCountExpressions.slice();
          copy._stepCountExpressions[key] = newValue;
          return copy;
        }
      }
      case "validator": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasValidator = true;
              copy._validator = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValidator) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasValidator = false;
              copy._validator = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "searchEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasSearchEffect = true;
              copy._searchEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSearchEffect) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasSearchEffect = false;
              copy._searchEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactEffet": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasDeprecatedImpactEffet = true;
              copy._impactEffet = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedImpactEffet) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasDeprecatedImpactEffet = false;
              copy._impactEffet = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "updateSourceToPreiousTarget": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasDeprecatedUpdateSourceToPreiousTarget = true;
              copy._updateSourceToPreiousTarget = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedUpdateSourceToPreiousTarget) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasDeprecatedUpdateSourceToPreiousTarget = false;
              copy._updateSourceToPreiousTarget = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "missingEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasMissingEffect = true;
              copy._missingEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMissingEffect) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasMissingEffect = false;
              copy._missingEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasImpactEffect = true;
              copy._impactEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactEffect) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasImpactEffect = false;
              copy._impactEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "updateSourceToPreviousTarget": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectEnumerateUnitList(this);
              copy._hasUpdateSourceToPreviousTarget = true;
              copy._updateSourceToPreviousTarget = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpdateSourceToPreviousTarget) {
                return this;
              }
              const copy = new EffectEnumerateUnitList(this);
              copy._hasUpdateSourceToPreviousTarget = false;
              copy._updateSourceToPreviousTarget = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectEnumerateUnitList} other
   * @returns {EffectEnumerateUnitList}
   */
  merge(other) {
    const copy = new EffectEnumerateUnitList(this);
    if (other._hasTargetType) {
      copy._hasTargetType = true;
      copy._targetType = other._targetType;
    }
    if (other._hasIterationMode) {
      copy._hasIterationMode = true;
      copy._iterationMode = other._iterationMode;
    }
    if (other._hasRepeatList) {
      copy._hasRepeatList = true;
      copy._repeatList = other._repeatList;
    }
    if (other._oneofLocationModeCase === 4) {
      if (this._oneofLocationModeCase === 4) {
        copy._oneofLocationModeValue = copy._oneofLocationModeValue.merge(other._oneofLocationModeValue);
      } else {
        copy._oneofLocationModeValue = other._oneofLocationModeValue;
      }
      copy._oneofLocationModeCase = 4;
    }
    if (other._oneofLocationModeCase === 4) {
      if (this._oneofLocationModeCase === 4) {
        copy._oneofLocationModeValue = copy._oneofLocationModeValue.merge(other._oneofLocationModeValue);
      } else {
        copy._oneofLocationModeValue = other._oneofLocationModeValue;
      }
      copy._oneofLocationModeCase = 4;
    }
    if (other._hasStepCount) {
      copy._hasStepCount = true;
      copy._stepCount = other._stepCount;
    }
    copy._stepCountExpressions = this._stepCountExpressions.concat(other._stepCountExpressions);
    if (other._hasValidator) {
      copy._hasValidator = true;
      copy._validator = other._validator;
    }
    if (other._hasSearchEffect) {
      copy._hasSearchEffect = true;
      copy._searchEffect = other._searchEffect;
    }
    if (other._hasDeprecatedImpactEffet) {
      copy._hasDeprecatedImpactEffet = true;
      copy._impactEffet = other._impactEffet;
    }
    if (other._hasDeprecatedUpdateSourceToPreiousTarget) {
      copy._hasDeprecatedUpdateSourceToPreiousTarget = true;
      copy._updateSourceToPreiousTarget = other._updateSourceToPreiousTarget;
    }
    if (other._hasMissingEffect) {
      copy._hasMissingEffect = true;
      copy._missingEffect = other._missingEffect;
    }
    if (other._hasImpactEffect) {
      copy._hasImpactEffect = true;
      copy._impactEffect = other._impactEffect;
    }
    if (other._hasUpdateSourceToPreviousTarget) {
      copy._hasUpdateSourceToPreviousTarget = true;
      copy._updateSourceToPreviousTarget = other._updateSourceToPreviousTarget;
    }
    return copy;
  }
}
EffectEnumerateUnitList.default = new EffectEnumerateUnitList();
EffectEnumerateUnitList.LocationModeStatic = EffectEnumerateUnitList_LocationModeStatic;
EffectEnumerateUnitList.LocationModeDynamic = EffectEnumerateUnitList_LocationModeDynamic;
EffectEnumerateUnitList.IterationModes = EffectEnumerateUnitList_IterationModes;
class EffectEnumerateUnitList_Builder {
  constructor(value) {
    this._value = new EffectEnumerateUnitList(value);
  }
  build() {
    return new EffectEnumerateUnitList(this._value);
  }
  setTargetType(value) {
    this._value._hasTargetType = true;
    this._value._targetType = value;
    return this;
  }
  deleteTargetType() {
    this._value._hasTargetType = false;
    this._value._targetType = null;
    return this;
  }
  setIterationMode(value) {
    this._value._hasIterationMode = true;
    this._value._iterationMode = value;
    return this;
  }
  deleteIterationMode() {
    this._value._hasIterationMode = false;
    this._value._iterationMode = null;
    return this;
  }
  setRepeatList(value) {
    this._value._hasRepeatList = true;
    this._value._repeatList = value;
    return this;
  }
  deleteRepeatList() {
    this._value._hasRepeatList = false;
    this._value._repeatList = null;
    return this;
  }
  clearoneofLocationMode() {
    this._value._oneofLocationModeCase = 0;
    this._value._oneofLocationModeValue = null;
    return this;
  }
  setUseSearchLocation(value) {
    this._value._oneofLocationModeCase = 4;
    this._value._oneofLocationModeValue = value;
    return this;
  }
  setUseTargetLocation(value) {
    this._value._oneofLocationModeCase = 5;
    this._value._oneofLocationModeValue = value;
    return this;
  }
  setStepCount(value) {
    this._value._hasStepCount = true;
    this._value._stepCount = value;
    return this;
  }
  deleteStepCount() {
    this._value._hasStepCount = false;
    this._value._stepCount = null;
    return this;
  }
  addAllStepCountExpressions(values) {
    this._value._stepCountExpressions = this._value._stepCountExpressions.concat(values);
    return this;
  }
  addStepCountExpressions(value) {
    this._value._stepCountExpressions = this._value._stepCountExpressions.concat([value]);
    return this;
  }
  setStepCountExpressions(index, value) {
    this._value._stepCountExpressions = this._value._stepCountExpressions.concat();
    this._value._stepCountExpressions[index] = value;
    return this;
  }
  clearStepCountExpressions() {
    this._value._stepCountExpressions = [];
    return this;
  }
  setValidator(value) {
    this._value._hasValidator = true;
    this._value._validator = value;
    return this;
  }
  deleteValidator() {
    this._value._hasValidator = false;
    this._value._validator = null;
    return this;
  }
  setSearchEffect(value) {
    this._value._hasSearchEffect = true;
    this._value._searchEffect = value;
    return this;
  }
  deleteSearchEffect() {
    this._value._hasSearchEffect = false;
    this._value._searchEffect = null;
    return this;
  }
  setDeprecatedImpactEffet(value) {
    this._value._hasDeprecatedImpactEffet = true;
    this._value._impactEffet = value;
    return this;
  }
  deleteDeprecatedImpactEffet() {
    this._value._hasDeprecatedImpactEffet = false;
    this._value._impactEffet = null;
    return this;
  }
  setDeprecatedUpdateSourceToPreiousTarget(value) {
    this._value._hasDeprecatedUpdateSourceToPreiousTarget = true;
    this._value._updateSourceToPreiousTarget = value;
    return this;
  }
  deleteDeprecatedUpdateSourceToPreiousTarget() {
    this._value._hasDeprecatedUpdateSourceToPreiousTarget = false;
    this._value._updateSourceToPreiousTarget = null;
    return this;
  }
  setMissingEffect(value) {
    this._value._hasMissingEffect = true;
    this._value._missingEffect = value;
    return this;
  }
  deleteMissingEffect() {
    this._value._hasMissingEffect = false;
    this._value._missingEffect = null;
    return this;
  }
  setImpactEffect(value) {
    this._value._hasImpactEffect = true;
    this._value._impactEffect = value;
    return this;
  }
  deleteImpactEffect() {
    this._value._hasImpactEffect = false;
    this._value._impactEffect = null;
    return this;
  }
  setUpdateSourceToPreviousTarget(value) {
    this._value._hasUpdateSourceToPreviousTarget = true;
    this._value._updateSourceToPreviousTarget = value;
    return this;
  }
  deleteUpdateSourceToPreviousTarget() {
    this._value._hasUpdateSourceToPreviousTarget = false;
    this._value._updateSourceToPreviousTarget = null;
    return this;
  }
}
EffectEnumerateUnitList.Builder = EffectEnumerateUnitList_Builder;
class EffectEnumerateUnitList_WithParent {
  /**
   * @param {EffectEnumerateUnitList} value
   * @param {EffectEnumerateUnitList_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectEnumerateUnitList.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTargetType() {
    if (this._cachedHasTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedHasTargetType = true;
      } else {
        this._cachedHasTargetType = this._parent ? this._parent.hasTargetType : false;
      }
    }
    return this._cachedHasTargetType;
  }
  get targetType() {
    if (this._cachedTargetType === undefined) {
      if (this._value.hasTargetType) {
        this._cachedTargetType = this._value.targetType;
      } else {
        this._cachedTargetType = this._parent ? this._parent.targetType : this._value.targetType;
      }
    }
    return this._cachedTargetType;
  }
  get hasIterationMode() {
    if (this._cachedHasIterationMode === undefined) {
      if (this._value.hasIterationMode) {
        this._cachedHasIterationMode = true;
      } else {
        this._cachedHasIterationMode = this._parent ? this._parent.hasIterationMode : false;
      }
    }
    return this._cachedHasIterationMode;
  }
  get iterationMode() {
    if (this._cachedIterationMode === undefined) {
      if (this._value.hasIterationMode) {
        this._cachedIterationMode = this._value.iterationMode;
      } else {
        this._cachedIterationMode = this._parent ? this._parent.iterationMode : this._value.iterationMode;
      }
    }
    return this._cachedIterationMode;
  }
  get hasRepeatList() {
    if (this._cachedHasRepeatList === undefined) {
      if (this._value.hasRepeatList) {
        this._cachedHasRepeatList = true;
      } else {
        this._cachedHasRepeatList = this._parent ? this._parent.hasRepeatList : false;
      }
    }
    return this._cachedHasRepeatList;
  }
  get repeatList() {
    if (this._cachedRepeatList === undefined) {
      if (this._value.hasRepeatList) {
        this._cachedRepeatList = this._value.repeatList;
      } else {
        this._cachedRepeatList = this._parent ? this._parent.repeatList : this._value.repeatList;
      }
    }
    return this._cachedRepeatList;
  }
  get oneofLocationModeCase() {
    if (this._cachedoneofLocationModeCase === undefined) {
      if (this._value._oneofLocationModeCase === 0) {
        this._cachedoneofLocationModeCase = this._parent ? this._parent.oneofLocationModeCase : 0;
      } else {
        this._cachedoneofLocationModeCase = this._value._oneofLocationModeCase;
      }
    }
    return this._cachedoneofLocationModeCase;
  }
  get useSearchLocation() {
    if (!this._cachedUseSearchLocation) {
      if (this._value._oneofLocationModeCase === 0) {
        this._cachedUseSearchLocation = this._parent ? new EffectEnumerateUnitList_LocationModeStatic.WithParent(EffectEnumerateUnitList_LocationModeStatic.default, this._parent.useSearchLocation) : this._value.useSearchLocation;
      } else if (this._value._oneofLocationModeCase === 4) {
        this._cachedUseSearchLocation = new EffectEnumerateUnitList_LocationModeStatic.WithParent(this._value.useSearchLocation, this._parent && this._parent.oneofLocationModeCase === 4 ? this._parent.useSearchLocation : null);
      } else {
        this._cachedUseSearchLocation = EffectEnumerateUnitList_LocationModeStatic.WithParent.default;
      }
    }
    return this._cachedUseSearchLocation;
  }
  get useTargetLocation() {
    if (!this._cachedUseTargetLocation) {
      if (this._value._oneofLocationModeCase === 0) {
        this._cachedUseTargetLocation = this._parent ? new EffectEnumerateUnitList_LocationModeDynamic.WithParent(EffectEnumerateUnitList_LocationModeDynamic.default, this._parent.useTargetLocation) : this._value.useTargetLocation;
      } else if (this._value._oneofLocationModeCase === 5) {
        this._cachedUseTargetLocation = new EffectEnumerateUnitList_LocationModeDynamic.WithParent(this._value.useTargetLocation, this._parent && this._parent.oneofLocationModeCase === 5 ? this._parent.useTargetLocation : null);
      } else {
        this._cachedUseTargetLocation = EffectEnumerateUnitList_LocationModeDynamic.WithParent.default;
      }
    }
    return this._cachedUseTargetLocation;
  }
  get hasStepCount() {
    if (this._cachedHasStepCount === undefined) {
      if (this._value.hasStepCount) {
        this._cachedHasStepCount = true;
      } else {
        this._cachedHasStepCount = this._parent ? this._parent.hasStepCount : false;
      }
    }
    return this._cachedHasStepCount;
  }
  get stepCount() {
    if (this._cachedStepCount === undefined) {
      if (this._value.hasStepCount) {
        this._cachedStepCount = this._value.stepCount;
      } else {
        this._cachedStepCount = this._parent ? this._parent.stepCount : this._value.stepCount;
      }
    }
    return this._cachedStepCount;
  }
  get selfStepCountExpressions() {
    if (!this._selfStepCountExpressions) {
      this._selfStepCountExpressions = [];
      for (let i of this._value.stepCountExpressions) {
        this._selfStepCountExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfStepCountExpressions;
  }
  get inherentStepCountExpressions() {
    if (!this._inherentStepCountExpressions) {
      this._inherentStepCountExpressions = this._parent ? this._parent.stepCountExpressions : [];
    }
    return this._inherentStepCountExpressions;
  }
  get stepCountExpressions() {
    if (!this._allStepCountExpressions) {
      this._allStepCountExpressions = this._parent ? this._parent.stepCountExpressions.concat(this.selfStepCountExpressions) : this.selfStepCountExpressions;
    }
    return this._allStepCountExpressions;
  }
  get hasValidator() {
    if (this._cachedHasValidator === undefined) {
      if (this._value.hasValidator) {
        this._cachedHasValidator = true;
      } else {
        this._cachedHasValidator = this._parent ? this._parent.hasValidator : false;
      }
    }
    return this._cachedHasValidator;
  }
  get validator() {
    if (this._cachedValidator === undefined) {
      if (this._value.hasValidator) {
        this._cachedValidator = this._value.validator;
      } else {
        this._cachedValidator = this._parent ? this._parent.validator : this._value.validator;
      }
    }
    return this._cachedValidator;
  }
  get hasSearchEffect() {
    if (this._cachedHasSearchEffect === undefined) {
      if (this._value.hasSearchEffect) {
        this._cachedHasSearchEffect = true;
      } else {
        this._cachedHasSearchEffect = this._parent ? this._parent.hasSearchEffect : false;
      }
    }
    return this._cachedHasSearchEffect;
  }
  get searchEffect() {
    if (this._cachedSearchEffect === undefined) {
      if (this._value.hasSearchEffect) {
        this._cachedSearchEffect = this._value.searchEffect;
      } else {
        this._cachedSearchEffect = this._parent ? this._parent.searchEffect : this._value.searchEffect;
      }
    }
    return this._cachedSearchEffect;
  }
  get hasDeprecatedImpactEffet() {
    if (this._cachedHasDeprecatedImpactEffet === undefined) {
      if (this._value.hasDeprecatedImpactEffet) {
        this._cachedHasDeprecatedImpactEffet = true;
      } else {
        this._cachedHasDeprecatedImpactEffet = this._parent ? this._parent.hasDeprecatedImpactEffet : false;
      }
    }
    return this._cachedHasDeprecatedImpactEffet;
  }
  get impactEffet() {
    if (this._cachedDeprecatedImpactEffet === undefined) {
      if (this._value.hasDeprecatedImpactEffet) {
        this._cachedDeprecatedImpactEffet = this._value.impactEffet;
      } else {
        this._cachedDeprecatedImpactEffet = this._parent ? this._parent.impactEffet : this._value.impactEffet;
      }
    }
    return this._cachedDeprecatedImpactEffet;
  }
  get hasDeprecatedUpdateSourceToPreiousTarget() {
    if (this._cachedHasDeprecatedUpdateSourceToPreiousTarget === undefined) {
      if (this._value.hasDeprecatedUpdateSourceToPreiousTarget) {
        this._cachedHasDeprecatedUpdateSourceToPreiousTarget = true;
      } else {
        this._cachedHasDeprecatedUpdateSourceToPreiousTarget = this._parent ? this._parent.hasDeprecatedUpdateSourceToPreiousTarget : false;
      }
    }
    return this._cachedHasDeprecatedUpdateSourceToPreiousTarget;
  }
  get updateSourceToPreiousTarget() {
    if (this._cachedDeprecatedUpdateSourceToPreiousTarget === undefined) {
      if (this._value.hasDeprecatedUpdateSourceToPreiousTarget) {
        this._cachedDeprecatedUpdateSourceToPreiousTarget = this._value.updateSourceToPreiousTarget;
      } else {
        this._cachedDeprecatedUpdateSourceToPreiousTarget = this._parent ? this._parent.updateSourceToPreiousTarget : this._value.updateSourceToPreiousTarget;
      }
    }
    return this._cachedDeprecatedUpdateSourceToPreiousTarget;
  }
  get hasMissingEffect() {
    if (this._cachedHasMissingEffect === undefined) {
      if (this._value.hasMissingEffect) {
        this._cachedHasMissingEffect = true;
      } else {
        this._cachedHasMissingEffect = this._parent ? this._parent.hasMissingEffect : false;
      }
    }
    return this._cachedHasMissingEffect;
  }
  get missingEffect() {
    if (this._cachedMissingEffect === undefined) {
      if (this._value.hasMissingEffect) {
        this._cachedMissingEffect = this._value.missingEffect;
      } else {
        this._cachedMissingEffect = this._parent ? this._parent.missingEffect : this._value.missingEffect;
      }
    }
    return this._cachedMissingEffect;
  }
  get hasImpactEffect() {
    if (this._cachedHasImpactEffect === undefined) {
      if (this._value.hasImpactEffect) {
        this._cachedHasImpactEffect = true;
      } else {
        this._cachedHasImpactEffect = this._parent ? this._parent.hasImpactEffect : false;
      }
    }
    return this._cachedHasImpactEffect;
  }
  get impactEffect() {
    if (this._cachedImpactEffect === undefined) {
      if (this._value.hasImpactEffect) {
        this._cachedImpactEffect = this._value.impactEffect;
      } else {
        this._cachedImpactEffect = this._parent ? this._parent.impactEffect : this._value.impactEffect;
      }
    }
    return this._cachedImpactEffect;
  }
  get hasUpdateSourceToPreviousTarget() {
    if (this._cachedHasUpdateSourceToPreviousTarget === undefined) {
      if (this._value.hasUpdateSourceToPreviousTarget) {
        this._cachedHasUpdateSourceToPreviousTarget = true;
      } else {
        this._cachedHasUpdateSourceToPreviousTarget = this._parent ? this._parent.hasUpdateSourceToPreviousTarget : false;
      }
    }
    return this._cachedHasUpdateSourceToPreviousTarget;
  }
  get updateSourceToPreviousTarget() {
    if (this._cachedUpdateSourceToPreviousTarget === undefined) {
      if (this._value.hasUpdateSourceToPreviousTarget) {
        this._cachedUpdateSourceToPreviousTarget = this._value.updateSourceToPreviousTarget;
      } else {
        this._cachedUpdateSourceToPreviousTarget = this._parent ? this._parent.updateSourceToPreviousTarget : this._value.updateSourceToPreviousTarget;
      }
    }
    return this._cachedUpdateSourceToPreviousTarget;
  }
  update(current, parent) {
    const result = new EffectEnumerateUnitList_WithParent(current, parent);
    if (this._cachedUseSearchLocation && this._value._oneofLocationModeCase === 4 && current._oneofLocationModeCase === 4) {
      if (this._value.useSearchLocation === current.useSearchLocation && this._parent === parent) {
        result._cachedUseSearchLocation = this._cachedUseSearchLocation;
      } else {
        result._cachedUseSearchLocation = this._cachedUseSearchLocation.update(current.useSearchLocation, parent && parent.oneofLocationModeCase === 4 ? parent.useSearchLocation : null);
      }
    }
    if (this._cachedUseTargetLocation && this._value._oneofLocationModeCase === 5 && current._oneofLocationModeCase === 5) {
      if (this._value.useTargetLocation === current.useTargetLocation && this._parent === parent) {
        result._cachedUseTargetLocation = this._cachedUseTargetLocation;
      } else {
        result._cachedUseTargetLocation = this._cachedUseTargetLocation.update(current.useTargetLocation, parent && parent.oneofLocationModeCase === 5 ? parent.useTargetLocation : null);
      }
    }
    if (this._selfStepCountExpressions) {
      if (this._value.stepCountExpressions === current.stepCountExpressions) {
        result._selfStepCountExpressions = this._selfStepCountExpressions;
      } else {
        result._selfStepCountExpressions = [];
        for (let i = 0; i < current.stepCountExpressions.length; i++) {
          const oldValue = this._value.stepCountExpressions[i];
          if (oldValue) {
            const oldCache = this._selfStepCountExpressions[i];
            if (oldValue === current.stepCountExpressions[i]) {
              result._selfStepCountExpressions[i] = oldCache;
            } else {
              result._selfStepCountExpressions[i] = oldCache.update(current.stepCountExpressions[i], null);
            }
          } else {
            result._selfStepCountExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.stepCountExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
EffectEnumerateUnitList_WithParent.default = new EffectEnumerateUnitList_WithParent(EffectEnumerateUnitList.default, null);
EffectEnumerateUnitList.WithParent = EffectEnumerateUnitList_WithParent;
class EffectEnumerateUnitList_Descriptor {
  get targetType() {
    if (!this._targetType) {
      this._targetType = {
        name: "targetType",
        Name: "TargetType",
        number: 1,
        protoType: 14,
        protoName: "target_type",
        type: EffectTargetType_Type,
        options: {
          comments: "Used to determine the ability target type if this effect is the first effect of an ability.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetType;
  }
  get iterationMode() {
    if (!this._iterationMode) {
      this._iterationMode = {
        name: "iterationMode",
        Name: "IterationMode",
        number: 2,
        protoType: 14,
        protoName: "iteration_mode",
        type: EffectEnumerateUnitList_IterationModes,
        options: {
          comments: "Determines how to iterate through the unit list.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._iterationMode;
  }
  get repeatList() {
    if (!this._repeatList) {
      this._repeatList = {
        name: "repeatList",
        Name: "RepeatList",
        number: 3,
        protoType: 8,
        protoName: "repeat_list",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the list will be iterated through on repeat until the step count is exhausted or no valid targets remain.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._repeatList;
  }
  get useSearchLocation() {
    if (!this._useSearchLocation) {
      this._useSearchLocation = {
        name: "useSearchLocation",
        Name: "UseSearchLocation",
        number: 4,
        protoType: 11,
        protoName: "use_search_location",
        oneofIndex: 3,
        type: EffectEnumerateUnitList_LocationModeStatic,
        options: {
          comments: "Run the search using the **Search Effect** location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useSearchLocation;
  }
  get useTargetLocation() {
    if (!this._useTargetLocation) {
      this._useTargetLocation = {
        name: "useTargetLocation",
        Name: "UseTargetLocation",
        number: 5,
        protoType: 11,
        protoName: "use_target_location",
        oneofIndex: 3,
        type: EffectEnumerateUnitList_LocationModeDynamic,
        options: {
          comments: "Run successive searches at the previous target\'s location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useTargetLocation;
  }
  get stepCount() {
    if (!this._stepCount) {
      this._stepCount = {
        name: "stepCount",
        Name: "StepCount",
        number: 6,
        protoType: 5,
        protoName: "step_count",
        type: JsonToInt32,
        options: {
          comments: "The number of times to run the impact effect.",
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stepCount;
  }
  get stepCountExpressions() {
    if (!this._stepCountExpressions) {
      this._stepCountExpressions = {
        name: "stepCountExpressions",
        Name: "StepCountExpressions",
        number: 14,
        protoType: 11,
        protoName: "step_count_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stepCountExpressions;
  }
  get validator() {
    if (!this._validator) {
      this._validator = {
        name: "validator",
        Name: "Validator",
        number: 7,
        protoType: 9,
        protoName: "validator",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedValidatorNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validator;
  }
  get searchEffect() {
    if (!this._searchEffect) {
      this._searchEffect = {
        name: "searchEffect",
        Name: "SearchEffect",
        number: 8,
        protoType: 9,
        protoName: "search_effect",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedAreaSearchEffectNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._searchEffect;
  }
  get impactEffet() {
    if (!this._impactEffet) {
      this._impactEffet = {
        name: "impactEffet",
        Name: "DeprecatedImpactEffet",
        number: 9,
        protoType: 9,
        protoName: "deprecated_impact_effet",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactEffet;
  }
  get updateSourceToPreiousTarget() {
    if (!this._updateSourceToPreiousTarget) {
      this._updateSourceToPreiousTarget = {
        name: "updateSourceToPreiousTarget",
        Name: "DeprecatedUpdateSourceToPreiousTarget",
        number: 10,
        protoType: 8,
        protoName: "deprecated_update_source_to_preious_target",
        type: JsonToBoolean,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._updateSourceToPreiousTarget;
  }
  get missingEffect() {
    if (!this._missingEffect) {
      this._missingEffect = {
        name: "missingEffect",
        Name: "MissingEffect",
        number: 11,
        protoType: 9,
        protoName: "missing_effect",
        type: JsonToString,
        options: {
          comments: "This effect is created if the number of units found by the [Search Effect](#search-effect) is less than the [Step Count](#step-count). This effect is created for each missing target.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._missingEffect;
  }
  get impactEffect() {
    if (!this._impactEffect) {
      this._impactEffect = {
        name: "impactEffect",
        Name: "ImpactEffect",
        number: 12,
        protoType: 9,
        protoName: "impact_effect",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactEffect;
  }
  get updateSourceToPreviousTarget() {
    if (!this._updateSourceToPreviousTarget) {
      this._updateSourceToPreviousTarget = {
        name: "updateSourceToPreviousTarget",
        Name: "UpdateSourceToPreviousTarget",
        number: 13,
        protoType: 8,
        protoName: "update_source_to_previous_target",
        type: JsonToBoolean,
        options: {
          comments: "If this is set, for the current iteration, the target of previous iteration will be used as the source for this iteration. E.g. Chain lighting",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._updateSourceToPreviousTarget;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.targetType,
        this.iterationMode,
        this.repeatList,
        this.useSearchLocation,
        this.useTargetLocation,
        this.stepCount,
        this.stepCountExpressions,
        this.validator,
        this.searchEffect,
        this.impactEffet,
        this.updateSourceToPreiousTarget,
        this.missingEffect,
        this.impactEffect,
        this.updateSourceToPreviousTarget,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTargetType",
        Name: "DummyOneofForTargetType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIterationMode",
        Name: "DummyOneofForIterationMode",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRepeatList",
        Name: "DummyOneofForRepeatList",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "oneofLocationMode",
        Name: "OneofLocationMode",
        fields: [
          this.fields[3],
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStepCount",
        Name: "DummyOneofForStepCount",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValidator",
        Name: "DummyOneofForValidator",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSearchEffect",
        Name: "DummyOneofForSearchEffect",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedImpactEffet",
        Name: "DummyOneofForDeprecatedImpactEffet",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedUpdateSourceToPreiousTarget",
        Name: "DummyOneofForDeprecatedUpdateSourceToPreiousTarget",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMissingEffect",
        Name: "DummyOneofForMissingEffect",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactEffect",
        Name: "DummyOneofForImpactEffect",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpdateSourceToPreviousTarget",
        Name: "DummyOneofForUpdateSourceToPreviousTarget",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectEnumerateUnitList.descriptor = new EffectEnumerateUnitList_Descriptor();
export class EffectSetBounty {
  get descriptor() {
    return EffectSetBounty.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectSetBounty) {
      return value;
    }
    return EffectSetBounty.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectSetBounty();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToDouble.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasAmount) {
      result.amount = JsonToDouble.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToDouble.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetBounty(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectSetBounty(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectSetBounty(this);
              copy._hasAmount = true;
              copy._amount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new EffectSetBounty(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectSetBounty} other
   * @returns {EffectSetBounty}
   */
  merge(other) {
    const copy = new EffectSetBounty(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
EffectSetBounty.default = new EffectSetBounty();
class EffectSetBounty_Builder {
  constructor(value) {
    this._value = new EffectSetBounty(value);
  }
  build() {
    return new EffectSetBounty(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
EffectSetBounty.Builder = EffectSetBounty_Builder;
class EffectSetBounty_WithParent {
  /**
   * @param {EffectSetBounty} value
   * @param {EffectSetBounty_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectSetBounty.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new EffectSetBounty_WithParent(current, parent);
    return result;
  }
}
EffectSetBounty_WithParent.default = new EffectSetBounty_WithParent(EffectSetBounty.default, null);
EffectSetBounty.WithParent = EffectSetBounty_WithParent;
class EffectSetBounty_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to apply the bounty to.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 1,
        protoName: "amount",
        type: JsonToDouble,
        options: {
          comments: "The amount of gold for the unit to drop when killed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectSetBounty.descriptor = new EffectSetBounty_Descriptor();
export class EffectRemove {
  get descriptor() {
    return EffectRemove.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectRemove) {
      return value;
    }
    return EffectRemove.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectRemove();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectRemove(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectRemove(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectRemove} other
   * @returns {EffectRemove}
   */
  merge(other) {
    const copy = new EffectRemove(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
EffectRemove.default = new EffectRemove();
class EffectRemove_Builder {
  constructor(value) {
    this._value = new EffectRemove(value);
  }
  build() {
    return new EffectRemove(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
EffectRemove.Builder = EffectRemove_Builder;
class EffectRemove_WithParent {
  /**
   * @param {EffectRemove} value
   * @param {EffectRemove_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectRemove.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new EffectRemove_WithParent(current, parent);
    return result;
  }
}
EffectRemove_WithParent.default = new EffectRemove_WithParent(EffectRemove.default, null);
EffectRemove.WithParent = EffectRemove_WithParent;
class EffectRemove_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to remove.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectRemove.descriptor = new EffectRemove_Descriptor();
export class EffectStop {
  get descriptor() {
    return EffectStop.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWhichUnit = false;
    this._whichUnit = null;
  }
  isEmpty() {
    if (this._hasWhichUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectStop) {
      return value;
    }
    return EffectStop.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectStop();
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectStop(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectStop(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectStop} other
   * @returns {EffectStop}
   */
  merge(other) {
    const copy = new EffectStop(this);
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    return copy;
  }
}
EffectStop.default = new EffectStop();
class EffectStop_Builder {
  constructor(value) {
    this._value = new EffectStop(value);
  }
  build() {
    return new EffectStop(this._value);
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
}
EffectStop.Builder = EffectStop_Builder;
class EffectStop_WithParent {
  /**
   * @param {EffectStop} value
   * @param {EffectStop_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectStop.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  update(current, parent) {
    const result = new EffectStop_WithParent(current, parent);
    return result;
  }
}
EffectStop_WithParent.default = new EffectStop_WithParent(EffectStop.default, null);
EffectStop.WithParent = EffectStop_WithParent;
class EffectStop_Descriptor {
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 1,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to stop.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.whichUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectStop.descriptor = new EffectStop_Descriptor();
export class EffectIssueAbility {
  get descriptor() {
    return EffectIssueAbility.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAbilityCaster = false;
    this._abilityCaster = null;
    this._hasAbilityTarget = false;
    this._abilityTarget = null;
    this._hasIgnoreCost = false;
    this._ignoreCost = null;
    this._oneofAbilityReferenceCase = 0;
    this._oneofAbilityReferenceValue = null;
  }
  isEmpty() {
    if (this._hasAbilityCaster) return false;
    if (this._hasAbilityTarget) return false;
    if (this._hasIgnoreCost) return false;
    if (this._oneofAbilityReferenceCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectIssueAbility) {
      return value;
    }
    return EffectIssueAbility.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectIssueAbility();
    if (json.abilityCaster != null) {
      result._hasAbilityCaster = true;
      result._abilityCaster = EffectUnitTarget_Type.fromJson(json.abilityCaster);
    }
    if (json.abilityTarget != null) {
      result._hasAbilityTarget = true;
      result._abilityTarget = EffectUnitTarget_Type.fromJson(json.abilityTarget);
    }
    if (json.ignoreCost != null) {
      result._hasIgnoreCost = true;
      result._ignoreCost = JsonToBoolean.fromJson(json.ignoreCost);
    }
    if (json.abilityName != null) {
      result._oneofAbilityReferenceCase = 11;
      result._oneofAbilityReferenceValue = JsonToString.fromJson(json.abilityName);
    }
    if (json.abilityTag != null) {
      result._oneofAbilityReferenceCase = 12;
      result._oneofAbilityReferenceValue = JsonToString.fromJson(json.abilityTag);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAbilityCaster) {
      result.abilityCaster = EffectUnitTarget_Type.toJson(this._abilityCaster);
    }
    if (this._hasAbilityTarget) {
      result.abilityTarget = EffectUnitTarget_Type.toJson(this._abilityTarget);
    }
    if (this._hasIgnoreCost) {
      result.ignoreCost = JsonToBoolean.toJson(this._ignoreCost);
    }
    switch (this._oneofAbilityReferenceCase) {
      case 11:
        result.abilityName = JsonToString.toJson(this._oneofAbilityReferenceValue);
        break;
      case 12:
        result.abilityTag = JsonToString.toJson(this._oneofAbilityReferenceValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get abilityCaster() {
    return this._hasAbilityCaster ? this._abilityCaster : EffectUnitTarget_Type.default;
  }
  get hasAbilityCaster() {
    return this._hasAbilityCaster;
  }
  setAbilityCaster(path, value) {
    return {type: 'SET', path: path.concat(['abilityCaster']), value};
  }
  deleteAbilityCaster(path) {
    return {type: 'DELETE', path: path.concat(['abilityCaster'])};
  }
  /**
   * @returns {number}
   */
  get abilityTarget() {
    return this._hasAbilityTarget ? this._abilityTarget : EffectUnitTarget_Type.default;
  }
  get hasAbilityTarget() {
    return this._hasAbilityTarget;
  }
  setAbilityTarget(path, value) {
    return {type: 'SET', path: path.concat(['abilityTarget']), value};
  }
  deleteAbilityTarget(path) {
    return {type: 'DELETE', path: path.concat(['abilityTarget'])};
  }
  /**
   * @returns {boolean}
   */
  get ignoreCost() {
    return this._hasIgnoreCost ? this._ignoreCost : JsonToBoolean.default;
  }
  get hasIgnoreCost() {
    return this._hasIgnoreCost;
  }
  setIgnoreCost(path, value) {
    return {type: 'SET', path: path.concat(['ignoreCost']), value};
  }
  deleteIgnoreCost(path) {
    return {type: 'DELETE', path: path.concat(['ignoreCost'])};
  }
  get oneofAbilityReferenceCase() {
    return this._oneofAbilityReferenceCase;
  }
  deleteOneofAbilityReference(path) {
    switch (this._oneofAbilityReferenceCase) {
      default:
      case 11: {
        return {type: 'DELETE', path: path.concat(['abilityName'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['abilityTag'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get abilityName() {
    return this._oneofAbilityReferenceCase === 11 ? this._oneofAbilityReferenceValue : JsonToString.default;
  }
  setAbilityName(path, value) {
    return {type: 'SET', path: path.concat(['abilityName']), value};
  }
  deleteAbilityName(path) {
    return {type: 'DELETE', path: path.concat(['abilityName'])};
  }
  /**
   * @returns {string}
   */
  get abilityTag() {
    return this._oneofAbilityReferenceCase === 12 ? this._oneofAbilityReferenceValue : JsonToString.default;
  }
  setAbilityTag(path, value) {
    return {type: 'SET', path: path.concat(['abilityTag']), value};
  }
  deleteAbilityTag(path) {
    return {type: 'DELETE', path: path.concat(['abilityTag'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "abilityCaster": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueAbility(this);
              copy._hasAbilityCaster = true;
              copy._abilityCaster = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityCaster) {
                return this;
              }
              const copy = new EffectIssueAbility(this);
              copy._hasAbilityCaster = false;
              copy._abilityCaster = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityTarget": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueAbility(this);
              copy._hasAbilityTarget = true;
              copy._abilityTarget = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityTarget) {
                return this;
              }
              const copy = new EffectIssueAbility(this);
              copy._hasAbilityTarget = false;
              copy._abilityTarget = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignoreCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueAbility(this);
              copy._hasIgnoreCost = true;
              copy._ignoreCost = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnoreCost) {
                return this;
              }
              const copy = new EffectIssueAbility(this);
              copy._hasIgnoreCost = false;
              copy._ignoreCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueAbility(this);
              copy._oneofAbilityReferenceCase = 11;
              copy._oneofAbilityReferenceValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityReferenceCase !== 11) {
                return this;
              }
              const copy = new EffectIssueAbility(this);
              copy._oneofAbilityReferenceCase = 0;
              copy._oneofAbilityReferenceValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueAbility(this);
              copy._oneofAbilityReferenceCase = 12;
              copy._oneofAbilityReferenceValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofAbilityReferenceCase !== 12) {
                return this;
              }
              const copy = new EffectIssueAbility(this);
              copy._oneofAbilityReferenceCase = 0;
              copy._oneofAbilityReferenceValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectIssueAbility} other
   * @returns {EffectIssueAbility}
   */
  merge(other) {
    const copy = new EffectIssueAbility(this);
    if (other._hasAbilityCaster) {
      copy._hasAbilityCaster = true;
      copy._abilityCaster = other._abilityCaster;
    }
    if (other._hasAbilityTarget) {
      copy._hasAbilityTarget = true;
      copy._abilityTarget = other._abilityTarget;
    }
    if (other._hasIgnoreCost) {
      copy._hasIgnoreCost = true;
      copy._ignoreCost = other._ignoreCost;
    }
    if (other._oneofAbilityReferenceCase === 11) {
      copy._oneofAbilityReferenceCase = 11;
      copy._oneofAbilityReferenceValue = other._oneofAbilityReferenceValue;
    }
    if (other._oneofAbilityReferenceCase === 11) {
      copy._oneofAbilityReferenceCase = 11;
      copy._oneofAbilityReferenceValue = other._oneofAbilityReferenceValue;
    }
    return copy;
  }
}
EffectIssueAbility.default = new EffectIssueAbility();
class EffectIssueAbility_Builder {
  constructor(value) {
    this._value = new EffectIssueAbility(value);
  }
  build() {
    return new EffectIssueAbility(this._value);
  }
  setAbilityCaster(value) {
    this._value._hasAbilityCaster = true;
    this._value._abilityCaster = value;
    return this;
  }
  deleteAbilityCaster() {
    this._value._hasAbilityCaster = false;
    this._value._abilityCaster = null;
    return this;
  }
  setAbilityTarget(value) {
    this._value._hasAbilityTarget = true;
    this._value._abilityTarget = value;
    return this;
  }
  deleteAbilityTarget() {
    this._value._hasAbilityTarget = false;
    this._value._abilityTarget = null;
    return this;
  }
  setIgnoreCost(value) {
    this._value._hasIgnoreCost = true;
    this._value._ignoreCost = value;
    return this;
  }
  deleteIgnoreCost() {
    this._value._hasIgnoreCost = false;
    this._value._ignoreCost = null;
    return this;
  }
  clearoneofAbilityReference() {
    this._value._oneofAbilityReferenceCase = 0;
    this._value._oneofAbilityReferenceValue = null;
    return this;
  }
  setAbilityName(value) {
    this._value._oneofAbilityReferenceCase = 11;
    this._value._oneofAbilityReferenceValue = value;
    return this;
  }
  setAbilityTag(value) {
    this._value._oneofAbilityReferenceCase = 12;
    this._value._oneofAbilityReferenceValue = value;
    return this;
  }
}
EffectIssueAbility.Builder = EffectIssueAbility_Builder;
class EffectIssueAbility_WithParent {
  /**
   * @param {EffectIssueAbility} value
   * @param {EffectIssueAbility_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectIssueAbility.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAbilityCaster() {
    if (this._cachedHasAbilityCaster === undefined) {
      if (this._value.hasAbilityCaster) {
        this._cachedHasAbilityCaster = true;
      } else {
        this._cachedHasAbilityCaster = this._parent ? this._parent.hasAbilityCaster : false;
      }
    }
    return this._cachedHasAbilityCaster;
  }
  get abilityCaster() {
    if (this._cachedAbilityCaster === undefined) {
      if (this._value.hasAbilityCaster) {
        this._cachedAbilityCaster = this._value.abilityCaster;
      } else {
        this._cachedAbilityCaster = this._parent ? this._parent.abilityCaster : this._value.abilityCaster;
      }
    }
    return this._cachedAbilityCaster;
  }
  get hasAbilityTarget() {
    if (this._cachedHasAbilityTarget === undefined) {
      if (this._value.hasAbilityTarget) {
        this._cachedHasAbilityTarget = true;
      } else {
        this._cachedHasAbilityTarget = this._parent ? this._parent.hasAbilityTarget : false;
      }
    }
    return this._cachedHasAbilityTarget;
  }
  get abilityTarget() {
    if (this._cachedAbilityTarget === undefined) {
      if (this._value.hasAbilityTarget) {
        this._cachedAbilityTarget = this._value.abilityTarget;
      } else {
        this._cachedAbilityTarget = this._parent ? this._parent.abilityTarget : this._value.abilityTarget;
      }
    }
    return this._cachedAbilityTarget;
  }
  get hasIgnoreCost() {
    if (this._cachedHasIgnoreCost === undefined) {
      if (this._value.hasIgnoreCost) {
        this._cachedHasIgnoreCost = true;
      } else {
        this._cachedHasIgnoreCost = this._parent ? this._parent.hasIgnoreCost : false;
      }
    }
    return this._cachedHasIgnoreCost;
  }
  get ignoreCost() {
    if (this._cachedIgnoreCost === undefined) {
      if (this._value.hasIgnoreCost) {
        this._cachedIgnoreCost = this._value.ignoreCost;
      } else {
        this._cachedIgnoreCost = this._parent ? this._parent.ignoreCost : this._value.ignoreCost;
      }
    }
    return this._cachedIgnoreCost;
  }
  get oneofAbilityReferenceCase() {
    if (this._cachedoneofAbilityReferenceCase === undefined) {
      if (this._value._oneofAbilityReferenceCase === 0) {
        this._cachedoneofAbilityReferenceCase = this._parent ? this._parent.oneofAbilityReferenceCase : 0;
      } else {
        this._cachedoneofAbilityReferenceCase = this._value._oneofAbilityReferenceCase;
      }
    }
    return this._cachedoneofAbilityReferenceCase;
  }
  get abilityName() {
    if (!this._cachedAbilityName) {
      if (this._value._oneofAbilityReferenceCase === 0) {
        this._cachedAbilityName = this._parent ? this._parent.abilityName : this._value.abilityName;
      } else {
        this._cachedAbilityName = this._value.abilityName;
      }
    }
    return this._cachedAbilityName;
  }
  get abilityTag() {
    if (!this._cachedAbilityTag) {
      if (this._value._oneofAbilityReferenceCase === 0) {
        this._cachedAbilityTag = this._parent ? this._parent.abilityTag : this._value.abilityTag;
      } else {
        this._cachedAbilityTag = this._value.abilityTag;
      }
    }
    return this._cachedAbilityTag;
  }
  update(current, parent) {
    const result = new EffectIssueAbility_WithParent(current, parent);
    return result;
  }
}
EffectIssueAbility_WithParent.default = new EffectIssueAbility_WithParent(EffectIssueAbility.default, null);
EffectIssueAbility.WithParent = EffectIssueAbility_WithParent;
class EffectIssueAbility_Descriptor {
  get abilityCaster() {
    if (!this._abilityCaster) {
      this._abilityCaster = {
        name: "abilityCaster",
        Name: "AbilityCaster",
        number: 1,
        protoType: 14,
        protoName: "ability_caster",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to issue an ability order to.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityCaster;
  }
  get abilityTarget() {
    if (!this._abilityTarget) {
      this._abilityTarget = {
        name: "abilityTarget",
        Name: "AbilityTarget",
        number: 2,
        protoType: 14,
        protoName: "ability_target",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit should be the target of the ability.",
          default: "TARGET_UNIT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityTarget;
  }
  get ignoreCost() {
    if (!this._ignoreCost) {
      this._ignoreCost = {
        name: "ignoreCost",
        Name: "IgnoreCost",
        number: 3,
        protoType: 8,
        protoName: "ignore_cost",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the ability won\'t use cost or cooldown when casting.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignoreCost;
  }
  get abilityName() {
    if (!this._abilityName) {
      this._abilityName = {
        name: "abilityName",
        Name: "AbilityName",
        number: 11,
        protoType: 9,
        protoName: "ability_name",
        oneofIndex: 3,
        type: JsonToString,
        options: {
          comments: "Select the ability to be cast by name.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityName;
  }
  get abilityTag() {
    if (!this._abilityTag) {
      this._abilityTag = {
        name: "abilityTag",
        Name: "AbilityTag",
        number: 12,
        protoType: 9,
        protoName: "ability_tag",
        oneofIndex: 3,
        type: JsonToString,
        options: {
          comments: "Select the first ability with the matching tag on the unit to cast.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityTag;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.abilityCaster,
        this.abilityTarget,
        this.ignoreCost,
        this.abilityName,
        this.abilityTag,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAbilityCaster",
        Name: "DummyOneofForAbilityCaster",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityTarget",
        Name: "DummyOneofForAbilityTarget",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnoreCost",
        Name: "DummyOneofForIgnoreCost",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "oneofAbilityReference",
        Name: "OneofAbilityReference",
        fields: [
          this.fields[3],
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectIssueAbility.descriptor = new EffectIssueAbility_Descriptor();
class EffectIssueCommand_CommandType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "MOVE_TO_LOCATION": return 1;
        case "ATTACK_TO_LOCATION": return 2;
        case "ATTACK_UNIT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EffectIssueCommand_CommandType.fromJson(value);
  }
  static fromReact(e) {
    return EffectIssueCommand_CommandType.fromJson(e);
  }
}
EffectIssueCommand_CommandType.NONE = 0;
EffectIssueCommand_CommandType.MOVE_TO_LOCATION = 1;
EffectIssueCommand_CommandType.ATTACK_TO_LOCATION = 2;
EffectIssueCommand_CommandType.ATTACK_UNIT = 3;
EffectIssueCommand_CommandType.default = 0;
EffectIssueCommand_CommandType.values = {
  NONE: 0,
  MOVE_TO_LOCATION: 1,
  ATTACK_TO_LOCATION: 2,
  ATTACK_UNIT: 3,
};
EffectIssueCommand_CommandType.names = {
  0: "NONE",
  1: "MOVE_TO_LOCATION",
  2: "ATTACK_TO_LOCATION",
  3: "ATTACK_UNIT",
};
export class EffectIssueCommand {
  get descriptor() {
    return EffectIssueCommand.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasWhichUnit = false;
    this._whichUnit = null;
    this._hasTargetUnit = false;
    this._targetUnit = null;
    this._hasTargetLocation = false;
    this._targetLocation = null;
    this._hasTargetOffset = false;
    this._targetOffset = null;
    this._hasTargetOffsetStart = false;
    this._targetOffsetStart = null;
    this._hasTargetOffsetEnd = false;
    this._targetOffsetEnd = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasWhichUnit) return false;
    if (this._hasTargetUnit) return false;
    if (this._hasTargetLocation) return false;
    if (this._hasTargetOffset && !this._targetOffset.isEmpty()) return false;
    if (this._hasTargetOffsetStart) return false;
    if (this._hasTargetOffsetEnd) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectIssueCommand) {
      return value;
    }
    return EffectIssueCommand.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectIssueCommand();
    if (json.type != null) {
      result._hasType = true;
      result._type = EffectIssueCommand_CommandType.fromJson(json.type);
    }
    if (json.whichUnit != null) {
      result._hasWhichUnit = true;
      result._whichUnit = EffectUnitTarget_Type.fromJson(json.whichUnit);
    }
    if (json.targetUnit != null) {
      result._hasTargetUnit = true;
      result._targetUnit = EffectUnitTarget_Type.fromJson(json.targetUnit);
    }
    if (json.targetLocation != null) {
      result._hasTargetLocation = true;
      result._targetLocation = EffectTarget_Type.fromJson(json.targetLocation);
    }
    if (json.targetOffset != null) {
      result._hasTargetOffset = true;
      result._targetOffset = EffectOffset.fromJson(json.targetOffset);
    }
    if (json.targetOffsetStart != null) {
      result._hasTargetOffsetStart = true;
      result._targetOffsetStart = EffectTarget_Type.fromJson(json.targetOffsetStart);
    }
    if (json.targetOffsetEnd != null) {
      result._hasTargetOffsetEnd = true;
      result._targetOffsetEnd = EffectTarget_Type.fromJson(json.targetOffsetEnd);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = EffectIssueCommand_CommandType.toJson(this._type);
    }
    if (this._hasWhichUnit) {
      result.whichUnit = EffectUnitTarget_Type.toJson(this._whichUnit);
    }
    if (this._hasTargetUnit) {
      result.targetUnit = EffectUnitTarget_Type.toJson(this._targetUnit);
    }
    if (this._hasTargetLocation) {
      result.targetLocation = EffectTarget_Type.toJson(this._targetLocation);
    }
    if (this._hasTargetOffset && !this._targetOffset.isEmpty()) {
      result.targetOffset = EffectOffset.toJson(this._targetOffset);
    }
    if (this._hasTargetOffsetStart) {
      result.targetOffsetStart = EffectTarget_Type.toJson(this._targetOffsetStart);
    }
    if (this._hasTargetOffsetEnd) {
      result.targetOffsetEnd = EffectTarget_Type.toJson(this._targetOffsetEnd);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : EffectIssueCommand_CommandType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {number}
   */
  get whichUnit() {
    return this._hasWhichUnit ? this._whichUnit : EffectUnitTarget_Type.default;
  }
  get hasWhichUnit() {
    return this._hasWhichUnit;
  }
  setWhichUnit(path, value) {
    return {type: 'SET', path: path.concat(['whichUnit']), value};
  }
  deleteWhichUnit(path) {
    return {type: 'DELETE', path: path.concat(['whichUnit'])};
  }
  /**
   * @returns {number}
   */
  get targetUnit() {
    return this._hasTargetUnit ? this._targetUnit : EffectUnitTarget_Type.default;
  }
  get hasTargetUnit() {
    return this._hasTargetUnit;
  }
  setTargetUnit(path, value) {
    return {type: 'SET', path: path.concat(['targetUnit']), value};
  }
  deleteTargetUnit(path) {
    return {type: 'DELETE', path: path.concat(['targetUnit'])};
  }
  /**
   * @returns {number}
   */
  get targetLocation() {
    return this._hasTargetLocation ? this._targetLocation : EffectTarget_Type.default;
  }
  get hasTargetLocation() {
    return this._hasTargetLocation;
  }
  setTargetLocation(path, value) {
    return {type: 'SET', path: path.concat(['targetLocation']), value};
  }
  deleteTargetLocation(path) {
    return {type: 'DELETE', path: path.concat(['targetLocation'])};
  }
  /**
   * @returns {EffectOffset}
   */
  get targetOffset() {
    return this._hasTargetOffset ? this._targetOffset : EffectOffset.default;
  }
  get hasTargetOffset() {
    return this._hasTargetOffset;
  }
  setTargetOffset(path, value) {
    return {type: 'SET', path: path.concat(['targetOffset']), value: value.toJson()};
  }
  deleteTargetOffset(path) {
    return {type: 'DELETE', path: path.concat(['targetOffset'])};
  }
  /**
   * @returns {number}
   */
  get targetOffsetStart() {
    return this._hasTargetOffsetStart ? this._targetOffsetStart : EffectTarget_Type.default;
  }
  get hasTargetOffsetStart() {
    return this._hasTargetOffsetStart;
  }
  setTargetOffsetStart(path, value) {
    return {type: 'SET', path: path.concat(['targetOffsetStart']), value};
  }
  deleteTargetOffsetStart(path) {
    return {type: 'DELETE', path: path.concat(['targetOffsetStart'])};
  }
  /**
   * @returns {number}
   */
  get targetOffsetEnd() {
    return this._hasTargetOffsetEnd ? this._targetOffsetEnd : EffectTarget_Type.default;
  }
  get hasTargetOffsetEnd() {
    return this._hasTargetOffsetEnd;
  }
  setTargetOffsetEnd(path, value) {
    return {type: 'SET', path: path.concat(['targetOffsetEnd']), value};
  }
  deleteTargetOffsetEnd(path) {
    return {type: 'DELETE', path: path.concat(['targetOffsetEnd'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasType = true;
              copy._type = EffectIssueCommand_CommandType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "whichUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasWhichUnit = true;
              copy._whichUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWhichUnit) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasWhichUnit = false;
              copy._whichUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasTargetUnit = true;
              copy._targetUnit = EffectUnitTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetUnit) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasTargetUnit = false;
              copy._targetUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasTargetLocation = true;
              copy._targetLocation = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetLocation) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasTargetLocation = false;
              copy._targetLocation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffset = true;
              copy._targetOffset = EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetOffset) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffset = false;
              copy._targetOffset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetOffset) {
            const copy = new EffectIssueCommand(this);
            copy._hasTargetOffset = true;
            copy._targetOffset = EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetOffset.apply(type, path.slice(1), value);
          if (newValue === this._targetOffset) {
            return this;
          }
          const copy = new EffectIssueCommand(this);
          copy._targetOffset = copy._targetOffset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "targetOffsetStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffsetStart = true;
              copy._targetOffsetStart = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetOffsetStart) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffsetStart = false;
              copy._targetOffsetStart = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetOffsetEnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffsetEnd = true;
              copy._targetOffsetEnd = EffectTarget_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetOffsetEnd) {
                return this;
              }
              const copy = new EffectIssueCommand(this);
              copy._hasTargetOffsetEnd = false;
              copy._targetOffsetEnd = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectIssueCommand} other
   * @returns {EffectIssueCommand}
   */
  merge(other) {
    const copy = new EffectIssueCommand(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasWhichUnit) {
      copy._hasWhichUnit = true;
      copy._whichUnit = other._whichUnit;
    }
    if (other._hasTargetUnit) {
      copy._hasTargetUnit = true;
      copy._targetUnit = other._targetUnit;
    }
    if (other._hasTargetLocation) {
      copy._hasTargetLocation = true;
      copy._targetLocation = other._targetLocation;
    }
    if (other._hasTargetOffset) {
      if (copy._hasTargetOffset) {
        copy._targetOffset = copy.targetOffset.merge(other.targetOffset);
      } else {
        copy._targetOffset = other._targetOffset;
      }
      copy._hasTargetOffset = true;
    }
    if (other._hasTargetOffsetStart) {
      copy._hasTargetOffsetStart = true;
      copy._targetOffsetStart = other._targetOffsetStart;
    }
    if (other._hasTargetOffsetEnd) {
      copy._hasTargetOffsetEnd = true;
      copy._targetOffsetEnd = other._targetOffsetEnd;
    }
    return copy;
  }
}
EffectIssueCommand.default = new EffectIssueCommand();
EffectIssueCommand.CommandType = EffectIssueCommand_CommandType;
class EffectIssueCommand_Builder {
  constructor(value) {
    this._value = new EffectIssueCommand(value);
  }
  build() {
    return new EffectIssueCommand(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setWhichUnit(value) {
    this._value._hasWhichUnit = true;
    this._value._whichUnit = value;
    return this;
  }
  deleteWhichUnit() {
    this._value._hasWhichUnit = false;
    this._value._whichUnit = null;
    return this;
  }
  setTargetUnit(value) {
    this._value._hasTargetUnit = true;
    this._value._targetUnit = value;
    return this;
  }
  deleteTargetUnit() {
    this._value._hasTargetUnit = false;
    this._value._targetUnit = null;
    return this;
  }
  setTargetLocation(value) {
    this._value._hasTargetLocation = true;
    this._value._targetLocation = value;
    return this;
  }
  deleteTargetLocation() {
    this._value._hasTargetLocation = false;
    this._value._targetLocation = null;
    return this;
  }
  setTargetOffset(value) {
    this._value._hasTargetOffset = true;
    this._value._targetOffset = value;
    return this;
  }
  deleteTargetOffset() {
    this._value._hasTargetOffset = false;
    this._value._targetOffset = null;
    return this;
  }
  setTargetOffsetStart(value) {
    this._value._hasTargetOffsetStart = true;
    this._value._targetOffsetStart = value;
    return this;
  }
  deleteTargetOffsetStart() {
    this._value._hasTargetOffsetStart = false;
    this._value._targetOffsetStart = null;
    return this;
  }
  setTargetOffsetEnd(value) {
    this._value._hasTargetOffsetEnd = true;
    this._value._targetOffsetEnd = value;
    return this;
  }
  deleteTargetOffsetEnd() {
    this._value._hasTargetOffsetEnd = false;
    this._value._targetOffsetEnd = null;
    return this;
  }
}
EffectIssueCommand.Builder = EffectIssueCommand_Builder;
class EffectIssueCommand_WithParent {
  /**
   * @param {EffectIssueCommand} value
   * @param {EffectIssueCommand_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectIssueCommand.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasWhichUnit() {
    if (this._cachedHasWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedHasWhichUnit = true;
      } else {
        this._cachedHasWhichUnit = this._parent ? this._parent.hasWhichUnit : false;
      }
    }
    return this._cachedHasWhichUnit;
  }
  get whichUnit() {
    if (this._cachedWhichUnit === undefined) {
      if (this._value.hasWhichUnit) {
        this._cachedWhichUnit = this._value.whichUnit;
      } else {
        this._cachedWhichUnit = this._parent ? this._parent.whichUnit : this._value.whichUnit;
      }
    }
    return this._cachedWhichUnit;
  }
  get hasTargetUnit() {
    if (this._cachedHasTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedHasTargetUnit = true;
      } else {
        this._cachedHasTargetUnit = this._parent ? this._parent.hasTargetUnit : false;
      }
    }
    return this._cachedHasTargetUnit;
  }
  get targetUnit() {
    if (this._cachedTargetUnit === undefined) {
      if (this._value.hasTargetUnit) {
        this._cachedTargetUnit = this._value.targetUnit;
      } else {
        this._cachedTargetUnit = this._parent ? this._parent.targetUnit : this._value.targetUnit;
      }
    }
    return this._cachedTargetUnit;
  }
  get hasTargetLocation() {
    if (this._cachedHasTargetLocation === undefined) {
      if (this._value.hasTargetLocation) {
        this._cachedHasTargetLocation = true;
      } else {
        this._cachedHasTargetLocation = this._parent ? this._parent.hasTargetLocation : false;
      }
    }
    return this._cachedHasTargetLocation;
  }
  get targetLocation() {
    if (this._cachedTargetLocation === undefined) {
      if (this._value.hasTargetLocation) {
        this._cachedTargetLocation = this._value.targetLocation;
      } else {
        this._cachedTargetLocation = this._parent ? this._parent.targetLocation : this._value.targetLocation;
      }
    }
    return this._cachedTargetLocation;
  }
  get hasTargetOffset() {
    if (this._cachedHasTargetOffset === undefined) {
      if (this._value.hasTargetOffset) {
        this._cachedHasTargetOffset = true;
      } else {
        this._cachedHasTargetOffset = this._parent ? this._parent.hasTargetOffset : false;
      }
    }
    return this._cachedHasTargetOffset;
  }
  get targetOffset() {
    if (!this._cachedTargetOffset) {
      if (this._value.hasTargetOffset) {
        this._cachedTargetOffset = new EffectOffset.WithParent(this._value.targetOffset, this._parent && this._parent.hasTargetOffset ? this._parent.targetOffset : null);
      } else {
        this._cachedTargetOffset = this._parent ? new EffectOffset.WithParent(EffectOffset.default, this._parent.targetOffset) : EffectOffset.WithParent.default;
      }
    }
    return this._cachedTargetOffset;
  }
  get hasTargetOffsetStart() {
    if (this._cachedHasTargetOffsetStart === undefined) {
      if (this._value.hasTargetOffsetStart) {
        this._cachedHasTargetOffsetStart = true;
      } else {
        this._cachedHasTargetOffsetStart = this._parent ? this._parent.hasTargetOffsetStart : false;
      }
    }
    return this._cachedHasTargetOffsetStart;
  }
  get targetOffsetStart() {
    if (this._cachedTargetOffsetStart === undefined) {
      if (this._value.hasTargetOffsetStart) {
        this._cachedTargetOffsetStart = this._value.targetOffsetStart;
      } else {
        this._cachedTargetOffsetStart = this._parent ? this._parent.targetOffsetStart : this._value.targetOffsetStart;
      }
    }
    return this._cachedTargetOffsetStart;
  }
  get hasTargetOffsetEnd() {
    if (this._cachedHasTargetOffsetEnd === undefined) {
      if (this._value.hasTargetOffsetEnd) {
        this._cachedHasTargetOffsetEnd = true;
      } else {
        this._cachedHasTargetOffsetEnd = this._parent ? this._parent.hasTargetOffsetEnd : false;
      }
    }
    return this._cachedHasTargetOffsetEnd;
  }
  get targetOffsetEnd() {
    if (this._cachedTargetOffsetEnd === undefined) {
      if (this._value.hasTargetOffsetEnd) {
        this._cachedTargetOffsetEnd = this._value.targetOffsetEnd;
      } else {
        this._cachedTargetOffsetEnd = this._parent ? this._parent.targetOffsetEnd : this._value.targetOffsetEnd;
      }
    }
    return this._cachedTargetOffsetEnd;
  }
  update(current, parent) {
    const result = new EffectIssueCommand_WithParent(current, parent);
    if (this._cachedTargetOffset && this._value.hasTargetOffset && current.hasTargetOffset) {
      if (this._value.targetOffset === current.targetOffset && this._parent === parent) {
        result._cachedTargetOffset = this._cachedTargetOffset;
      } else {
        result._cachedTargetOffset = this._cachedTargetOffset.update(current.targetOffset, parent && parent.hasTargetOffset ? parent.targetOffset : null);
      }
    }
    return result;
  }
}
EffectIssueCommand_WithParent.default = new EffectIssueCommand_WithParent(EffectIssueCommand.default, null);
EffectIssueCommand.WithParent = EffectIssueCommand_WithParent;
class EffectIssueCommand_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: EffectIssueCommand_CommandType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get whichUnit() {
    if (!this._whichUnit) {
      this._whichUnit = {
        name: "whichUnit",
        Name: "WhichUnit",
        number: 2,
        protoType: 14,
        protoName: "which_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to give the move or attack order to.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._whichUnit;
  }
  get targetUnit() {
    if (!this._targetUnit) {
      this._targetUnit = {
        name: "targetUnit",
        Name: "TargetUnit",
        number: 3,
        protoType: 14,
        protoName: "target_unit",
        type: EffectUnitTarget_Type,
        options: {
          comments: "Which unit to attack when using **Attack Unit**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetUnit;
  }
  get targetLocation() {
    if (!this._targetLocation) {
      this._targetLocation = {
        name: "targetLocation",
        Name: "TargetLocation",
        number: 4,
        protoType: 14,
        protoName: "target_location",
        type: EffectTarget_Type,
        options: {
          comments: "Which location to use when using **Move To Location** or **Attack To Location**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetLocation;
  }
  get targetOffset() {
    if (!this._targetOffset) {
      this._targetOffset = {
        name: "targetOffset",
        Name: "TargetOffset",
        number: 5,
        protoType: 11,
        protoName: "target_offset",
        type: EffectOffset,
        options: {
          comments: "Offset used for the target location if type is location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetOffset;
  }
  get targetOffsetStart() {
    if (!this._targetOffsetStart) {
      this._targetOffsetStart = {
        name: "targetOffsetStart",
        Name: "TargetOffsetStart",
        number: 6,
        protoType: 14,
        protoName: "target_offset_start",
        type: EffectTarget_Type,
        options: {
          comments: "Offset start & end together determines the orientation of the offset.\nIf offset start & end are both specified but are overlapping, and the offset start is an unit (e.g., caster unit), the facing of that unit will be used.\nIf offset start & end are not specified, or specified but cannot determine the facing using the above rules, the commanded unit\'s facing will be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetOffsetStart;
  }
  get targetOffsetEnd() {
    if (!this._targetOffsetEnd) {
      this._targetOffsetEnd = {
        name: "targetOffsetEnd",
        Name: "TargetOffsetEnd",
        number: 7,
        protoType: 14,
        protoName: "target_offset_end",
        type: EffectTarget_Type,
        options: {
          comments: "Used in combination with Offset Start to determine the facing of this effect. If both are set to a unit, the effect will use that unit\'s facing.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetOffsetEnd;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.whichUnit,
        this.targetUnit,
        this.targetLocation,
        this.targetOffset,
        this.targetOffsetStart,
        this.targetOffsetEnd,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWhichUnit",
        Name: "DummyOneofForWhichUnit",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetUnit",
        Name: "DummyOneofForTargetUnit",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetLocation",
        Name: "DummyOneofForTargetLocation",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetOffset",
        Name: "DummyOneofForTargetOffset",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetOffsetStart",
        Name: "DummyOneofForTargetOffsetStart",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetOffsetEnd",
        Name: "DummyOneofForTargetOffsetEnd",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectIssueCommand.descriptor = new EffectIssueCommand_Descriptor();
export class ValueType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PERCENTAGE": return 0;
        case "VALUE": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ValueType.fromJson(value);
  }
  static fromReact(e) {
    return ValueType.fromJson(e);
  }
}
ValueType.PERCENTAGE = 0;
ValueType.VALUE = 1;
ValueType.default = 0;
ValueType.values = {
  PERCENTAGE: 0,
  VALUE: 1,
};
ValueType.names = {
  0: "PERCENTAGE",
  1: "VALUE",
};
export class DistanceCheckModes {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "CHECK_CLOSEST_EDGE": return 0;
        case "CHECK_CENTER_ONLY": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return DistanceCheckModes.fromJson(value);
  }
  static fromReact(e) {
    return DistanceCheckModes.fromJson(e);
  }
}
DistanceCheckModes.CHECK_CLOSEST_EDGE = 0;
DistanceCheckModes.CHECK_CENTER_ONLY = 1;
DistanceCheckModes.default = 0;
DistanceCheckModes.values = {
  CHECK_CLOSEST_EDGE: 0,
  CHECK_CENTER_ONLY: 1,
};
DistanceCheckModes.names = {
  0: "CHECK_CLOSEST_EDGE",
  1: "CHECK_CENTER_ONLY",
};
export class DistanceExtendModes {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NO_EXTEND": return 0;
        case "INCLUDE_SOURCE_UNIT_RADIUS": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return DistanceExtendModes.fromJson(value);
  }
  static fromReact(e) {
    return DistanceExtendModes.fromJson(e);
  }
}
DistanceExtendModes.NO_EXTEND = 0;
DistanceExtendModes.INCLUDE_SOURCE_UNIT_RADIUS = 1;
DistanceExtendModes.default = 0;
DistanceExtendModes.values = {
  NO_EXTEND: 0,
  INCLUDE_SOURCE_UNIT_RADIUS: 1,
};
DistanceExtendModes.names = {
  0: "NO_EXTEND",
  1: "INCLUDE_SOURCE_UNIT_RADIUS",
};
